/* eslint-disable no-console */
import React, { Component, Fragment } from 'react'
// import path from 'path'
import {
  Row, Col, Typography, Form, Card, Table, Modal, Select, Tooltip, Input, InputNumber, Button, Checkbox, Radio, DatePicker, TimePicker, Space, notification, Statistic, Spin, Badge, Popconfirm, Switch, Popover, Upload, /*Divider, message*/
  Tag,
  List,
  Image,
  Tabs
} from 'antd'
import {
  SearchOutlined, CloseCircleFilled, /*SaveOutlined, PlusOutlined,*/ CheckOutlined, CloseOutlined, CheckCircleFilled, CheckCircleTwoTone, InfoCircleFilled, MehOutlined, SmileOutlined, FrownOutlined, CustomerServiceOutlined, ExclamationCircleOutlined, /*PaperClipOutlined*/
  InfoCircleOutlined, LoadingOutlined, CaretRightOutlined, CaretDownOutlined,
  InboxOutlined,
  UserOutlined,
  FileExcelOutlined,
  // FilePdfOutlined,
  PlusOutlined,
  CloudUploadOutlined,
  PaperClipOutlined,
  ReloadOutlined,
  SnippetsOutlined,
  UploadOutlined
} from '@ant-design/icons'
import download from '../../assets/images/download.svg'
import addIcon from '../../assets/images/add.svg'
import editIcon from '../../assets/images/edit.svg'
import deleteIcon from '../../assets/images/delete.svg'
import restoreIcon from '../../assets/images/restore.svg'
import Update from '../../assets/images/input-tick.svg'
import documentIcon from '../../assets/images/document.svg'
import planeDarkIcon from '../../assets/images/plane-icon-dark.svg'
import planeLightIcon from '../../assets/images/plane-icon-light.svg'
import ULDicon from '../../assets/images/uld_icon.png'
import RedirectIcon from '../../assets/images/open-external-link.svg'
import cssconstants from '../../constants/cssconstants'
import Http from '../../utils/http'
import Notes from '../notes/notes'
import Cookies from 'universal-cookie'
// import AftHold from '../../assets/images/conf-1.png'
// import ForwardHold from '../../assets/images/conf-2.png'
import { cloneDeep } from 'lodash'
import moment, { isMoment } from 'moment'
import { constants, timezone, cut_codes, audit_status, ldd_status, ch_wt_goals, /*station as org_stations*/ } from '../../constants/constants'
import { weightCalculator, formatWeight, cacheRetrieve, volumnCalculator } from '../../utils/common'
import './index.css'
import BuildPlan from './tabs/checklist/buildplan'
import HeaderSearch from '../../pages/search'
import WeightAndBalance from './tabs/checklist/weight-balance-planner'
import { pageHandler, getCookie, COOKIE } from '../../utils/cookie'
import TruckLoading from './tabs/checklist/truckloading'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
// import Download from './tabs/checklist/uldDetails/Download'
// import DryIce from './tabs/checklist/weight-balance-planner/dryice'
import Slider from 'react-slick'
import html2canvas from 'html2canvas'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const { Dragger } = Upload

const cookies = new Cookies()

const { Title, Text } = Typography
const { Option } = Select
const { Search } = Input
const { Countdown } = Statistic
const { TabPane } = Tabs
const dateTimeFormat = 'DDMMMYY HH:mm'
const dateOnly = 'DDMMMYY'
const dateFormat = 'YYYY-MM-DD'
const timeFormat = 'HH:mm:ss'
const completeDateTime = 'YYYY-MM-DD HH:mm:ss'
const { Column, ColumnGroup } = Table
const country = ['USA', 'U.S. VIRGIN ISLANDS', 'PUERTO RICO']

// Utility to get followup_question from options by name
function getFollowupQuestion(options, name) {
  return options?.find(option => option.name === name)?.followup_question
}

const legendPopover = (
  <div className='width-250 fs-10'>
    <Row gutter={[8, 8]}>
      <Col span={7}>AS</Col>
      <Col span={17}>Cargo checked in at station</Col>

      <Col span={7}><img src={planeDarkIcon} width='12' height='12' alt='plane' /></Col>
      <Col span={17}>Cargo enroute to station</Col>

      <Col span={7}><Text type='success'>C</Text></Col>
      <Col span={17}>Cargo at station built up, ULD closed</Col>

      <Col span={7}><Text type='danger'>O</Text></Col>
      <Col span={17}>Cargo at station built up, ULD open</Col>

      <Col span={7}>1 | 111 | 1</Col>
      <Col span={17}>AWBS | WEIGHT | VOLUME</Col>
    </Row>
  </div>
)
const flightno_pattern = /^DL\d{3,4}[A-Za-z]?$/
const users = ['diksha@orgadynamics.com', 'noel@orgadynamics.com', 'craig@orgadynamics.com', 'jessio@orgadynamics.com', 'narayan@orgadynamics.com']
const emailregex = '^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*.[a-z]{2,})(,([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*.[a-z]{2,}))*$'
const const_ulds = ['PMC', 'PAG', 'LD2', 'LD3', 'LD4', 'LD8', 'AKE', 'PLA', 'PLB', 'AKN', 'AKX', 'AKY', 'DPA', 'DPE', 'DPL', 'DPN', 'DQL', 'DQP', 'DQF', 'FQA']

let ENV = process.env.REACT_APP_ENV

//FORMAT FLIGHT NO
function formatFlightNo(flight_no, flight_date) {
  let formatted = ''
  formatted = flight_no + '/' + moment(flight_date).format(dateOnly)
  return formatted
}

//FORMAT AWB NO
function formatAWBNo(awb) {
  let result = ''
  if (awb) {
    let b = '-'
    let position = 3
    result = [awb.slice(0, position), b, awb.slice(position)].join('')
  }
  return result
}

const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

// const dummy = [
//   {
//     location: '-',
//     awb: '006-12345678', 
//     pcs: 10,
//     grwt: 1000,
//     chwt: 1000,
//     vol: 14,
//     pri: 2,
//     dest: 'LAX',
//     prod: 'HUM',
//     spl: 'HUM', 
//     preBuilt: 'Y',
//     onHand: 'Y'
//   }
// ]

const uld_colors = [
  {
    name: 'blue',
    code: '#0000FF'
  },
  {
    name: 'purple',
    code: '#800080'
  },
  {
    name: 'cyan',
    code: '#00FFFF'
  },
  {
    name: 'magenta',
    code: '#FF00FF'
  },
  {
    name: 'red',
    code: '#FF0000'
  },
  {
    name: 'green',
    code: '#00FF00'
  },
  {
    name: 'yellow',
    code: '#FFFF00'
  },
  {
    name: 'orange',
    code: '#FFA500'
  },
  {
    name: 'pink',
    code: '#FFC0CB'
  },
  {
    name: 'brown',
    code: '#A52A2A'
  },
  {
    name: 'indigo',
    code: '#4B0082'
  },
  {
    name: 'teal',
    code: '#008080'
  },
  {
    name: 'lavender',
    code: '#E6E6FA'
  },
  {
    name: 'gold',
    code: '#FFD700'
  },
  {
    name: 'silver',
    code: '#C0C0C0'
  },
  {
    name: 'gray',
    code: '#808080'
  },
  {
    name: 'maroon',
    code: '#800000'
  },
  {
    name: 'olive',
    code: '#808000'
  },
  {
    name: 'turquoise',
    code: '#40E0D0'
  },
  {
    name: 'slate blue',
    code: '#6A5ACD'
  }
]

class FlightControl extends Component {
  constructor() {
    super()
    this.modalRef = React.createRef()
    this.state = {
      servererror: false,
      acChange: false,
      loading: false,
      modalLoading: false,
      loadplanvisible: false,
      awbSearch:  '',
      station: new Cookies().get('station'),
      user_id: new Cookies().get('id'),
      timezone: new Cookies().get('timezone'),
      ext: timezone.find((item) => item.value === new Cookies().get('station'))?.ext || 'EST',
      start: moment().tz(new Cookies().get('timezone')).format(dateFormat),
      end: moment().tz(new Cookies().get('timezone')).add(12, 'hours').format(dateFormat),
      //set time to 00:00:00
      stime: moment().tz(new Cookies().get('timezone')).add(12, 'hours').set({
        hours: 0,
        hour: 0,
        minutes: 0,
        second: 0,
      }),
      etime: moment().tz(new Cookies().get('timezone')).set({
        hours: 23,
        hour: 23,
        minutes: 59,
        second: 59,
      }),
      start_checklist: moment().tz(new Cookies().get('timezone')).format(dateFormat),
      stime_checklist: moment().tz(new Cookies().get('timezone')).set({
        hours: 0,
        hour: 0,
        minutes: 0,
        second: 0,
      }),
      end_checklist: moment().tz(new Cookies().get('timezone')).add(12, 'hours').format(dateFormat),
      etime_checklist: moment().tz(new Cookies().get('timezone')).add(12, 'hours').set({
        hours: 23,
        hour: 23,
        minutes: 59,
        second: 59,
      }),
      page: 1,
      weight_unit: 'KG',
      cookieInterval: null,
      search: '',
      milestoneData: [],
      milestoneFBData: [],
      allQuestionsData: [],
      questionsData: [],
      tempquestionsData: [],
      openQuizModal: false,
      quizMilestonid: null,
      checklistTitle: '',
      quizModalFlight: null,
      milestonButton: 'Submit',
      hideCompleted: false,
      showInternational: false,
      showDomestic: false,
      showMyFlights: false,
      truckplanner: false,
      paxLogs: [],
      feedback: false,
      feedbackType: null,
      flightData: [],
      displayData: [],
      fleetData: [],
      userList: [],
      defaultSystemParameters: [],
      uldMappingData: [],
      stationsData: [],
      destStations: [],
      destFilters: [],
      sort: 'dept_time',
      dodsort: 'dept_time',
      departedFlightsCheck: false,
      amberFlightsCheck: false,
      redFlightsCheck: false,
      searchString: '',
      noteType: null,
      flightNotes: false,
      optimalBuild: false,
      showAlloc: false,
      notesTitle: '',
      isListening: false,
      searchFlightNo: '',
      latestTimestamp: '',
      searchDate: '',
      ccView: false,
      showSuccess: false,

      editRecord: null,
      editAllocRecord: null,
      deleteAllocID: null,
      mergeEditRecord: null,
      editRecordId: null,

      editFcst: 0,
      editBagP96: 0,
      editBagP88: 0,
      editBagLD3: 0,
      editBagLD2: 0,
      editCargoMD: 0,
      editCargoP96: 0,
      editCargoP88: 0,
      editCargoLD3: 0,
      editCargoLD2: 0,
      editWgtValue: 0,
      editWgtUnit: '',
      editBuPrio: false,
      editAllocArray: [],
      editIsExceeded: false,
      previewAft: null,
      previewFwd: null,
      lastUpdatedAt: '',
      lastUpdatedBy: '',
      lastUpdatedPpr: '',

      editPos: '',
      editType: '',
      editWorkArea: '',
      editULDAWB: '',
      editProd: '',
      editComm1: '',
      editComm2: '',
      editUlds: {},

      editTPos: '',
      editTType: '',
      editTWorkArea: '',
      editTULDAWB: '',
      editTProd: '',
      editTComm1: '',
      editTComm2: '',

      remainingP96: 0,
      remainingP88: 0,
      remainingLD3: 0,
      remainingLD2: 0,
      remainingMD: 0,

      SLUSummary: [],
      PTUSummary: [],
      BuiltSummary: [],
      BLKSummary: null,
      selected: [],
      bagSummary: [],
      bagSelected: null,
      isWideBody: false,
      hideMD: true,
      hints: '',
      notes: '',
      selectedRow: '',
      checkListOpen: false,
      checkListTitle: '',
      radioValue: 2,
      showBP: false,
      openPlanner: false,
      openInitPlanner: false,
      openFinalPlanner: false,
      addULD: false,
      assignUld: {},
      assignedUldsData: [],
      flightDetails: null,
      editAwbs: {},
      editAwbsRecord: null,
      bpIndex: null,

      openNoRideModal: false,
      noRideModalType: null,
      noRideTitle: null,
      norideData: [],
      noride_container_id: null,
      noride_type: null,
      noride_rmvbfpe: null,
      noride_cutcode: null,
      cut_reasons: [],
      noride_cutreason: null,
      noride_cutby: null,
      noride_comment: null,
      noride_flight: null,
      noride_ldd: null,
      noride_ala: null,
      noride_attach_conf: false,
      noride_fileList: [],
      isModalVisible: false,
      noRideQts: {},

      edit_noride_id: null,
      edit_noride_container_id: null,
      edit_noride_type: null,
      edit_noride_rmvbfpe: null,
      edit_noride_cutcode: null,
      edit_cut_reasons: [],
      edit_noride_cutreason: null,
      edit_noride_cutby: null,
      edit_noride_comment: null,
      edit_noride_flight: null,
      edit_noride_attach_conf: false,
      edit_noride_fileList: [],

      openLDDModal: false,
      pallets_paired: null,
      pallets_paired_contact: null,
      pallets_paired_explain: null,
      conveyances_staged: null,
      conveyances_staged_contact: null,
      conveyances_staged_explain: null,


      addedULD: [],
      optiUld: {},
      editOptiUld: {},
      chblWgtGoal: null,
      optiLoader: false,
      assignLoader: false,
      clearLoader: false,
      switch: true,

      //audit form
      attach_conf: false,
      fileList: [],
      bin_config: null,
      audit_built_right: null,
      audit_reason: null,
      audit_explain: null,
      audit_was_optimal: null,
      audit_was_optimal_explain: null,
      audit_meet_wgt_goal: null,
      audit_meet_wgt_goal_explain: null,

      load_trac_conf: false,
      load_trac_conf_fileList: [],
      build_plan_conf: false,
      build_plan_conf_fileList: [],
      wandb_conf: false,
      wandb_conf_fileList: [],
      wandb_conf2: false,
      wandb_conf2_fileList: [],
      onesource_conf: false,
      onesource_conf_fileList: [],
      audit_meet_wgt_goal_conf: [],
      load_trac_conf_previewImg: false,
      build_plan_conf_previewImg: false,
      wandb_conf_previewImg: false,
      wandb_conf2_previewImg: false,
      onesource_conf_previewImg: false,
      audit_meet_wgt_goal_conf_previewImg: false,

      //feedback form
      fb_req_name: cookies.get('name'),
      fb_req_email: cookies.get('username').match(emailregex) ? cookies.get('username') : null,
      fb_type: null,
      fb_urgency: null,
      fb_tools_impacted: [],
      fb_milestones: [],
      fb_description: null,
      fb_rec_solution: null,
      fb_fileList: [],

      //add flight form
      edit_flight_id: null,
      flightModalType: 'ADD',
      showFlightModal: false,
      flight_no: null,
      flight_date: null,
      dept_time: moment().startOf('day'),
      arr_time: moment().startOf('day'),
      org_stn: cookies.get('station'),
      dest_stn: null,
      aircrafttype: null,
      ack1: false,
      ack2: false,

      flightAuditImg: false,
      previewImgNoRide: false,

      newULDType: '',
      newULDNumber: '',

      visiblePopoverId: null,
      edit_uld_dir_id: null,
      editULDType: '',
      editULDNumber: '',

      completedBy: '',
      completedById: '',
      isUploadModalOpen: false,
      previewOpen: false,
      previewImage: '',
      previewFileName: '',
      searchStations: [],
      flightAssessment: false,
      assessment_station: cookies.get('station'),
      assessment_date: moment().tz(new Cookies().get('timezone')).add(12, 'hours').format(dateFormat),
      dodAssignmentAgentList: [],
      dodAssignmentFlights: [],
      dodAgents: [],
      priority: true,
      priorityData: [],

      activeTab: 'bp',
      visibleTabs: ['bp', 'initial', 'final'],
    }
    this._queue = []
    this._isBusy = false
    this.assignUldFormRef = React.createRef()
    this.modalContentRef = React.createRef()
  }

  componentDidMount() {

    pageHandler(window.location.pathname, getCookie(COOKIE.ROLE))
    // const system_params_events = new EventSource(process.env.REACT_APP_API_URL+`events?pgtype=sp&stn=${station}`)
    const flight_control_events = new EventSource(process.env.REACT_APP_API_URL + `events?pgtype=fc&stn=${this.state.station}`)

    flight_control_events.onmessage = (event) => {
      const parsedData = JSON.parse(event.data)
      if (!this.state.isListening) this.setState({ isListening: true })
      else {
        const myFakeAsyncJob = this.getFakeAsyncJob(parsedData)
        this.enqueue(myFakeAsyncJob)
      }
    }
    flight_control_events.onerror = (error) => {
      if (error?.type === 'error') {
        this.setState({ servererror: true })
      }
    }

    // system_params_events.onmessage = (event) => {
    //   const parsedData = JSON.parse(event.data)
    //   if(!this.state.isListening) this.setState({ isListening: true })
    //   else {
    //     const myFakeAsyncJob = this.getFakeAsyncJob(parsedData)
    //     this.enqueue(myFakeAsyncJob)
    //   }
    // }
    // system_params_events.onerror = (error) => {
    //   if(error?.type === 'error') {
    //     this.setState({ servererror : true })
    //   }
    // }

    this.setState({ cookieInterval: setInterval(this.checkInterval, 1000) })
    // // radioValue == 1
    // this.fetchFleet()
    // radioValue == 2
    // this.fetchAllQuestions()
    // this.fetchMilestones()
    // this.fetchStations()
    // this.fetchPaxLogs()
    this.fetchData()
  }

  componentWillUnmount() {
    this.setState({ cookieInterval: clearInterval(this.state.cookieInterval) })
  }

  fetchData = () => {
    this.fetchPriority()
    this.fetchAllQuestions()
    this.fetchMilestones()
    this.fetchStations()
    this.fetchPaxLogs()
  }

  fetchPriority = () => {
    Http.get(`products_priority?station=${this.state.station}`).then(({ data }) => {
      if (data?.data?.length > 0) {
        this.setState({ priorityData: data?.data?.[0]?.prod_prior_list || [] })
      }
    })
  }


  handleToggle = () => {
    if (this.state.radioValue === 1) {
      this.fetchFleet()
    } else if (this.state.radioValue === 2) {
      this.fetchMilestones()
      this.fetchStations()
    }
  }
  openWB = (value) => {
    this.setState({
      openPlanner: value,
      openInitPlanner: false,
      openFinalPlanner: false
    })
  }

  openInitWB = (value) => {
    this.setState({
      openInitPlanner: value,
      openFinalPlanner: false
    })
  }

  openFinalWB = (value) => {
    this.setState({
      openFinalPlanner: value,
      openInitPlanner: false
    })
  }

  openWnb = (value) => {
    this.setState({
      openWnbPlanner: value,
      openFinalPlanner: false,
      openInitPlanner: false
    })
  }

  openTruckPlanner = (value) => {
    this.setState({ truckplanner: value })
  }

  opti = () => {
    this.setState({ optiLoader: true })
    Http.get(`/build_opti/${this.state.editRecord?.id}?priority=${this.state.priority || false}`)
      .then(() => {
        setTimeout(() => {
          this.setState({ optiLoader: false })
        }, 4000)
      })
  }
  opti_clear = () => {
    this.setState({ clearLoader: true })
    Http.get(`/build_opti_clear/${this.state.editRecord?.id}?stn=${cookies.get('station')}`)
      .then(() => {
        setTimeout(() => {
          this.setState({ clearLoader: false })
        }, 4000)
      })
  }

  autoAssignUlds = () => {
    this.setState({ assignLoader: true })
    Http.get(`/assign_ulds/${this.state.editRecord?.id}?stn=${cookies.get('station')}`).then((d) => {
      setTimeout(() => {
        this.setState({ assignLoader: false })
      }, 4000)
      if (d?.status !== 200) {
        notification.destroy()
        notification.error({
          message: 'Error',
          description: d?.data?.message || 'Something went wrong'
        })
      }
    }).catch((e) => {
      this.setState({ assignLoader: false })
      notification.destroy()
      notification.error({
        message: 'Error',
        description: e?.response?.data?.message || 'Something went wrong'
      })
    })
  }

  getUnassignedAwbs = () => {
    let assigned_awbs = []
    this.state.mergeEditRecord.map(item => {
      let bpIndex = this.state.editRecord.build_plan.findIndex((item2) => item2.awb_no === item.awb_no)
      if (bpIndex !== -1) {
        if (!this.state.editRecord.build_plan[bpIndex].ulds || this.state.editRecord.build_plan[bpIndex].ulds.length === 0) {
          assigned_awbs.push(item)
        } else {
          let { pcs, wgt, vol } = this.state.editRecord.build_plan[bpIndex].ulds.reduce((acc, curr) => {
            acc.pcs += curr.pcs || 0
            acc.wgt += curr.wgt || 0
            acc.vol += curr.vol || 0
            return acc
          }, {
            pcs: 0,
            wgt: 0,
            vol: 0
          })
          if (item.pcs != pcs) {
            assigned_awbs.push({
              ...item,
              asgn_pcs: pcs,
              asgn_wgt: wgt,
              asgn_vol: vol
            })
          }
        }
      } else {
        assigned_awbs.push(item)
      }
    })
    return assigned_awbs
  }

  showAwbs = (record, awbs) => {
    let a = []
    if (record?.type == 'SLU') {
      record?.awbs_in?.map(awb => {
        let act = this.state.mergeEditRecord?.find(a1 => awb.awb_no == a1.awb_no)
        a.push({
          ...act || {},
          vol: awb?.vol?.value,
          wgt: awb?.wgt?.value,
          pcs: awb?.pcs,
          ch_wgt: (act?.wgt?.value / act?.pcs) * awb?.pcs
        })
      })
    } else {
      if (awbs?.length > 0) {
        awbs.map((awb) => {
          if (record.type == 'BULK') {
            if (awb?.data && awb?.data?.blk && parseInt(awb?.data?.blk) > 0) {
              let act = this.state.mergeEditRecord?.find(a1 => awb.awb_no == a1.awb_no)
              a.push({
                ...act,
                t_pcs: act.pcs,
                pcs: awb.data.blk,
                ch_wgt: awb.data.ch_wgt,
                pri: awb.data.pri,
                wgt: awb.data.blk_wgt,
                vol: awb.data.blk_vol,
                id: 0,
                uld_id: 0
              })
            }
          } else {
            const data = awb?.ulds.find((u) => record.id == u.id)
            if (data) {
              let act = this.state.mergeEditRecord?.find(a1 => awb.awb_no == a1.awb_no)
              a.push({
                ...act,
                ...data,
                t_pcs: act?.pcs,
                pcs: data.pcs,
                t_wgt: act?.wgt,
                wgt: data.wgt,
                ch_wgt: data.ch_wgt,
                vol: data?.vol
              })
            }
          }
        })
      }
    }
    return a
  }

  eventList = (parsedData) => {
    if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'UPDATE' && parsedData?.Action === 'UPDATE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'DETAILS')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'PLAN' && parsedData?.Action === 'UPDATE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'PLAN')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'wgt_bal_plan' && parsedData?.Action === 'UPDATE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'wgt_bal_plan')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'build_plan_lock' && parsedData?.Action === 'UPDATE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'build_plan_lock')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && (parsedData?.msg === 'BUILD_ULD' || parsedData?.msg === 'CREATE_ULD') && (parsedData?.Action === 'ADD' || parsedData?.Action === 'UPDATE' || parsedData?.Action === 'REMOVE')) {
      this.updateFlightDetails(parsedData?.DETAILS?.data, parsedData?.msg)
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'BUILD_AWB' && (parsedData?.Action === 'UPDATE' || parsedData?.Action === 'ADD')) {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'BUILD_AWB')
    } else if (parsedData?.TYPE === 'FLIGHT_CONTROL' && parsedData?.msg === 'BUILD_AWB' && parsedData?.Action === 'REMOVE') {
      this.updateFlightDetails(parsedData?.DETAILS?.data, 'BUILD_AWB_REMOVE')
    } else if (parsedData?.TYPE === 'NOTES') {
      this.updateFlightNotesCount(parsedData?.DETAILS)
    } else if (parsedData?.TYPE === 'FLIGHT_EVENT') {
      this.updateFlight(parsedData?.DETAILS, 'DEPARTURE')
    } else if (parsedData?.TYPE === 'FSU' && parsedData?.msg === 'MAN') {
      this.updateFlight(parsedData?.DETAILS?.data, 'BUILDUP')
    } else if (parsedData?.TYPE === 'FSU' && parsedData?.msg === 'GATE') {
      this.updateFlight(parsedData?.DETAILS?.data, 'GATE')
    } else if (parsedData?.TYPE === 'BOOKING' && parsedData?.msg === 'UPDATE') {
      this.updateFlight(parsedData?.DETAILS, 'BOOKING')
    } else if (parsedData?.TYPE === 'BOOKING' && parsedData?.msg === 'ADD') {
      this.addAWB_segment(parsedData?.DETAILS)
    } else if (parsedData?.TYPE === 'BOOKING' && parsedData?.msg === 'REMOVE') {
      this.removeAWB_segment(parsedData?.DETAILS)
    } else if (parsedData?.TYPE === 'FLEET') {
      this.fetchFleet('EVENT')
    } else if (parsedData?.TYPE === 'STATIONS') {
      this.fetchStations('EVENT')
    } else if (parsedData?.TYPE === 'DEFAULT_HANDLING_TIMES') {
      this.fetchDefaultSystemParameters('EVENT')
    } else if (parsedData?.TYPE === 'GLOBAL_DETAILS') {
      this.fetchGlobalDetails('EVENT')
    } else if (parsedData?.TYPE === 'NORIDE') {
      this.handleNoRideEvent(parsedData?.Action, parsedData?.DETAILS)
    } else if (parsedData?.TYPE === 'FLIGHTNORIDE') {
      this.updateFlight(parsedData?.DETAILS, 'FLIGHTNORIDE')
    } else if (parsedData?.TYPE === 'FLIGHTAUDIT') {
      this.updateFlight(parsedData?.DETAILS, 'FLIGHTAUDIT')
    } else if (parsedData?.TYPE === 'FLIGHTAUDITFILE') {
      this.updateFlight(parsedData?.DETAILS, 'FLIGHTAUDITFILE')
    } else if (parsedData?.TYPE === 'FLIGHTLDD') {
      this.updateFlight(parsedData?.DETAILS, 'FLIGHTLDD')
    } else if (parsedData?.TYPE === 'ASSIGNED_TO_AGENT') {
      this.updateFlight(parsedData?.DETAILS, 'ASSIGNED_TO_AGENT')
    } else if (parsedData?.TYPE === 'ULD_DIRECTIVES_UPDATED') {
      this.updateFlight(parsedData?.DETAILS, 'ULD_DIRECTIVES_UPDATED')
    } else if (parsedData?.TYPE === 'ANSWER') {
      this.fetchQuestions(parsedData?.DETAILS?.flight_id, parsedData?.DETAILS?.milestones_id, true)
    } else if (parsedData?.TYPE === 'MILESTONES') {
      this.fetchMilestones('EVENT')
    } else if (parsedData?.TYPE === 'FLIGHT') {
      this.fetchFlightsChecklist(null, parsedData?.DETAILS?.data?.flight_id)
    }
    // else if(parsedData?.TYPE === 'GLOBAL_DETAILS') {
    //   this.fetchGlobalDetails('EVENT')
    // }
  }

  /*************************************************************** */

  enqueue = (job) => {
    // we'll wrap the job in a promise and include the resolve and reject functions in the job we'll enqueue, so we can control when we resolve and execute them sequentially
    new Promise((resolve, reject) => {
      this._queue.push({
        job,
        resolve,
        reject
      })
    })
    // we'll add a nextJob function and call it when we enqueue a new job; we'll use _isBusy to make sure we're executing the next job sequentially
    this.nextJob()
  }
  nextJob = () => {
    if (this._isBusy) return
    const next = this._queue.shift()
    // if the array is empty shift() will return undefined
    if (next) {
      this._isBusy = true
      next
        .job()
        .then((value) => {
          this.eventList(value)
          next.resolve(value)
          this._isBusy = false
          this.nextJob()
        })
        .catch((error) => {
          next.reject(error)
          this._isBusy = false
          this.nextJob()
        })
    }
  }
  getFakeAsyncJob = (item) => {
    return () =>
      new Promise((resolve) => {
        setTimeout(() => {
          resolve(item)
        }, 600)
      })
  }

  /*************************************************************** */

  checkInterval = () => {
    let newCookie = new Cookies().get('weight')
    if (newCookie !== this.state.weight_unit) {
      this.setState({ weight_unit: newCookie })
    }
  }
  //PROCESS FLIGHT DATA
  processData = () => {
    let flight_array = this.state.flightData?.map((flight) => {
      return { ...this.processIndividualFlight(flight) }
    })
    this.sort(flight_array, false)
  }

  //FETCH FLEET
  fetchFleet = async () => {
    let callback = this.fetchFleetFn
    let pageURL = 'flights'
    let headers = {}
    cacheRetrieve(callback, pageURL, headers)
  }
  fetchFleetFn = async (resp, event) => {
    if (!event) this.setState({ loading: true })
    const respData = await resp.json()
    if (respData && respData?.data?.length > 0) {
      let fleetData = respData?.data.filter((item) => item?.details?.ac_type === 'WB')
      this.setState({ fleetData: fleetData })
    } else {
      this.setState({ fleetData: [] })
    }

    if (!event && this.state.radioValue !== 2) { this.fetchULDMappingData() }
    else if (!event && this.state.radioValue === 2) { this.fetchFlightsChecklist() }
    else {
      this.processData()
    }
  }
  //FETCH ULD MAPPING DATA
  fetchULDMappingData = async () => {
    let callback = this.fetchULDMappingDataFn
    let pageURL = 'uld_mappings'
    let headers = {}
    cacheRetrieve(callback, pageURL, headers)
  }
  fetchULDMappingDataFn = async (resp, event) => {
    const respData = await resp.json()
    if (resp?.status === 200) {
      if (respData?.data?.length > 0) {
        this.setState({ uldMappingData: respData?.data })
      }
      if (!event) this.fetchDefaultSystemParameters()
      else {
        this.processData()
      }
    } else {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: respData?.message ? respData?.message : constants.SERVER_CONNECTION_ERROR,
      })
      this.setState({ loading: false })
    }
  }
  //FETCH DEFAULT HANDLING TIMES
  fetchDefaultSystemParameters = async (event) => {
    let callback = this.fetchDefaultSystemParametersFn
    let pageURL = `handling_times?default=true&station=${this.state.station}`
    let headers = {}
    cacheRetrieve(callback, pageURL, headers, event)
  }

  fetchDefaultSystemParametersFn = async (resp, event) => {
    const respData = await resp.json()
    if (resp?.status === 200) {
      if (respData?.data?.length > 0) {
        this.setState({ defaultSystemParameters: respData?.data })
      } else {
        this.setState({ defaultSystemParameters: [] })
      }
      if (!event && this.state.radioValue !== 2) { this.fetchStations() }
      else if (!event && this.state.radioValue === 2) { this.fetchFleet() }
      else {
        this.processData()
      }
    } else {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: respData.message,
      })
      this.setState({ loading: false })
    }
  }

  fetchPaxLogs = async () => {
    Http.get('logs/pax').then((resp) => {
      const respData = resp.data
      if (resp?.status === 200) {
        if (respData?.data?.length > 0) {
          this.setState({ paxLogs: respData?.data })
        } else {
          this.setState({ paxLogs: [] })
        }
      }
    })
  }

  //FETCH STATIONS
  fetchStations = async () => {
    let callback = this.fetchStationsFn
    let pageURL = 'stations'
    let headers = {}
    cacheRetrieve(callback, pageURL, headers)
  }
  fetchStationsFn = async (resp, event) => {
    const respData = await resp.json()
    if (resp?.status === 200) {
      if (respData?.data?.length > 0) {
        this.setState({ stationsData: respData?.data })
      } else {
        this.setState({ stationsData: [] })
      }
      if (!event) this.fetchUsers()
      else {
        this.processData()
      }
    } else {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: respData.message,
      })
      this.setState({ loading: false })
    }
  }
  fetchUsers = async () => {
    let callback = this.fetchUsersFn
    let pageURL = 'users?sa=true'
    let headers = { station: this.state.station }
    cacheRetrieve(callback, pageURL, headers)
  }
  fetchUsersFn = async (resp, event) => {
    const respData = await resp.json()
    if (resp?.status === 200) {
      if (respData?.data?.length > 0) {
        this.setState({ userList: respData?.data })
      } else {
        this.setState({ userList: [] }, () => {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: respData?.message,
          })
        })
      }
      if (!event) this.fetchGlobalDetails()
      else {
        this.processData()
      }
    } else {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: respData.message,
      })
      this.setState({ loading: false })
    }
  }

  //FETCH GLOBAL DETAILS
  fetchGlobalDetails = async () => {
    let callback = this.fetchGlobalDetailsFn
    let pageURL = 'global_details'
    let headers = {}
    cacheRetrieve(callback, pageURL, headers)
  }
  fetchGlobalDetailsFn = async (resp, event) => {
    const respData = await resp.json()
    if (resp?.status === 200) {
      if (respData?.data?.length > 0) {
        let filtered = respData?.data?.find((item) => item?.details?.stations?.includes(this.state.station)) || null
        if (filtered) {
          this.setState({
            hideMD: filtered?.show_md ? false : true,
            searchStations: filtered?.details?.stations || [],
          })
        } else {
          this.setState({
            hideMD: false,
            searchStations: [],
          })
        }
        if (!event && this.state.radioValue !== 2) this.fetchFlights()
      } else {
        this.setState({ loading: false })
      }
    } else {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: respData?.message ? respData?.message : constants.SERVER_CONNECTION_ERROR,
      })
      this.setState({ loading: false })
    }
  }
  //UPDATE FLIGHT
  updateFlight = (DETAILS, TYPE) => {
    let ID = parseInt(DETAILS?.flight_id)
    let type = 'null'
    if (this.state.flightData && this.state.flightData.length > 0) {
      type = 'flight'
    } else {
      type = 'checklist'
    }
    let DATA = cloneDeep(this.state.flightData)
    let flight_index = DATA?.findIndex((p) => p.id === ID)
    if (flight_index > -1) {
      if (TYPE === 'DEPARTURE') {
        let dept_obj = {}
        dept_obj.act = DETAILS?.flight?.dept?.act ? parseInt(DETAILS.flight.dept.act) : null
        dept_obj.eta = DETAILS?.flight?.dept?.eta ? parseInt(DETAILS.flight.dept.eta) : null
        dept_obj.schdl = DETAILS?.flight?.dept?.schdl ? parseInt(DETAILS.flight.dept.schdl) : null
        DATA[flight_index].dept_date = DETAILS?.flight?.dept_date ? DETAILS?.flight?.dept_date : DATA[flight_index].dept_date
        DATA[flight_index].dept = dept_obj
        DATA[flight_index] = this.processIndividualFlight(DATA[flight_index])
      } else if (TYPE === 'BUILDUP') {
        let buildUpArray = DETAILS?.build_up
        DATA[flight_index].build_up = buildUpArray
        DATA[flight_index] = this.processIndividualFlight(DATA[flight_index])
      } else if (TYPE === 'BOOKING') {
        let bookingArray = DETAILS?.details
        DATA[flight_index].awb_segments = bookingArray
        DATA[flight_index] = this.processIndividualFlight(DATA[flight_index])
      } else if (TYPE === 'GATE') {
        let gateArray = DETAILS?.gate
        DATA[flight_index].awb_segments = gateArray
        DATA[flight_index] = this.processIndividualFlight(DATA[flight_index])
      } else if (TYPE === 'FLIGHTNORIDE') {
        let norideArray = DETAILS?.data
        DATA[flight_index].noride = norideArray
      } else if (TYPE === 'FLIGHTAUDIT' || TYPE === 'FLIGHTAUDITFILE') {
        let auditArray = DETAILS?.data
        DATA[flight_index].audit = auditArray
      } else if (TYPE === 'FLIGHTLDD') {
        if (!DATA[flight_index].ldd) {
          DATA[flight_index].ldd = DETAILS?.data
        } else {
          DATA[flight_index].ldd = DETAILS?.data
        }
      } else if (TYPE === 'ASSIGNED_TO_AGENT') {
        DATA[flight_index].dod_agent_id = DETAILS?.dod_agent_id
        DATA[flight_index].dod_agent = [DETAILS?.dod_agent]
      } else if (TYPE === 'ULD_DIRECTIVES_UPDATED') {
        DATA[flight_index].uld_directives = DETAILS?.uld_directives
      }

      this.setState({ flightData: [] }, () => {
        if (type === 'flight') {
          this.setState({ flightData: DATA }, () => {
            if (this.state.departedFlightsCheck) {
              this.departedFlightsFilter()
            }
          })
        } else {
          this.setState({ flightData: DATA }, () => {
            if (this.state.departedFlightsCheck) {
              this.departedFlightsFilter()
            }
          })
        }
      })
    }
  }
  addAWB_segment = (DETAILS) => {
    let ID = parseInt(DETAILS?.flight_id)
    let DATA = cloneDeep(this.state.flightData)
    let flight_index = DATA?.findIndex((p) => p.id === ID)
    if (flight_index > -1) {
      let awb_seg_index = DATA[flight_index].awb_segments.findIndex((p) => p.id === DETAILS?.details?.id)
      if (awb_seg_index > -1) {
        //do nothing
      } else {
        let obj = {
          id: DETAILS?.details?.id,
          awb_no: DETAILS?.details?.awb_no,
          space: DETAILS?.details?.space,
          awb: {
            weight_unit: DETAILS?.details?.weight_unit,
            vol_unit: DETAILS?.details?.vol_unit
          }
        }
        DATA[flight_index].awb_segments.push(obj)
        DATA[flight_index] = this.processIndividualFlight(cloneDeep(DATA[flight_index]))
        this.setState({ flightData: [] }, () => this.setState({ flightData: DATA }))
      }

    }
  }
  removeAWB_segment = (DETAILS) => {
    let ID = parseInt(DETAILS?.flight_id)
    let DATA = cloneDeep(this.state.flightData)
    let flight_index = DATA?.findIndex((p) => p.id === ID)
    if (flight_index > -1) {
      let awb_seg_index = DATA[flight_index].awb_segments.findIndex((p) => p.id === DETAILS?.details?.id)
      if (awb_seg_index > -1) {
        DATA[flight_index].awb_segments.splice(awb_seg_index, 1)
        DATA[flight_index] = this.processIndividualFlight(cloneDeep(DATA[flight_index]))
        this.setState({ flightData: [] }, () => this.setState({ flightData: DATA }))
      }
    }
  }
  //FETCH FLIGHT CONTROL DATA
  fetchFlights = async (search = null) => {
    let temp_timestamp = moment().valueOf()
    this.setState({
      loading: search || this.state.page === 1 ? true : false,
      latestTimestamp: temp_timestamp,
      page: search ? 1 : this.state.page,
    })
    let headers = { station: this.state.station }

    let start_date = moment.tz((isMoment(this.state.start) ? this.state.start.format(dateFormat) : this.state.start) + ' ' + this.state.stime.format(timeFormat), this.state.timezone).utc()
    let end_date = moment.tz((isMoment(this.state.end) ? this.state.end.format(dateFormat) : this.state.end) + ' ' + this.state.etime.format(timeFormat), this.state.timezone).utc()
    let start = this.state.start ? start_date.format(dateFormat) : ''
    let end = this.state.end ? end_date.format(dateFormat) : ''
    let stime = this.state.stime ? start_date.format(timeFormat) : ''
    let etime = this.state.etime ? end_date.format(timeFormat) : ''
    let url = 'flight_control_list'
    if (search) {
      url = url + search
    } else {
      url = url + `?start=${start}&end=${end}&stime=${stime}&etime=${etime}&page=${this.state.page}&count=50`
    }

    await Http.get(url, { headers }).then(resp => {
      if (this.state.latestTimestamp === temp_timestamp) {
        if (resp && resp.status === 200) {
          if (resp?.data?.data?.length > 0) {
            let data = []
            if (search === '' || search === null) {
              data = this.state.flightData?.concat(resp.data.data)
            } else {
              data = resp.data.data
            }

            //DUPLICATE DATA CHECK
            let newData = []
            data?.map((item, index) => {
              let id = newData.findIndex(p => p.id == parseInt(item.id))
              if (id > -1) {
                //DO NOTHING
              } else {
                item.key = index
                newData.push(item)
              }
            })

            newData = newData.map((flight) => {
              return { ...this.processIndividualFlight(flight) }
            })

            this.sort(newData, true)
            this.setState({
              loading: false,
              flightData: newData,
              page: search ? 1 : this.state.page + 1,
            }, () => {
              if (this.state.departedFlightsCheck) {
                this.departedFlightsFilter()
              }
              if (!search) {
                this.fetchFlights()
              }
            })
          } else {
            if (this.state.page > 1) {
              //DO NOTHING
            } else {
              this.setState({
                flightData: [],
                loading: false
              }, () => {
                notification.destroy()
                notification.error({
                  message: constants.NO_DATA_ERROR,
                  description: resp?.data?.message,
                })
              })
            }
          }
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: constants.SERVER_CONNECTION_ERROR,
          })
          this.setState({ loading: false })
        }
      }
    }).catch(() => {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: constants.SERVER_CONNECTION_ERROR,
      })
      this.setState({
        loading: false,
        servererror: true
      })
    })
  }
  //UPDATE INDIVIDUAL FLIGHT DETAILS
  updateFlightDetails = async (DETAILS, UPDATE_TYPE) => {
    let DATA = cloneDeep(this.state.flightData)

    if (UPDATE_TYPE === 'wgt_bal_plan') {
      let flight_index1 = DATA?.findIndex(p => p?.id == DETAILS?.id)
      if (flight_index1 > -1) {
        // DATA[flight_index1].wgt_bal_plan = DETAILS?.wgt_bal_plan || {}
        // DATA[flight_index1].wgt_bal_status = DETAILS?.wgt_bal_status || {}
        // DATA[flight_index1].aft_index = DETAILS?.aft_index || {}
        DATA[flight_index1] = {
          ...DATA[flight_index1],
          ...DETAILS
        }
        this.setState({ flightData: DATA }, () => {
          if (this.state.editRecord && DETAILS?.id == this.state.editRecord?.id) {
            this.setState({ editRecord: DATA[flight_index1] })
          }
        })

      }
    }
    if (UPDATE_TYPE === 'build_plan_lock') {
      let flight_index1 = DATA?.findIndex(p => p?.id == DETAILS?.id)
      if (flight_index1 > -1) {
        if (DETAILS?.type && DETAILS?.type == 'Initial') {
          DATA[flight_index1].init_build_plan = DETAILS?.init_build_plan || false
        } else if (DETAILS?.type && DETAILS?.type == 'Final') {
          DATA[flight_index1].final_build_plan = DETAILS?.final_build_plan || false
        }
        this.setState({ flightData: DATA }, () => {
          if (this.state.editRecord && DETAILS?.id == this.state.editRecord?.id) {
            this.setState({ editRecord: DATA[flight_index1] })
          }
        })
      }

    }

    if (UPDATE_TYPE === 'BUILD_AWB' || UPDATE_TYPE === 'BUILD_ULD' || UPDATE_TYPE === 'BUILD_AWB_REMOVE') {
      if (UPDATE_TYPE === 'BUILD_ULD') {
        if (DETAILS && DETAILS?.ulds) {
          this.setState({ assignedUldsData: DETAILS?.ulds })
        }
      }
      let flight_index1 = DATA?.findIndex(p => p?.id == DETAILS?.flights_id)
      if (flight_index1 > -1) {
        let build_plan = cloneDeep(DATA[flight_index1].build_plan || [])
        let awb_index = DATA[flight_index1].build_plan?.findIndex(p => p?.id == DETAILS?.id)
        if (UPDATE_TYPE === 'BUILD_AWB_REMOVE') {
          if (awb_index > -1) {
            build_plan.splice(awb_index, 1)
          }
        } else {
          if (awb_index > -1) {
            build_plan[awb_index] = DETAILS
          }
          else {
            build_plan.push(DETAILS)
          }
        }
        DATA[flight_index1].build_plan = build_plan
        this.setState({ flightData: DATA }, () => {
          if (this.state.editRecord && DETAILS?.flights_id == this.state.editRecord?.id) {
            this.setState({ editRecord: DATA[flight_index1] }, () => {
              this.bookedULD()
              if (this.state.flightDetails?.id == DETAILS?.id) {
                this.setState({
                  flightDetails: {
                    ...this.state.flightDetails,
                    ...DETAILS
                  }
                }, () => {
                  this.fetchUlds()
                })
              }
            })
          }
        })
      }
    }

    if (UPDATE_TYPE === 'CREATE_ULD') {
      let flight_index1 = DATA?.findIndex(p => p?.id == DETAILS?.flights_id)
      if (flight_index1 > -1) {
        let build_uld = cloneDeep(DATA[flight_index1].build_uld || [])
        if (DETAILS && DETAILS?.delete) {
          let uld_index = build_uld.findIndex(p => p?.id == DETAILS?.id)
          if (uld_index > -1) {
            build_uld.splice(uld_index, 1)
          }
        } else {
          let uld_index = build_uld.findIndex(p => p?.id == DETAILS?.id)
          if (uld_index > -1) {
            build_uld[uld_index] = DETAILS
          }
          else {
            build_uld.push(DETAILS)
          }
        }
        DATA[flight_index1].build_uld = build_uld
        this.setState({ flightData: DATA }, () => {
          if (this.state.editRecord && DETAILS?.flights_id == this.state.editRecord?.id) {
            this.setState({ editRecord: DATA[flight_index1] }, () => {
              this.bookedULD()
              if (this.state.flightDetails?.id == DETAILS?.id) {
                this.setState({ flightDetails: DETAILS }, () => {
                  this.fetchUlds()
                })
              }
            })
          }
        })
      }
    }

    //CHECK FLIGHT RANGE
    let start_date = moment.tz((isMoment(this.state.start) ? this.state.start.format(dateFormat) : this.state.start) + ' ' + this.state.stime.format(timeFormat), this.state.timezone).utc().valueOf()
    let end_date = moment.tz((isMoment(this.state.end) ? this.state.end.format(dateFormat) : this.state.end) + ' ' + this.state.etime.format(timeFormat), this.state.timezone).utc().valueOf()

    let local_tz_dept_date = 0
    if (DETAILS?.flight_date) {
      local_tz_dept_date = moment.utc(DETAILS?.flight_date).valueOf()
      if (local_tz_dept_date > start_date && local_tz_dept_date < end_date) {
        let flight_index = DATA?.findIndex(p => p.id == parseInt(DETAILS?.flight_id))
        //UPDATE FLIGHT DATA
        if (flight_index > -1) {
          if (UPDATE_TYPE === 'DETAILS') {
            DATA[flight_index] = this.processIndividualFlight(this.parseFlight(DATA[flight_index], DETAILS))
          } else if (UPDATE_TYPE === 'PLAN') {
            DATA[flight_index].details = DETAILS?.details || []
          }
          if (DETAILS?.last_updated?.length > 0) {
            let user_obj = this.state.userList?.find((item) => item?.id === parseInt(DETAILS.last_updated[DETAILS.last_updated.length - 1]?.user_id))
            DATA[flight_index].last_updated = DETAILS?.last_updated
            DATA[flight_index].last_updated_by = `${user_obj?.name?.first_name} ${user_obj?.name?.last_name}` || ''
            DATA[flight_index].last_updated_at = moment.utc(DETAILS.last_updated[DETAILS.last_updated.length - 1]?.updated_date).tz(this.state.timezone).format(dateTimeFormat) || ''
            DATA[flight_index].last_updated_ppr = `${user_obj?.ppr}` || ''
          }
          //CHECK IF EDITING RECORD MATCHES FETCHED FLIGHT RECORD
          if (this.state.editRecord && DATA[flight_index]?.id === this.state.editRecord?.id) {
            if (this.state.user_id !== DETAILS?.user_id) {
              let flight_no_date = ''
              if (DATA[flight_index]?.dept_time)
                flight_no_date = `${DATA[flight_index]?.flight_no}/${moment(DATA[flight_index]?.dept_time).format(dateOnly)}`
              else
                flight_no_date = `${DATA[flight_index]?.flight_no}/${moment(DATA[flight_index]?.flight_date).format(dateOnly)}`
              notification.destroy()
              if (UPDATE_TYPE === 'DETAILS') {
                notification.warning({ message: `Flight ${flight_no_date} details was updated.` })
              } else if (UPDATE_TYPE === 'PLAN') {
                notification.warning({ message: 'Load plan details were updated' })
              }
            } else {
              //SET RECORD EDIT IF OPEN (MAY NOT BE NEEDED)
              this.setEdit(DATA[flight_index], UPDATE_TYPE)
            }
          }

          this.sort(DATA, false)
        } else {
          //UPDATE RECORD IF NOT IN CURRENT LIST
          this.fetchIndividualFlight(parseInt(DETAILS?.flight_id)).then((item) => {
            if (item) {
              DATA = cloneDeep(this.state.flightData)
              DATA.push(this.processIndividualFlight(item))
              this.setState({ flightData: DATA }, () => this.updateFlightDetails(DETAILS, UPDATE_TYPE))
            }
          })
        }
      } else {
        //IF FLIGHT DOES NOT EXIST IN CURRENT LIST AND IS BEING EDITED ON SEARCH, THEN UPDATE DETAILS/PLAN
        let editingRecord = this.state.editRecord
        if (editingRecord?.id) {
          if (UPDATE_TYPE === 'DETAILS') {
            editingRecord = this.processIndividualFlight(this.parseFlight(this.state.editRecord, DETAILS))
          } else if (UPDATE_TYPE === 'PLAN') {
            editingRecord.details = DETAILS?.details || []
            //GET LAST UPDATED INFO
          }
          if (DETAILS?.last_updated?.length > 0) {
            let user_obj = this.state.userList?.find((item) => item?.id === parseInt(DETAILS.last_updated[DETAILS.last_updated.length - 1]?.user_id))
            editingRecord.last_updated = DETAILS?.last_updated
            editingRecord.last_updated_by = `${user_obj?.name?.first_name} ${user_obj?.name?.last_name}` || ''
            editingRecord.last_updated_at = moment.utc(DETAILS.last_updated[DETAILS.last_updated.length - 1]?.updated_date).tz(this.state.timezone).format(dateTimeFormat) || ''
            editingRecord.last_updated_ppr = `${user_obj?.ppr}` || ''
          }

          //CHECK IF EDITING RECORD MATCHES FETCHED FLIGHT RECORD
          if (editingRecord?.id === parseInt(DETAILS?.flight_id)) {
            if (this.state.user_id !== DETAILS?.user_id) {
              // let flight_no_date = `${DATA[flight_index]?.flight_no}/${moment(DATA[flight_index]?.flight_date).format(dateOnly)}`
              notification.destroy()
              if (UPDATE_TYPE === 'DETAILS') {
                // notification.warning({ message: `Flight ${flight_no_date} details was updated.` })
                notification.warning({ message: 'Flight details was updated.' })
              } else if (UPDATE_TYPE === 'PLAN') {
                notification.warning({ message: 'Load plan details were updated' })
              }
            } else {
              //SET RECORD EDIT IF OPEN (MAY NOT BE NEEDED)
              this.setEdit(editingRecord, UPDATE_TYPE)
            }
          }
        }
      }
    }
  }
  //FETCH INDIVIDUAL FLIGHT
  fetchIndividualFlight = async (ID) => {
    let headers = { station: this.state.station }
    let obj = null
    await Http.get(`flight_control_list?id=${ID}`, { headers }).then(resp => {
      if (resp?.status === 200) {
        if (resp?.data?.data?.length > 0) {
          obj = resp?.data?.data[0]
        }
      }
    })
    return obj
  }
  //PARSE FLIGHT RECORD
  parseFlight = (flight, event_record) => {
    let flightObj = {
      bag: {},
      cargo: {},
      wgt: {},
    }

    flight.fcst = event_record?.fcst ? parseInt(event_record?.fcst) : 0
    flight.bu_prio = event_record?.bu_prio === 'true' || event_record?.bu_prio === true ? true : false
    flight.load_plan = event_record?.load_plan === 'true' || event_record?.load_plan === true ? true : false

    flightObj.bag.p96 = event_record?.bag?.p96 ? parseInt(event_record.bag.p96) : 0
    flightObj.bag.p88 = event_record?.bag?.p88 ? parseInt(event_record.bag.p88) : 0
    flightObj.bag.ld3 = event_record?.bag?.ld3 ? parseInt(event_record.bag.ld3) : 0
    flightObj.bag.ld2 = event_record?.bag?.ld2 ? parseInt(event_record.bag.ld2) : 0
    flight.bag = flightObj.bag

    flightObj.cargo.md = event_record?.cargo?.md ? parseInt(event_record.cargo.md) : 0
    flightObj.cargo.p96 = event_record?.cargo?.p96 ? parseInt(event_record.cargo.p96) : 0
    flightObj.cargo.p88 = event_record?.cargo?.p88 ? parseInt(event_record.cargo.p88) : 0
    flightObj.cargo.ld3 = event_record?.cargo?.ld3 ? parseInt(event_record.cargo.ld3) : 0
    flightObj.cargo.ld2 = event_record?.cargo?.ld2 ? parseInt(event_record.cargo.ld2) : 0
    flight.cargo = flightObj.cargo

    flightObj.wgt.value = event_record?.wgt?.value ? parseFloat(event_record.wgt.value) : 0
    flightObj.wgt.unit = event_record?.wgt?.unit
    flight.wgt = flightObj.wgt
    return flight
  }
  // Append DL is not present
  checkPrefix = async () => {
    let fltno = this.state.searchFlightNo
    if (fltno.includes('DL')) {
      //do nothing
    } else if (fltno) {
      this.setState({ searchFlightNo: 'DL' + fltno })
    }
  }
  //FETCH FLIGHT DATA ON SEARCH
  fetchFlightOnSearch = async () => {
    let headers = { station: this.state.station }
    if (this.state.searchFlightNo && this.state.searchDate) {
      let date = moment(this.state.searchDate).format(dateFormat)
      await Http.get(`flight_control_list?flight_no=${this.state.searchFlightNo}&flight_date=${date}`, { headers }).then((resp) => {
        this.setState({ modalLoading: false })
        if (resp && resp?.data && resp?.data?.data?.length > 0) {
          this.setEdit(this.processIndividualFlight(resp?.data?.data[resp?.data?.data?.length - 1]))
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: resp?.data?.message,
          })
        }
      }).catch(() => {
        this.setState({
          servererror: true,
          modalLoading: false,
        }, () => {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: constants.SERVER_CONNECTION_ERROR,
          })
        })
      })
    } else {
      this.setState({ modalLoading: false }, () => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: 'Invalid Input',
        })
      })
    }
  }
  //PRODCESS INDIVDUAL FLIGHT
  processIndividualFlight = (flight) => {
    //NOTES
    flight.notes = flight?.notes_count || 0
    flight.checklist_notes = flight?.checklist_notes_count || 0
    flight.notes_date = flight.notes_date ? moment.utc(flight.notes_date).tz(this.state.timezone).format(completeDateTime) : null
    //CALCULATE DEPARTURE TIME
    flight.dept_time = ''
    flight.schdl = ''
    flight.dept_prefix = 'S'
    flight.fpe = this.getFPE(flight)
    if (flight?.dept) {
      if (flight?.dept?.act) {
        flight.dept_prefix = 'A'
        flight.dept_time = moment.utc(flight.dept.act).tz(this.state.timezone).valueOf()
      }
      else if (flight?.dept?.eta) {
        flight.dept_prefix = 'E'
        flight.dept_time = moment.utc(flight.dept.eta).tz(this.state.timezone).valueOf()
      }
      else if (flight?.dept?.schdl) {
        flight.dept_prefix = 'S'
        flight.dept_time = moment.utc(flight.dept.schdl).tz(this.state.timezone).valueOf()
      } else if (flight?.dept_date) {
        flight.dept_time = moment.utc(flight.dept_date).tz(this.state.timezone).valueOf()
      } else {
        flight.dept_time = moment(flight.flight_date).valueOf()
      }
    } else if (flight?.dept_date) {
      flight.dept_time = moment.utc(flight.dept_date).tz(this.state.timezone).valueOf()
    } else {
      flight.dept_time = moment(flight.flight_date).valueOf()
    }

    if (flight?.dept_date) {
      flight.schdl = moment.utc(flight.dept_date).tz(this.state.timezone).valueOf()
    } else if (flight?.dept?.schdl) {
      flight.schdl = moment.utc(flight.dept.schdl).tz(this.state.timezone).valueOf()
    }
    //CALCULATE BOOKED WEIGHT
    flight.booked_kg = 0
    flight.booked_lbs = 0

    let uniqueULDNo = []
    if (flight?.ulds_out?.length > 0) {
      flight.ulds_out.map((uld) => {
        if (uld?.awbs_in?.length > 0) {
          uld.awbs_in.map((item) => {
            uniqueULDNo.push(item?.awb_no)
            let unit = item?.wgt?.unit
            if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
              flight.booked_lbs += parseFloat(item?.wgt?.value)
              flight.booked_kg += weightCalculator(parseFloat(item?.wgt?.value), 'LBS')
            } else if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
              flight.booked_kg += parseFloat(item?.wgt?.value)
              flight.booked_lbs += weightCalculator(parseFloat(item?.wgt?.value), 'KGM')
            }
          })
        }
      })
    }

    if (flight?.awb_segments?.length > 0) {
      flight.awb_segments.map((seg) => {
        if (!uniqueULDNo?.includes(seg?.awb_no)) {
          uniqueULDNo.push(seg?.awb_no)
          let unit = seg?.awb?.weight_unit
          if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
            flight.booked_lbs += parseFloat(seg?.space?.wgt)
            flight.booked_kg += weightCalculator(parseFloat(seg?.space?.wgt), 'LBS')
          } else if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
            flight.booked_kg += parseFloat(seg?.space?.wgt)
            flight.booked_lbs += weightCalculator(parseFloat(seg?.space?.wgt), 'KGM')
          }
        }
      })
    }
    //CALCULATE BUILD UP WEIGHT
    flight.ready_kg = 0
    flight.ready_lbs = 0
    flight.gate_kg = 0
    flight.gate_lbs = 0
    if (flight?.ulds_out?.length > 0) {
      flight.ulds_out.map((uld) => {
        uld.type = this.checkULDType(uld)
        if (uld?.awbs_in?.length > 0) {
          uld.awbs_in.map((awb) => {
            let unit = awb?.wgt?.unit
            let value = awb?.wgt?.value
            if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
              if (!uld?.blk) {
                flight.ready_lbs += parseFloat(value)
                flight.ready_kg += weightCalculator(parseFloat(value), 'LBS')
              } else {
                if ((awb?.man && (uld?.type === 'BLK' || uld?.blk)) || (uld?.type === 'CART')) {
                  flight.ready_lbs += parseFloat(value)
                  flight.ready_kg += weightCalculator(parseFloat(value), 'LBS')
                }
              }
              // if(!uld?.blk) {
              //   if(uld?.rdy) {
              //     flight.ready_lbs += parseFloat(value)
              //     flight.ready_kg += weightCalculator(parseFloat(value), 'LBS')
              //   }
              // } else {
              //   if(awb?.man || (uld?.uld_no?.startsWith('C') && uld?.uld_no?.endsWith('#'))) {
              //     flight.ready_lbs += parseFloat(value)
              //     flight.ready_kg += weightCalculator(parseFloat(value), 'LBS')
              //   }
              // }

              if (awb?.location?.startsWith('0') && awb?.inbound && (awb?.prev_location !== null && awb?.prev_location !== 'UNKNOWN')) {
                flight.gate_lbs += parseFloat(value)
                flight.gate_kg += weightCalculator(parseFloat(value), 'LBS')
              }
            } else if (unit === 'K' || unit === 'KG' || unit === 'KGM') {
              if (!uld?.blk) {
                flight.ready_kg += parseFloat(value)
                flight.ready_lbs += weightCalculator(parseFloat(value), 'KGM')
              } else {
                if ((awb?.man && (uld?.type === 'BLK' || uld?.blk)) || (uld?.type === 'CART')) {
                  flight.ready_kg += parseFloat(value)
                  flight.ready_lbs += weightCalculator(parseFloat(value), 'KGM')
                }
              }
              // if(!uld?.blk) {
              //   if(uld?.rdy) {
              //     flight.ready_kg += parseFloat(value)
              //     flight.ready_lbs += weightCalculator(parseFloat(value), 'KGM')
              //   }
              // } else {
              //   if(awb?.man || (uld?.uld_no?.startsWith('C') && uld?.uld_no?.endsWith('#'))) {
              //     flight.ready_kg += parseFloat(value)
              //     flight.ready_lbs += weightCalculator(parseFloat(value), 'KGM')
              //   }
              // }

              if (awb?.location?.startsWith('0') && awb?.inbound && (awb?.prev_location !== null && awb?.prev_location !== 'UNKNOWN')) {
                flight.gate_kg += parseFloat(value)
                flight.gate_lbs += weightCalculator(parseFloat(value), 'KGM')
              }
            }
          })
        }
      })
    }
    //CALCULATE COUNTDOWN TIMER
    let time_left = moment(flight.dept_time).diff(moment().tz(this.state.timezone), 'minutes')
    //SUBTRACT FPE
    time_left = time_left - (1 * (flight.fpe || 0))
    flight.time_to_dept = moment().add(time_left, 'minutes').format('YYYY-MM-DD HH:mm:ss')
    //CALCULATE PAX CAPACITY, CONT TYPE, AFT AND FWS CONFIG.
    flight.pax_cap = 0
    flight.aft_conf = null
    flight.fwd_conf = null
    flight.cont_type = []
    flight.acpt_body = true
    if (this.state.fleetData?.length > 0) {
      let filter = this.state.fleetData.filter((item) => item?.details?.ac_code === flight?.ac_type)
      if (filter?.length > 0) {
        flight.fleet = filter[0]?.details?.fleet
        flight.pax_cap = filter[0]?.details?.pax_cap
        flight.aft_conf = filter[0]?.details?.aft_conf
        flight.fwd_conf = filter[0]?.details?.fwd_conf
        flight.cont_type = filter[0]?.details?.cont_type?.split(',') || []
        flight.acpt_body = filter[0]?.details?.ac_type === 'WB' ? true : false
      }
    }
    //CALC FLIGHT WEIGHT
    let unit = flight?.wgt?.unit
    let value = flight?.wgt?.value
    if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
      flight.weight_lbs = parseFloat(value) //ROUNDED TO NEAREST INTEGER
      flight.weight_kg = weightCalculator(parseFloat(value), 'LBS')
    } else if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
      flight.weight_kg = parseFloat(value) //ROUNDED TO NEAREST INTEGER
      flight.weight_lbs = weightCalculator(parseFloat(value), 'KGM')
    }
    //GET LAST UPDATED INFO
    flight.last_updated_by = ''
    flight.last_updated_at = ''
    flight.last_updated_ppr = ''
    if (flight?.last_updated?.length > 0) {
      let user_obj = this.state.userList?.find((item) => item?.id === parseInt(flight.last_updated[flight.last_updated.length - 1]?.user_id))
      flight.last_updated_by = `${user_obj?.name?.first_name} ${user_obj?.name?.last_name}` || ''
      flight.last_updated_at = moment.utc(flight.last_updated[flight.last_updated.length - 1]?.updated_date).tz(this.state.timezone).format(dateTimeFormat) || ''
      flight.last_updated_ppr = `${user_obj?.ppr}` || ''
    }
    //STORE ULDS FOR NOT TENDERED SUMMARY
    flight.not_tendered = {
      blk_count: 0,
      weight_lbs: 0,
      weight_kg: 0,
      pcs: 0,
      md: 0,
      udp: 0,
      ldc: 0,
      ldp: 0,
    }
    let notTenderedArr = []
    flight?.awb_segments?.map(ar => {
      flight?.ulds_out?.find(uld => {
        if (!uld?.awbs_in?.find(awb => awb.awb_no === ar.awb_no)) {
          notTenderedArr.push(ar)
        }
      })
    })
    if (notTenderedArr?.length > 0) {
      let blk_count = 0
      let weight_lbs = 0
      let weight_kg = 0
      let pcs = 0

      notTenderedArr?.map((item) => {
        if (item?.space?.udp || item?.space?.ldc || item?.space?.ldp) {
          flight.not_tendered.udp = flight.not_tendered.udp + parseInt(item?.space?.udp || 0)
          flight.not_tendered.ldc = flight.not_tendered.ldc + parseInt(item?.space?.ldc || 0)
          flight.not_tendered.ldp = flight.not_tendered.ldp + parseInt(item?.space?.ldp || 0)
        } else {
          blk_count += 1
          pcs += parseFloat(item?.space?.vol || 0) || 0
          // if(item?.vol?.unit === 'FTQ') {
          //   pcs += parseFloat(item?.space?.vol || 0)
          // } else if(item?.vol?.unit === 'MTQ') {
          //   pcs += parseFloat((item?.space?.vol || 0) * 35.314667)
          // } else if(item?.vol?.unit === 'CF') {
          //   pcs += parseFloat(item?.space?.vol || 0)
          // }
          if (item.awb.weight_unit === 'L' || item.awb.weight_unit === 'LB' || item.awb.weight_unit === 'LBS' || item.awb.weight_unit === 'LBR') {
            weight_lbs += item.space.wgt //ROUNDED TO NEAREST INTEGER
            weight_kg += weightCalculator(item.space.wgt, 'LBS')
          } else if (item.awb.weight_unit === 'K' || item.awb.weight_unit === 'KG' || item.awb.weight_unit === 'KGS' || item.awb.weight_unit === 'KGM') {
            weight_kg += item.space.wgt //ROUNDED TO NEAREST INTEGER
            weight_lbs += weightCalculator(item.space.wgt, 'KGM')
          }
        }
      })
      flight.not_tendered.blk_count = blk_count
      flight.not_tendered.weight_lbs = weight_lbs
      flight.not_tendered.weight_kg = weight_kg
      flight.not_tendered.pcs = pcs?.toFixed(2) || 0
    }

    //GET ACTUAL ULD POSITIONS
    let ULDs = []
    flight.unique_ulds = []
    if (flight?.ulds_out?.length > 0) {
      flight.ulds_out.map((uld) => {
        uld.position_obj = this.state.uldMappingData?.find((item) => item?.uld_prefix === uld?.uld_no?.slice(0, 3) && item?.ac_types?.includes(flight?.ac_type)) || null
        ULDs.push(uld)
      })
    }

    //GET UNIQUE ULDS AND CALC ULD POSITIONS LOGIC
    flight.unique_ulds = [...new Map(ULDs.map(item => [item?.uld_no, item])).values()]
    let uldPositionsObj = this.calcULDPositions(flight)
    flight.actual = {
      MD: uldPositionsObj?.MD,
      P96: uldPositionsObj?.P96,
      P88: uldPositionsObj?.P88,
      LD3: uldPositionsObj?.LD3,
      LD2: uldPositionsObj?.LD2,
    }

    //FLIGHT TARE WEIGHT AND ADD TO READY WEIGHT
    flight.tare_wgt_kg = this.addTareWgt(flight)?.weight_kg || 0
    flight.tare_wgt_lbs = this.addTareWgt(flight)?.weight_lbs || 0
    flight.ready_kg += parseFloat(flight.tare_wgt_kg)
    flight.ready_lbs += parseFloat(flight.tare_wgt_lbs)
    flight.cccolour = ''
    flight.cccolour_css = ''
    let weight_assigned = this.state.weight_unit === 'KG' ? flight?.booked_kg : flight?.booked_lbs
    let weight_cargo = this.state.weight_unit === 'KG' ? flight?.weight_kg : flight?.weight_lbs
    if (!flight?.bag) {
      if (weight_cargo > 0) {
        if (weight_assigned > weight_cargo) {
          flight.cccolour_css = 'p-icon cc-icon fs-0 amber-cc' //SHOW YELLOW
          flight.cccolour = 'amber'
        } else {
          flight.cccolour_css = 'p-icon cc-icon fs-0 green-cc' //SHOW GREEN
          flight.cccolour = 'green'
        }
      } else {
        flight.cccolour_css = 'p-icon cc-icon fs-0' //SHOW BLUE
        flight.cccolour = 'blue'
      }
    } else if (flight?.bag && flight?.cargo && flight?.cargo?.md === 0 && flight?.cargo?.p96 === 0 && flight?.cargo?.p88 === 0 && flight?.cargo?.ld3 === 0 && flight?.cargo?.ld2 === 0) {
      if (weight_cargo > 0) {
        if (weight_assigned > weight_cargo) {
          flight.cccolour_css = 'p-icon cc-icon fs-0 amber-cc' //SHOW YELLOW
          flight.cccolour = 'amber'
        } else {
          flight.cccolour_css = 'p-icon cc-icon fs-0 green-cc' //SHOW GREEN
          flight.cccolour = 'green'
        }
      } else {
        flight.cccolour_css = 'p-icon cc-icon fs-0' //SHOW BLUE
        flight.cccolour = 'blue'
      }
    } else {
      if (((flight?.cargo?.md || 0) - (flight?.actual?.MD || 0)) < 0 ||
        ((flight?.cargo?.p96 || 0) - (flight?.actual?.P96 || 0)) < 0 ||
        ((flight?.cargo?.p88 || 0) - (flight?.actual?.P88 || 0)) < 0 ||
        ((flight?.cargo?.ld3 || 0) - (flight?.actual?.LD3 || 0)) < 0 ||
        ((flight?.cargo?.ld2 || 0) - (flight?.actual?.LD2 || 0)) < 0) {
        flight.cccolour_css = 'p-icon cc-icon fs-0 red-cc' //SHOW RED
        flight.cccolour = 'red'
      } else {
        if (weight_cargo > 0 && (weight_assigned > weight_cargo)) {
          flight.cccolour_css = 'p-icon fs-0 amber-cc' //SHOW YELLOW
          flight.cccolour = 'amber'
        } else if (((flight?.cargo?.md || 0) - (flight?.actual?.MD || 0)) > 0 ||
          ((flight?.cargo?.p96 || 0) - (flight?.actual?.P96 || 0)) > 0 ||
          ((flight?.cargo?.p88 || 0) - (flight?.actual?.P88 || 0)) > 0 ||
          ((flight?.cargo?.ld3 || 0) - (flight?.actual?.LD3 || 0)) > 0 ||
          ((flight?.cargo?.ld2 || 0) - (flight?.actual?.LD2 || 0)) > 0) {
          flight.cccolour_css = 'p-icon cc-icon fs-0 green-cc'
          flight.cccolour = 'green'
        } else {
          flight.cccolour_css = 'p-icon cc-icon fs-0' //SHOW Blue
          flight.cccolour = 'blue'
        }
      }
    }
    return flight
  }
  //ADDING TARE WEIGHT TO FLIGHT
  addTareWgt = (flight) => {
    let weight_kg = 0
    let weight_lbs = 0
    if (flight?.unique_ulds?.length > 0) {
      flight?.unique_ulds?.map((item) => {
        if ((item?.uld_type !== 'CART') && item?.position_obj?.ac_types?.includes(flight?.ac_type)) {
          let unit = item?.position_obj?.weight?.unit
          let value = item?.position_obj?.weight?.value
          if (unit === 'LBS' || unit === 'L' || unit === 'LB' || unit === 'LBR') {
            weight_lbs += value //ROUNDED TO NEAREST INTEGER
            weight_kg += weightCalculator(value, 'LBS')
          } else if (unit === 'K' || unit === 'KG' || unit === 'KGM') {
            weight_kg += value //ROUNDED TO NEAREST INTEGER
            weight_lbs += weightCalculator(value, 'KGM')
          }
        }
      })
    }
    return {
      weight_kg: weight_kg,
      weight_lbs: weight_lbs,
    }
  }
  //CALCULATE ULD POSITIONS
  calcULDPositions = (flight) => {
    let a_md = 0
    let a_p96 = 0
    let a_p88 = 0
    let a_ld3 = 0
    let a_ld2 = 0

    if (flight?.unique_ulds?.length > 0) {
      flight?.unique_ulds?.map((item) => {
        if ((!item?.uld_no?.startsWith('C') && !item?.uld_no?.endsWith('#')) && item?.position_obj?.ac_types?.includes(flight?.ac_type)) {
          switch (item?.position_obj?.uldtype) {
          case 'MD':
            a_md += item?.position_obj?.position
            break
          case 'P96':
            a_p96 += item?.position_obj?.position
            break
          case 'P88':
            a_p88 += item?.position_obj?.position
            break
          case 'LD3':
            a_ld3 += item?.position_obj?.position
            break
          case 'LD2':
            a_ld2 += item?.position_obj?.position
            break
          default:
            break
          }
        }
      })
    }
    return {
      MD: a_md,
      P96: a_p96,
      P88: a_p88,
      LD3: a_ld3,
      LD2: a_ld2,
    }
  }
  //CALCULATE FLIGHT FPE
  getFPE = (flight) => {
    let fpe = 0
    let dest_type = ''

    let details = this.state.stationsData?.find((stn) => stn?.code === flight?.dest?.arriv) || ''
    if (details) {
      if (country.includes(details?.country?.toUpperCase())) {
        dest_type = 'EXPORT-D'
      } else {
        dest_type = 'EXPORT-I'
      }

      let ht = this.state.defaultSystemParameters?.find((item) => item?.details?.process?.toUpperCase() === dest_type)
      if (ht && ht.dest_list && ht.dest_list.length > 0) {
        let index = ht.dest_list.findIndex((p) => p.dest === flight?.dest?.arriv)
        if (index > -1) {
          fpe = ht.dest_list[index].fpe
        } else {
          fpe = this.state.defaultSystemParameters?.find((item) => item?.details?.process?.toUpperCase() === dest_type)?.details?.fpe
        }
      } else {
        fpe = this.state.defaultSystemParameters?.find((item) => item?.details?.process?.toUpperCase() === dest_type)?.details?.fpe
      }
    }
    return fpe
  }
  //UPDATE NOTES COUNT
  updateFlightNotesCount = (DETAILS) => {
    let DATA = cloneDeep(this.state.flightData)
    let flight_index = DATA?.findIndex(p => p.id == parseInt(DETAILS?.type?.toUpperCase() === 'CHECKLIST' ? DETAILS?.checklist_id : DETAILS?.flights_id))
    if (flight_index > -1) {
      if (DETAILS?.type?.toUpperCase() === 'FLIGHT') {
        DATA[flight_index].notes = DETAILS?.notes?.length || 0
        DATA[flight_index].notes_date = DETAILS?.timestamp ? moment.utc(DETAILS.timestamp).tz(this.state.timezone).format(completeDateTime) : null
        this.sort(DATA, false)
      } else if (DETAILS?.type?.toUpperCase() === 'CHECKLIST') {
        DATA[flight_index].checklist_notes_count = DETAILS?.checklist_notes?.length || 0
        this.setState({ flightData: [] }, () => this.setState({ flightData: this.sortDodCC(DATA, false) }))
      }
    }
  }

  //DISABLE PRE DEPARTURE NOTES IF FLIGHT HAS DEPARTED
  disableNote = (dept_time) => {
    return moment.tz(dept_time, this.state.timezone).diff(moment().tz(this.state.timezone), 'minutes') < 0
  }
  //UPDATE WEIGHT ON TOGGLE
  updateWeightVal = (unit, value) => {
    value = parseFloat(value || 0)
    if (value > 0) {
      if (unit === 'LB') {
        return weightCalculator(parseFloat(value || 0), 'KGM')?.toFixed(2)
      } else if (unit === 'KG') {
        return weightCalculator(parseFloat(value || 0), 'LBS')?.toFixed(2)
      }
    }
  }

  updateVolumeVal = (unit, value) => {
    if (value > 0) {
      if (unit === 'CBM') {
        return volumnCalculator(parseFloat(value || 0), 'CBF')?.toFixed(2)
      } else if (unit === 'CBF' || unit === 'CFT') {
        return volumnCalculator(parseFloat(value || 0), 'CBM')?.toFixed(2)
      }
    }
  }

  // Start of CheckList APIs
  //FETCH MILESTONES
  fetchMilestones = async () => {
    let callback = this.fetchMilestonesFn
    let pageURL = 'milestones'
    let headers = {}
    cacheRetrieve(callback, pageURL, headers)
  }
  fetchMilestonesFn = async (resp, event) => {
    if (!event) this.setState({ loading: true })
    const respData = await resp.json()
    if (respData && respData?.data?.length > 0) {
      respData.data = respData?.data.map((item) => {
        item.label = item.title
        item.value = item.title
        return item
      })
      let noride = {
        amber: null,
        cutoff: 0,
        id: 'No Ride Alert',
        priority: null,
        title: 'No Ride Alert',
        type: 'No Rides',
        label: 'No Ride Alert',
        value: 'No Ride Alert',
      }
      respData?.data.push(noride)
      let milestoneFBData = cloneDeep(respData?.data)
      milestoneFBData.push({
        id: 'Interacted with LDD',
        label: 'Interacted with LDD',
        value: 'Interacted with LDD',
      })
      milestoneFBData.push({
        id: 'Flight Audit',
        label: 'Flight Audit',
        value: 'Flight Audit',
      })
      this.setState({
        milestoneData: respData?.data,
        milestoneFBData: milestoneFBData,
      })
    } else {
      this.setState({
        milestoneData: [],
        milestoneFBData: [],
      })
    }
    if (!event) this.fetchDefaultSystemParameters()
    // else {
    //   this.processChecklistData()
    // }
  }

  fetchAllQuestions = async () => {
    let headers = { station: this.state.station }
    await Http.get('questions?type=all', { headers }).then(resp => {
      if (resp?.status === 200) {
        if (resp?.data?.data?.length > 0) {
          let data = resp?.data?.data

          this.setState({ allQuestionsData: data })
        } else {
          this.setState({ allQuestionsData: [] })
        }
      }
    })
  }
  fetchQuestions = async (flight_id, ms_id, event) => {
    let headers = { station: this.state.station }
    //completedBy currenrt user's name
    let completedBy = cookies.get('name')
    let completedById = cookies.get('user')
    Promise.all([
      await Http.get(`questions?&ms_id=${ms_id}`, { headers }),
      await Http.get(`answers?&flight_id=${flight_id}&milestones_id=${ms_id}`, { headers }),
    ])
      .then(([questions, answers]) => {
        let questionsArr = []
        questions = questions?.data?.data
        answers = answers?.data?.data
        if (answers?.updatedby?.name) {
          completedById = answers.updatedBy
          completedBy = answers.updatedby.name.first_name + ' ' + answers.updatedby.name.last_name
        }
        if (questions && questions.length > 0 && answers && answers.answers.length > 0) {
          if (event) {
            let flights = this.state.flightData
            let flight_index = flights.findIndex((flight) => flight.id === flight_id)
            if (flight_index > -1) {
              if (!flights[flight_index].answers) {
                flights[flight_index].answers = []
              }
              let answers_index = flights[flight_index].answers.findIndex((answer) => answer.milestones_id === ms_id)
              if (answers_index > -1) {
                flights[flight_index].answers[answers_index] = answers
              } else {
                flights[flight_index].answers.push(answers)
              }
              flights[flight_index] = this.processIndividualFlightChecklist(flights[flight_index])
              this.setState({ flightData: [] }, () => this.setState({ flightData: flights }))
            }
          }
          questions.map((question, index) => {
            let answer = answers.answers.find((answer) => answer.question_id === question.id)
            questions[index].answer = answer?.answer || null
            questions[index].comment = answer?.comment || null
            questions[index].answer_attach_conf = answer?.answer_attach_conf || null
            questions[index].answer_attach_data = answer?.answer_attach_data || null
            questions[index].has_attachment = answer?.has_attachment || false
            questionsArr.push(questions[index])
            if (questions[index].details.nested === 'Yes') {
              questions[index].parent?.map((child) => {
                let nestedanswer = answers.answers.find((answer) => answer.question_id === child.id)
                child.answer = nestedanswer?.answer || null
                child.comment = nestedanswer?.comment || null
                child.showchild = answer?.answer === 'Yes' ? true : false
                child.answer_attach_conf = nestedanswer?.answer_attach_conf || null
                child.answer_attach_data = nestedanswer?.answer_attach_data || null
                child.has_attachment = nestedanswer?.has_attachment || false
                questionsArr.push(child)
              })
            }
          })
          let quizModalFlight = cloneDeep(this.state.quizModalFlight)
          if (quizModalFlight) {
            if (!quizModalFlight.answers) {
              quizModalFlight.answers = []
            }
            quizModalFlight.answers = answers || []
          }
          this.setState({
            openQuizModal: event ? false : true,
            questionsData: event ? [] : questionsArr,
            tempquestionsData: event ? [] : questionsArr,
            quizModalFlight: event ? null : quizModalFlight,
            milestonButton: 'Resubmit',
            completedBy,
            completedById
          })
        } else if (questions && questions.length > 0) {
          let questionsArr = []
          questions.map((question) => {
            questionsArr.push(question)
            if (question.details.nested === 'Yes') {
              question.parent && question.parent.map((child) => {
                child.showchild = false
                questionsArr.push(child)
              })
            }
          })
          this.setState({
            openQuizModal: event ? null : true,
            questionsData: event ? [] : questionsArr,
            tempquestionsData: event ? [] : questionsArr,
            milestonButton: 'Submit',
            completedBy,
            completedById
          })
        } else {
          notification.destroy()
          notification.warning({
            message: 'Warning',
            description: 'No Questions Found',
          })
          this.setState({
            questionsData: [],
            tempquestionsData: [],
            completedBy,
            completedById
          })
        }
      })
  }

  //FETCH FLIGHT CHECKLIST
  fetchFlightsChecklist = async (search = null, fid = null) => {
    let temp_timestamp = moment().valueOf()
    this.setState({
      loading: search || this.state.page === 1 ? true : false,
      latestTimestamp: temp_timestamp,
      page: search ? 1 : this.state.page,
    })
    let headers = { station: this.state.station }

    let start_date = moment.tz((isMoment(this.state.start_checklist) ? this.state.start_checklist.format(dateFormat) : this.state.start_checklist) + ' ' + this.state.stime_checklist.format(timeFormat), this.state.timezone).utc()
    let end_date = moment.tz((isMoment(this.state.end_checklist) ? this.state.end_checklist.format(dateFormat) : this.state.end_checklist) + ' ' + this.state.etime_checklist.format(timeFormat), this.state.timezone).utc()
    let start = this.state.start_checklist ? start_date.format(dateFormat) : ''
    let end = this.state.end_checklist ? end_date.format(dateFormat) : ''
    let stime = this.state.stime_checklist ? start_date.format(timeFormat) : ''
    let etime = this.state.etime_checklist ? end_date.format(timeFormat) : ''
    let url = 'flight_control_list'
    if (search) {
      url = url + search + `&start=${start}&end=${end}&stime=${stime}&etime=${etime}&type=checklist`
    } else if (fid) {
      url = url + `?id=${fid}`
    } else {
      url = url + `?start=${start}&end=${end}&stime=${stime}&etime=${etime}&page=${this.state.page}&count=10&type=checklist`
    }

    await Http.get(url, { headers }).then(resp => {
      if (this.state.latestTimestamp === temp_timestamp) {
        if (resp && resp.status === 200) {
          if (resp?.data?.data?.length > 0) {
            let data = []
            if (search === '' || search === null) {
              data = this.state.flightData?.concat(resp.data.data)
            } else {
              data = resp.data.data
            }
            //DUPLICATE DATA CHECK
            let newData = []
            data?.map((item, index) => {
              let id = newData.findIndex(p => p.id == parseInt(item.id))
              if (id > -1) {
                //DO NOTHING
                item.key = index
                newData[id] = item
              } else {
                item.key = index
                newData.push(item)
              }
            })
            newData = newData.map((flight) => {
              return { ...this.processIndividualFlightChecklist(flight) }
            })
            let destStations = newData?.map((flight) => flight?.dest?.arriv || flight?.dest_stn)
            let destStationsArr = [...new Set(destStations)]
            destStationsArr.sort()
            // this.sort(newData, true)
            this.setState({
              loading: false,
              flightData: this.sortDodCC(newData),
              destStations: destStationsArr,
              page: search ? 1 : fid ? this.state.page : this.state.page + 1,
            }, () => {
              if (this.state.departedFlightsCheck) {
                this.departedFlightsFilter()
              }
              if (!search && !fid) {
                this.fetchFlightsChecklist()
              }
            })
          } else {
            if (this.state.page > 1) {
              //DO NOTHING
            } else {
              this.setState({
                flightData: [],
                loading: false
              }, () => {
                notification.destroy()
                notification.error({
                  message: constants.NO_DATA_ERROR,
                  description: resp?.data?.message,
                })
              })
            }
          }
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: constants.SERVER_CONNECTION_ERROR,
          })
          this.setState({ loading: false })
        }
      }
    }).catch(() => {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: constants.SERVER_CONNECTION_ERROR,
      })
      this.setState({
        loading: false,
        servererror: true
      })
    })
  }

  //PRODCESS INDIVDUAL FLIGHT CHECKLIST
  processIndividualFlightChecklist = (flight) => {
    //NOTES
    flight.notes = flight?.notes_count || 0
    flight.checklist_notes_count = flight?.checklist_notes_count || 0
    flight.notes_date = flight.notes_date ? moment.utc(flight.notes_date).tz(this.state.timezone).format(completeDateTime) : null
    //CALCULATE DEPARTURE TIME
    flight.dept_time = ''
    flight.arr_time = ''
    flight.schdl = ''
    flight.dept_prefix = 'S'
    flight.fpe = this.getFPE(flight)
    if (flight?.dept) {
      if (flight?.dept?.act) {
        flight.dept_prefix = 'A'
        flight.dept_time = moment.utc(flight.dept.act).tz(this.state.timezone).valueOf()
      }
      else if (flight?.dept?.eta) {
        flight.dept_prefix = 'E'
        flight.dept_time = moment.utc(flight.dept.eta).tz(this.state.timezone).valueOf()
      }
      else if (flight?.dept?.schdl) {
        flight.dept_prefix = 'S'
        flight.dept_time = moment.utc(flight.dept.schdl).tz(this.state.timezone).valueOf()
      } else if (flight?.dept_date) {
        flight.dept_time = moment.utc(flight.dept_date).tz(this.state.timezone).valueOf()
      } else {
        flight.dept_time = moment(flight.flight_date).valueOf()
      }
    } else if (flight?.dept_date) {
      flight.dept_time = moment.utc(flight.dept_date).tz(this.state.timezone).valueOf()
    } else {
      flight.dept_time = moment(flight.flight_date).valueOf()
    }


    if (flight?.dept_date) {
      flight.schdl = moment.utc(flight.dept_date).tz(this.state.timezone).valueOf()
    } else if (flight?.dept?.schdl) {
      flight.schdl = moment.utc(flight.dept.schdl).tz(this.state.timezone).valueOf()
    }
    if (flight?.arriv_date) {
      flight.arr_time = moment.utc(flight.arriv_date).tz(this.state.timezone).valueOf()
    } else {
      flight.arr_time = moment(flight.flight_date).valueOf()
    }
    //CALCULATE BOOKED WEIGHT
    flight.booked_kg = 0
    flight.booked_lbs = 0

    let uniqueULDNo = []
    if (flight?.ulds_out?.length > 0) {
      flight.ulds_out.map((uld) => {
        if (uld?.awbs_in?.length > 0) {
          uld.awbs_in.map((item) => {
            uniqueULDNo.push(item?.awb_no)
            let unit = item?.wgt?.unit
            if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
              flight.booked_lbs += parseFloat(item?.wgt?.value)
              flight.booked_kg += weightCalculator(parseFloat(item?.wgt?.value), 'LBS')
            } else if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
              flight.booked_kg += parseFloat(item?.wgt?.value)
              flight.booked_lbs += weightCalculator(parseFloat(item?.wgt?.value), 'KGM')
            }
          })
        }
      })
    }

    if (flight?.awb_segments?.length > 0) {
      flight.awb_segments.map((seg, sindex) => {
        if (!uniqueULDNo?.includes(seg?.awb_no)) {
          uniqueULDNo.push(seg?.awb_no)
          let unit = seg?.awb?.weight_unit
          if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
            flight.booked_lbs += parseFloat(seg?.space?.wgt)
            flight.booked_kg += weightCalculator(parseFloat(seg?.space?.wgt), 'LBS')
          } else if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
            flight.booked_kg += parseFloat(seg?.space?.wgt)
            flight.booked_lbs += weightCalculator(parseFloat(seg?.space?.wgt), 'KGM')
          }
          if (flight.build_plan.length > 0) {
            let build_plan = flight.build_plan.find((item) => item?.awb_no === seg?.awb_no)
            if (build_plan) {
              if (build_plan.ulds.length > 0) {
                let tpcs = 0
                build_plan.ulds.map((uld) => {
                  tpcs += uld.pcs
                })
                flight.awb_segments[sindex].showred = parseInt(seg?.space?.pcs) === tpcs ? false : true
              }
            }
          }
        }
      })
    }
    //CALCULATE BUILD UP WEIGHT
    flight.ready_kg = 0
    flight.ready_lbs = 0
    flight.gate_kg = 0
    flight.gate_lbs = 0
    if (flight?.ulds_out?.length > 0) {
      flight.ulds_out.map((uld, uindex) => {
        uld.type = this.checkULDType(uld)
        if (uld?.awbs_in?.length > 0) {
          uld.awbs_in.map((awb, aindex) => {
            let unit = awb?.wgt?.unit
            let value = awb?.wgt?.value
            if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
              if (!uld?.blk) {
                flight.ready_lbs += parseFloat(value)
                flight.ready_kg += weightCalculator(parseFloat(value), 'LBS')
              } else {
                if ((awb?.man && (uld?.type === 'BLK' || uld?.blk)) || (uld?.type === 'CART')) {
                  flight.ready_lbs += parseFloat(value)
                  flight.ready_kg += weightCalculator(parseFloat(value), 'LBS')
                }
              }
              // if(!uld?.blk) {
              //   if(uld?.rdy) {
              //     flight.ready_lbs += parseFloat(value)
              //     flight.ready_kg += weightCalculator(parseFloat(value), 'LBS')
              //   }
              // } else {
              //   if(awb?.man || (uld?.uld_no?.startsWith('C') && uld?.uld_no?.endsWith('#'))) {
              //     flight.ready_lbs += parseFloat(value)
              //     flight.ready_kg += weightCalculator(parseFloat(value), 'LBS')
              //   }
              // }

              if (awb?.location?.startsWith('0') && awb?.inbound && (awb?.prev_location !== null && awb?.prev_location !== 'UNKNOWN')) {
                flight.gate_lbs += parseFloat(value)
                flight.gate_kg += weightCalculator(parseFloat(value), 'LBS')
              }
            } else if (unit === 'K' || unit === 'KG' || unit === 'KGM') {
              if (!uld?.blk) {
                flight.ready_kg += parseFloat(value)
                flight.ready_lbs += weightCalculator(parseFloat(value), 'KGM')
              } else {
                if ((awb?.man && (uld?.type === 'BLK' || uld?.blk)) || (uld?.type === 'CART')) {
                  flight.ready_kg += parseFloat(value)
                  flight.ready_lbs += weightCalculator(parseFloat(value), 'KGM')
                }
              }
              // if(!uld?.blk) {
              //   if(uld?.rdy) {
              //     flight.ready_kg += parseFloat(value)
              //     flight.ready_lbs += weightCalculator(parseFloat(value), 'KGM')
              //   }
              // } else {
              //   if(awb?.man || (uld?.uld_no?.startsWith('C') && uld?.uld_no?.endsWith('#'))) {
              //     flight.ready_kg += parseFloat(value)
              //     flight.ready_lbs += weightCalculator(parseFloat(value), 'KGM')
              //   }
              // }

              if (awb?.location?.startsWith('0') && awb?.inbound && (awb?.prev_location !== null && awb?.prev_location !== 'UNKNOWN')) {
                flight.gate_kg += parseFloat(value)
                flight.gate_lbs += weightCalculator(parseFloat(value), 'KGM')
              }
              if (flight.build_plan.length > 0) {
                let build_plan = flight.build_plan.find((item) => item?.awb_no === awb?.awb_no)
                if (build_plan) {
                  if (build_plan.ulds.length > 0) {
                    let tpcs = 0
                    build_plan.ulds.map((uld) => {
                      tpcs += uld.pcs
                    })
                    flight.ulds_out[uindex].awbs_in[aindex].showred = awb.pcs === tpcs ? false : true
                  }
                }
              }
            }
          })
        }
      })
    }
    //CALCULATE COUNTDOWN TIMER
    let time_left = moment(flight.dept_time).diff(moment().tz(this.state.timezone), 'minutes')
    //SUBTRACT FPE
    time_left = time_left - (1 * (flight.fpe || 0))
    flight.time_to_dept = moment().add(time_left, 'minutes').format('YYYY-MM-DD HH:mm:ss')
    //CALCULATE PAX CAPACITY, CONT TYPE, AFT AND FWS CONFIG.
    flight.pax_cap = 0
    flight.aft_conf = null
    flight.fwd_conf = null
    flight.cont_type = []
    flight.acpt_body = true
    if (this.state.fleetData?.length > 0) {
      let filter = this.state.fleetData.filter((item) => item?.details?.ac_code === flight?.ac_type)
      if (filter?.length > 0) {
        flight.fleet = filter[0]?.details?.fleet
        flight.pax_cap = filter[0]?.details?.pax_cap
        flight.aft_conf = filter[0]?.details?.aft_conf
        flight.fwd_conf = filter[0]?.details?.fwd_conf
        flight.cont_type = filter[0]?.details?.cont_type?.split(',') || []
        flight.acpt_body = filter[0]?.details?.ac_type === 'WB' ? true : false
      }
    }
    //CALC FLIGHT WEIGHT
    let unit = flight?.wgt?.unit
    let value = flight?.wgt?.value
    if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
      flight.weight_lbs = parseFloat(value) //ROUNDED TO NEAREST INTEGER
      flight.weight_kg = weightCalculator(parseFloat(value), 'LBS')
    } else if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
      flight.weight_kg = parseFloat(value) //ROUNDED TO NEAREST INTEGER
      flight.weight_lbs = weightCalculator(parseFloat(value), 'KGM')
    }
    //GET LAST UPDATED INFO
    flight.last_updated_by = ''
    flight.last_updated_at = ''
    flight.last_updated_ppr = ''
    if (flight?.last_updated?.length > 0) {
      let user_obj = this.state.userList?.find((item) => item?.id === parseInt(flight.last_updated[flight.last_updated.length - 1]?.user_id))
      flight.last_updated_by = `${user_obj?.name?.first_name} ${user_obj?.name?.last_name}` || ''
      flight.last_updated_at = moment.utc(flight.last_updated[flight.last_updated.length - 1]?.updated_date).tz(this.state.timezone).format(dateTimeFormat) || ''
      flight.last_updated_ppr = `${user_obj?.ppr}` || ''
    }
    //STORE ULDS FOR NOT TENDERED SUMMARY
    flight.not_tendered = {
      blk_count: 0,
      weight_lbs: 0,
      weight_kg: 0,
      pcs: 0,
      md: 0,
      udp: 0,
      ldc: 0,
      ldp: 0,
    }
    let notTenderedArr = []
    flight?.awb_segments?.filter(ar => {
      flight?.ulds_out?.find(uld => {
        if (!uld?.awbs_in?.find(awb => awb.awb_no === ar.awb_no)) {
          notTenderedArr.push(ar)
        }
      })
    })
    if (notTenderedArr?.length > 0) {
      let blk_count = 0
      let weight_lbs = 0
      let weight_kg = 0
      let pcs = 0

      notTenderedArr?.map((item) => {
        if (item?.space?.udp || item?.space?.ldc || item?.space?.ldp) {
          flight.not_tendered.udp = flight.not_tendered.udp + parseInt(item?.space?.udp || 0)
          flight.not_tendered.ldc = flight.not_tendered.ldc + parseInt(item?.space?.ldc || 0)
          flight.not_tendered.ldp = flight.not_tendered.ldp + parseInt(item?.space?.ldp || 0)
        } else {
          blk_count += 1
          pcs += parseFloat(item?.space?.vol || 0) || 0
          // if(item?.vol?.unit === 'FTQ') {
          //   pcs += parseFloat(item?.space?.vol || 0)
          // } else if(item?.vol?.unit === 'MTQ') {
          //   pcs += parseFloat((item?.space?.vol || 0) * 35.314667)
          // } else if(item?.vol?.unit === 'CF') {
          //   pcs += parseFloat(item?.space?.vol || 0)
          // }
          if (item.awb.weight_unit === 'L' || item.awb.weight_unit === 'LB' || item.awb.weight_unit === 'LBS' || item.awb.weight_unit === 'LBR') {
            weight_lbs += item.space.wgt //ROUNDED TO NEAREST INTEGER
            weight_kg += weightCalculator(item.space.wgt, 'LBS')
          } else if (item.awb.weight_unit === 'K' || item.awb.weight_unit === 'KG' || item.awb.weight_unit === 'KGS' || item.awb.weight_unit === 'KGM') {
            weight_kg += item.space.wgt //ROUNDED TO NEAREST INTEGER
            weight_lbs += weightCalculator(item.space.wgt, 'KGM')
          }
        }
      })
      flight.not_tendered.blk_count = blk_count
      flight.not_tendered.weight_lbs = weight_lbs
      flight.not_tendered.weight_kg = weight_kg
      flight.not_tendered.pcs = pcs?.toFixed(2) || 0
    }

    //GET ACTUAL ULD POSITIONS
    let ULDs = []
    flight.unique_ulds = []
    if (flight?.ulds_out?.length > 0) {
      flight.ulds_out.map((uld) => {
        uld.position_obj = this.state.uldMappingData?.find((item) => item?.uld_prefix === uld?.uld_no?.slice(0, 3) && item?.ac_types?.includes(flight?.ac_type)) || null
        ULDs.push(uld)
      })
    }
    //GET UNIQUE ULDS AND CALC ULD POSITIONS LOGIC
    flight.unique_ulds = [...new Map(ULDs.map(item => [item?.uld_no, item])).values()]
    let uldPositionsObj = this.calcULDPositions(flight)
    flight.actual = {
      MD: uldPositionsObj?.MD,
      P96: uldPositionsObj?.P96,
      P88: uldPositionsObj?.P88,
      LD3: uldPositionsObj?.LD3,
      LD2: uldPositionsObj?.LD2,
    }

    //FLIGHT TARE WEIGHT AND ADD TO READY WEIGHT
    flight.tare_wgt_kg = this.addTareWgt(flight)?.weight_kg || 0
    flight.tare_wgt_lbs = this.addTareWgt(flight)?.weight_lbs || 0
    flight.ready_kg += parseFloat(flight.tare_wgt_kg)
    flight.ready_lbs += parseFloat(flight.tare_wgt_lbs)
    flight.cccolour = ''
    flight.cccolour_css = ''
    let weight_assigned = this.state.weight_unit === 'KG' ? flight?.booked_kg : flight?.booked_lbs
    let weight_cargo = this.state.weight_unit === 'KG' ? flight?.weight_kg : flight?.weight_lbs
    if (!flight?.bag) {
      if (weight_cargo > 0) {
        if (weight_assigned > weight_cargo) {
          flight.cccolour_css = 'p-icon cc-icon fs-0 amber-cc' //SHOW YELLOW
          flight.cccolour = 'amber'
        } else {
          flight.cccolour_css = 'p-icon cc-icon fs-0 green-cc' //SHOW GREEN
          flight.cccolour = 'green'
        }
      } else {
        flight.cccolour_css = 'p-icon cc-icon fs-0' //SHOW BLUE
        flight.cccolour = 'blue'
      }
    } else if (flight?.bag && flight?.cargo && flight?.cargo?.md === 0 && flight?.cargo?.p96 === 0 && flight?.cargo?.p88 === 0 && flight?.cargo?.ld3 === 0 && flight?.cargo?.ld2 === 0) {
      if (weight_cargo > 0) {
        if (weight_assigned > weight_cargo) {
          flight.cccolour_css = 'p-icon cc-icon fs-0 amber-cc' //SHOW YELLOW
          flight.cccolour = 'amber'
        } else {
          flight.cccolour_css = 'p-icon cc-icon fs-0 green-cc' //SHOW GREEN
          flight.cccolour = 'green'
        }
      } else {
        flight.cccolour_css = 'p-icon cc-icon fs-0' //SHOW BLUE
        flight.cccolour = 'blue'
      }
    } else {
      if (((flight?.cargo?.md || 0) - (flight?.actual?.MD || 0)) < 0 ||
        ((flight?.cargo?.p96 || 0) - (flight?.actual?.P96 || 0)) < 0 ||
        ((flight?.cargo?.p88 || 0) - (flight?.actual?.P88 || 0)) < 0 ||
        ((flight?.cargo?.ld3 || 0) - (flight?.actual?.LD3 || 0)) < 0 ||
        ((flight?.cargo?.ld2 || 0) - (flight?.actual?.LD2 || 0)) < 0) {
        flight.cccolour_css = 'p-icon cc-icon fs-0 red-cc' //SHOW RED
        flight.cccolour = 'red'
      } else {
        if (weight_cargo > 0 && (weight_assigned > weight_cargo)) {
          flight.cccolour_css = 'p-icon fs-0 amber-cc' //SHOW YELLOW
          flight.cccolour = 'amber'
        } else if (((flight?.cargo?.md || 0) - (flight?.actual?.MD || 0)) > 0 ||
          ((flight?.cargo?.p96 || 0) - (flight?.actual?.P96 || 0)) > 0 ||
          ((flight?.cargo?.p88 || 0) - (flight?.actual?.P88 || 0)) > 0 ||
          ((flight?.cargo?.ld3 || 0) - (flight?.actual?.LD3 || 0)) > 0 ||
          ((flight?.cargo?.ld2 || 0) - (flight?.actual?.LD2 || 0)) > 0) {
          flight.cccolour_css = 'p-icon cc-icon fs-0 green-cc'
          flight.cccolour = 'green'
        } else {
          flight.cccolour_css = 'p-icon cc-icon fs-0' //SHOW Blue
          flight.cccolour = 'blue'
        }
      }
    }
    if (flight.answers && flight.answers.length > 0) {
      let greymilestones = []
      let ignoremilestones = []
      flight.answers.map((item, i) => {
        if (item.answers && item.answers.length > 0) {
          item.answers.map((answer, j) => {
            let question = this.state.allQuestionsData.find((q) => q.id === answer.question_id) || null
            flight.answers[i].answers[j].question = question
            // handle greymilestone for type 'yes/no'
            if (question?.details.type === 'yes/no' && question?.details.actionout && answer.answer === question?.details.actionout) {
              // for greymilestone
              if (question?.details?.actiontype === 'Turn Grey') {
                flight.answers[i].answers[j].greyon = true
                if (question?.details.actionms && question?.details.actionms.length > 0) {
                  question?.details.actionms.map((ms) => {
                    let indx = greymilestones.findIndex((item) => item === ms)
                    if (indx === -1) {
                      greymilestones.push(ms)
                    }
                  })
                }
              }
              // for ignore action performed
              else if (question?.details?.actiontype === 'Do Nothing') {
                flight.answers[i].answers[j].ignore = true
                if (question?.details.actionms && question?.details.actionms.length > 0) {
                  question?.details.actionms.map((ms) => {
                    let indx = ignoremilestones.findIndex((item) => item === ms)
                    if (indx === -1) {
                      ignoremilestones.push(ms)
                    }
                  })
                }
              }
            }
            // handle greymilestone for type mcq
            else if (question.details.type === 'mcq' && question?.details?.options && question?.details?.options?.length > 0) {
              let option = question?.details?.options.find((o) => o.name === answer.answer) || null
              if (option && option?.actionon) {
                // for greymilestone
                if (option?.actiontype === 'Turn Grey') {
                  flight.answers[i].answers[j].greyon = option?.actionon
                  if (option.actionms && option.actionms.length > 0) {
                    option.actionms.map((ms) => {
                      let indx = greymilestones.findIndex((item) => item === ms)
                      if (indx === -1) {
                        greymilestones.push(ms)
                      }
                    })
                  }
                }
                // for ignore action performed
                else if (option?.actiontype === 'Do Nothing') {
                  flight.answers[i].answers[j].ignore = option?.actionon
                  if (option.actionms && option.actionms.length > 0) {
                    option.actionms.map((ms) => {
                      let indx = ignoremilestones.findIndex((item) => item === ms)
                      if (indx === -1) {
                        ignoremilestones.push(ms)
                      }
                    })
                  }
                }
              }
            }
          })
        }
      })
      flight.greymilestones = greymilestones
      flight.ignoremilestones = ignoremilestones
    } else {
      flight.greymilestones = []
      flight.ignoremilestones = []
    }
    return flight
  }

  FlightAssessmentContent = (record) => {
    return (
      <div>
        <Select
          placeholder='Select'
          style={{ width: '100%' }}
          value={record.dod_agent_id || null}
          onChange={(value) => {
            this.assignToChangeHandler(record.id, value)
          }}
          options={
            this.state.userList?.filter(user => user.role === 'DOD Agent' || user.role === 'Centralized DoD').map((user) => ({
              value: user.id,
              label: `${user.name.first_name} ${user.name.last_name}`
            }))
          }
        />
        <Button className='mt-2 custom-button w-100' onClick={() => this.assignUsertoFlight(record)}>Assign Flight</Button>
      </div>
    )
  }

  assignToChangeHandler = (flight_id, value) => {
    let flightData = [...this.state.flightData]
    let index = flightData.findIndex(flight => flight.id === flight_id)
    if (index !== -1) {
      flightData[index].dod_agent_id = value
      this.setState({ flightData })
    }
  }

  assignUsertoFlight = async (record) => {
    //put API assign_dod_agent
    let headers = { station: this.state.station }
    let payload = { dod_agent_id: record.dod_agent_id }
    await Http.put(`assign_dod_agent/${record.id}`, payload, { headers }).then(resp => {
      if (resp && resp.status === 200) {
        notification.destroy()
        notification.success({
          message: 'Success',
          description: 'Dod Agent assigned successfully',
        })
      } else {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      }
    }).catch(() => {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: constants.SERVER_CONNECTION_ERROR,
      })
    })
  }

  uldContent = (record) => {
    const columns = [
      {
        title: 'ULD Type',
        dataIndex: 'uld_type',
        key: 'uld_type',
        render: (_, row, index) => {
          if (this.state.edit_uld_dir_id === index) {
            return (
              <Select
                size='small'
                placeholder='Select ULD Type'
                className='w-100'
                value={this.state.editULDType}
                onChange={(value) => this.setState({ editULDType: value })}
              >
                <Option value='MD'>MD</Option>
                <Option value='P96'>P96</Option>
                <Option value='P88'>P88</Option>
                <Option value='LD3'>LD3</Option>
                <Option value='LD2'>LD2</Option>
              </Select>
            )
          }
          return <span>{row.uld_type}</span>
        }
      },
      {
        title: 'Number',
        dataIndex: 'number',
        key: 'number',
        render: (_, row, index) => {
          if (this.state.edit_uld_dir_id === index) {
            return (
              <InputNumber
                size='small'
                placeholder='Enter number'
                className='w-100'
                min={0}
                precision={0}
                value={this.state.editULDNumber}
                onChange={(value) => this.setState({ editULDNumber: value })}
              />
            )
          }
          return <span>{row.number}</span>
        }
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, row, index) => (
          <div className='action-column'>
            {this.state.edit_uld_dir_id === index ? (
              <>
                <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                  <img src={Update} alt='save' onClick={() => this.handleULDDirectives(record.id, 'EDIT')} />
                </Tooltip>
                <Tooltip title='Cancel' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                  <span className='form-clear' onClick={() => this.handleULDDirectives(record.id, 'CANCEL')}>×</span>
                </Tooltip>
              </>
            ) : (
              <>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                  <img src={editIcon} alt='edit' onClick={() => {
                    this.setState({
                      edit_uld_dir_id: index,
                      editULDType: row.uld_type,
                      editULDNumber: row.number,
                    })
                  }}
                  />
                </Tooltip>
                <Popconfirm
                  placement='top'
                  title={constants.DeleteText}
                  onConfirm={() => {
                    this.setState({ edit_uld_dir_id: index }, () => this.handleULDDirectives(record.id, 'DELETE'))
                  }}
                  okText='Yes'
                  cancelText='No'
                >
                  <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                    <img src={deleteIcon} alt='delete' />
                  </Tooltip>
                </Popconfirm>
              </>
            )}
          </div>
        )
      }
    ]

    let uldData = []
    uldData = record?.uld_directives || []

    return (
      <div>
        <Form layout='vertical' className='mb-3'>
          <Row gutter={[12, 12]}>
            <Col xs={10}>
              <Form.Item label='ULD Type' className='mb-0'>
                <Select
                  size='small'
                  placeholder='Select ULD Type'
                  className='w-100'
                  value={this.state.newULDType}
                  onChange={(value) => this.setState({ newULDType: value })}
                >
                  <Option value='MD'>MD</Option>
                  <Option value='P96'>P96</Option>
                  <Option value='P88'>P88</Option>
                  <Option value='LD3'>LD3</Option>
                  <Option value='LD2'>LD2</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={11}>
              <Form.Item label='Number' className='mb-0'>
                <InputNumber
                  size='small'
                  placeholder='Enter number'
                  className='w-100'
                  min={0}
                  precision={0}
                  value={this.state.newULDNumber}
                  onChange={(value) => this.setState({ newULDNumber: value })}
                />
              </Form.Item>
            </Col>
            <Col flex='none' className='text-center'>
              <Form.Item label=' ' className='transparent-label mb-0'>
                <Tooltip title={'Add ULD'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' height={'26px'} onClick={() => this.handleULDDirectives(record.id, 'ADD')} /></Tooltip>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <div className='uld-directive-table'>
          <Table dataSource={uldData} columns={columns} pagination={false} className='ULD-directive-table' />
        </div>
      </div>
    )


  }

  async handleULDDirectives(flight_id, action) {
    if (action === 'CANCEL') {
      this.setState({
        edit_uld_dir_id: null,
        editULDType: null,
        editULDNumber: null,
        editingULDRecord: null
      })
      return
    }
    // call put API add_uld_directives and pass flight id, uld type and number array called uld_directives
    if (action === 'ADD' && (!this.state.newULDType || this.state.newULDNumber === null || this.state.newULDNumber === undefined)) {
      notification.destroy()
      notification.error({
        message: 'Error',
        description: 'Please select ULD Type and enter Number',
      })
      return
    } else if (action === 'EDIT' && (!this.state.editULDType || this.state.editULDNumber === null || this.state.editULDNumber === undefined)) {
      notification.destroy()
      notification.error({
        message: 'Error',
        description: 'Please select ULD Type and enter Number',
      })
      return
    }
    let headers = { station: this.state.station }
    // first get existing uld directives
    let existingULDs = []
    let record = this.state.flightData.find(flight => flight.id === flight_id)
    if (record && record.uld_directives && record.uld_directives.length > 0) {
      existingULDs = record.uld_directives
    }
    if (action === 'ADD') {
      // add new uld directive to existing array
      existingULDs.push({
        uld_type: this.state.newULDType,
        number: this.state.newULDNumber
      })
    } else if (action === 'EDIT') {
      // update the existing uld directive in array
      let index = this.state.edit_uld_dir_id
      if (index !== -1) {
        existingULDs[index].uld_type = this.state.editULDType
        existingULDs[index].number = this.state.editULDNumber
      }
    } else if (action === 'DELETE') {
      // delete the uld directive from array
      let index = this.state.edit_uld_dir_id
      existingULDs.splice(index, 1)
    }

    let payload = { uld_directives: existingULDs }
    await Http.put(`add_uld_directives/${flight_id}`, payload, { headers }).then(resp => {
      if (resp && resp.status === 200) {
        notification.destroy()
        notification.success({
          message: 'Success',
          description: `ULD Directive ${action === 'ADD' ? 'added' : 'updated'} successfully`,
        })
        this.setState({
          newULDType: null,
          newULDNumber: null,
          editULDType: null,
          editULDNumber: null,
          editingULDRecord: null,
          edit_uld_dir_id: null
        })
      } else {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      }
    }).catch(() => {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: constants.SERVER_CONNECTION_ERROR,
      })
    })
  }

  //Build Milestones Columns
  generateMilestonesColumns = () => {
    let milestonesColumns = [
      {
        title: (<span className='test'>  Flight #  </span>),
        dataIndex: 'flight',
        key: 'flight',
        className: '',
        render: (_, record) => (
          <span>{record?.flight_no ? record.flight_no : 'N/A'}</span>
        )
      },
      {
        title: (<span className='test'>  Flight Date  </span>),
        dataIndex: 'date',
        key: 'date',
        className: '',
        render: (_, record) => (
          <span>{record.flight_date ? `${moment(record.flight_date).format('DDMMMYY')?.toUpperCase()}` : record.dept_date ? `${moment(record.dept_date).format('DDMMMYY')?.toUpperCase()}` : record?.dept_time ? `${moment(record.dept_time).format('DDMMMYY')?.toUpperCase()}` : 'N/A'}</span>
        )
      },
      {
        title: (<span className='test'> Agent Assignment  </span>),
        dataIndex: 'dodAssigned',
        key: 'dodAssigned',
        className: '',
        align: 'center',
        render: (_, record) => (
          record?.dod_agent.length > 0 ? `${record.dod_agent[0]?.name.first_name} ${record.dod_agent[0]?.name.last_name}` :
            <Popover
              placement='rightTop'
              content={this.FlightAssessmentContent(record)}
              title='Assign Dod Agent'
              trigger='click'
              overlayClassName='uld-directive-popover'>
              <UserOutlined />
            </Popover>
        )
      },
      {
        title: (<span className='test'>  Dept Time EST  </span>),
        dataIndex: 'DeptTimeEST',
        key: 'DeptTimeEST',
        className: 'est-col space-nowrap ',
        align: 'center',
        render: (_, record) => (
          <Space className=''>
            <span className='px-1 fs-10 pa-badge'>{record?.dept_prefix ? record?.dept_prefix : ''}</span>
            <span>{record?.dept_time ? `${moment.tz(record.dept_time, this.state.timezone).format(dateTimeFormat)?.toUpperCase()}` : 'N/A'}</span>
          </Space>
        )
      },
      {
        title: (<span className='test'>  AC Type  </span>),
        dataIndex: 'ACType',
        key: 'ACType',
        className: 'checklist-cols-1',
        render: (_, record) => (
          <span
            onClick={() => record?.info?.remark === 'created by User' ? this.setState({
              edit_flight_id: record?.id,
              flightModalType: 'EDIT',
              showFlightModal: true,
              flight_no: record?.flight_no,
              flight_date: moment(record?.flight_date),
              dept_time: moment.tz(record.dept_time, this.state.timezone),
              arr_time: moment.tz(record.arr_time, this.state.timezone).utc(),
              org_stn: cookies.get('station'),
              dest_stn: record?.dest_stn,
              aircrafttype: record?.ac_type,
              ack1: false,
              ack2: false,
            }) : null}
          >{record?.ac_type ? record.ac_type : 'N/A'}</span>
        )
      },
      {
        title: (<span className='test'>  ORG-DST  </span>),
        dataIndex: 'OrgDst',
        key: 'OrgDst',
        className: 'checklist-cols-1 min-width-100',
        align: 'center',
        render: (_, record) => (
          <span>{record?.org_stn + ' - ' + record?.dest_stn}</span>
        ),
        filteredValue: this.state.destFilters,
        filterDropdown: () => (
          <div className='fliter-dd'>
            {
              this.state.destStations?.map((item, index) => {
                return (
                  <Checkbox key={index} checked={this.state.destFilters?.includes(item)} value={item} onChange={(e) => this.handleFilterChange(e)} >{item}</Checkbox>
                )
              })
            }
          </div>
        ),
        onFilter: (value, record) => {
          return record?.dest_stn?.startsWith(value)
        }
      },
      {
        title: (<span className='test'>Action</span>),
        dataIndex: 'BuildPlan',
        key: 'BuildPlan',
        className: '',
        align: 'center',
        render: (_, record) => (
          <div className='action-column'>
            <Badge size='small' count={record?.checklist_notes_count || 0} color={'var(--primaryblue'} className='sm-badge'>
              <Tooltip
                title='Notes'
                overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}
                onClick={() => this.showFlightNotes(record)}
              >
                <img src={documentIcon} alt='document' />
              </Tooltip>
            </Badge>
            <Tooltip
              title='Build Plan'
              overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}
            >
              <Button
                min={0}
                precision={0}
                controls={false}
                size='small'
                placeholder=''
                className='checklist-bp-btn'
                onClick={() => this.setEdit(record)}
              >
                BP
              </Button>
            </Tooltip>
            <Tooltip
              title='ULD Directives'
              overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}
            >
              <Popover
                placement='rightTop'
                content={this.uldContent(record)}
                title={'ULD Directives - ' + (record.flight_no || 'N/A')}
                trigger='click'
                open={this.state.visiblePopoverId === record.id}
                onOpenChange={(visible) => {
                  this.setState({ visiblePopoverId: visible ? record.id : null })
                }}
                overlayClassName='uld-directive-popover'>
                <span className='uld-directive-btn'>ULD</span>
              </Popover>
            </Tooltip>
          </div>
        )
      },
    ]
    if (this.state.milestoneData?.length > 0) {
      let dod = this.state.milestoneData.filter((item) => item?.type === 'Dod')
      let rebooking = this.state.milestoneData.filter((item) => item?.type === 'Rebookings')
      let noride = this.state.milestoneData.filter((item) => item?.type === 'No Rides')
      //Dod Section
      let dodchildren = []
      dod.map((item) => {
        !item.parent_id || (item.parent_id && item.showchild) ?
          dodchildren.push(
            {
              title: (<>
                <Tooltip title={item.title} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                  <div className='title-overflow'>{item.title}</div>
                </Tooltip>
                <Tooltip title={this.formatCutoff(item.cutoff)} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                  <div className='title-overflow pt-1'>({this.formatCutoff(item.cutoff)})</div>
                </Tooltip>
              </>),
              dataIndex: 'BuildPlanSubmittedToWH',
              key: 'BuildPlanSubmittedToWH',
              className: 'checklist-cols color-cols',
              render: (_, record) => {
                const isBuildPlan = item.title && item.title.toLowerCase().includes('build plan')
                const isSpecialFlight =
                  record.flight_no === 'DL105' ||
                  (record?.org_stn === 'ATL' && record?.dest_stn === 'SCL') ||
                  (record?.org_stn === 'ATL' && record?.dest_stn === 'LIM')

                let effectiveCutoff = item.cutoff
                let useSkyBlue = false

                if (isBuildPlan && isSpecialFlight && record?.dept_date) {
                  const nowET = moment().tz('America/New_York')
                  const deptMoment = moment.utc(record.dept_date).tz('America/New_York')
                  const deptDate = deptMoment.format('YYYY-MM-DD')
                  const todayET = nowET.format('YYYY-MM-DD')
                  const tomorrowET = nowET.clone().add(1, 'day').format('YYYY-MM-DD')

                  // Calculate the 10 PM deadline (night before departure)
                  const scheduledMoment = deptMoment.clone().subtract(1, 'day').set({
                    hour: 22,
                    minute: 0,
                    second: 0
                  })

                  // Handle Special Flight if:
                  // 1. Departure is today
                  // 2. Departure is tomorrow AND current time is past 10 PM
                  if (deptDate === todayET || (deptDate === tomorrowET && nowET.hour() >= 22)) {
                    // Calculate hours from 10 PM ET the night before to departure time
                    const hoursDiff = deptMoment.diff(scheduledMoment, 'hours', true)
                    effectiveCutoff = hoursDiff * 60
                    useSkyBlue = true
                  } else {
                    // For future flights, still calculate the cutoff but don't show sky blue
                    const hoursDiff = deptMoment.diff(scheduledMoment, 'hours', true)
                    effectiveCutoff = hoursDiff * 60
                  }
                }
                return (
                  <div
                    className={
                      `${useSkyBlue && (useSkyBlue && this.checkStatusColour((record?.dept_date ?
                        moment.utc(record.dept_date).tz(this.state.timezone).subtract(this.getCutoff(effectiveCutoff, record), 'hours') : null),
                      this.getAct(record, item.id, 'YYYY-MM-DD HH:mm'), item.amber, record?.flight_leg, item, record.greymilestones, record.ignoremilestones
                      ) === 'bg-white' ?
                        'alerts-border-white' : 'alerts-border')}
                      ${this.checkStatusColour((record?.dept_date ?
                    moment.utc(record.dept_date).tz(this.state.timezone).subtract(this.getCutoff(effectiveCutoff, record), 'hours') : null),
                  this.getAct(record, item.id, 'YYYY-MM-DD HH:mm'), item.amber, record?.flight_leg, item, record.greymilestones, record.ignoremilestones
                  )}`
                    }
                    // style={useSkyBlue ? { border: '1px solid var(--redText) !important' } : {}}
                    onClick={() => this.showQuizModal(record, item)} >
                    {`SKD ${record?.dept_date ?
                      moment.utc(record.dept_date).tz(this.state.timezone).subtract(this.getCutoff(effectiveCutoff, record), 'hours').format('HH:mm') :
                      'N/A'} 
                      ACT ${['bg-grey', 'bg-red'].includes(this.checkStatusColour((record?.dept_date ?
                    moment.utc(record.dept_date).tz(this.state.timezone).subtract(this.getCutoff(effectiveCutoff, record), 'hours') : null),
                  this.getAct(record, item.id, 'YYYY-MM-DD HH:mm'), item.amber, record?.flight_leg, item, record.greymilestones, record.ignoremilestones
                  )) ? 'N/A' : this.getAct(record, item.id, 'HH:mm') || 'N/A'}`
                      // && this.getCountdown(record?.dept_date, this.getAct(record, item.id, 'YYYY-MM-DD HH:mm'), item.cutoff, item.amber)
                    }
                    <span className='countdown'>{this.getCountdown(record?.dept_date, this.getAct(record, item.id, 'YYYY-MM-DD HH:mm'), effectiveCutoff, item.amber)}</span>
                  </div>
                )
              }
            }

          )
          : null

      })
      let dodobj = {
        title: 'DoD MileStones',
        dataIndex: 'DoDMileStones',
        key: 'DoDMileStones',
        className: 'main-head',
        children: dodchildren,
      }
      milestonesColumns.push(dodobj)

      //Rebookings Section
      let rbchildren = []
      let rbobj = {}
      if (rebooking && rebooking.length > 0) {
        rebooking.map((item) => {
          rbchildren.push(
            {
              title: (<>
                <Tooltip title={item.title} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                  <div className='title-overflow'>{item.title}</div>
                </Tooltip>
                <Tooltip title={this.formatCutoff(item.cutoff)} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                  <div className='title-overflow pt-1'>
                    ({this.formatCutoff(item.cutoff)})
                  </div>
                </Tooltip>
              </>),
              dataIndex: 'BuildPlanSubmittedToWH',
              key: 'BuildPlanSubmittedToWH',
              className: 'checklist-cols color-cols',
              render: (_, record) => {
                return (
                  <div
                    className={this.checkStatusColour((record?.dept_date ?
                      moment.utc(record.dept_date).tz(this.state.timezone).subtract(this.getCutoff(item.cutoff, record), 'hours') : null),
                    this.getAct(record, item.id, 'YYYY-MM-DD HH:mm'), item.amber, record?.flight_leg, item, record.greymilestones, record.ignoremilestones
                    )}
                    onClick={() => this.showQuizModal(record, item)} >
                    {`SKD ${record?.dept_date ?
                      moment.utc(record.dept_date).tz(this.state.timezone).subtract(this.getCutoff(item.cutoff, record), 'hours').format('HH:mm') :
                      'N/A'} 
                    ACT ${['bg-grey', 'bg-red'].includes(this.checkStatusColour((record?.dept_date ?
                    moment.utc(record.dept_date).tz(this.state.timezone).subtract(this.getCutoff(item.cutoff, record), 'hours') : null),
                  this.getAct(record, item.id, 'YYYY-MM-DD HH:mm'), item.amber, record?.flight_leg, item, record.greymilestones, record.ignoremilestones
                  )) ? 'N/A' : this.getAct(record, item.id, 'HH:mm') || 'N/A'}`
                    }
                  </div>
                )
              }
            }
          )
        })
        rbobj = {
          title: 'Rebookings',
          dataIndex: 'Rebookings',
          key: 'Rebookings',
          children: rbchildren,
          className: 'main-head',
        }
        milestonesColumns.push(rbobj)
      }

      //No Ride Section
      let nrchildren = []
      noride.map((item) => {
        nrchildren.push(
          {
            title: (<>
              <Tooltip title={item.title} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                <div className='title-overflow'>{item.title}</div>
              </Tooltip>
              <Tooltip title={this.formatCutoff(item.cutoff)} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                <div className='title-overflow pt-1'>({this.formatCutoff(item.cutoff)})</div>
              </Tooltip></>),
            dataIndex: 'BuildPlanSubmittedToWH',
            key: 'BuildPlanSubmittedToWH',
            className: 'checklist-cols color-cols',
            render: (_, record) => {
              return (
                <div className='position-relative'>
                  <div
                    className={`${this.checkStatusColour((record?.dept_date ?
                      moment.utc(record.dept_date).tz(this.state.timezone).subtract(this.getCutoff(item.cutoff, record), 'hours') : null),
                    (record?.noride?.updatedAt ? moment(record?.noride?.updatedAt).format('YYYY-MM-DD HH:mm') : null), null, record?.flight_leg, item, record.greymilestones, record.ignoremilestones)
                    } ${record.norides?.length > 0 ? 'pb-3' : ''}`}
                    onClick={() => this.setState({
                      // openNoRideModal: true,
                      quizModalFlight: cloneDeep(record),
                      noride_flight: record.id,
                      noRideModalType: 'NORIDE',
                      noRideTitle: 'Send No-Ride Alert',
                      completedBy: record?.completedBy ? record.completedBy : cookies.get('name'),
                      completedById: record?.completedById || cookies.get('user'),
                      noRideQts: record?.noride?.noRideQts || {},
                    }, () => this.fetchNoride())} >
                    {`SKD ${record?.dept_date ?
                      moment.utc(record.dept_date).tz(this.state.timezone).subtract(this.getCutoff(item.cutoff, record), 'hours').format('HH:mm') :
                      'N/A'} 
                    ACT ${['bg-grey', 'bg-red'].includes(this.checkStatusColour((record?.dept_date ?
                  moment.utc(record.dept_date).tz(this.state.timezone).subtract(this.getCutoff(item.cutoff, record), 'hours') : null),
                this.getAct(record, item.id, 'YYYY-MM-DD HH:mm'), item.amber, record?.flight_leg, item, record.greymilestones, record.ignoremilestones
                )) ? 'N/A' : (record?.noride?.updatedAt ? moment(record?.noride?.updatedAt).format('HH:mm') : 'N/A') || 'N/A'}`
                    }
                  </div>
                  {/* NORIDE-OFFLOAD */}
                  {record.norides?.length > 0 && <div className={`no-rides 
                  ${['bg-red', 'bg-green'].includes(this.checkStatusColour((record?.dept_date ?
                  moment.utc(record.dept_date).tz(this.state.timezone).subtract(this.getCutoff(item.cutoff, record), 'hours') : null),
                (record?.noride?.updatedAt ? moment(record?.noride?.updatedAt).format('YYYY-MM-DD HH:mm') : null), null, record?.flight_leg, item, record.greymilestones, record.ignoremilestones)
                ) ? 'no-rides-white' : ''}`}>offload</div>}
                </div>
              )
            }
          }
        )
      })
      let nrobj = {
        title: 'No Rides',
        dataIndex: 'No Rides',
        key: 'No Rides',
        align: 'center',
        children: nrchildren,
        className: 'main-head',
      }
      milestonesColumns.push(nrobj)
    }
    milestonesColumns.push(
      // {
      //   title: 'LDD',
      //   dataIndex: 'LDD',
      //   align: 'center',
      //   key: 'LDD',
      //   className: 'checklist-cols main-head',
      //   children: [
      //     {
      //       title: (<span className=''>  Interacted with LDD  </span>),
      //       dataIndex: 'LDD',
      //       key: 'LDD',
      //       align: 'center',
      //       className: 'checklist-cols-1 min-width-80 th-top',
      //       render: (_, record) => (
      //         <div
      //           onClick={() => this.setState({
      //             pallets_paired: record?.ldd?.pallets_paired || null,
      //             pallets_paired_contact: record?.ldd?.pallets_paired_contact || null,
      //             pallets_paired_explain: record?.ldd?.pallets_paired_explain || null,
      //             conveyances_staged: record?.ldd?.conveyances_staged || null,
      //             conveyances_staged_contact: record?.ldd?.conveyances_staged_contact || null,
      //             conveyances_staged_explain: record?.ldd?.conveyances_staged_explain || null,
      //             openLDDModal: true,
      //             quizModalFlight: cloneDeep(record),
      //           })}
      //         >
      //           {this.getLDDStatus(record)}
      //         </div>
      //       )
      //     }
      //   ]
      // },
      {
        title: 'Audit',
        dataIndex: 'Audit',
        align: 'center',
        key: 'Audit',
        className: 'checklist-cols main-head',
        children: [
          {
            title: (<span className='test'>  Flight Audit  </span>),
            dataIndex: 'FlightAudit',
            key: 'FlightAudit',
            align: 'center',
            className: 'checklist-cols-1 th-top',
            render: (_, record) => (
              <div
                onClick={() => this.setState({
                  // openNoRideModal: true,
                  quizModalFlight: cloneDeep(record),
                  noride_flight: record.id,
                  noRideModalType: 'AUDIT',
                  noRideTitle: 'Flight Audit',
                  bin_config: record?.audit?.bin_config ? record?.audit?.bin_config : (record?.cargo ? `PMC:- ${record?.cargo?.p96}, PAG:- ${record?.cargo?.p88}, LD2:- ${record?.cargo?.ld2}, LD3:- ${record?.cargo?.ld3}` : ''),
                  audit_built_right: record?.audit?.audit_built_right,
                  audit_reason: record?.audit?.audit_reason,
                  audit_explain: record?.audit?.audit_explain,
                  audit_was_optimal: record?.audit?.audit_was_optimal,
                  audit_was_optimal_explain: record?.audit?.audit_was_optimal_explain,
                  audit_meet_wgt_goal: record?.audit?.audit_meet_wgt_goal,
                  audit_meet_wgt_goal_explain: record?.audit?.audit_meet_wgt_goal_explain,
                  audit_attachment: record?.audit?.audit_attachment,
                  load_trac_conf: record.audit?.load_trac_conf ? JSON.stringify(record.audit?.load_trac_conf) : null,
                  load_trac_conf_fileList: record.audit?.load_trac_conf?.name ? [{ name: record.audit?.load_trac_conf?.name }] : [],
                  load_trac_conf_previewImg: record.audit?.load_trac_conf?.path || null,
                  build_plan_conf: record.audit?.build_plan_conf ? JSON.stringify(record.audit?.build_plan_conf) : null,
                  build_plan_conf_fileList: record.audit?.build_plan_conf?.name ? [{ name: record.audit?.build_plan_conf?.name }] : [],
                  build_plan_conf_previewImg: record.audit?.build_plan_conf?.path || null,
                  wandb_conf: record.audit?.wandb_conf ? JSON.stringify(record.audit?.wandb_conf) : null,
                  wandb_conf_fileList: record.audit?.wandb_conf?.name ? [{ name: record.audit?.wandb_conf?.name }] : [],
                  wandb_conf_previewImg: record.audit?.wandb_conf?.path || null,
                  wandb_conf2: record.audit?.wandb_conf2 ? JSON.stringify(record.audit?.wandb_conf2) : null,
                  wandb_conf2_fileList: record.audit?.wandb_conf2?.name ? [{ name: record.audit?.wandb_conf2?.name }] : [],
                  wandb_conf2_previewImg: record.audit?.wandb_conf2?.path || null,
                  onesource_conf: record.audit?.onesource_conf ? JSON.stringify(record.audit?.onesource_conf) : null,
                  onesource_conf_fileList: record.audit?.onesource_conf?.name ? [{ name: record.audit?.onesource_conf?.name }] : [],
                  onesource_conf_previewImg: record.audit?.onesource_conf?.path || null,
                  audit_meet_wgt_goal_conf: Array.isArray(record.audit?.audit_meet_wgt_goal_conf) && record.audit.audit_meet_wgt_goal_conf.length > 0
                    ? JSON.stringify(record.audit.audit_meet_wgt_goal_conf)
                    : null,
                  audit_meet_wgt_goal_conf_fileList: Array.isArray(record.audit?.audit_meet_wgt_goal_conf)
                    ? record.audit.audit_meet_wgt_goal_conf.map(item => ({
                      name: item.name,
                      url: item.path,
                      status: 'done'
                    }))
                    : [],
                  audit_meet_wgt_goal_conf_previewImg: Array.isArray(record.audit?.audit_meet_wgt_goal_conf) && record.audit.audit_meet_wgt_goal_conf.length > 0
                    ? record.audit.audit_meet_wgt_goal_conf[0].path
                    : null,
                  completedBy: record?.audit?.completedBy ? record.audit.completedBy : cookies.get('name'),
                  completedById: record?.audit?.completedById || cookies.get('user'),
                }, () => this.fetchNoride())}
              >
                {this.getAuditStatus(record)}
              </div>
            )
          }
        ]
      }
    )
    return milestonesColumns
  }

  handleOptiUldChange = (e) => {
    let optiUld = this.state.optiUld
    optiUld[e.target.name] = e.target.value
    this.setState({ optiUld })
  }

  handleEditOptiUldChange = (e) => {
    let editOptiUld = this.state.editOptiUld
    editOptiUld[e.target.name] = e.target.value
    this.setState({ editOptiUld })
  }

  lockWB = () => {
    Http.post(`/wgt_bal_lock/${this.state.editRecord.id}`, {})
  }

  trimPlan = () => {
    Http.post(`/trim_build_plan/${this.state.editRecord.id}`, {})
  }

  unlockWB = (data) => {
    Http.post(`/wgt_bal_unlock/${this.state.editRecord.id}`, data)
  }

  lockBP = () => {
    let build_plan = this.state.editRecord?.build_plan || []
    let build_uld = this.state.editRecord?.build_uld || []
    let data = {
      build_plan: build_plan,
      build_uld: build_uld
    }
    let headers = { user_id: this.state.user_id, }
    Http.post(`/build_plan_lock/${this.state.editRecord.id}`, data, { headers })
      .then((resp) => {
        if (resp && resp.status === 200) {
          notification.destroy()
          notification.success({
            message: 'Success',
            description: 'Build Plan locked successfully! \nPlease do not close the modal screenshot is being uploaded to Flight Audit.',
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: constants.SERVER_CONNECTION_ERROR,
          })
        }
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
  }

  unlockBP = (data) => {
    Http.post(`/build_plan_unlock/${this.state.editRecord.id}`, data)
  }

  handleLockAndScreenshot = () => {
    if (this.lockBP) {
      this.lockBP()
    }
    setTimeout(() => {
      let fieldName = 'load_trac_conf'
      let type = 'version_1_'
      if (!this.state.editRecord?.init_build_plan) {
        fieldName = 'load_trac_conf'
        type = 'version_1_'
      } else {
        fieldName = 'build_plan_conf'
        type = 'version_2_'
      }
      const node = this.modalContentRef.current
      if (node) {
        node.classList.add('wnb-modal-expanded')
        node.scrollTop = 0
        setTimeout(() => {
          html2canvas(node).then(canvas => {
            node.classList.remove('wnb-modal-expanded')
            canvas.toBlob(blob => {
              if (this.handleAuditScreenshotUpload) {
                const filename = `BuildPlan_${type}${this.state.editRecord?.flight_no || 'flight'}.png`
                this.handleAuditScreenshotUpload(blob, filename, fieldName)
              }
            }, 'image/png')
          })
        }, 100)
      }
    }, 500)
  }

  callbackTabClicked = (key) => {
    this.setState({ activeTab: key })
  }

  onTabEdit = (targetKey, action) => {
    if (action === 'remove') {
      this.removeTab(targetKey)
    }
  }

  removeTab = (targetKey) => {
    const { visibleTabs, activeTab } = this.state
    const newVisibleTabs = visibleTabs.filter(key => key !== targetKey)

    // Call unlock function based on which tab is being removed
    if (targetKey === 'initial') {
      this.unlockBP({ init: true })
    } else if (targetKey === 'final') {
      this.unlockBP({ final: true })
    }

    // If removing the active tab, switch to the first available tab
    let newActiveTab = activeTab
    if (activeTab === targetKey && newVisibleTabs.length > 0) {
      newActiveTab = newVisibleTabs[0]
    }

    this.setState({
      visibleTabs: newVisibleTabs,
      activeTab: newActiveTab
    })
  }

  addOptiData = () => {
    let obj = {
      uld_no: this.state.optiUld?.uld_no,
      type: this.state.optiUld?.type,
      remark: this.state.optiUld?.remark,
      stn: cookies.get('station')
    }
    if (obj.type) {
      Http.post(`/build_uld/${this.state.editRecord.id}`, obj).then(() => {
        this.setState({
          optiUld: {},
          switch: false
        })
      })
    }
  }
  addAwb = () => {
    let data = {
      id: 0,
      init: true,
      manual: true,
      awb_no: '',
      location: '',
      delay: moment().tz(this.state.timezone).format('YYYY-MM-DD HH:mm'),
      priority: '',
      prod_code: '',
      spl_code: '',
      wgt: { value: 0, },
      vol: { value: 0, },
      ch_wgt: { value: 0, }
    }
    const find = this.state.mergeEditRecord.find((item) => item.init === true)
    if (find) {
      return true
    }
    this.setState({ mergeEditRecord: [...this.state.mergeEditRecord, data] }, () => {
      this.setState({ editAwbsRecord: data })
    })
  }

  get_bin_config = () => {
    let p_pmc = 0, p_pag = 0, p_ld2 = 0, p_ld3 = 0
    let Hint = ''
    let className = ''
    if (this.state.editRecord?.build_uld?.length > 0) {
      this.state.editRecord?.build_uld?.map((item) => {
        if (item?.type === 'PMC') {
          p_pmc++
        }
        if (item?.type === 'PAG' || item?.type === 'PAJ' || item?.type === 'RAP') {
          p_pag++
        }
        if (item?.type === 'LD2' || item?.type === 'DPA' || item?.type === 'DPE' || item?.type === 'DPL' || item?.type === 'DPN' || item?.type === 'LD4' || item?.type === 'LD8' || item?.type === 'FQA' || item?.type === 'DQL' || item?.type === 'DQP' || item?.type === 'DQF') {
          p_ld2++
        }
        if(item?.type === 'LD4' || item?.type === 'LD8' || item?.type === 'FQA' || item?.type === 'DQL' || item?.type === 'DQP' || item?.type === 'DQF'){
          p_ld2++
        }
        if (item?.type === 'LD3' || item?.type === 'AKE' || item?.type === 'AKN' || item?.type === 'AKX' || item?.type === 'AKY' || item?.type === 'RKN' || item?.type === 'PLA' || item?.type === 'FLA' || item?.type === 'PLB') {
          p_ld3++
        }
        if (item?.type === 'PLA' || item?.type === 'FLA' || item?.type === 'PLB') {
          p_ld3++
        }
      })
      if (!(this.state.editCargoP96 || this.state.editRecord?.cargo?.p96) && !(this.state.editCargoP88 || this.state.editRecord?.cargo?.p88) && !(this.state.editCargoLD2 || this.state.editRecord?.cargo?.ld2) && !(this.state.editCargoLD3 || this.state.editRecord?.cargo?.ld3)) {
        Hint = 'Max Bin Configuration missing'
        className = 'table-row-warning'
      } else {
        if (((this.state.editCargoP96 || this.state.editRecord?.cargo?.p96 || 0) >= p_pmc) && ((this.state.editCargoP88 || this.state.editRecord?.cargo?.p88 || 0) >= p_pag) && ((this.state.editCargoLD2 || this.state.editRecord?.cargo?.ld2 || 0) >= p_ld2) && ((this.state.editCargoLD3 || this.state.editRecord?.cargo?.ld3 || 0) >= p_ld3)) {
          if (this.state.editRecord?.fleet == '763' || this.state.editRecord?.fleet == '764') {
            if (p_ld3 == 0) {
              Hint = 'Optimal Bin Configuration'
              className = 'table-row-success'
            } else {
              Hint = 'Suboptimal Bin Configuration'
              className = 'table-row-danger'
            }
          }
          if (this.state.editRecord?.fleet == '332' && p_pmc > 0) {
            if (p_pmc % 2 == 0) {
              Hint = 'Optimal Bin Configuration'
              className = 'table-row-success'
            } else {
              Hint = 'Suboptimal Bin Configuration (The sum of PMC\'s and PAG\'s is not even)'
              className = 'table-row-danger'
            }
          }
          if (this.state.editRecord?.fleet == '333' && (p_pmc > 0 || p_pag > 0)) {
            let sub_opti = false
            if ((p_pmc + p_pag) % 2 != 0) {
              sub_opti = '(The sum of PMC\'s and PAG\'s is not even)'
            }
            if (!(p_pmc <= 6 && p_pag <= 2)) {
              sub_opti = '(Doesn\'t meet the criteria)'
            }
            if (sub_opti) {
              Hint = `Suboptimal Bin Configuration ${sub_opti}`
              className = 'table-row-danger'
            } else {
              Hint = 'Optimal Bin Configuration'
              className = 'table-row-success'
            }
          }
          if (this.state.editRecord?.fleet == '339' && (p_pmc > 0 || p_pag > 0)) {
            let sub_opti = false
            if ((p_pmc + p_pag) % 2 != 0) {
              sub_opti = '(The sum of PMC\'s and PAG\'s is not even)'
            }
            if (!((p_pmc == 6 && p_pag == 0) || (p_pmc <= 5 && p_pag <= 1))) {
              sub_opti = '(Doesn\'t meet the criteria)'
            }
            if (sub_opti) {
              Hint = `Suboptimal Bin Configuration ${sub_opti}`
              className = 'table-row-danger'
            } else {
              Hint = 'Optimal Bin Configuration'
              className = 'table-row-success'
            }
          }
          if (this.state.editRecord?.fleet == '359' && (p_pmc > 0 || p_pag > 0)) {
            let sub_opti = false
            if ((p_pmc + p_pag) % 2 != 0) {
              sub_opti = '(The sum of PMC\'s and PAG\'s is not even)'
            }
            if (!((p_pmc == 8 && p_pag == 0) || (p_pmc == 6 && p_pag == 0) || (p_pmc <= 5 && p_pag <= 1))) {
              sub_opti = '(Doesn\'t meet the criteria)'
            }
            if (sub_opti) {
              Hint = `Suboptimal Bin Configuration ${sub_opti}`
              className = 'table-row-danger'
            } else {
              Hint = 'Optimal Bin Configuration'
              className = 'table-row-success'
            }
          }
        } else {
          Hint = 'Planned exceeds Max bin configuration'
          className = 'table-row-warning'
        }
      }
    }

    return [
      {
        key: '1',
        empty: 'Max Bin Configuration',
        PMC: this.state.editCargoP96 || this.state.editRecord?.cargo?.p96 || 0,
        PAG: this.state.editCargoP88 || this.state.editRecord?.cargo?.p88 || 0,
        LD2: this.state.editCargoLD2 || this.state.editRecord?.cargo?.ld2 || 0,
        LD3: this.state.editCargoLD3 || this.state.editRecord?.cargo?.ld3 || 0,
        Hint: this.state.hints || this.state.editRecord?.cargo?.hint,
        Notes: this.state.notes || this.state.editRecord?.cargo?.note,
      },
      {
        key: '2',
        empty: 'Planned Bin Configuration',
        PMC: p_pmc,
        PAG: p_pag,
        LD2: p_ld2,
        LD3: p_ld3,
        Hint: Hint,
        Notes: '-',
        className
      },
      // {
      //   key: '3',
      //   empty: 'Actual Bin Configuration',
      //   PMC: this.state.editRecord?.actual?.P96,
      //   PAG: this.state.editRecord?.actual?.P88,
      //   LD2: this.state.editRecord?.actual?.LD2,
      //   LD3: this.state.editRecord?.actual?.LD3,
      //   Hint: '-',
      //   Notes: '-',
      // }
    ]
  }

  exportScrub = async (download_type = null) => {
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet('Flight Plan')

    ws.columns = [
      { width: 15 },   // A
      { width: 20 },  // B
      { width: 14 },  // C
      { width: 12 },  // D
      { width: 10 },  // E
      { width: 12 },  // F
      { width: 10 },  // G
      { width: 12 },  // H
      { width: 22 },  // I
    ]

    const blue = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9EAF7' }
    }
    const yellow = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FEFEA2' }
    }

    const grey = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9D9D9' }
    }

    const border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    }

    const bold = { bold: true }

    /* ---------------- LEFT FLIGHT INFO ---------------- */
    ws.mergeCells('A1:A5')
    ws.getCell('A1').value = this.state.editRecord.flight_no + ' ' + this.state.editRecord.dest_stn
    ws.getCell('A1').alignment = {
      horizontal: 'center',
      vertical: 'middle',
      wrapText: true
    }
    const bin_config = this.get_bin_config()

    /* ---------------- CONTAINER CONFIG ---------------- */
    ws.mergeCells('B1:D1')
    ws.getCell('B1').value = 'Container Type:'
    ws.mergeCells('B2:D2')
    ws.getCell('B2').value = 'Max Config:'
    if (bin_config[0]) {
      ws.getCell('E2').value = bin_config[0].PMC
      ws.getCell('F2').value = bin_config[0].PAG
      ws.getCell('G2').value = bin_config[0].LD2
      ws.getCell('H2').value = bin_config[0].LD3
    }
    ws.mergeCells('B3:D3')
    ws.getCell('B3').value = 'Planned Config:'
    if (bin_config[1]) {
      ws.getCell('E3').value = bin_config[1].PMC
      ws.getCell('F3').value = bin_config[1].PAG
      ws.getCell('G3').value = bin_config[1].LD2
      ws.getCell('H3').value = bin_config[1].LD3
    }
    ws.mergeCells('B4:D5')
    ws.getCell('B4').value = 'Final Config:'
    ws.mergeCells('E4:E5')
    ws.mergeCells('F4:F5')
    ws.mergeCells('G4:G5')
    ws.mergeCells('H4:H5')
    ws.mergeCells('I4:I5')
    ws.mergeCells('J1:L1')
    ws.mergeCells('J2:L2')
    ws.mergeCells('J3:L3')
    ws.mergeCells('J4:L5')
    ws.getCell('J4').value = '<---Scrub desk please update this count when replying'
    ws.getCell('J4').alignment = {
      horizontal: 'center',
      vertical: 'middle',
      wrapText: true
    }


    ws.getCell('E1').value = 'PMC'
    ws.getCell('F1').value = 'PAG'
    ws.getCell('G1').value = 'LD2'
    ws.getCell('H1').value = 'LD3'
    ws.getCell('I1').value = 'LD4/8/FQA'

    for (let row = 1; row <= 7; row++) {
      for (let col = 1; col <= 12; col++) { // A=1 to L=12
        const cell = ws.getRow(row).getCell(col)
        cell.fill = blue
        cell.font = bold
        cell.border = border
      }
    }
    ws.getCell('E4').fill = yellow
    ws.getCell('F4').fill = yellow
    ws.getCell('G4').fill = yellow
    ws.getCell('H4').fill = yellow
    ws.getCell('I4').fill = yellow
    ws.getCell('J4').font = { bold: false }

    /* ---------------- FLIGHT PLAN RESPONSE ---------------- */
    ws.mergeCells('A6:L6')
    ws.getCell('A6').value = 'Flight Plan Response'
    ws.getCell('A6').fill = blue
    ws.getCell('A6').font = bold
    ws.getCell('A6').alignment = { horizontal: 'center' }
    ws.getCell('A6').border = border
    ws.getCell('A7').value = 'Number'
    ws.getCell('B7').value = 'AWB/Conveyances'
    ws.getCell('C7').value = 'Location'
    ws.getCell('D7').value = 'Days Delayed'
    ws.getCell('E7').value = 'Priority'
    ws.getCell('F7').value = 'Product'
    ws.getCell('G7').value = 'Yes/No'
    ws.mergeCells('H7:I7')
    ws.getCell('H7').value = 'Built ULDs'
    ws.mergeCells('J7:L7')
    ws.getCell('J7').value = 'Scrub Desk Comments'

    let data = cloneDeep(this.state.editRecord)
    let workarea = []
    data.ulds_out?.map((uld) => {
      if (uld.blk) {
        uld.awbs_in.map((awb) => {
          !workarea[uld.build_to || 'UNKNOWN'] && (workarea[uld.build_to || 'UNKNOWN'] = [])
          !workarea[uld.build_to || 'UNKNOWN']['loose'] && (workarea[uld.build_to || 'UNKNOWN']['loose'] = [])
          workarea[uld.build_to || 'UNKNOWN']['loose'].push(awb)
        })
      } else {
        !workarea[uld.build_to || 'UNKNOWN'] && (workarea[uld.build_to || 'UNKNOWN'] = [])
        !workarea[uld.build_to || 'UNKNOWN']['uld'] && (workarea[uld.build_to || 'UNKNOWN']['uld'] = [])
        workarea[uld.build_to || 'UNKNOWN']['uld'].push(uld)
      }
    })
    //sort Unknown to last
    const sortedWorkareaKeys = Object.keys(workarea).sort((a, b) => {
      if (a === 'UNKNOWN') return 1
      if (b === 'UNKNOWN') return -1
      return a.localeCompare(b)
    })
    let last_row = 7
    let counter = 1
    sortedWorkareaKeys.forEach((index) => {
      const area = workarea[index]
      last_row++
      ws.mergeCells(`A${last_row}:L${last_row}`)
      ws.getCell(`A${last_row}`).value = index == 'UNKNOWN' ? 'Miscellaneous' : index
      ws.getCell(`A${last_row}`).fill = yellow
      ws.getCell(`A${last_row}`).font = bold
      ws.getCell(`A${last_row}`).alignment = { horizontal: 'center' }
      ws.getCell(`A${last_row}`).border = border
      if (area.loose) {
        last_row++
        ws.mergeCells(`A${last_row}:L${last_row}`)
        ws.getCell(`A${last_row}`).value = 'Loose'
        ws.getCell(`A${last_row}`).fill = grey
        ws.getCell(`A${last_row}`).font = bold
        ws.getCell(`A${last_row}`).alignment = { horizontal: 'center' }
        ws.getCell(`A${last_row}`).border = border
        area.loose && (area.loose.forEach((awb) => {
          last_row++
          let delay = awb?.awb?.time_of_avl ? moment(moment().tz(cookies.get('timezone')).format('YYYY-MM-DD')).diff(moment(awb.awb.time_of_avl), 'days') * -1 : 0
          const row = ws.addRow([counter, awb.awb_no.replace(/(\d{3})(\d{8})/, '$1-$2'), awb.location || '', delay, awb.priority || '', awb.prod_code || '', '', '', ''])
          ws.mergeCells(`H${row.number}:I${row.number}`)
          ws.mergeCells(`J${row.number}:L${row.number}`)
          if (counter % 2 == 0) {
            row.eachCell((cell) => {
              cell.fill = blue
              cell.border = border
            })
          } else {
            row.eachCell((cell) => {
              cell.border = border
            })
          }

          // if (['RDG', 'ICE', 'ICV'].includes(awb?.prod_code)) {
          //   row.getCell(6).fill = {
          //     type: 'pattern',
          //     pattern: 'solid',
          //     fgColor: { argb: 'FFC7CE' }
          //   }
          // }

          if (delay <= 1) {
            // green
            row.getCell(4).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'C6EFCE' }
            }
          }
          if (delay > 0) {
            // red
            row.getCell(4).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFC7CE' }
            }
          }
          counter++
        }))
      }
      if (area.uld) {
        last_row++
        ws.mergeCells(`A${last_row}:L${last_row}`)
        ws.getCell(`A${last_row}`).value = 'Pre-Built'
        ws.getCell(`A${last_row}`).fill = grey
        ws.getCell(`A${last_row}`).font = bold
        ws.getCell(`A${last_row}`).alignment = { horizontal: 'center' }
        ws.getCell(`A${last_row}`).border = border
        area.uld && (area.uld.forEach((uld) => {
          last_row++
          let delays = []
          let products = []
          uld.awbs_in.forEach((awb) => {
            products.push(awb.prod_code)
            let delay = awb?.awb?.time_of_avl ? moment(moment().tz(cookies.get('timezone')).format('YYYY-MM-DD')).diff(moment(awb.awb.time_of_avl), 'days') : 0
            delays.push(delay)
          })
          let minDelay = Math.min(...delays)
          products = [...new Set(products)]
          const productStr = products.join(', ')
          const row = ws.addRow([counter, uld.uld_no, uld.location || '', minDelay, '', productStr, '', '', ''])
          ws.mergeCells(`H${row.number}:I${row.number}`)
          ws.mergeCells(`J${row.number}:L${row.number}`)
          if (counter % 2 == 0) {
            row.eachCell((cell) => {
              cell.fill = blue
              cell.border = border
            })
          } else {
            row.eachCell((cell) => {
              cell.border = border
            })
          }
          if (minDelay >= 1) {
            // green
            row.getCell(4).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'C6EFCE' }
            }
          }
          if (minDelay < 0) {
            // red
            row.getCell(4).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFC7CE' }
            }
          }
          counter++
        }))
      }
    })

    /* ---------------- SUMMARY ---------------- */
    last_row++
    ws.mergeCells(`A${last_row}:L${last_row}`)
    ws.getCell(`A${last_row}`).value = 'Flight Summary:'
    ws.getCell(`A${last_row}`).fill = blue
    ws.getCell(`A${last_row}`).font = bold
    ws.getCell(`A${last_row}`).border = border

    last_row++
    ws.mergeCells(`A${last_row}:L${last_row}`)
    ws.getCell(`A${last_row}`).value = 'MEF'
    ws.getCell(`A${last_row}`).fill = yellow
    ws.getCell(`A${last_row}`).font = bold
    ws.getCell(`A${last_row}`).alignment = { horizontal: 'center' }
    ws.getCell(`A${last_row}`).border = border

    last_row++
    ws.getCell(`A${last_row}`).value = 'Number'
    ws.mergeCells(`B${last_row}:L${last_row}`)
    ws.getCell(`A${last_row}`).value = 'AWB/Conveyances'
    ws.getCell(`A${last_row}`).fill = blue
    ws.getCell(`A${last_row}`).font = bold
    ws.getCell(`A${last_row}`).border = border
    ws.getCell(`A${last_row}`).fill = blue
    ws.getCell(`A${last_row}`).font = bold
    ws.getCell(`A${last_row}`).border = border
    // Add summary rows
    let summaryRows = [[1, ''], [2, ''], [3, ''], [4, ''], [5, '']]
    summaryRows.forEach(r => {
      const row = ws.addRow([...r])
      if (row.number % 2 == 0) {
        row.eachCell(c => c.fill = blue)
      }
      ws.mergeCells(`B${row.number}:L${row.number}`)
      row.eachCell(c => c.border = border)
    })


    /* -------------------- SAVE -------------------- */
    const buffer = await wb.xlsx.writeBuffer()
    if (download_type === 'email') {
      const fileName = `SCRUB_COPY_${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`
      const fileBlob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      // saveAs(fileBlob, fileName); // still triggers download
      return {
        fileName,
        fileBlob
      }
    } else {
      saveAs(new Blob([buffer]), `SCRUB_COPY_${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`)
    }
  }

  generateLoadPlan = async (download_type = null) => {
    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet('Builder Copy', { properties: { defaultRowHeight: 18 } })

    for (let i = 1; i <= 100; i++) {
      for (let j = 1; j <= 50; j++) {
        const cell = sheet.getRow(i).getCell(j)
        cell.border = {
          top: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          left: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          bottom: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          right: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          }
        }
      }
    }

    const blue = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }

    /* -------------------------------------------------
       COLUMN SETUP
    ------------------------------------------------- */
    sheet.columns = [
      { width: 2 },
      { width: 16 },
      { width: 18 },
      { width: 15 },
      { width: 8 },
      { width: 12 },
      { width: 12 },
      { width: 10 },
      { width: 10 },
      { width: 15 },
      { width: 12 },
      { width: 10 },
      { width: 10 },
    ]
    let columns = [
      { header: '', },
      { header: 'AWB', },
      { header: 'Location', },
      { header: 'Comments', },
      { header: 'Pcs', },
      { header: `GR Wt (${this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'})`, },
      { header: `Vol (${this.state.editWgtUnit === 'KG' ? 'cbm' : 'cft'})`, },
      { header: 'Prod', },
      { header: 'Dest', },
      { header: 'Days Delayed', },
      { header: 'Pri #', },
      { header: 'On Hand' },
    ]


    // trasnparent border for all cell

    /* -------------------------------------------------
       HELPERS
    ------------------------------------------------- */
    function setBorderForRange(r1, c1, r2, c2) {
      // Apply thin border to all cells first
      for (let r = r1; r <= r2; r++) {
        for (let c = c1; c <= c2; c++) {
          sheet.getCell(r, c).border = {
            top: {
              style: 'thin',
              color: { argb: '000000' }
            },
            left: {
              style: 'thin',
              color: { argb: '000000' }
            },
            bottom: {
              style: 'thin',
              color: { argb: '000000' }
            },
            right: {
              style: 'thin',
              color: { argb: '000000' }
            },
          }
          if (r == r2) {
            sheet.getCell(r + 1, c).border = {
              top: {
                style: 'thin',
                color: { argb: '000000' }
              },
              left: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              bottom: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              right: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              }
            }
          }
          if (c == c2) {
            sheet.getCell(r, c + 1).border = {
              top: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              left: {
                style: 'thin',
                color: { argb: '000000' }
              },
              bottom: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              right: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              }
            }
          }
        }
      }
    }

    const center = (cell) => {
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      }
    }

    /* -------------------------------------------------
       FLIGHT INFO BOX (TOP LEFT)
    ------------------------------------------------- */
    const flightInfo = [
      ['', 'Flight #', this.state.editRecord.flight_no],
      ['', 'Date', moment(this.state.editRecord.flight_date).format('DD/MM/YYYY')],
      ['', 'Aircraft Type', this.state.editRecord.fleet || ''],
      ['', 'Departure Time', moment(this.state.editRecord.dept_date).tz(this.state.timezone).format('HH:mm')],
      ['', 'FP Time', this.state.editRecord.time_to_dept ? moment(this.state.editRecord.time_to_dept).format('HH:mm') : ''],
      ['', 'DOD Name', cookies.get('name')],
      ['', 'DOD Contact #', ''],
      ['', 'PPR No.', cookies.get('ppr')]
    ]

    flightInfo.forEach((row, i) => {
      const r = i + 2
      sheet.mergeCells(`C${r}:D${r}`)
      sheet.getCell(`B${r}`).value = row[1]
      sheet.getCell(`C${r}`).value = row[2]
      sheet.getCell(`B${r}`).font = { bold: true }
      sheet.getCell(`B${r}`).fill = blue
    })

    setBorderForRange(2, 2, 9, 4)

    /* -------------------------------------------------
       MAX ULD CONFIG BOX (TOP RIGHT)
    ------------------------------------------------- */
    sheet.mergeCells('M5:P6')
    sheet.getCell('M5').value = 'Max ULD Configuration'
    sheet.getCell('M5').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('M5').fill = blue
    center(sheet.getCell('M5'))

    sheet.mergeCells('M7:P8')
    sheet.getCell('M7').value = 'Planned Bin Configuration'
    sheet.getCell('M7').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('M7').fill = blue
    center(sheet.getCell('M7'))


    sheet.getCell('Q4').value = 'PMC'
    sheet.getCell('Q4').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('Q4').fill = blue
    center(sheet.getCell('Q4'))
    // PAG
    sheet.getCell('R4').value = 'PAG'
    sheet.getCell('R4').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('R4').fill = blue
    center(sheet.getCell('R4'))
    // LD2
    sheet.getCell('S4').value = 'LD2'
    sheet.getCell('S4').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('S4').fill = blue
    center(sheet.getCell('S4'))
    // LD3
    sheet.getCell('T4').value = 'LD3'
    sheet.getCell('T4').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('T4').fill = blue
    center(sheet.getCell('T4'))
    //LD4/8/FQA
    sheet.getCell('U4').value = 'LD4/8/FQA'
    sheet.getCell('U4').alignment = { wrapText: true }
    sheet.getCell('U4').font = {
      bold: true,
      size: 9
    }
    sheet.getCell('U4').fill = blue
    center(sheet.getCell('U4'))

    const bin_config = this.get_bin_config()
    sheet.mergeCells('Q5:Q6')
    sheet.getCell('Q5').value = bin_config[0]?.PMC || ''
    center(sheet.getCell('Q5'))
    sheet.mergeCells('R5:R6')
    sheet.getCell('R5').value = bin_config[0]?.PAG || ''
    center(sheet.getCell('R5'))
    sheet.mergeCells('S5:S6')
    sheet.getCell('S5').value = bin_config[0]?.LD2 || ''
    center(sheet.getCell('S5'))
    sheet.mergeCells('T5:T6')
    sheet.getCell('T5').value = bin_config[0]?.LD3 || ''
    center(sheet.getCell('T5'))
    sheet.mergeCells('U5:U6')
    sheet.getCell('U5').value = bin_config[0]?.LD4_8_FQA || ''
    center(sheet.getCell('U5'))

    sheet.mergeCells('Q7:Q8')
    sheet.getCell('Q7').value = bin_config[1]?.PMC || ''
    center(sheet.getCell('Q7'))
    sheet.mergeCells('R7:R8')
    sheet.getCell('R7').value = bin_config[1]?.PAG || ''
    center(sheet.getCell('R7'))
    sheet.mergeCells('S7:S8')
    sheet.getCell('S7').value = bin_config[1]?.LD2 || ''
    center(sheet.getCell('S7'))
    sheet.mergeCells('T7:T8')
    sheet.getCell('T7').value = bin_config[1]?.LD3 || ''
    center(sheet.getCell('T7'))
    sheet.mergeCells('U7:U8')
    sheet.getCell('U7').value = bin_config[1]?.LD4_8_FQA || ''
    center(sheet.getCell('U7'))

    setBorderForRange(4, 17, 4, 21)
    setBorderForRange(5, 13, 8, 21)

    /* -------------------------------------------------
       TABLE HEADER ROW
    ------------------------------------------------- */
    const headerRow = sheet.getRow(14)
    headerRow.values = columns.map(col => col.header)

    headerRow.eachCell((cell, c) => {
      if (c === 1) return // skip first col
      cell.font = { bold: true }
      center(cell)
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFDAE3F3' }
      }
    })

    for (let i = 13; i <= 33; i++) {
      const cell = sheet.getRow(11).getCell(i)
      cell.value = i == 13 ? 'BULK' : i - 13
      cell.font = {
        size: 10,
        color: { argb: 'FF808080' } // grey
      }
      center(cell)
    }

    let uld_col = 14
    this.state.editRecord?.build_uld?.map((uld) => {
      const cell = sheet.getRow(12).getCell(uld_col)
      cell.value = uld.type
      center(cell)
      uld_col++
    })

    uld_col = 14
    this.state.editRecord?.build_uld?.map((uld) => {
      const cell = sheet.getRow(13).getCell(uld_col)
      cell.value = uld.uld_no || ''
      center(cell)
      uld_col++
    })

    setBorderForRange(12, 13, 13, 33)
    setBorderForRange(14, 2, 14, 33)

    /* -------------------------------------------------
       SAMPLE DATA ROWS
    ------------------------------------------------- */
    const dataRows = []
    this.state.mergeEditRecord?.map((awb) => {
      if (awb.is_deleted) {
        return
      }
      let unit = awb?.wgt?.unit
      let wgtValue = ''
      {
        if (this.state.editWgtUnit === 'KG') {
          if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
            let kg = this.updateWeightVal('KG', awb?.wgt?.value)
            wgtValue = Math.round(kg)
          }
          else {
            wgtValue = Math.round(awb?.wgt?.value)
          }
        }
        else if (this.state.editWgtUnit === 'LB') {
          if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
            let lb = this.updateWeightVal('LB', awb?.wgt?.value)
            wgtValue = Math.round(lb)
          }
          else {
            wgtValue = Math.round(awb?.wgt?.value)
          }
        }
      }

      let vol = awb?.vol?.value
      let volValue = ''
      if (this.state.editWgtUnit === 'LB' && awb?.vol?.unit === 'CBM') {
        let cbf = this.updateVolumeVal('CBF', vol)
        volValue = Math.round(cbf)
      } else if (this.state.editWgtUnit === 'KG' && (awb?.vol?.unit === 'CBF' || awb?.vol?.unit === 'CFT')) {
        let cbm = this.updateVolumeVal('CBM', vol)
        volValue = Math.round(cbm * 10) / 10
      } else {
        volValue = awb?.vol?.unit === 'CBF' || awb?.vol?.unit === 'CFT' ? Math.round(vol) : (Math.round(vol * 10) / 10)
      }

      // let delay = awb?.delay ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment(awb?.delay), 'days') * -1 : 0
      let delay = awb?.delay ? awb?.delay : 0

      let bpIndex = this.state.editRecord.build_plan.findIndex((item) => item.awb_no === awb.awb_no)
      let priority = bpIndex !== -1 && this.state.editRecord.build_plan[bpIndex]?.data?.pri != null ? this.state.editRecord.build_plan[bpIndex]?.data?.pri : awb.priority
      let awb_data = [
        '',
        awb?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2') || '',
        awb?.location || '',
        '',
        awb?.pcs || '',
        wgtValue || '',
        volValue || '',
        awb?.prod_code || '',
        awb?.dest || '',
        delay || '',
        priority || 999,
        awb?.on_hand ? 'Y' : 'N',
        bpIndex !== -1 && this.state.editRecord.build_plan[bpIndex]?.data?.blk ? this.state.editRecord.build_plan[bpIndex]?.data?.blk : '']
      this.state.editRecord?.build_uld?.map((uld) => {
        let pcs = ''
        if (bpIndex !== -1 && this.state.editRecord.build_plan[bpIndex]?.ulds?.length > 0) {
          let found = this.state.editRecord.build_plan[bpIndex]?.ulds.find((u) => u.id === uld.id)
          if (found) {
            pcs = found.pcs
          }
        }
        awb_data.push(pcs)
      })
      dataRows.push(awb_data)
    })

    // sort by priority and then delays
    dataRows.sort((a, b) => {
      let a_pri = a[10] != '' ? a[10] : 99
      let b_pri = b[10] != '' ? b[10] : 99
      if (a_pri != b_pri) {
        return a[10] - b[10] // sort by priority
      } else {
        return b[9] - a[9] // then sort by delays
      }
    })


    dataRows.forEach((rowData, i) => {
      const row = sheet.getRow(15 + i)
      let fData = [...rowData]
      fData[10] = fData[10] == 999 ? '' : fData[10]
      row.values = fData

      row.eachCell((cell, colNumber) => {
        center(cell)

        // Days Delayed coloring
        if (colNumber === 10) {
          if (cell.value > 0) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFFFC7CE' }
            } // red
          } else if (cell.value < 0) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFC6EFCE' }
            } // green
          }
        }
        // prod_code if (['RDG', 'ICE', 'ICV'].includes(awb?.prod_code)) {
        // if (colNumber == 8) {
        //   if (['RDG', 'ICE', 'ICV'].includes(cell.value)) {
        //     cell.fill = {
        //       type: 'pattern',
        //       pattern: 'solid',
        //       fgColor: { argb: 'FFFFC7CE' }
        //     }
        //   }
        // }
      })
    })

    setBorderForRange(15, 2, 14 + dataRows.length, 33)

    /* -------------------------------------------------
       ULD POSITION HEADER
    ------------------------------------------------- */
    // sheet.mergeCells('L8:S8')
    // const uldTitle = sheet.getCell('L8')
    // uldTitle.value = 'ULD POSITIONS'
    // uldTitle.font = { bold: true }
    // center(uldTitle)
    // borderAll(uldTitle)

    // Grey blocked area (like aircraft hold)
    for (let col = 13; col <= 33; col++) {
      const cell = sheet.getCell(14, col)
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFBFBFBF' }
      }
    }


    const buffer = await workbook.xlsx.writeBuffer()
    if (download_type === 'email') {
      const fileName = `LoadPlan${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`
      const fileBlob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      // saveAs(fileBlob, fileName); // still triggers download
      return {
        fileName,
        fileBlob
      }
    } else {
      saveAs(new Blob([buffer]), `LoadPlan${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`)
    }
  }

  generateLoadPlanLHR = async (download_type = null) => {
    const workbook = new ExcelJS.Workbook()
    const ws = workbook.addWorksheet('LHR Builder Copy', {
      pageSetup: {
        paperSize: 20,
        orientation: 'landscape',
        scale: 50
      }
    })
    // const borderAll = (cell) => {
    //   cell.border = {
    //     top: {
    //       style: 'thin',
    //       color: { argb: '000000' }
    //     },
    //     left: {
    //       style: 'thin',
    //       color: { argb: '000000' }
    //     },
    //     bottom: {
    //       style: 'thin',
    //       color: { argb: '000000' }
    //     },
    //     right: {
    //       style: 'thin',
    //       color: { argb: '000000' }
    //     }
    //   }
    // }

    for (let i = 1; i <= 100; i++) {
      for (let j = 1; j <= 50; j++) {
        const cell = ws.getRow(i).getCell(j)
        cell.border = {
          top: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          left: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          bottom: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          },
          right: {
            style: 'thin',
            color: { argb: 'FFFFFF' }
          }
        }
      }
    }


    const thin = {
      style: 'thin',
      color: { argb: '000000' }
    }
    const center = {
      vertical: 'middle',
      horizontal: 'center'
    }
    const bold = { bold: true }

    // Helper to draw borders around ANY range (fixes missing edges on merged cells)
    // function box(r1, c1, r2, c2) {
    //   for (let r = r1; r <= r2; r++) {
    //     for (let c = c1; c <= c2; c++) {
    //       const cell = ws.getCell(r, c)
    //       cell.border = {
    //         top: r === r1 ? thin : undefined,
    //         bottom: r === r2 ? thin : undefined,
    //         left: c === c1 ? thin : undefined,
    //         right: c === c2 ? thin : undefined,
    //       }
    //     }
    //   }
    // }

    function setBorderForRange(r1, c1, r2, c2) {
      // Apply thin border to all cells first
      for (let r = r1; r <= r2; r++) {
        for (let c = c1; c <= c2; c++) {
          ws.getCell(r, c).border = {
            top: {
              style: 'thin',
              color: { argb: '000000' }
            },
            left: {
              style: 'thin',
              color: { argb: '000000' }
            },
            bottom: {
              style: 'thin',
              color: { argb: '000000' }
            },
            right: {
              style: 'thin',
              color: { argb: '000000' }
            },
          }
          if (r == r2) {
            ws.getCell(r + 1, c).border = {
              top: {
                style: 'thin',
                color: { argb: '000000' }
              },
              left: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              bottom: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              right: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              }
            }
          }
          if (c == c2) {
            ws.getCell(r, c + 1).border = {
              top: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              left: {
                style: 'thin',
                color: { argb: '000000' }
              },
              bottom: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              },
              right: {
                style: 'thin',
                color: { argb: 'FFFFFF' }
              }
            }
          }
        }
      }
    }

    // Column widths
    ws.columns = [
      { width: 2 }, // A
      { width: 28 }, // B
      { width: 4 }, // C
      { width: 7 }, // D
      { width: 7 }, // E
      { width: 7 }, // F
      { width: 7 }, // G
      { width: 7 }, // H
      { width: 7 }, // I
      { width: 15 }, // J
      { width: 15 }, // K
      { width: 15 }, // L
      { width: 17 }, // M
      { width: 17 }, // N  
      { width: 7 }, // O
      { width: 7 }, // P
      { width: 8 }, // Q
      { width: 8 }, // R
      { width: 8 }, // S
      { width: 8 }, // T
      { width: 8 }, // U
      { width: 8 }, // V
      { width: 8 }, // W
      { width: 8 }, // X
      { width: 8 }, // Y
      { width: 8 }, // Z
      { width: 8 }, // AA
      { width: 8 }, // AB
      { width: 8 }, // AC
      { width: 8 }, // AD
      { width: 8 }, // AE
      { width: 8 }, // AF
      { width: 8 }, // AG
      { width: 8 }, // AH
      { width: 8 }, // AI
      { width: 8 }, // AJ
      { width: 8 }, // AK
    ]

    function labelCell(r, c, text) {
      const cell = ws.getCell(r, c)
      cell.value = text
      cell.font = bold
      cell.alignment = center
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DAE3F3' }
      }
    }

    function valueCell(r, c1, c2, text = '') {
      ws.mergeCells(r, c1, r, c2)
      const cell = ws.getCell(r, c1)
      cell.value = text
      cell.alignment = center
    }

    // ==== TOP LEFT FLIGHT INFO ====
    labelCell(2, 2, 'Flight #:'); valueCell(2, 3, 7, this.state.editRecord.flight_no)
    labelCell(3, 2, 'Date:'); valueCell(3, 3, 7, moment(this.state.editRecord.flight_date).format('DD/MM/YYYY'))
    labelCell(4, 2, 'Destination:'); valueCell(4, 3, 7, this.state.editRecord.dest_stn)
    labelCell(5, 2, 'Aircraft Type:'); valueCell(5, 3, 7, this.state.editRecord.fleet)
    labelCell(6, 2, 'Departure time:'); valueCell(6, 3, 7, moment(this.state.editRecord.dept_date).tz(this.state.timezone).format('h:mm A'))
    labelCell(7, 2, 'FP time:'); valueCell(7, 3, 7, this.state.editRecord.time_to_dept ? moment(this.state.editRecord.time_to_dept).format('h:mm A') : '')
    labelCell(8, 2, 'DoD Name:'); valueCell(8, 3, 7, cookies.get('name'))
    labelCell(9, 2, 'DoD Contact #:'); valueCell(9, 3, 7, 'Enter Contact #')
    labelCell(10, 2, 'PPR No.:'); valueCell(10, 3, 7, cookies.get('ppr') || '')
    labelCell(11, 2, 'Baggage Bins:'); valueCell(11, 3, 7, '')

    // box(2, 2, 10, 3)
    setBorderForRange(2, 2, 11, 7)

    // ==== DRY ICE LIMITS ====
    ws.mergeCells('H2:J3')
    ws.getCell('H2').value = 'DRY ICE LIMITS'
    ws.getCell('H2').font = bold
    ws.getCell('H2').alignment = center
    ws.getCell('H2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F8CBAD' }
    }
    ws.mergeCells('H4:H5')
    ws.getCell('H4').value = 'FWD'
    ws.mergeCells('I4:J5')
    ws.getCell('I4').value = '2204 LBS (1000 KG)'
    ws.mergeCells('H6:H7')
    ws.getCell('H6').value = 'AFT'
    ws.mergeCells('I6:J7')
    ws.getCell('I6').value = 'FORBIDDEN'
    ws.mergeCells('H8:H9')
    ws.getCell('H8').value = 'BULK'
    ws.mergeCells('I8:J9')
    ws.getCell('I8').value = 'FORBIDDEN'
    for (let r = 4; r <= 9; r++) {
      for (let c = 8; c <= 10; c++) {
        ws.getCell(r, c).alignment = center
        ws.getCell(r, c).font = bold
        ws.getCell(r, c).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FCE4D6' }
        }
      }
    }

    // ==== MAG MATERIAL ====
    ws.mergeCells('K2:K3')
    ws.getCell('K2').value = 'MAG MATERIAL'
    ws.getCell('K2').font = bold
    ws.getCell('K2').alignment = {
      wrapText: true,
      ...center
    }
    ws.getCell('K2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F8CBAD' }
    }

    ws.mergeCells('K4:K9')
    ws.getCell('K4').value = 'NO WEIGHT RESTRICTION, BUT MUST BE LOADED AFT'
    ws.getCell('K4').alignment = {
      wrapText: true,
      ...center
    }
    ws.getCell('K4').font = bold
    ws.getCell('K4').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FCE4D6' }
    }
    setBorderForRange(2, 8, 9, 11)

    // ==== MAX ULD SECTION ====
    ws.mergeCells('L3:N3')
    ws.getCell('L3').value = 'Max Available ULDs'
    ws.getCell('L3').alignment = center
    ws.getCell('L3').font = bold
    ws.getCell('L3').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9D9D9' }
    }
    ws.mergeCells('L4:N4')
    ws.getCell('L4').value = 'Shipper Built ULDs'
    ws.getCell('L4').alignment = center
    ws.getCell('L4').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('L5:N5')
    ws.getCell('L5').value = 'Built On Hand ULDs'
    ws.getCell('L5').alignment = center
    ws.getCell('L5').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('L6:N6')
    ws.getCell('L6').value = 'To Be Built ULDs'
    ws.getCell('L6').alignment = center
    ws.getCell('L6').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('L7:N7')
    ws.getCell('L7').value = 'Positions Available for MEP & Overflow'
    ws.getCell('L7').alignment = center
    ws.getCell('L7').font = bold
    ws.getCell('L7').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9D9D9' }
    }

    // ['PMC','PAG','LD2','LD3','LD4/8/FQA'].forEach((t,i)=>{
    //   ws.getCell(2,15+i).value = t
    //   ws.getCell(2,15+i).font = bold
    //   ws.getCell(2,15+i).alignment = center
    // })

    ws.getCell('O2').value = 'PMC'
    ws.getCell('O2').font = bold
    ws.getCell('O2').alignment = center
    ws.getCell('O2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.getCell('P2').value = 'PAG'
    ws.getCell('P2').font = bold
    ws.getCell('P2').alignment = center
    ws.getCell('P2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('Q2:R2')
    ws.getCell('Q2').value = 'LD2'
    ws.getCell('Q2').font = bold
    ws.getCell('Q2').alignment = center
    ws.getCell('Q2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('S2:T2')
    ws.getCell('S2').value = 'LD3'
    ws.getCell('S2').font = bold
    ws.getCell('S2').alignment = center
    ws.getCell('S2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('U2:V2')
    ws.getCell('U2').value = 'LD4/8/FQA'
    ws.getCell('U2').font = bold
    ws.getCell('U2').alignment = center
    ws.getCell('U2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }

    // box(1,9,5,14)

    // ==== HINTS BOX ====
    ws.mergeCells('W2:AD2')
    ws.getCell('W2').value = 'Hints'
    ws.getCell('W2').alignment = center
    ws.getCell('W2').font = bold
    ws.getCell('W2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('W3:AD4')
    ws.getCell('W3').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('W5:AD5')
    ws.getCell('W5').value = 'Notes'
    ws.getCell('W5').alignment = center
    ws.getCell('W5').font = bold
    ws.getCell('W5').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }
    ws.mergeCells('W6:AD7')
    ws.getCell('W6').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DAE3F3' }
    }

    const bin_config = this.get_bin_config()
    ws.getCell('O3').value = bin_config[0]?.PMC || ''
    ws.getCell('P3').value = bin_config[0]?.PAG || ''
    ws.getCell('Q3').value = bin_config[0]?.LD2 || ''
    ws.getCell('S3').value = bin_config[0]?.LD3 || ''
    ws.getCell('U3').value = bin_config[0]?.LD4_8_FQA || ''

    for (let r = 3; r <= 7; r++) {
      for (let c = 14; c <= 22; c++) {
        ws.getCell(r, c).alignment = center
        ws.getCell(r, c).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: r == 3 || r == 7 ? 'D9D9D9' : 'DAE3F3' }
        }
      }
    }

    setBorderForRange(2, 15, 2, 30)
    setBorderForRange(3, 12, 7, 30)

    ws.getCell('AE2').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'C5E0B4' }
    }
    ws.getCell('AE3').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FAE395' }
    }
    ws.getCell('AE4').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'F2C7AB' }
    }

    ws.mergeCells('AF2:AI2')
    ws.getCell('AF2').value = 'Light: <= 1.5 t'
    ws.getCell('AF2').alignment = center
    ws.mergeCells('AF3:AI3')
    ws.getCell('AF3').value = 'Medium: > 1.5 t and <= 3 t'
    ws.getCell('AF3').alignment = center
    ws.mergeCells('AF4:AI4')
    ws.getCell('AF4').value = 'Heavy: > 3 t'
    ws.getCell('AF4').alignment = center

    setBorderForRange(2, 31, 4, 35)

    ws.mergeCells('AE6:AF6')
    ws.getCell('AE6').value = 'LOOSE:'
    ws.getCell('AE6').font = bold
    ws.getCell('AE6').alignment = center
    ws.mergeCells('AE7:AF7')
    ws.getCell('AE7').value = 'ULD:'
    ws.getCell('AE7').alignment = center
    ws.getCell('AE7').font = bold
    ws.mergeCells('AE8:AF8')
    ws.getCell('AE8').value = 'UWS:'
    ws.getCell('AE8').alignment = center
    ws.getCell('AE8').font = bold
    ws.mergeCells('AG6:AH6')
    ws.getCell('AG6').value = moment(this.state.editRecord.dept_date).tz(this.state.timezone).subtract(6, 'hours').format('h:mm A')
    ws.getCell('AG6').alignment = center
    ws.mergeCells('AG7:AH7')
    ws.getCell('AG7').value = moment(this.state.editRecord.dept_date).tz(this.state.timezone).subtract(4, 'hours').format('h:mm A')
    ws.getCell('AG7').alignment = center
    ws.mergeCells('AG8:AH8')
    ws.getCell('AG8').value = moment(this.state.editRecord.dept_date).tz(this.state.timezone).subtract(3.5, 'hours').format('h:mm A')
    ws.getCell('AG8').alignment = center
    // box(1,15,4,24)

    // ==== MAIN AWB HEADER ====
    const headers = ['AWB', 'Pri #', 'Pcs.', `GrWt. (${this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'})`, `Vol (${this.state.editWgtUnit === 'KG' ? 'cbm' : 'cft'})`, 'Orig', 'Dest', 'Prod', 'SPLs', 'Desc', 'Agent', 'DoD Remarks', 'CSO Remarks', 'Shipper-Built?', 'On Hand?']

    headers.forEach((h, i) => {
      const cell = ws.getCell(12, 2 + i)
      cell.value = h
      cell.font = bold
      cell.alignment = {
        textRotation: [1, 2, 3, 4, 5, 6, 7, 8, 13, 14].includes(i) ? -90 : 0,
        ...center
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'DAE3F3' }
      }
      cell.border = {
        top: thin,
        left: thin,
        right: thin,
        bottom: thin
      }
    })
    for (let i = 17; i <= 37; i++) {
      const cell = ws.getRow(10).getCell(i)
      cell.value = i == 37 ? 'BULK' : i - 16
      cell.font = {
        size: 10,
        color: { argb: 'FF808080' } // grey
      }
      cell.alignment = center
    }
    let uld_col = 17
    this.state.editRecord?.build_uld?.map((uld) => {
      const cell = ws.getRow(11).getCell(uld_col)
      cell.value = uld.type
      cell.alignment = center
      uld_col++
    })


    uld_col = 17
    this.state.editRecord?.build_uld?.map((uld) => {
      const cell = ws.getRow(12).getCell(uld_col)
      cell.value = uld.uld_no || ''
      cell.alignment = center
      uld_col++
    })

    setBorderForRange(11, 17, 12, 37)

    const dataRows = []
    this.state.mergeEditRecord?.map((awb) => {
      let unit = awb?.wgt?.unit
      let wgtValue = ''
      {
        if (this.state.editWgtUnit === 'KG') {
          if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
            let kg = this.updateWeightVal('KG', awb?.wgt?.value)
            wgtValue = Math.round(kg)
          }
          else {
            wgtValue = Math.round(awb?.wgt?.value)
          }
        }
        else if (this.state.editWgtUnit === 'LB') {
          if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
            let lb = this.updateWeightVal('LB', awb?.wgt?.value)
            wgtValue = Math.round(lb)
          }
          else {
            wgtValue = Math.round(awb?.wgt?.value)
          }
        }
      }

      let vol = awb?.vol?.value
      let volValue = ''
      if (this.state.editWgtUnit === 'LB' && awb?.vol?.unit === 'CBM') {
        let cbf = this.updateVolumeVal('CBF', vol)
        volValue = Math.round(cbf)
      } else if (this.state.editWgtUnit === 'KG' && (awb?.vol?.unit === 'CBF' || awb?.vol?.unit === 'CFT')) {
        let cbm = this.updateVolumeVal('CBM', vol)
        volValue = Math.round(cbm * 10) / 10
      } else {
        volValue = awb?.vol?.unit === 'CBF' || awb?.vol?.unit === 'CFT' ? Math.round(vol) : (Math.round(vol * 10) / 10)
      }

      let bpIndex = this.state.editRecord.build_plan.findIndex((item) => item.awb_no === awb.awb_no)
      let priority = bpIndex !== -1 && this.state.editRecord.build_plan[bpIndex]?.data?.pri != null ? this.state.editRecord.build_plan[bpIndex]?.data?.pri : awb.priority
      let awb_data = [
        '',
        awb?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2') || '',
        priority || 0,
        awb?.pcs || '',
        wgtValue || '',
        volValue || '',
        awb?.org || '',
        awb?.dest || '',
        awb?.prod_code || '',
        awb?.spl_code || '',
        '',
        '',
        '',
        '',
        '',
        awb?.on_hand ? 'Y' : 'N',
      ]
      this.state.editRecord?.build_uld?.map((uld) => {
        let pcs = ''
        if (bpIndex !== -1 && this.state.editRecord.build_plan[bpIndex]?.ulds?.length > 0) {
          let found = this.state.editRecord.build_plan[bpIndex]?.ulds.find((u) => u.id === uld.id)
          if (found) {
            pcs = found.pcs
          }
        }
        awb_data.push(pcs)
      })
      awb_data[36] = bpIndex !== -1 && this.state.editRecord.build_plan[bpIndex]?.data?.blk ? this.state.editRecord.build_plan[bpIndex]?.data?.blk : ''
      dataRows.push(awb_data)
    })

    dataRows.sort((a, b) => {
      if (a[3] != b[3]) {
        return b[3] - a[3] // sort by pieces desc
      }
    })

    dataRows.forEach((rowData, i) => {
      const row = ws.getRow(13 + i)
      // trim rowData till 36 index
      row.values = rowData
      row.eachCell((cell, colNumber) => {
        // prod_code if (['RDG', 'ICE', 'ICV'].includes(awb?.prod_code)) {
        if (colNumber == 9) {
          if (cell.value.includes('RDG') || cell.value.includes('ICE') || cell.value.includes('ICV')) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFFFC7CE' }
            }
          }
        }
      })
    })

    setBorderForRange(13, 2, 13 + dataRows.length - 1, 37)

    const buffer = await workbook.xlsx.writeBuffer()
    if (download_type === 'email') {
      const fileName = `LHR${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`
      const fileBlob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      // saveAs(fileBlob, fileName); // still triggers download
      return {
        fileName,
        fileBlob
      }
    } else {
      saveAs(new Blob([buffer]), `LHR${this.state.editRecord.flight_no}_${moment(this.state.editRecord.flight_date).format('DDMMMYYYY')}.xlsx`)
    }
  }

  updateOptiData = () => {
    let obj = {
      id: this.state.editOptiUld?.id,
      uld_no: this.state.editOptiUld?.uld_no,
      type: this.state.editOptiUld?.type,
      remark: this.state.editOptiUld?.remark,
      stn: cookies.get('station')
    }
    if (obj.type && obj.id) {
      Http.put(`/build_uld/${this.state.editRecord.id}`, obj).then(() => {
        this.setState({ editOptiUld: {} })
      })
    }
  }

  removeOptiData = (id) => {
    Http.put(`/build_uld_delete/${this.state.editRecord.id}`, {
      id,
      stn: cookies.get('station')
    })
  }

  editOptiData = (record) => {
    this.setState({ editOptiUld: record })
  }

  clearOptiData = () => {
    this.setState({ editOptiUld: {} })
  }

  showQuizModal = (record, item) => {
    let milestoneData = this.state.milestoneData
    const order = ['Dod', 'Rebookings', 'No Rides']
    // get 'Freight at Gate' record id
    let freightAtGateId = milestoneData.find((item) => item?.title.includes('Freight at Gate'))?.id
    milestoneData = milestoneData.sort((a, b) => {
      return order.indexOf(a.type) - order.indexOf(b.type)
    })
    let current = null
    let prevprev = null
    let prev = null
    milestoneData.map((item2) => {
      if (item2?.id === item?.id) {
        current = item2
      } else if (!current) {
        if (freightAtGateId === item2?.id) {
          prevprev = prev
        }
        prev = item2
      }
    })
    let found = false
    if (prev) {
      if (record.answers.find((rec) => rec?.milestones_id === prev?.id)) {
        found = true
      }
    }
    if (prevprev) {
      if (record.answers.find((rec) => rec?.milestones_id === prevprev?.id) && found) {
        found = true
      } else {
        found = false
      }
    }
    if (!prev || (prev && found) || item?.title.includes('Freight at Gate')) {
      this.setState({
        // openQuizModal: true,
        quizMilestonid: item.id,
        quizModalFlight: cloneDeep(record),
        checklistTitle: item.title,
        questionsData: [],
        tempquestionsData: []
      }, () => this.fetchQuestions(record.id, item.id, false))
    } else {
      notification.destroy()
      notification.warning({
        message: 'Warning',
        description: 'Please complete previous milestone to proceed',
      })
    }
  }

  getAuditStatus = (record) => {
    let audit_submitted = record?.audit ? 'Yes' : 'No'
    let audit_built_right = record?.audit?.audit_built_right || null
    let audit_was_optimal = record?.audit?.audit_was_optimal || null
    let audit_meet_wgt_goal = record?.audit?.audit_meet_wgt_goal || null
    let noridelen = record?.norides?.length > 0 ? 'greater' : 'zero'
    if (!audit_built_right && !audit_was_optimal && !audit_meet_wgt_goal) {
      audit_submitted = 'No'
    }
    let audit_row = audit_status.find((item) =>
      item?.audit_submitted == audit_submitted
      && item?.planned_accordingly === audit_built_right
      && item?.optimal === audit_was_optimal
      && item?.meet_wgt_goal === audit_meet_wgt_goal
      && item?.num_of_rides === noridelen
    )
    if (!audit_row && noridelen === 'zero') {
      return (
        <MehOutlined
          style={{
            fontSize: 'large',
            color: 'grey',
            cursor: 'pointer'
          }}
          min={0}
          precision={0}
          controls={false}
          className='text-center'
          size='large'
          placeholder=''
        />
      )
    } else if (audit_row?.emote === 'MehOutlined') {
      return (
        <MehOutlined
          style={{
            fontSize: 'large',
            color: audit_row.color,
            cursor: 'pointer'
          }}
          min={0}
          precision={0}
          controls={false}
          className='text-center'
          size='large'
          placeholder=''
        />
      )
    } else if (audit_row?.emote === 'SmileOutlined') {
      return (
        <SmileOutlined
          style={{
            fontSize: 'large',
            color: audit_row.color,
            cursor: 'pointer'
          }}
          min={0}
          precision={0}
          controls={false}
          className='text-center'
          size='large'
          placeholder=''
        />
      )
    } else if (audit_row?.emote === 'FrownOutlined') {
      return (
        <FrownOutlined
          style={{
            fontSize: 'large',
            color: audit_row.color,
            cursor: 'pointer'
          }}
          min={0}
          precision={0}
          controls={false}
          className='text-center'
          size='large'
          placeholder=''
        />
      )
    }
  }

  getLDDStatus = (record) => {
    let pallets_paired = record?.ldd?.pallets_paired || null
    let pallets_paired_contact = record?.ldd?.pallets_paired_contact || null
    let conveyances_staged = record?.ldd?.conveyances_staged || null
    let conveyances_staged_contact = record?.ldd?.conveyances_staged_contact || null

    let ldd_row = ldd_status.find((item) =>
      item?.pallets_paired === pallets_paired
      && item?.pallets_paired_contact === pallets_paired_contact
      && item?.conveyances_staged === conveyances_staged
      && item?.conveyances_staged_contact === conveyances_staged_contact
    )
    if (ldd_row) {
      if (ldd_row?.emote === 'MehOutlined') {
        return (
          <MehOutlined
            style={{
              fontSize: 'large',
              color: ldd_row.color,
              cursor: 'pointer'
            }}
            min={0}
            precision={0}
            controls={false}
            className='text-center'
            size='large'
            placeholder=''
          />
        )
      } else if (ldd_row?.emote === 'SmileOutlined') {
        return (
          <SmileOutlined
            style={{
              fontSize: 'large',
              color: ldd_row.color,
              cursor: 'pointer'
            }}
            min={0}
            precision={0}
            controls={false}
            className='text-center'
            size='large'
            placeholder=''
          />
        )
      } else if (ldd_row?.emote === 'FrownOutlined') {
        return (
          <FrownOutlined
            style={{
              fontSize: 'large',
              color: ldd_row.color,
              cursor: 'pointer'
            }}
            min={0}
            precision={0}
            controls={false}
            className='text-center'
            size='large'
            placeholder=''
          />
        )
      }
    } else {
      return (
        <MehOutlined
          style={{
            fontSize: 'large',
            color: 'grey',
            cursor: 'pointer'
          }}
          min={0}
          precision={0}
          controls={false}
          className='text-center'
          size='large'
          placeholder=''
        />
      )
    }
  }

  formatCutoff = (cutoff) => {
    let str = ''
    if (typeof cutoff === 'string' && cutoff.includes(',')) {
      let arr = cutoff.split(',')
      if (arr.length === 2) {
        str = `D-${(parseInt(arr[0]) / 60).toFixed(2)} Hrs Intl, D-${(parseInt(arr[1]) / 60).toFixed(2)} Hrs Dom`
        str = str.replace(/,/g, ',\n')
      } else if (arr.length === 3) {
        str = `D-${(parseInt(arr[0]) / 60).toFixed(2)} Hrs Intl, D-${(parseInt(arr[1]) / 60).toFixed(2)} Hrs Dom, D-${(parseInt(arr[2]) / 60).toFixed(2)} Hrs Hawaii `
        str = str.replace(/,/g, ',\n')
      }
    } else {
      str = `D-${(parseInt(cutoff) / 60).toFixed(2)} Hrs`
    }
    return str
  }
  getCutoff = (cutoff, flight) => {
    let Hawaii = ['HNL', 'OGG', 'KOA', 'MKK']
    if (typeof cutoff === 'string' && cutoff.includes(',')) {
      let arr = cutoff.split(',')
      let details = this.state.stationsData?.find((stn) => stn?.code === flight?.dest?.arriv) || ''
      if (details) {
        if (Hawaii.includes(flight?.dest?.arriv?.toUpperCase()) && arr.length === 3) {
          return (parseInt(arr[2]) / 60).toFixed(2)
        } else if (country.includes(details?.country?.toUpperCase())) {
          return (parseInt(arr[1]) / 60).toFixed(2)
        } else {
          return (parseInt(arr[0]) / 60).toFixed(2)
        }
      }
    } else {
      return (parseInt(cutoff) / 60).toFixed(2)
    }
  }
  //End of Checklist APIs

  //LOAD PLAN MODAL JSX
  loadPlanModal = () => {
    const planLoadColumns = [
      {
        title: '',
        dataIndex: 'pos',
        key: 'pos',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <InputNumber
              min={0}
              precision={0}
              controls={false}
              size='small'
              placeholder=''
              value={this.state.editTPos || ''}
              onChange={(e) => this.setState({ editTPos: e })}
            />
            : <span>{record?.pos}</span>)
      },
      {
        title: '',
        dataIndex: 'type',
        key: 'type',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Select size='small'
              placeholder='Select process'
              className='w-100'
              value={this.state.editTType || ''}
              onChange={(e) => this.setState({ editTType: e })}
            >
              <Option value='P96'>PMC</Option>
              <Option value='P88'>PAG</Option>
              <Option value='LD3'>LD3</Option>
              <Option value='LD2'>LD2</Option>
              <Option value='MD'>MD</Option>
            </Select>
            : <span>{record?.type}</span>)
      },
      {
        title: '',
        dataIndex: 'work_area',
        key: 'work_area',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Select size='small'
              placeholder='Select process'
              className='w-100'
              value={this.state.editTWorkArea || ''}
              onChange={(e) => this.setState({ editTWorkArea: e })}
            >
              <Option value='International'>International</Option>
              <Option value='Dash'>Dash</Option>
              <Option value='Breezeway'>Breezeway</Option>
              <Option value='T-Point'>T-Point</Option>
            </Select>
            : <span>{record?.work_area}</span>)
      },
      {
        title: '',
        dataIndex: 'uld_awb_no',
        key: 'uld_awb_no',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editTULDAWB || ''}
              onChange={(e) => this.setState({ editTULDAWB: e.target.value?.toUpperCase() })}
            />
            : <span>{record?.uld_awb_no}</span>)
      },
      {
        title: '',
        dataIndex: 'prod_code',
        key: 'prod_code',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editTProd || ''}
              onChange={(e) => this.setState({ editTProd: e.target.value?.toUpperCase() })}
            />
            : <span>{record?.prod_code}</span>)
      },
      {
        title: '',
        dataIndex: 'plan_comm',
        key: 'plan_comm',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editTComm1 || ''}
              onChange={(e) => this.setState({ editTComm1: e.target.value })}
            />
            : <span>{record?.comm1}</span>)
      },
      {
        title: '',
        dataIndex: 'dep_comm',
        key: 'dep_comm',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editTComm2 || ''}
              onChange={(e) => this.setState({ editTComm2: e.target.value })}
            />
            : <span>{record?.comm2}</span>)
      },
      {
        title: '',
        dataIndex: 'action',
        key: 'action',
        width: '10%',
        render: (_, record) =>
          <div>
            {this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
              <div className='action-column'>
                <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.submit('edit')} ><img src={Update} alt='Save' /></Tooltip>
                <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.clearAllocTableForm()} ><span className='form-clear'>x</span></Tooltip>
              </div>
              :
              <div className='action-column'>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.editAllocTableForm(record)} ><img src={editIcon} alt='edit' /></Tooltip>
                <Popconfirm placement='top' title={constants.DeleteText} onConfirm={() => this.setState({ deleteAllocID: record.id }, () => this.submit('delete'))} okText='Yes' cancelText='No'>
                  <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
                </Popconfirm>
              </div>
            }
          </div>
      },
    ]

    const CCcolumns = [
      {
        title: 'DOD Team Comments',
        dataIndex: 'plan_comm',
        key: 'plan_comm',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              disabled={this.disableNote(this.state.editRecord?.dept_time)}
              size='small'
              placeholder=''
              value={this.state.editTComm1 || ''}
              onChange={(e) => this.setState({ editTComm1: e.target.value })}
            />
            : <span>{record?.comm1}</span>)
      },
      {
        title: 'Warehouse Team Comments',
        dataIndex: 'dep_comm',
        key: 'dep_comm',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editTComm2 || ''}
              onChange={(e) => this.setState({ editTComm2: e.target.value })}
              disabled
            />
            : <span>{record?.comm2}</span>)
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        render: (_, record) => (
          this.state.editAllocRecord && this.state.editAllocRecord.id === record.id ?
            <div className='action-column'>
              <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.submit('edit')} ><img src={Update} alt='Save' /></Tooltip>
              <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.clearAllocTableForm()} ><span className='form-clear'>x</span></Tooltip>
            </div>
            :
            <div className='action-column'>
              {/* <Tooltip title='Attachment'>
                <Badge size='small' count={2}>
                  <Button type='text' shape='circle' className='clip' icon={<PaperClipOutlined />} />
                </Badge>
              </Tooltip> */}
              <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.editAllocTableForm(record)} ><img src={editIcon} alt='edit' /></Tooltip>
              <Popconfirm placement='top' title={constants.DeleteText} onConfirm={() => this.setState({ deleteAllocID: record.id }, () => this.submit('delete'))} okText='Yes' cancelText='No'>
                <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
              </Popconfirm>
            </div>
        ),
      },
    ]


    // const configData = [
    //   {
    //     key: '1',
    //     empty: 'Max Bin Configuration',
    //     PMC: this.state.editCargoP96 || this.state.editRecord?.cargo?.p96 || 0,
    //     PAG: this.state.editCargoP88 || this.state.editRecord?.cargo?.p88 || 0,
    //     LD2: this.state.editCargoLD2 || this.state.editRecord?.cargo?.ld2 || 0,
    //     LD3: this.state.editCargoLD3 || this.state.editRecord?.cargo?.ld3 || 0,
    //     Hint: this.state.hints || this.state.editRecord?.cargo?.hint,
    //     Notes: this.state.notes || this.state.editRecord?.cargo?.note,
    //   },
    //   {
    //     key: '2',
    //     empty: 'Planned Bin Configuration',
    //     PMC: function (){
    //       let count = 0
    //       if(this.state.editRecord?.build_uld?.length > 0){
    //         this.state.editRecord?.build_uld?.map((item)=>{
    //           if(item?.type === 'PMC'){
    //             count++
    //           }
    //         })
    //       }
    //       return count
    //     },
    //     PAG: this.state.editRecord?.actual?.P88,
    //     LD2: this.state.editRecord?.actual?.LD2,
    //     LD3: this.state.editRecord?.actual?.LD3,
    //     Hint: '-',
    //     Notes: '-',
    //   },
    //   // {
    //   //   key: '3',
    //   //   empty: 'Actual Bin Configuration',
    //   //   PMC: this.state.editRecord?.actual?.P96,
    //   //   PAG: this.state.editRecord?.actual?.P88,
    //   //   LD2: this.state.editRecord?.actual?.LD2,
    //   //   LD3: this.state.editRecord?.actual?.LD3,
    //   //   Hint: '-',
    //   //   Notes: '-',
    //   // }
    // ]

    const configColumns = [
      {
        title: '',
        dataIndex: 'empty',
        key: 'empty',
        className: 'min-width-80',
        width: '10%',
        // render: (_, record, index) => (
        //   <span>{index === 0? 'Optimal Configuration': 'Final Configuration'}</span>
        // )
      },
      {
        title: (<span className='test'>  PMC </span>),
        dataIndex: 'PMC',
        key: 'PMC',
        align: 'center',
        className: 'min-width-40',
        width: '10%',
        // render: (_, record) => (
        //   <span>{record?.cargo?.hint}</span>
        // )
      },
      {
        title: (<span className='test'>  PAG </span>),
        dataIndex: 'PAG',
        key: 'PAG',
        align: 'center',
        className: 'min-width-40',
        width: '10%',
        // render: (_, record) => (
        //   <span>{record?.cargo?.hint}</span>
        // )
      },
      {
        title: (<span className='test'>  LD2 </span>),
        dataIndex: 'LD2',
        key: 'LD2',
        align: 'center',
        className: 'min-width-40',
        width: '10%',
        // render: (_, record) => (
        //   <span>{record?.cargo?.ld2}</span>
        // )
      },
      {
        title: (<span className='test'>  LD3 </span>),
        dataIndex: 'LD3',
        key: 'LD3',
        align: 'center',
        className: 'min-width-40',
        width: '10%',
        // render: (_, record) => (
        //   <span>{record?.cargo?.ld3}</span>
        // )
      },
      //   {
      //     title: (<span className='test'>  LD4/8/FQA </span>),
      //     dataIndex: 'LD4',
      //     key: 'LD4',
      //     className: 'checklist-cols-1'
      //   },
      {
        title: (<span className='test'>  Hint </span>),
        // dataIndex: 'Hint',
        key: 'Hint',
        align: 'center',
        render: (_, record) => {
          const obj = {
            children: record.Hint,
            props: {},
          }
          if (record.key != 1) {
            obj.props.colSpan = 2
          }
          obj.children =
            record.key === '1' ?
              (record.Hint ?
                <Popover content={record.Hint || '-'} title='Hint'>
                  <SnippetsOutlined style={{ fontSize: '16px' }} />
                </Popover> :
                <div className={record.key != 1 ? 'col-hint' : ''}>
                  <SnippetsOutlined style={{
                    fontSize: '16px',
                    color: 'lightgray'
                  }} />
                </div>)
              : record.Hint
          return obj
        }
      },
      {
        title: (<span className='test'>  Notes </span>),
        dataIndex: 'Notes',
        // key: 'Notes',
        align: 'center',
        render: (_, record) => {
          const obj = {
            children: record.Notes,
            props: {},
          }
          if (record.key > 1) {
            obj.props.rowSpan = 0
          }
          obj.children = (
            record.Notes ?
              <Popover content={record.Notes} title='Notes'>
                <img src={documentIcon} alt='document' />
              </Popover> :
              <img src={documentIcon} alt='document' className='disabledImg' />
          )
          return obj
        }
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        width: '10%',
        render: (_, record) => {
          if (record.key === '1') {
            return (
              <div className='action-column'>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.fetchFlightSummary()} ><img src={editIcon} alt='edit' /></Tooltip>
              </div>
            )
          }
          return null
        },
      }
    ]

    const optiColumns = [
      {
        title: 'ULD Type',
        dataIndex: 'type',
        key: 'type',
        className: 'min-width-100',
        render: (_, record, index) => (
          this.state.editOptiUld && this.state.editOptiUld?.id === record?.id ?
            <Select
              value={this.state.editOptiUld?.type}
              size='small'
              name='type'
              className='text-center w-100'
              onChange={(e) => this.handleEditOptiUldChange({
                target: {
                  name: 'type',
                  value: e
                }
              })}
            >
              {const_ulds?.map((c_u, index) => <Option key={index} value={c_u}>{c_u}</Option>)}
            </Select>
            :
            record.type ? <Tag className='bp-tag' color={uld_colors[index].name}>{record.type}</Tag> : '-'
        )
      },
      {
        title: 'ULD #',
        dataIndex: 'number',
        key: 'number',
        className: 'min-width-100',
        render: (_, record) => (
          this.state.editOptiUld && this.state.editOptiUld?.id === record?.id ?
            <Input
              size='small'
              placeholder=''
              name='uld_no'
              value={this.state.editOptiUld?.uld_no}
              onChange={this.handleEditOptiUldChange}
            />
            :
            record.uld_no ? record.uld_no : '-'
        )
      },
      {
        title: 'Remarks/Pri #',
        dataIndex: 'remarks',
        key: 'remarks',
        className: 'min-width-100',
        width: '20%',
        render: (_, record) => {
          let pri = []
          let awbs = this.showAwbs(record, getCurrentPlan() || [])
          if (awbs && awbs?.length > 0) {
            awbs.map((awb) => {
              if (awb?.pri) {
                pri.push(awb.pri)
              }
            })
          }
          pri.sort((a, b) => a - b)
          return (
            <span>{pri && pri?.[0] ? pri[0] : ('')}</span>
          )
        }
      },
      {
        title: `Est. Vol.(${this.state.editWgtUnit === 'LB' ? 'cbf' : 'cbm'})`,
        dataIndex: 'vol',
        key: 'vol',
        className: 'min-width-100',
        render: (_, record) => {
          let vol = 0
          if (record?.type === 'BULK') {
            let awbs = this.showAwbs(record, getCurrentPlan() || [])
            if (awbs && awbs?.length > 0) {
              awbs.map((awb) => {
                vol = vol + parseFloat(awb?.blk_vol || 0)
              })
            }
          } else {
            let build_plan = getCurrentPlan()
            if (build_plan && build_plan?.length > 0) {
              build_plan?.map((item) => {
                if (item?.ulds && item?.ulds?.length > 0) {
                  item?.ulds?.map((uld) => {
                    if (uld.id && uld.id == record.id) {
                      vol = vol + parseFloat(uld.vol || 0)
                    }
                  })
                }
              })
            }
          }
          if (this.state.editWgtUnit === 'LB') {
            vol = vol > 0 ? Math.round(this.updateVolumeVal('CBF', vol)) : 0
          } else {
            vol = (Math.round(vol * 10) / 10)
          }
          return <span>{vol}</span>
        }
      },
      {
        title: `Est. Grs.Wgt(${this.state.editWgtUnit})`,
        dataIndex: 'wgt',
        key: 'wgt',
        className: 'min-width-100',
        render: (_, record) => {
          let wgt = (record?.data?.tare_wgt || 0)
          if (record?.type === 'BULK') {
            let awbs = this.showAwbs(record, getCurrentPlan() || [])
            if (awbs && awbs?.length > 0) {
              awbs.map((awb) => {
                wgt = wgt + parseFloat(awb?.blk_wgt || 0)
              })
            }
          } else {
            let build_plan = getCurrentPlan()
            if (build_plan && build_plan?.length > 0) {
              build_plan?.map((item) => {
                if (item?.ulds && item?.ulds?.length > 0) {
                  item?.ulds?.map((uld) => {
                    if (uld.id && uld.id == record.id) {
                      wgt = wgt + parseFloat(uld.wgt || 0)
                    }
                  }
                  )
                }
              })
            }
          }
          if (this.state.editWgtUnit === 'KG') {
            wgt = wgt > 0 ? this.updateWeightVal('KG', wgt) : 0
          }
          return (
            <span>{Math.round(wgt)}</span>
          )
        }
      },
      {
        title: 'Postions Occupied',
        dataIndex: 'positions',
        key: 'positions',
        className: 'min-width-100',
        render: (_, record) => (
          <span>{record?.data?.ld3}</span>
        )
      },
      {
        title: `Chbl ${this.state?.editWgtUnit === 'KG' ? 'kgs' : 'lbs'} per LD3 position`,
        dataIndex: 'chbl',
        key: 'chbl',
        className: 'min-width-100',
        align: 'left',
        render: (_, record) => {
          let wgt = 0
          let org_dest = this.state.editRecord?.org_stn + this.state.editRecord?.dest_stn
          let goal = ch_wt_goals.find((item) => item.lane == org_dest)
          let build_plan = getCurrentPlan()
          if (build_plan && build_plan?.length > 0) {
            build_plan?.map((item) => {
              if (item?.ulds && item?.ulds?.length > 0) {
                item?.ulds?.map((uld) => {
                  if (uld.id && uld.id == record.id) {
                    wgt = wgt + (uld?.ch_wgt || 0)
                  }
                }
                )
              }
            })
          }
          let props = {}
          let value = ''
          if (wgt) {
            if (goal) {
              let wgtUnit = this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'
              let goal_wgt = wgtUnit === 'kgs' ? goal?.kg : goal?.lbs
              if(wgtUnit === 'kgs'){
                wgt = this.updateWeightVal('KG', wgt)
              }
              if (parseFloat(goal_wgt) <= (wgt / record?.data?.ld3)) {
                props.style = {
                  color: 'green',
                  marginRight: '2px',
                }
                value = (<> {Math.round(wgt / record?.data?.ld3)} <CheckCircleFilled twoToneColor='#52c41a' />  </>)
              } else {
                props.style = {
                  color: 'var(--redText)',
                  marginRight: '2px',
                }
                value = (<> {Math.round(wgt / record?.data?.ld3)} <CloseCircleFilled style={{ color: 'red' }} />  </>)
              }
            } else {
              value = Math.round(wgt / record?.data?.ld3)
            }
          } else {
            value = ('')
          }
          return {
            props,
            children: value
          }
        }
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        align: 'center',
        className: 'min-width-100',
        render: (_, record) =>
          this.state.activeTab != 'initial' && this.state.activeTab != 'final' && <>
            {record?.id === this.state.editOptiUld?.id ?
              <div className='action-column f-middle'>
                <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.updateOptiData()} ><img src={Update} alt='Save' /></Tooltip>
                <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.clearOptiData()} ><span className='form-clear'>x</span></Tooltip>
              </div>
              :
              (record.id > 0 && <div className='action-column f-middle'>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.editOptiData(record)} ><img src={editIcon} alt='edit' /></Tooltip>
                <Popconfirm placement='top' title={constants.DeleteText} onConfirm={() => this.removeOptiData(record?.id)} okText='Yes' cancelText='No'>
                  <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
                </Popconfirm>
              </div>)
            }
          </>
      },
    ]

    const awbSortFunction = (a, b) => {
      // sort by delay amd then priority
      // let a_delay = a?.delay ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment(a?.delay), 'days') * -1 : 0
      // let b_delay = b?.delay ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment(b?.delay), 'days') * -1 : 0
      let a_delay = a?.delay ? a?.delay : 0
      let b_delay = b?.delay ? b?.delay : 0
      let a_priority = a.sort_priority || 999
      let b_priority = b.sort_priority || 999
      if (a.init && !b.init) return -1
      if (!a.init && b.init) return 1
      if (a_priority !== b_priority) {
        return a_priority - b_priority
      } else {
        return b_delay - a_delay
      }
    }


    const awbColumns = [
      {
        title: (<span className='test'>  Location </span>),
        dataIndex: 'location',
        key: 'location',
        className: 'min-width-80',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='Location'
                name='location'
                value={this.state.editAwbs.location}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          } else {
            return <span>{record?.location?.split?.(',')?.join(', ') || '-'}</span>
          }
        }
      },
      {
        title: 'Assigned',
        dataIndex: 'assigned',
        key: 'assigned',
        align: 'center',
        render: (_, record) => {
          return <Space size='small'>
            {record.is_booked && record.is_assigned ? <Tooltip title={'Booked + Assigned'}>
              <div className='d-flex f-column'>
                <span className='assigned-tag'>Assigned</span>
                <span className='booked-tag mt-2'>Booked</span>
              </div>
            </Tooltip> : (
              !record.is_booked && record.is_assigned ? <Tooltip title={'Assigned'} >
                <span className='assigned-tag'>Assigned</span>
              </Tooltip> : (
                record.is_booked && !record.is_assigned ? <Tooltip title={'Booked'}>
                  <span className='booked-tag'>Booked</span>
                </Tooltip> : ''
              )
            )}
          </Space>
        }
      },
      {
        title: (<span className='test'>  AWB </span>),
        dataIndex: 'awb',
        key: 'awb',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Space>
                {record.manual && <Input
                  size='small'
                  placeholder='AWB#'
                  name='awb_no'
                  value={this.state.editAwbs.awb_no}
                  onChange={(e) => this.handleEditAwb(e, record)}
                  className='min-width-100'
                />}
                {!record.manual && <b className={`${this.mismatchPcs(record?.pcs, record)} space-nowrap`}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</b>}
              </Space>
            )
          } else {
            return <Popover
              overlayClassName='awb-popover'
              content={
                <>
                  {record.at_stn && (
                    <>
                      <p className='at-stn-title'>On Hand</p>
                      {record.at_stn?.map((at, index) => (
                        <div key={index} className='at-stn-tag'>
                          <span className='awb-tag-label'>{at?.blk ? 'LOOSE' : at?.uld_no}</span>
                          <span>----------------</span>
                          <span className='min-width-80 text-right'>{at.pcs}Pcs</span>
                        </div>
                      ))}
                    </>
                  )}
                  {record.booked && (
                    <>
                      <p className='at-bkd-title'>Booked</p>
                      {record.booked?.map((bk, index) => (
                        <div key={index} className='at-stn-tag'>
                          <span className='awb-tag-label'>{bk.flight_no}</span>
                          <span>----------------</span>
                          <span className='min-width-80 text-right'>{bk.pcs}Pcs</span>
                        </div>
                      ))}
                    </>
                  )}
                </>
              }>
              <b className={`${this.mismatchPcs(record?.pcs, record)} space-nowrap`}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</b>
            </Popover>
          }
        }
      },
      {
        title: (<span className='test'>  Pcs </span>),
        dataIndex: 'pcs',
        key: 'pcs',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='Pcs'
                name='pcs'
                value={this.state.editAwbs.pcs}
                onChange={(e) => this.handleEditAwb(e, record)}
                className='min-width-60'
              />
            )
          } else {
            return <span>{record?.pcs}Pcs</span>
          }
        }
      },
      {
        title: (<span className='test'>  GrWt.({this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'}) </span>),
        dataIndex: 'grwt',
        key: 'grwt',
        render: (_, record) => {
          let unit = record?.wgt?.unit
          let wgtValue = ''
          {
            if (this.state.editWgtUnit === 'KG') {
              if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
                let kg = this.updateWeightVal('KG', record?.wgt?.value)
                wgtValue = Math.round(kg)
              }
              else {
                wgtValue = Math.round(record?.wgt?.value)
              }
            }
            else if (this.state.editWgtUnit === 'LB') {
              if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
                let lb = this.updateWeightVal('LB', record?.wgt?.value)
                wgtValue = Math.round(lb)
              }
              else {
                wgtValue = Math.round(record?.wgt?.value)
              }
            }
          }
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='GrWt'
                name='wgt'
                defaultValue={wgtValue}
                value={this.state.editAwbs.wgt}
                onChange={(e) => this.handleEditAwb(e, record)}
                className='min-width-80'
              />
            )
          } else {
            return <span>{wgtValue}{this.state.editWgtUnit === 'KG' ? 'KG' : 'LB'}</span>
          }
        }
      },
      {
        title: (<span className='test'>  ChblWt.({this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'}) </span>),
        dataIndex: 'chwt',
        key: 'chwt',
        render: (_, record) => {
          let unit = record?.ch_wgt?.unit
          let wgtValue = ''
          if (this.state.editWgtUnit === 'KG') {
            if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
              let kg = this.updateWeightVal('KG', record?.ch_wgt?.value)
              wgtValue = kg
            }
            else {
              wgtValue = record?.wgt?.value
            }
          } else if (this.state.editWgtUnit === 'LB') {
            if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
              let lb = this.updateWeightVal('LB', record?.ch_wgt?.value)
              wgtValue = lb
            }
            else {
              wgtValue = record?.ch_wgt?.value
            }
          }
          wgtValue = Math.round(wgtValue)
          if (record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id)) {
            return (
              <Input
                size='small'
                placeholder='Chbl Wgt'
                name='ch_wgt'
                defaultValue={wgtValue}
                value={this.state.editAwbs.ch_wgt || ''}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          }
          return <span>{wgtValue}{this.state.editWgtUnit}</span>
        }
      },
      {
        title: (<span className='test'>  Vol.({this.state.editWgtUnit === 'LB' ? 'cbf' : 'cbm'}) </span>),
        dataIndex: 'vol',
        key: 'vol',
        render: (_, record) => {
          let vol = record?.vol?.value || 0
          if (this.state.editWgtUnit === 'LB' && record?.vol?.unit === 'CBM') {
            vol = Math.round(this.updateVolumeVal('CBF', vol))
          } else if (this.state.editWgtUnit === 'KG' && (record?.vol?.unit === 'CBF' || record?.vol?.unit === 'CFT')) {
            vol = Math.round(this.updateVolumeVal('CBM', vol) * 10) / 10
          } else {
            vol = record?.vol?.unit === 'CBF' || record?.vol?.unit === 'CFT' ? Math.round(vol) : (Math.round(vol * 10) / 10)
          }

          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='Vol'
                name='vol'
                defaultValue={vol}
                value={this.state.editAwbs.vol}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          } else {
            return <span>{vol}</span>
          }
        }
      },
      {
        title: (<span className='test'>  Pri# </span>),
        dataIndex: 'pri',
        key: 'pri',
        render: (_, record) => {
          if (record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id)) {
            return (
              <Input
                size='small'
                placeholder='Pri#'
                name='pri'
                value={this.state.editAwbs.pri}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          }
          else {
            return (<span>{record.pri}</span>)
          }
        }

      },
      {
        title: (<span className='test'>  Dest </span>),
        dataIndex: 'dest',
        key: 'dest',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='Dest'
                name='dest'
                value={this.state.editAwbs.dest}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          }
          return <span>{record?.dest}</span>
        }
      },
      {
        title: (<span className='test'>  Prod </span>),
        dataIndex: 'prod',
        key: 'prod',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='Prod Code'
                name='prod_code'
                value={this.state.editAwbs.prod_code}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          }
          return <span>{record?.prod_code}</span>
        }
      },
      {
        title: (<span className='test text-wrap'>Days <br /> DLYD </span>),
        dataIndex: 'time_of_avl',
        key: 'time_of_avl',
        align: 'center',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <InputNumber
                size='small'
                placeholder='Delay'
                className='w-100'
                min={-10}
                max={10}
                precision={0}
                value={this.state.editAwbs.delay}
                onChange={(e) => this.handleEditAwb(e, 'delay')}
                name='delay'
              />
            )
          }
          let delay = record?.delay ? record?.delay : 0
          if (delay > 0) {
            return <span className='color-red'>{delay}</span>
          } else {
            return <span>{delay}</span>
          }
        }
      },
      {
        title: (<span className='test'>  SPL </span>),
        dataIndex: 'spl',
        key: 'spl',
        className: 'min-width-100',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Input
                size='small'
                placeholder='SPLs'
                name='spl_code'
                value={this.state.editAwbs.spl_code}
                onChange={(e) => this.handleEditAwb(e, record)}
              />
            )
          }
          if ((record?.spl_code?.includes('RDG') || record?.spl_code?.includes('ICE') || record?.spl_code?.includes('ICV'))) {
            return <span className='color-red'>{record?.spl_code?.split?.(',')?.join(', ')}</span>
          } else {
            return <span>{record?.spl_code?.split?.(',')?.join(', ') || '-'}</span>
          }
        }
      },
      {
        title: (<span className='test'>  Pre-Built? </span>),
        dataIndex: 'preBuilt',
        key: 'preBuilt',
        align: 'center',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Select
                size='small'
                name='pre_build'
                value={this.state.editAwbs.pre_build}
                onChange={(e) => this.handleEditAwb({
                  target: {
                    name: 'pre_build',
                    value: e
                  }
                }, record)}
              >
                <Option value={true}>Y</Option>
                <Option value={false}>N</Option>
              </Select>
            )
          }
          return <span>{record?.pre_build ? 'Y' : 'N'}</span>
        }
      },
      {
        title: (<span className='test'>  On Hand? </span>),
        dataIndex: 'onHand',
        key: 'onHand',
        align: 'center',
        render: (_, record) => {
          if ((record?.awb_no === this.state.editAwbsRecord?.awb_no || (typeof record?.id === 'number' && record?.id === this.state.editAwbsRecord?.id))) {
            return (
              <Select
                size='small'
                name='on_hand'
                value={this.state.editAwbs.on_hand}
                onChange={(e) => this.handleEditAwb({
                  target: {
                    name: 'on_hand',
                    value: e
                  }
                }, record)}
              >
                <Option value={true}>Y</Option>
                <Option value={false}>N</Option>
              </Select>
            )
          }
          return <span>{record?.on_hand ? 'Y' : 'N'}</span>
        }
      },
      {
        title: (<span className='test'>  Assigned ULD </span>),
        dataIndex: 'addUld',
        key: 'addUld',
        align: 'center',
        width: '10%',
        className: '',
        render: (_, row) => {
          let bpIndex = this.state.editRecord.build_plan.findIndex((item) => item.awb_no === row.awb_no)
          return (
            <div>
              {row.uldAdded === false ?
                <p>-</p>
                :
                <Space size={[0, 8]} wrap className='tag-class' >
                  {this.state.editRecord.build_plan && this.state.editRecord.build_plan.length > 0 && this.state.editRecord.build_plan[bpIndex] && this.state.editRecord.build_plan[bpIndex]?.ulds?.length > 0 ?
                    this.state.editRecord.build_plan[bpIndex]?.ulds?.map((uld) => {
                      let index = this.state.editRecord.build_uld.sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt).findIndex((item) => item.id === uld.id)
                      let color = index !== -1 ? uld_colors[index].name : ''
                      return <Fragment key={uld.id}><Tooltip title={`pcs: ${uld.pcs}, grs.wt: ${uld.wgt}`} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                        <Tag className='bp-tag' color={color}>{uld?.uld_type + (uld?.uld_no || '')}</Tag>
                      </Tooltip></Fragment>
                    }) : (row.slu_uld && row.slu_uld.length > 0 ? row.slu_uld.map((uld) => {
                      return <Fragment key={uld.id}><Tooltip title={`pcs: ${uld.pcs}, grs.wt: ${uld.wgt}`} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                        <Tag className='bp-tag' color='blue'>{uld.uld_no}</Tag>
                      </Tooltip></Fragment>
                    }) : null)
                  }
                </Space>
              }
            </div>
          )
        }
      },
      {
        title: (<span className='test'>  Bulk Pcs</span>),
        dataIndex: 'bulk',
        key: 'bulk',
        align: 'center',
        className: '',
        render: (_, row) => {
          let bpIndex = this.state.editRecord.build_plan.findIndex((item) => item.awb_no === row.awb_no)
          let blk = bpIndex !== -1 ? this.state.editRecord.build_plan[bpIndex]?.data?.blk : 0
          if (row?.awb_no === this.state.editAwbsRecord?.awb_no) {
            return !row.init && (
              <Input
                size='small'
                placeholder='Bulk Pcs'
                name='blk'
                value={this.state.editAwbs.blk}
                onChange={(e) => this.handleEditAwb(e, row)}
              />
            )
          }
          else {
            return (<span>{blk}</span>)
          }
        }
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        align: 'center',
        className: 'hide-printcol',
        render: (_, record) =>
          this.state.activeTab != 'initial' && this.state.activeTab != 'final' && (record.is_deleted ? (<div className='action-column'>
            <Popconfirm placement='top' title={constants.RestoreText} onConfirm={() => this.deleteAwbRecord(record)} okText='Yes' cancelText='No'>
              <Tooltip title='Restore' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={restoreIcon} alt='Restore' /></Tooltip>
            </Popconfirm>
          </div>) :
            (record?.awb_no === this.state.editAwbsRecord?.awb_no ?
              <div className='action-column'>
                <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.updateAwbRecord()} ><img src={Update} alt='Save' /></Tooltip>
                <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.clearTableForm(record)} ><span className='form-clear'>x</span></Tooltip>
              </div>
              :
              <div className='action-column'>
                <Tooltip title='Assign to ULD' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                  <img className='assign-uldicon' src={ULDicon} alt='uld' onClick={() => this.addULD(record)} />
                </Tooltip>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.editAwbs(record)} ><img src={editIcon} alt='edit' /></Tooltip>
                <Popconfirm placement='top' title={constants.DeleteText} onConfirm={() => this.deleteAwbRecord(record)} okText='Yes' cancelText='No'>
                  <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
                </Popconfirm>
              </div>))
      },
    ]

    const nestedAwbColumns = [
      {
        title: (<span className='test'>  Location </span>),
        dataIndex: 'location',
        key: 'location',
        className: 'min-width-100',
        render: (_, record) => (
          <span>{record?.location || '-'}</span>
        )
        // render: (_, record) => {
        //   record && record.awbs_in && record?.locations &&
        //     record?.locations.map((loc, index) => {

        //       return <div key={index}>{loc?.fromLocation}</div>
        //     }) 
        // }
      },
      {
        title: (<span className='test'>  AWB </span>),
        dataIndex: 'awb',
        key: 'awb',
        className: 'space-nowrap',
        render: (_, record) => (
          // <span className={record?.showred ? 'bg-red' : null}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</span>
          <span className={this.mismatchPcs(record?.pcs, record)}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</span>
        )
      },
      {
        title: (<span className='test'>  Pcs </span>),
        dataIndex: 'pcs',
        key: 'pcs',
      },
      {
        title: (<span className='test'>  GrWt.({this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'}) </span>),
        dataIndex: 'wgt',
        key: 'wgt',
        className: 'min-width-100',
        render: (_, record) => {
          if (this.state.editWgtUnit === 'KG') {
            let kg = this.updateWeightVal('KG', record?.wgt)
            return <span>{Math.round(kg)} kG</span>
          }
          else {
            return <span>{Math.round(record?.wgt)} LB</span>
          }
        }
      },
      // {
      //   title: (<span className='test'>  ChblWt.({this.state.editWgtUnit === 'KG' ? 'kgs' : 'lbs'}) </span>),
      //   dataIndex: 'ch_wgt',
      //   key: 'ch_wgt',
      //   render: (_, record) => {
      //     if (this.state.editWgtUnit === 'KG') {
      //       let kg = this.updateWeightVal('KG', record?.ch_wgt)
      //       return <span>{Math.round(kg)} kG</span>
      //     }
      //     else {
      //       return <span>{Math.round(record?.ch_wgt)} LB</span>
      //     }
      //   }
      // },
      {
        title: (<span className='test'>  Vol.({this.state.editWgtUnit === 'LB' ? 'cbf' : 'cbm'}) </span>),
        dataIndex: 'vol',
        key: 'vol',
        render: (_, record) => {
          if (this.state.editWgtUnit === 'LB') {
            let cbf = record?.vol > 0 ? this.updateVolumeVal('CBF', record?.vol) : 0
            return <span>{Math.round(cbf)}</span>
          } else {
            return <span>{Math.round(record?.vol * 10) / 10}</span>
          }
        }
      },
      {
        title: (<span className='test'>  Pri # </span>),
        dataIndex: 'pri',
        key: 'pri',
      },
      {
        title: (<span className='test'>  Dest </span>),
        dataIndex: 'dest',
        key: 'dest',
        render: (_, record) => (
          <span>{record?.dest}</span>
        )
      },
      {
        title: (<span className='test'>  Prod </span>),
        dataIndex: 'prod',
        key: 'prod',
        render: (_, record) => (
          <span>{record?.prod_code}</span>
        )
      },
      {
        title: (<span className='test'>  SPL </span>),
        dataIndex: 'spl',
        key: 'spl',
        className: 'min-width-100',
        render: (_, record) => (
          <span>{record?.spl_code}</span>
        )
      },
      {
        title: (<span className='test'>  Pre-Built? </span>),
        dataIndex: 'preBuilt',
        key: 'preBuilt',
        align: 'center',
        render: (_, record) => (
          <span>{record?.pre_build ? 'Y' : 'N'}</span>
        )
      },
      {
        title: (<span className='test'>  On Hand? </span>),
        dataIndex: 'onHand',
        key: 'onHand',
        align: 'center',
        render: (_, record) => (
          <span>{record?.on_hand ? 'Y' : 'N'}</span>
        )
      },
    ]

    const getCurrentPlan = () => {
      const { activeTab, editRecord } = this.state
      if (activeTab === 'initial') {
        return editRecord?.init_build_plan?.data?.build_plan
      } else if (activeTab === 'final') {
        return editRecord?.final_build_plan?.data?.build_plan
      } else {
        return editRecord?.build_plan || []
      }
    }
    const renderTabContent = () => (
      <div className='opti-input'>
        <Row gutter={[0, 0]}>
          <Col xs={24} className='switch print-uld'>
            <div className='awb-switch print-uld'>
              <Space align='start' className='f-spaceBtw'>
                <Title level={5} className='mb-0' xs={12}>
                  ULD Optimization
                </Title>
                <div className='awb-switch ml-5 print-uld'>
                  <Switch
                    checkedChildren='AWBs'
                    unCheckedChildren='ULDs'
                    checked={this.state.switch}
                    onChange={(e) => this.setState({ switch: e })}
                  // className='awb-switch'
                  />
                </div>
              </Space>
            </div>
            <div className='ml-auto print-uld'>
              <div className='goal'>
                <p>Chbl Wgt Goal: {this.state.chblWgtGoal ? <b className='goal-wgt'> {this.state.editWgtUnit === 'KG' ? Math.round(this.state.chblWgtGoal.kg) : Math.round(this.state.chblWgtGoal.lbs)} {this.state.editWgtUnit}</b> : <b className='goal-wgt'>N/A</b>}</p>
              </div>
            </div>
          </Col>
          <Col xs={24}>
            <div className='print-uld'>
              <Row gutter={[8, 16]} className='mb-2'>
                <Col xs={24} sm={24} md={6} lg={6} xl={6} className='right-section'>
                  <label>ULD Type</label>
                  <Select
                    value={this.state.optiUld?.type}
                    size='small'
                    name='type'
                    className='text-center w-100'
                    onChange={(e) => this.handleOptiUldChange({
                      target: {
                        name: 'type',
                        value: e
                      }
                    })}
                    disabled={this.state.activeTab !== 'bp'}
                  >
                    {const_ulds?.map((c_u, index) => <Option key={index} value={c_u}>{c_u}</Option>)}
                  </Select>
                </Col>
                <Col xs={24} sm={24} md={6} lg={6} xl={6} className='right-section'>
                  <label>ULD Number (Optional)</label>
                  <Input
                    name='uld_no'
                    value={this.state.optiUld?.uld_no}
                    onChange={this.handleOptiUldChange}
                    disabled={this.state.activeTab !== 'bp'}
                  />
                </Col>
                <Col flex='154px' className='text-center p-0 uld-btn-container'>
                  <Button type='ghost' className='image-btn' disabled={this.state.activeTab !== 'bp'} onClick={() => this.addOptiData()}>
                    <Tooltip title='Add' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                  </Button>
                </Col>
                <Col flex='auto' className='awb-btn-container'>
                  <Button type='link' className='ml-auto add-btn' icon={<img src={addIcon} alt='add' />} disabled={this.state.activeTab !== 'bp'} onClick={() => this.addAwb()}>
                    Add AWB
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
            <div className='table-outer print-uld'>
              {this.state.switch ?
                <>
                  <Search allowClear className='search-input' placeholder='Search'
                    onChange={(e) => this.setState({ awbSearch: e.target.value })}
                  />
                  <Table
                    className='custom-table w-100 ex-tabl buildup-table dod-bp-table'
                    dataSource={this.state.mergeEditRecord?.sort(awbSortFunction)?.filter(awb => {
                      if (this.state.awbSearch != '') {
                        return awb.awb_no.includes(this.state.awbSearch.replace(/-/, ''))
                      } else {
                        return true
                      }
                    }) || []}
                    columns={awbColumns}
                    pagination={false}
                    rowClassName={(record) => record.is_deleted ? 'strike-row' : ''}
                  />
                </> :
                <Table
                  className='custom-table w-100 ex-tabl buildup-table'
                  dataSource={[
                    ...(this.state.activeTab === 'initial'
                      ? this.state.editRecord?.init_build_plan?.data?.build_uld?.sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt) || []
                      : this.state.activeTab === 'final'
                        ? this.state.editRecord?.final_build_plan?.data?.build_uld?.sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt) || []
                        : this.state.editRecord?.build_uld?.sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt) || []
                    ),
                    ...(
                      this.state.editRecord?.ulds_out?.filter(u => {
                        if (u.info?.remark?.includes('SLU')) {
                          return {
                            id: u.id,
                            type: u.uld_no,
                            slu: true
                          }
                        }
                      }) || []
                    ),
                    {
                      id: 0,
                      type: 'BULK'
                    } || []
                  ]}
                  columns={optiColumns}
                  pagination={false}
                  expandable={{
                    // rowExpandable: () => {
                    //   this.state.activeTab === 'initial' ? (this.state.editRecord?.init_build_plan?.data?.build_plan?.length > 0) :
                    //     this.state.activeTab === 'final' ? (this.state.editRecord?.final_build_plan?.data?.build_plan?.length > 0) :
                    //       true
                    // },
                    expandedRowRender: (record) => <Table
                      className='custom-table w-100 ex-tabl buildup-table nested'
                      // dataSource={this.showAwbs(record, this.state.editRecord?.build_plan || [])}
                      dataSource={this.showAwbs(record, getCurrentPlan() || [])}
                      columns={nestedAwbColumns}
                      pagination={false}
                    // rowKey={this.state.editRecord.id}
                    />,
                    expandIcon: ({ expanded, onExpand, record }) =>
                      expanded ?
                        <CaretDownOutlined onClick={e => onExpand(record, e)} />
                        :
                        <CaretRightOutlined onClick={e => onExpand(record, e)} />,
                  }}
                  rowKey='id'
                />
              }
            </div>

            {/* {JSON.stringify(this.state.mergeEditRecord)} */}
          </Col>
          <Col xs={24} className='text-right mt-2 print-uld'>
            <Space size={'middle'}>
              <Checkbox checked={this.state.priority} disabled={this.state.activeTab !== 'bp'} onChange={(e) => this.setState({ priority: e.target.checked })}>Include Delay Days & Booking Priority</Checkbox>
              <Button
                type='primary'
                className='custom-button bp-button'
                disabled={this.state.activeTab !== 'bp'}
                onClick={() => this.handleLockAndScreenshot()}>
                {this.state.optiLoader ? <LoadingOutlined style={{ fontSize: 18 }} /> : 'Lock Build Plan'}
              </Button>
              {this.state.editRecord.init_build_plan || this.state.editRecord.final_build_plan ?
                <Popover content={
                  <div>
                    <p>Last Updated By: {
                      this.state.editRecord?.final_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.name?.first_name + ' ' + this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.name?.last_name :
                        this.state.editRecord?.init_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.name?.first_name + ' ' + this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.name?.last_name : 'N/A'
                    }</p>
                    <p>PPR#: {this.state.editRecord?.final_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.ppr
                      : this.state.editRecord?.init_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.ppr : 'N/A'}</p>
                  </div>
                }><InfoCircleFilled /></Popover> : null}
              <Button type='primary' className='custom-button' disabled={this.state.activeTab !== 'bp'} onClick={() => this.autoAssignUlds()}>
                {this.state.assignLoader ? <LoadingOutlined style={{ fontSize: 18 }} /> : 'Auto-Assign ULDs'}
              </Button>
              <Space.Compact block>
                <Button
                  type='primary'
                  className='custom-button bp-button opti-btn'
                  disabled={this.state.activeTab !== 'bp'}
                  onClick={() => this.opti()}>
                  {this.state.optiLoader ? <LoadingOutlined style={{ fontSize: 18 }} /> : 'Run Optimization'}
                </Button>
                <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                  <Button className='bp-icon-btn del-icon-btn'
                    type='primary'
                    disabled={this.state.activeTab !== 'bp'}
                    onClick={() => this.opti_clear()}
                    icon={this.state.clearLoader ? <LoadingOutlined style={{ fontSize: 18 }} /> :
                      <img src={deleteIcon} alt='delete' />}
                  />
                </Tooltip>
              </Space.Compact>
            </Space>
          </Col>
        </Row>
      </div>
    )

    return (
      <div>
        <Modal
          title={
            <Row>
              <Col xs={24} md={6} className='my-auto'>
                <span className='print-uld'>Build Plan</span>
                <div className='print-uld-show'>
                  <div className='f-spacebtw'>
                    <span>Build Plan -{this.state.editRecord ? `${this.state.editRecord?.flight_no} / ${this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly) : ''}` : ''}</span>
                    <Space>
                      <Text>Last Updated by: {
                        this.state.editRecord?.final_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.name?.first_name + ' ' + this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.name?.last_name :
                          this.state.editRecord?.init_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.name?.first_name + ' ' + this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.name?.last_name : 'N/A'
                      }</Text>
                      <Text>PPR#:{this.state.editRecord?.final_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.final_build_plan?.user_id)?.ppr
                        : this.state.editRecord?.init_build_plan ? this.state.userList.find(list => list.id == this.state.editRecord?.init_build_plan?.user_id)?.ppr : 'N/A'}</Text>
                    </Space>
                  </div>
                </div>
              </Col>
              <Col xs={24} md={18}>
                <div className='print-uld'>
                  <div className='ml-auto d-flex'>
                    <Space size={'middle'} className='ml-auto'>
                      {/* <Button type='primary' disabled className='custom-button bp-button'>Run Optimization </Button> */}
                      <Button
                        type='link'
                        className='link-btn-dod'
                        icon={<img src={RedirectIcon} alt='redirect' width={14} />}
                        onClick={() => window.open('https://apps.powerapps.com/play/e/f7a9917a-c0f8-e704-b911-cd160be3bc02/a/025d57e5-a3f3-435f-906b-e392ab115a95?tenantId=45e6435d-dc1c-42e3-89be-e72e6c8f072d&sourcetime=1716317814249&source=portal&hidenavbar=true', '_blank')}
                      >
                        Dimension Check Tool
                      </Button>
                      <Button type='primary' className='custom-button mr-5 bp-button' onClick={() => this.openWB(true)}
                      >WB Planner </Button>
                      {/* <Button type='primary' className='custom-button mr-0 bp-button' onClick={() => this.openTruckPlanner(true)}
                  disabled={(ENV === 'stage' || ENV === 'production') && !users.includes(cookies.get('username'))}>Truck Planner </Button> */}
                    </Space>
                  </div>
                </div>
              </Col>
              {this.bookedULD}
              {/* <Col xs={24} md={18} className='text-center'>
                <Form layout='inline'>
                  <Space wrap>
                    <Form.Item label='Enter Flight Number'>
                      <Input
                        size='small'
                        placeholder='Eg:DL123'
                        onChange={(e) => this.setState({ searchFlightNo: e.target.value?.toUpperCase() })}
                        onBlur={this.checkPrefix}
                        value={this.state.searchFlightNo}
                        className='min-width-120'
                      />
                    </Form.Item>
                    <Form.Item label='Flight Date'>
                      <DatePicker
                        size='small'
                        onChange={(mom) => this.setState({ searchDate: mom })}
                        value={this.state.searchDate}
                        placeholder='Select Date'
                      />
                    </Form.Item>
                    <Button
                      className='custom-icon-button mb-2'
                      size='small'
                      icon={<SearchOutlined />}
                      onClick={() => this.setState({ modalLoading: true }, () => this.fetchFlightOnSearch())}
                    />
                    <small className='color-red'>{this.state.editRecord && this.state.editRecord.ac_change && this.state.editRecord.ac_change.length > 0 ?
                      `This flight A/C is changed from ${this.state.editRecord.ac_change[this.state.editRecord.ac_change.length - 1].old} to ${this.state.editRecord?.ac_change[this.state.editRecord.ac_change.length - 1].ac} ` : ''
                    }</small>
                  </Space>
                </Form>
              </Col> */}
            </Row>
          }
          open={this.state.loadplanvisible}
          onOk={() => this.setState({
            loadplanvisible: false,
            showAlloc: false,
            ccView: false,
            SLUSummary: [],
            PTUSummary: [],
            BuiltSummary: [],
            BLKSummary: null,
            selected: [],
            bagSummary: [],
            remainingP96: 0,
            remainingP88: 0,
            remainingLD3: 0,
            remainingLD2: 0,
            remainingMD: 0,
          }, () => {
            this.clearEditAllocForm()
            this.clearEditFlightForm()
            this.clearAllocTableForm()
          })}
          onCancel={() => this.setState({
            loadplanvisible: false,
            showAlloc: false,
            ccView: false,
            SLUSummary: [],
            PTUSummary: [],
            BuiltSummary: [],
            BLKSummary: null,
            selected: [],
            bagSummary: [],
          }, () => {
            this.clearEditAllocForm()
            this.clearEditFlightForm()
            this.clearAllocTableForm()
          })}
          closable={true}
          footer={[
            <>
              {this.state.showSuccess && <div className='mr-4 print-uld'><b><CheckCircleTwoTone twoToneColor='#52c41a' /> Build Plan updated successfully</b></div>}
              <div className='print-uld'>
                <Space size={'middle'} className='py-2 pr-3 mr-1 print-uld'>
                  <Button
                    disabled={this.disableNote(this.state.editRecord?.dept_time) || !this.state.editRecord}
                    onClick={this.submitData}
                    type='primary'
                    className='custom-button bp-button'
                  >Update Build Plan
                  </Button>
                  {/* <Button
                  disabled={this.disableNote(this.state.editRecord?.dept_time) || !this.state.editRecord}
                  // onClick={this.submitData}
                  type='primary'
                  className='custom-button bp-button'
                >Email BP
                </Button> */}
                  <Button
                    onClick={this.emailLoadPlan}
                    type='primary'
                    className='custom-button bp-button'
                  >Send Email
                  </Button>
                </Space>
              </div>
            </>
          ]}
          // width={'90%'}
          centered
          className='custom-modal pb-0 load-plan dod-bp-modal'
        >
          {this.state.modalLoading && (<div id='spinner' className='spinner-cont'>
            <Spin />
          </div>)}
          <Row gutter={[{
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24
          }, {
            xs: 24,
            sm: 24,
            md: 32,
            lg: 32
          },]} className='with-table print-uld'
          // ref={this.modalRef}
          ref={this.modalContentRef}
          >
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={14} className=''>
              <div className='cargo-cap-card bp print-uld'>
                <Row gutter={[{
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: 24
                }, {
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: 24
                },]}
                >
                  <Col xs={24} sm={12} md={6} lg={3} xl={2} xxl={3}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Fight #</small>
                      <p className='info-data mb-2'>{this.state.editRecord?.flight_no || 'N/A'}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={4} xl={2} xxl={4}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Date</small>
                      <p className='info-data mb-2'>{this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly)?.toUpperCase() : 'N/A'}</p>
                    </div>
                  </Col>
                  <Col flex='auto' className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>AC</small>
                      <p className='info-data mb-2'>{this.state.editRecord?.ac_type || 'N/A'}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={3} xl={2} xxl={3} className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Seg</small>
                      <p className='info-data mb-2'>{this.state.editRecord?.org && this.state.editRecord?.dest ? `${this.state.editRecord.org.origin}-${this.state.editRecord.dest.arriv}` : 'N/A'}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={3} xxl={5} className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Dept Time</small>
                      <p className='info-data mb-2'>{this.state.editRecord?.dept_time && `${this.state.editRecord?.dept_prefix} ${moment.tz(this.state.editRecord.dept_time, this.state.timezone).format(dateTimeFormat)?.toUpperCase()}` || 'N/A'}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={4} xl={2} xxl={4} className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>AWB Count</small>
                      <p className='info-data mb-2'>{this.state.mergeEditRecord?.sort(awbSortFunction)?.length || 0}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={3} xl={2} xxl={3} className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Ship #</small>
                      <p className='info-data mb-2 space-nowrap'>{this.state.editRecord?.wgt_bal_plan?.ship || 'N/A'}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={3} xl={2} xxl={3}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>FPE Time</small>
                      <p className='info-data mb-2 space-nowrap'>{this.state.editRecord?.fpe ? moment.utc(this.state.editRecord.dept_time).tz(this.state.timezone).subtract(this.state.editRecord.fpe, 'minutes').format('HH:mm') : '-'}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={4} xl={2} xxl={4}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Plan Due</small>
                      <p className='info-data mb-2 space-nowrap'>
                        {this.state.milestoneData && this.state.milestoneData.length > 0 ? (
                          (() => {
                            let planDue = this.state.milestoneData.find(
                              (item) => item?.type === 'Dod' && item.title === 'Build Plan Submitted to Warehouse'
                            )
                            if (planDue) {
                              const cutoffTime = this.state.editRecord?.dept_date ? moment
                                .utc(this.state.editRecord?.dept_date)
                                .tz(this.state.timezone)
                                .subtract(this.getCutoff(planDue.cutoff, this.state.editRecord), 'hours') : null

                              // Return the formatted time value or render it within a JSX element
                              // return `SKD ${cutoffTime.format('HH:mm')} ACT ${this.getAct(this.state.editRecord, planDue.id, 'HH:mm') || 'N/A'}`
                              return `SKD ${cutoffTime?.format('HH:mm')}`

                            } else {
                              return '-'
                            }
                          })()
                        ) : (
                          '-'
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={4} xxl={5} className='flight-info-text'>
                    <div className='sub-head'>
                      <div><small className='info-title'>Bag Pstns</small></div>
                      <Space size='middle'>
                        <div className=''>
                          <small className='info-title'>LD3</small>
                          <InputNumber
                            className='bp-info-ip'
                            min={0}
                            precision={0}
                            controls={false}
                            size='small'
                            placeholder=''
                            value={this.state.editBagLD3 || 0}
                            onChange={(e) => this.setState({ editBagLD3: e })}
                            disabled={!this.state.editRecord?.cont_type.includes('LD3') || this.disableNote(this.state.editRecord?.dept_time) || !this.state.isWideBody}
                          />
                        </div>
                        <div className=''>
                          <small className='info-title'>LD2</small>
                          <InputNumber
                            className='bp-info-ip'
                            min={0}
                            precision={0}
                            controls={false}
                            size='small'
                            placeholder=''
                            value={this.state.editBagLD2 || 0}
                            onChange={(e) => this.setState({ editBagLD2: e })}
                            disabled={!this.state.editRecord?.cont_type.includes('LD2') || this.disableNote(this.state.editRecord?.dept_time) || !this.state.isWideBody}
                          />
                        </div>
                        <Button
                          className='custom-icon-button mt-4 disabled-bg-none'
                          ghost
                          icon={<SearchOutlined />}
                          onClick={() => this.fetchFlightSummary()}
                          disabled={this.disableNote(this.state.editRecord?.dept_time) || !this.state.isWideBody}
                        />
                      </Space>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={4} xxl={5} className='flight-info-text'>
                    <div className='h-100'><small className='info-title'>PAX CAP / FCST</small>
                      <Space size='middle' direction='horizontal' className='mt-auto h-100'>
                        <p className='info-data text-right'>{this.state.editRecord?.pax_cap || 0} </p>
                        <span className='color-white'>/</span>
                        {<InputNumber
                          min={0}
                          precision={0}
                          controls={false}
                          size='small'
                          placeholder=''
                          value={this.state.editFcst || 0}
                          onChange={(e) => this.setState({ editFcst: e })}
                          disabled={this.disableNote(this.state.editRecord?.dept_time)}
                          className='bp-info-ip'
                        />}
                      </Space>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={4} xl={3} xxl={4} className='sub-head flight-info-text'>
                    <small className='info-title space-nowrap'>Cargo Payload</small>
                    <div className=''>
                      <div className='weight-toggle'>
                        <Switch
                          checkedChildren='LB'
                          unCheckedChildren='KG'
                          size='small'
                          className='mx-1'
                          checked={this.state.editWgtUnit === 'KG' ? false : true}
                          onChange={((e) => this.setState({
                            editWgtUnit: e === false ? 'KG' : 'LB',
                            editWgtValue: this.updateWeightVal(e === false ? 'KG' : 'LB', this.state.editWgtValue)
                          }))}
                        />
                      </div>
                      <div className='mt-2'>
                        <InputNumber
                          min={0}
                          controls={false}
                          size='small'
                          placeholder=''
                          value={this.state.editWgtValue || 0}
                          onChange={(e) => this.setState({ editWgtValue: e })}
                          disabled={this.disableNote(this.state.editRecord?.dept_time)}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={3} xl={2} xxl={3} className='flight-info-text'>
                    <div className='recd-ht'>
                      <small className='info-title '>BU PRIO</small>
                      <Checkbox
                        className='light-checkbox mx-auto'
                        checked={this.state.editBuPrio}
                        onChange={(e) => this.setState({ editBuPrio: e.target.checked })}
                        disabled={this.disableNote(this.state.editRecord?.dept_time)}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={10} className=''>
              <div className='print-uld h-100'>
                <Row className='opti-input h-100'>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
                    <div className='table-outer print-uld'>
                      <Table
                        id='config-table'
                        className='custom-table w-100 checklist-table1'
                        // dataSource={this.processIndividualFlight([this.state.editRecord])}
                        // dataSource={[this.state.editRecord]}
                        dataSource={this.get_bin_config()}
                        columns={configColumns}
                        pagination={false}
                        rowClassName={(record, index) => index != 0 ? record.className : ''}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            {/* <Col xs={24}>
              <div className='opti-input'>
                <Title level={5} className='' xs={12}>
                  Dry Ice
                </Title>
                <DryIce fleetType={this.state.editRecord?.fleet} ship_no={this.state.editRecord?.wgt_bal_plan?.ship} />
              </div>
            </Col> */}

            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className='position-relative'>
              <Space align='center' className='download-doc-icon'>
                {/* <Tooltip title={'Builder Copy'}>
                  <Button className='download-icon-btn' icon={<FilePdfOutlined style={{
                    fontSize: '28px',
                    color: '#E02F2F',
                    backgroundColor: 'transparent'
                  }} />}
                  onClick={() => window.print()}
                  // onClick={this.generateLoadPlan}
                  />
                </Tooltip> */}
                <Tooltip title={'Builder Copy'}>
                  <Button className='download-icon-btn' icon={<FileExcelOutlined style={{
                    fontSize: '28px',
                    color: '#629d03',
                    backgroundColor: 'transparent'
                  }} />}
                  // onClick={() => window.print()}
                  onClick={this.generateLoadPlan}
                  />
                </Tooltip>
                {this.state.editRecord?.org_stn === 'LHR' && <Tooltip title={'LHR Builder Copy '}>
                  <Button className='download-icon-btn' icon={<FileExcelOutlined style={{
                    fontSize: '28px',
                    color: '#629d03',
                    backgroundColor: 'transparent'
                  }} />}
                  // onClick={() => window.print()}
                  onClick={this.generateLoadPlanLHR}
                  />
                </Tooltip>}
                <Tooltip title='Scrub Copy'>
                  <Button className='download-icon-btn' icon={<FileExcelOutlined style={{
                    fontSize: '28px',
                    color: '#629d03',
                    backgroundColor: 'transparent'
                  }} />}
                  onClick={this.exportScrub}
                  />
                </Tooltip>
              </Space>
              <Tabs
                activeKey={this.state.activeTab}
                onChange={this.callbackTabClicked}
                onEdit={this.onTabEdit}
                type='editable-card'
                hideAdd
                className='bp-tab position-relative'
              >
                <TabPane tab='Build Plan' key='bp' closable={false}>
                  {renderTabContent()}
                </TabPane>
                {this.state.editRecord?.init_build_plan &&
                  <TabPane tab='Proposed' key='initial' closable={true}>{renderTabContent()}</TabPane>

                }
                {this.state.editRecord?.final_build_plan &&
                  <TabPane tab='Final' key='final' closable={true}>{renderTabContent()}</TabPane>
                }
              </Tabs>
            </Col>
            {this.state.showAlloc && <>
              <Col xs={24} sm={24} md={24} lg={8} xl={12} className='opti-input'>
                <Title level={5} className='mb-0 print-uld'>Load Plan</Title>
              </Col>
              <Col xs={24} sm={24} md={24} lg={16} xl={12} className=''>
                <span className='rem-pos-title print-uld'>Remaining Positions: </span>
                <div className='d-flex f-wrap gap-10 rem_posn print-uld'>
                  <p className='fv-middle gap-10'>P96:
                    <InputNumber
                      size='small'
                      className={this.state.remainingP96 > 0 ? 'w-35px dis-blue' : this.state.remainingP96 < 0 ? 'w-35px dis-red' : 'w-35px dis-grey'}
                      value={this.state.remainingP96 < 0 ? this.state.remainingP96?.toString()?.split('-')[1] : this.state.remainingP96 || 0}
                      disabled
                    />
                  </p>
                  <p className='fv-middle gap-10'>P88:
                    <InputNumber
                      size='small'
                      className={this.state.remainingP88 > 0 ? 'w-35px dis-blue' : this.state.remainingP88 < 0 ? 'w-35px dis-red' : 'w-35px dis-grey'}
                      value={this.state.remainingP88 < 0 ? this.state.remainingP88?.toString()?.split('-')[1] : this.state.remainingP88 || 0}
                      disabled
                    />
                  </p>
                  <p className='fv-middle gap-10'>LD3:
                    <InputNumber
                      size='small'
                      className={this.state.remainingLD3 > 0 ? 'w-35px dis-blue' : this.state.remainingLD3 < 0 ? 'w-35px dis-red' : 'w-35px dis-grey'}
                      value={this.state.remainingLD3 < 0 ? this.state.remainingLD3?.toString()?.split('-')[1] : this.state.remainingLD3 || 0}
                      disabled
                    />
                  </p>
                  <p className='fv-middle gap-10'>LD2:
                    <InputNumber
                      size='small'
                      className={this.state.remainingLD2 > 0 ? 'w-35px dis-blue' : this.state.remainingLD2 < 0 ? 'w-35px dis-red' : 'w-35px dis-grey'}
                      value={this.state.remainingLD2 < 0 ? this.state.remainingLD2?.toString()?.split('-')[1] : this.state.remainingLD2 || 0}
                      disabled
                    />
                  </p>
                  <p className='fv-middle gap-10'>MD:
                    <InputNumber
                      size='small'
                      className={this.state.remainingMD > 0 ? 'w-35px dis-blue' : this.state.remainingMD < 0 ? 'w-35px dis-red' : 'w-35px dis-grey'}
                      value={this.state.remainingMD < 0 ? this.state.remainingMD?.toString()?.split('-')[1] : this.state.remainingMD || 0}
                      disabled
                    />
                  </p>
                </div>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className='px-0 p-12'>
                <div className='print-uld'>
                  <Form
                    layout='vertical'
                    className='position-relative'
                  >
                    <Row
                      gutter={[{
                        xs: 0,
                        sm: 0,
                        md: 24,
                        lg: 24
                      }, {
                        xs: 0,
                        sm: 0,
                        md: 0,
                        lg: 0
                      },]}
                      className='product-ht'>

                      <Col xs={24} sm={24} md={8} lg={6} xl={2} xxl={2} className=''>
                        <Form.Item label='# Of Posns'>
                          <InputNumber
                            min={0}
                            precision={0}
                            controls={false}
                            size='small'
                            placeholder=''
                            value={this.state.editPos || ''}
                            onChange={(e) => this.setState({ editPos: e })}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={6} xl={2} xxl={2} className=''>
                        <Form.Item label='Posn Type'>
                          <Select size='small'
                            placeholder='Select process'
                            className='w-100'
                            value={this.state.editType || []}
                            onChange={(e) => this.setState({ editType: e })}
                          >
                            <Option value='P96'>PMC</Option>
                            <Option value='P88'>PAG</Option>
                            <Option value='LD3'>LD3</Option>
                            <Option value='LD2'>LD2</Option>
                            <Option value='MD'>MD</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={6} xl={4} xxl={3} className=''>
                        <Form.Item label='For Work Area'>
                          <Select size='small'
                            placeholder='Select process'
                            className='w-100'
                            value={this.state.editWorkArea || []}
                            onChange={(e) => this.setState({ editWorkArea: e })}
                          >
                            <Option value='International'>International</Option>
                            <Option value='Dash'>Dash</Option>
                            <Option value='Breezeway'>Breezeway</Option>
                            <Option value='T-Point'>T-Point</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={6} xl={4} xxl={3} className=''>
                        <Form.Item label='ULD ID / AWB'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.editULDAWB || ''}
                            onChange={(e) => this.setState({ editULDAWB: e.target.value?.toUpperCase() })}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={6} xl={3} xxl={3} className=''>
                        <Form.Item label='Prod'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.editProd || []}
                            onChange={(e) => this.setState({ editProd: e.target.value?.toUpperCase() })}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8} xl={4} xxl={5} className=''>
                        <Form.Item label='Planning Comments'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.editComm1 || ''}
                            onChange={(e) => this.setState({ editComm1: e.target.value })}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8} xl={4} xxl={5} className=''>
                        <Form.Item label='Post Departure Comments'>
                          <Input
                            size='small'
                            placeholder=''
                            value={this.state.editComm2 || ''}
                            onChange={(e) => this.setState({ editComm2: e.target.value })}
                          />
                        </Form.Item>
                      </Col>

                      <Col flex='44px' className='text-center ml-auto p-0'>
                        <label className='custom-label transparent'>-</label>
                        <Button type='ghost' className='ml-auto image-btn' onClick={() => this.submit('add')}>
                          <Tooltip title={this.state.isEdit ? 'Update' : 'Add'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>

              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                className='table-overflow'
              >
                <Table
                  className='custom-table w-100 no-header-table'
                  dataSource={this.state.editAllocArray}
                  columns={planLoadColumns}
                  pagination={false}
                />
              </Col>
            </>}
            <Col xs={24}>
              <div className='print-uld'>
                <Row className='opti-input last'>
                  <Col className='switch'>
                    <Title level={5} className='mb-0' xs={12}>
                      Load Planning Notes
                    </Title>
                    <div className='ml-auto'>
                      <Text type='secondary' strong>Last Update:</Text>
                      <Space size={[48, 0]} direction='horizontal'>
                        <Text strong>{this.state.lastUpdatedAt ? this.state.lastUpdatedAt + ' ' + this.state.ext : 'N/A'}</Text>
                        <Text strong>{this.state.lastUpdatedBy ? this.state.lastUpdatedBy : 'N/A'}</Text>
                        <Text strong>{this.state.lastUpdatedPpr ? this.state.lastUpdatedPpr : 'N/A'}</Text>
                      </Space>
                    </div>
                  </Col>
                  <Row className='mt-2'>
                    <Col xs={24} sm={24} md={6} lg={6} xl={6} className='right-section'>
                      <label>Planning Comments</label>
                      <Input
                        disabled={this.disableNote(this.state.editRecord?.dept_time)}
                        size='small'
                        placeholder=''
                        value={this.state.editComm1 || ''}
                        onChange={(e) => this.setState({ editComm1: e.target.value })}
                      />
                    </Col>
                    <Col flex='154px' className='text-center p-0 right-section'>
                      <label className='custom-label transparent'>-</label>
                      <Button type='ghost' className='ml-auto image-btn' onClick={() => this.submit('add')}>
                        <Tooltip title={this.state.isEdit ? 'Update' : 'Add'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                      </Button>
                    </Col>
                  </Row>
                  <Col xs={24}>
                    <div className='table-outer'>
                      <Table
                        className='custom-table w-100'
                        dataSource={this.state.editAllocArray} columns={CCcolumns}
                        pagination={false}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            {/* <Row className='opti-row'> */}
            {/* </Row> */}
          </Row>
          <div className='print-uld-show'>
            <Table
              className='print-uld-table'
              dataSource={this.state.mergeEditRecord?.sort(awbSortFunction) || []}
              columns={awbColumns}
              pagination={false}
            />
          </div>
        </Modal>

        <div ref={this.modalRef}>
          <div className='email-table' // class not applied to email
            style={{
              fontSize: '13px',
              textAlign: 'left',
              direction: 'ltr',
              verticalAlign: 'bottom',
              width: '100%'
            }}>

            <table align='center' border='0' cellPadding='0' cellSpacing='0' role='presentation'>
              <tbody>
                <tr>
                  <td
                    style={{
                      borderBottom: '#333957 solid 5px',
                      backgroundColor: '#f2f2f2',
                      direction: 'ltr',
                      fontSize: 0,
                      padding: '20px 0',
                      textAlign: 'center',
                      verticalAlign: 'top',
                    }}
                  ></td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '#dddddd solid 1px',
                      borderTop: '0px',
                      direction: 'ltr',
                      fontSize: 0,
                      padding: '20px 0',
                      textAlign: 'center',
                      verticalAlign: 'top',
                    }}
                  >
                    <table border='0' cellPadding='0' cellSpacing='0' role='presentation' style={{ verticalAlign: 'bottom' }}
                      width='100%'>

                      <tbody>

                        <tr>
                          <td align='center' style={{
                            padding: '25px',
                            paddingBottom: '40px',
                            wordBreak: 'break-word'
                          }}>

                            <div style={{
                              fontSize: '22px',
                              lineHeight: '1',
                              textAlign: 'center',
                              color: '#555',
                              borderBottom: '2px solid #df1931',
                              paddingBottom: '12px'
                            }}>
                              Build Plan: {this.state.editRecord?.flight_no || 'N/A'}/{this.state.editRecord?.org && this.state.editRecord?.dest ? `${this.state.editRecord.org.origin}-${this.state.editRecord.dest.arriv}` : 'N/A'} {this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly)?.toUpperCase() : 'N/A'}
                            </div>

                          </td>
                        </tr>

                        <tr>
                          <td align='left' style={{
                            padding: '10px 25px',
                            paddingBottom: '30px',
                            wordBreak: 'break-word'
                          }}>
                            <p style={{
                              fontSize: '18px',
                              color: '#013466'
                            }}>Hello User,</p>
                            <div style={{
                              fontSize: '16px',
                              lineHeight: '1',
                              color: '#555'
                            }}>
                              Build Plan: {this.state.editRecord?.flight_no || 'N/A'}/{this.state.editRecord?.org && this.state.editRecord?.dest ? `${this.state.editRecord.org.origin}-${this.state.editRecord.dest.arriv}` : 'N/A'} {this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly)?.toUpperCase() : 'N/A'}
                            </div>

                          </td>
                        </tr>

                        <tr>
                          <td style={{ verticalAlign: 'top' }}>
                            <div style={{ width: '100%' }}>
                              <div style={{
                                minWidth: '240px',
                                borderRadius: '4px',
                                background: '#fff',
                                marginBottom: '30px',
                                marginRight: '20px',
                                width: '20%',
                                display: 'inline-block'
                              }}>
                                <table style={{
                                  borderCollapse: 'collapse',
                                  width: '100%'
                                }}>
                                  <tbody>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Flight #</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.flight_no || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Date</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly)?.toUpperCase() : 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left',
                                      }}>AC</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.ac_type || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Seg</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.org && this.state.editRecord?.dest ? `${this.state.editRecord.org.origin}-${this.state.editRecord.dest.arriv}` : 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Ship #</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.wgt_bal_plan?.ship || 'N/A'}</td>
                                    </tr>

                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Departure Time</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.dept_time && `${this.state.editRecord?.dept_prefix} ${moment.tz(this.state.editRecord.dept_time, this.state.timezone).format(dateTimeFormat)?.toUpperCase()}` || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>FPE Time</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.fpe ? moment.utc(this.state.editRecord.dept_time).tz(this.state.timezone).subtract(this.state.editRecord.fpe, 'minutes').format('HH:mm') : 'N/A'}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Plan Due</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.milestoneData && this.state.milestoneData.length > 0 ? (
                                          (() => {
                                            let planDue = this.state.milestoneData.find(
                                              (item) => item?.type === 'Dod' && item.title === 'Build Plan Submitted to Warehouse'
                                            )
                                            if (planDue) {
                                              const cutoffTime = this.state.editRecord?.dept_date ? moment
                                                .utc(this.state.editRecord?.dept_date)
                                                .tz(this.state.timezone)
                                                .subtract(this.getCutoff(planDue.cutoff, this.state.editRecord), 'hours') : null

                                              // Return the formatted time value or render it within a JSX element
                                              // return `SKD ${cutoffTime.format('HH:mm')} ACT ${this.getAct(this.state.editRecord, planDue.id, 'HH:mm') || 'N/A'}`
                                              return `SKD ${cutoffTime?.format('HH:mm')}`

                                            } else {
                                              return '-'
                                            }
                                          })()
                                        ) : (
                                          '-'
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>P CAP / FCST</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editRecord?.pax_cap || 0} / {this.state.editFcst || 0}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Bag Posns</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px'
                                      }}>
                                        <p style={{
                                          margin: 0,
                                          display: 'inline-block',
                                          marginRight: '20px'
                                        }}>LD3:&nbsp;&nbsp;{this.state.editBagLD3 || 0}</p>
                                        <p style={{
                                          margin: 0,
                                          display: 'inline-block'
                                        }}>LD2:&nbsp;&nbsp;{this.state.editBagLD2 || 0}</p>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>Cargo Payload</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editWgtValue || 0}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        width: '100px',
                                        textAlign: 'left'
                                      }}>BU PRIO</td>
                                      <td style={{
                                        padding: '4px 8px',
                                        border: '1px solid #bfc9d1',
                                        fontSize: '12px',
                                        textAlign: 'left'
                                      }}>{this.state.editBuPrio === true ? 'Y' : 'N'}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div style={{
                                minWidth: '500px',
                                display: 'inline-block'
                              }}>
                                <table style={{
                                  borderCollapse: 'collapse',
                                  width: '100%',
                                  marginBottom: '30px'
                                }}>
                                  <thead>
                                    <tr>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}></th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>PMC</th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>PAG</th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>LD2</th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>LD3</th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>Hints</th>
                                      <th style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        background: '#eeeeee'
                                      }}>Notes</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td style={{
                                        background: '#eeeeee',
                                        fontWeight: 'bold',
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>Max ULD Configuration</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editCargoP96 || this.state.editRecord?.cargo?.p96 || 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editCargoP88 || this.state.editRecord?.cargo?.p88 || 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editCargoLD2 || this.state.editRecord?.cargo?.ld2 || 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editCargoLD3 || this.state.editRecord?.cargo?.ld3 || 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.hints || this.state.editRecord?.cargo?.hint}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.notes || this.state.editRecord?.cargo?.note}</td>
                                    </tr>
                                    <tr>
                                      <td style={{
                                        background: '#eeeeee',
                                        fontWeight: 'bold',
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>Planned Bin Configuration</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editRecord?.build_uld?.length > 0 ? (this.state.editRecord?.build_uld?.filter((u => u.type === 'PMC')))?.length : 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editRecord?.build_uld?.length > 0 ? (this.state.editRecord?.build_uld?.filter((u => u.type === 'PAG')))?.length : 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editRecord?.build_uld?.length > 0 ? (this.state.editRecord?.build_uld?.filter((u => (['LD2', 'DPA', 'DPE', 'DPL', 'DPN', 'LD4', 'LD8', 'FQA', 'DQL', 'DQP', 'DQF'].includes(u?.type))))?.length + this.state.editRecord?.build_uld?.filter((u => (['LD4', 'LD8', 'FQA', 'DQL', 'DQP', 'DQF'].includes(u?.type))))?.length) : 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>{this.state.editRecord?.build_uld?.length > 0 ? (this.state.editRecord?.build_uld?.filter((u => ['LD3', 'AKE', 'AKN', 'AKX', 'AKY', 'RKN', 'PLA', 'FLA', 'PLB'].includes(u?.type))))?.length + (this.state.editRecord?.build_uld?.filter((u => ['PLA', 'FLA', 'PLB'].includes(u?.type))))?.length : 0}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>-</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 10px',
                                        textAlign: 'center',
                                        fontSize: '12px'
                                      }}>-</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </td>
                        </tr>


                        <tr>
                          <td align='left' style={{
                            fontSize: '0px',
                            padding: '10px 25px',
                            paddingBottom: '30px',
                            wordBreak: 'break-word'
                          }}>

                            <div>
                              <table border='1' cellSpacing='0' cellPadding='4' style={{
                                fontSize: '12px',
                                borderCollapse: 'collapse',
                                width: '100%' 
                              }}>
                                <thead>
                                  <tr>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee' 
                                    }}>AWB Nb</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee' 
                                    }}>Dest</th>
                                    <th rowSpan={2}  style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee' 
                                    }}>Days Delayed</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee' 
                                    }}>Pcs</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee' 
                                    }}>Gr.Wt (lbs)</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee' 
                                    }}>Vol (cbf)</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee' 
                                    }}>ULD Type</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee' 
                                    }}>ULD Prio</th>
                                    
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>On Hand?</th>
                                  </tr>
                                
                                </thead>
                                <tbody>
                                  {(() => {

                                    const planUlds = [
                                      ...(this.state.activeTab === 'initial'
                                        ? this.state.editRecord?.init_build_plan?.data?.build_uld || []
                                        : this.state.activeTab === 'final'
                                          ? this.state.editRecord?.final_build_plan?.data?.build_uld || []
                                          : this.state.editRecord?.build_uld || []
                                      ).sort((a, b) => b?.data?.max_wgt - a?.data?.max_wgt),

                                      ...(this.state.editRecord?.ulds_out?.filter(u =>
                                        u.info?.remark?.includes('SLU')
                                      ) || []),

                                      {
                                        id: 0,
                                        type: 'BULK' 
                                      }
                                    ]

                                    let awbAssigned = []
                                    const awbMap = {}

                                    return (
                                      <>
                                        {/* ================= ASSIGNED ================= */}
                                        {planUlds.map((uld) => {
                                          const awbs = this.showAwbs(uld, getCurrentPlan()) || []
                                          const totals = awbs.reduce((acc, a) => {
                                            let vol = this.state.editWgtUnit === 'LB'
                                              ? Math.round(this.updateVolumeVal('CBF', a?.vol || 0))
                                              : Math.round((a?.vol || 0) * 10) / 10
                                            acc.pcs += a.pcs || 0
                                            acc.wgt += Math.round(a.wgt) || 0
                                            acc.vol += vol || 0

                                            // build assigned map
                                            awbAssigned.push({
                                              awb_no: a.awb_no,
                                              pcs: (awbAssigned.find(x => x.awb_no === a.awb_no)?.pcs || 0) + 1,
                                              // new
                                              wgt: (awbAssigned.find(x => x.awb_no === a.awb_no)?.wgt || 0) + Math.round(a.wgt),
                                              vol: (awbAssigned.find(x => x.awb_no === a.awb_no)?.vol || 0) + vol
                                            })

                                            return acc
                                          }, {
                                            pcs: 0,
                                            wgt: 0,
                                            vol: 0 
                                          })

                                          awbs.forEach((a) => {
                                            let vol = this.state.editWgtUnit === 'LB'
                                              ? Math.round(this.updateVolumeVal('CBF', a?.vol || 0))
                                              : Math.round((a?.vol || 0) * 10) / 10

                                            if (!a?.awb_no) return

                                            if (!awbMap[a.awb_no]) {
                                              awbMap[a.awb_no] = {
                                                awb_no: a.awb_no,
                                                pcs: 0,
                                                wgt: 0,
                                                vol: 0
                                              }
                                            }

                                            //  SUM pcs across ALL ULDs
                                            awbMap[a.awb_no].pcs += Number(a.pcs) || 0
                                            awbMap[a.awb_no].wgt += Math.round(Number(a.wgt) || 0)
                                            awbMap[a.awb_no].vol += vol || 0
                                          })

                                          return (
                                            <>
                                              {awbs.map((awb, i) => (
                                                <tr key={awb.awb_no + i}>
                                                  <td style={{ textAlign: 'center' }}>
                                                    {awb.awb_no
                                                      ? awb.awb_no.slice(0, 3) + '-' + awb.awb_no.slice(3)
                                                      : ''}
                                                  </td>
                                                  <td style={{ textAlign: 'center' }}>{awb.dest}</td>

                                                  <td style={{ textAlign: 'center' }}>
                                                    {awb?.delay > 0
                                                      ? <span className='color-red'>{awb.delay}</span>
                                                      : <span>{awb?.delay || 0}</span>}
                                                  </td>

                                                  <td style={{ textAlign: 'center' }}>{awb.pcs}</td>
                                                  <td style={{ textAlign: 'center' }}>{Math.round(awb.wgt)}</td>

                                                  <td style={{ textAlign: 'center' }}>
                                                    {this.state.editWgtUnit === 'LB'
                                                      ? Math.round(this.updateVolumeVal('CBF', awb?.vol || 0))
                                                      : Math.round((awb?.vol || 0) * 10) / 10}
                                                  </td>

                                                  {i === 0 && (
                                                    <>
                                                      <td rowSpan={awbs.length + 1} style={{
                                                        color:'#006bbe',
                                                        fontWeight:'bold',
                                                        textAlign: 'center' 
                                                      }}>
                                                        {awb.uld_id === 0 ? 'Bulk' : awb.uld_type}
                                                        <span style={{
                                                          color: 'grey',
                                                          display: 'block' 
                                                        }}>{uld?.uld_no}</span>
                                                      </td>
                                                      <td rowSpan={awbs.length + 1} style={{ textAlign: 'center' }}>{awb.pri}</td>
                                                    </>
                                                  )}
                                                  <td style={{ textAlign: 'center' }}>{awb?.on_hand ? 'Y' : 'N'}</td>
                                                </tr>
                                              ))}

                                              {/* TOTAL ROW */}
                                              {awbs.length > 0 && (
                                                <tr style={{
                                                  fontWeight:'bold',
                                                  color:'#006bbe' 
                                                }}>
                                                  <td colSpan='3'></td>
                                                  <td style={{ textAlign: 'center' }}>{totals.pcs}</td>
                                                  <td style={{ textAlign: 'center' }}>{totals.wgt}</td>
                                                  <td style={{ textAlign: 'center' }}>{Math.round(totals.vol)}</td>
                                                </tr>
                                              )}
                                              {awbs.length > 0 && (
                                                <tr><td colSpan='9' style={{
                                                  background: 'transparent',
                                                  height: '24px' 
                                                }}></td></tr>)}
                                            </>
                                          )
                                        })}

                                        {/* ================= UNASSIGNED ================= */}
                                        {(() => {
                                          const unassigned = this.getUnassignedAwbs() || []
                                          const awbAssigned = Object.values(awbMap)
                                          const awbLookup = Object.fromEntries(
                                            awbAssigned.map(a => [a.awb_no, a])
                                          )
                                          const totals = unassigned.reduce((acc, a) => {
                                            let pcs = (Number(a.avl_pcs) || 0) - (Number(awbLookup[a.awb_no]?.pcs) || 0)
                                            // wgt calc
                                            let unit = a?.wgt?.unit
                                            let wgtValue = ''
                                            {
                                              if (this.state.editWgtUnit === 'KG') {
                                                if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
                                                  let kg = this.updateWeightVal('KG', a?.wgt?.value)
                                                  wgtValue = Math.round(kg)
                                                }
                                                else {
                                                  wgtValue = Math.round(a?.wgt?.value)
                                                }
                                              }
                                              else if (this.state.editWgtUnit === 'LB') {
                                                if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
                                                  let lb = this.updateWeightVal('LB', a?.wgt?.value)
                                                  wgtValue = Math.round(lb)
                                                }
                                                else {
                                                  wgtValue = Math.round(a?.wgt?.value)
                                                }
                                              }
                                            }
                                            wgtValue  = (Number(wgtValue) || 0) - (Number(awbLookup[a.awb_no]?.wgt) || 0)

                                            // vol calc
                                            let vol = a?.vol?.value || 0
                                            if (this.state.editWgtUnit === 'LB' && a?.vol?.unit === 'CBM') {
                                              vol = Math.round(this.updateVolumeVal('CBF', vol))
                                            } else if (this.state.editWgtUnit === 'KG' && (a?.vol?.unit === 'CBF' || a?.vol?.unit === 'CFT')) {
                                              vol = Math.round(this.updateVolumeVal('CBM', vol) * 10) / 10
                                            } else {
                                              vol = a?.vol?.unit === 'CBF' || a?.vol?.unit === 'CFT' ? Math.round(vol) : (Math.round(vol * 10) / 10)
                                            }

                                            vol = Number(vol) - Number(awbLookup[a.awb_no]?.vol || 0)

                                            acc.pcs += pcs || 0
                                            acc.wgt += Math.round(wgtValue) || 0
                                            acc.vol += Math.round(vol) || 0
                                            return acc
                                          }, {
                                            pcs: 0,
                                            wgt: 0,
                                            vol: 0 
                                          })

                                          return (
                                            <>
                                              {unassigned.map((awb, i) => (
                                                <tr key={awb.awb_no + i}>
                                                  <td style={{ textAlign: 'center' }}>
                                                    {awb.awb_no
                                                      ? awb.awb_no.slice(0, 3) + '-' + awb.awb_no.slice(3)
                                                      : ''}
                                                  </td>
                                                  <td style={{ textAlign: 'center' }}>{awb.dest}</td>

                                                  <td style={{ textAlign: 'center' }}>
                                                    {awb?.delay > 0
                                                      ? <span className='color-red'>{awb.delay}</span>
                                                      : <span>{awb?.delay || 0}</span>}
                                                  </td>

                                                  <td style={{ textAlign: 'center' }}>
                                                    {(() => {
                                                      const awbAssigned = Object.values(awbMap)
                                                      const awbLookup = Object.fromEntries(
                                                        awbAssigned.map(a => [a.awb_no, a])
                                                      )
                                                      return <div>
                                                        {(Number(awb.avl_pcs) || 0) - (Number(awbLookup[awb.awb_no]?.pcs) || 0)}
                                                      </div>
                                                    })()}
                                                  </td>
                                                  <td style={{ textAlign: 'center' }}>
                                                    {(() => {
                                                      const awbAssigned = Object.values(awbMap)
                                                      const awbLookup = Object.fromEntries(
                                                        awbAssigned.map(a => [a.awb_no, a])
                                                      )
                                                      let unit = awb?.wgt?.unit
                                                      let wgtValue = ''
                                                      {
                                                        if (this.state.editWgtUnit === 'KG') {
                                                          if (unit === 'L' || unit === 'LB' || unit === 'LBS' || unit === 'LBR') {
                                                            let kg = this.updateWeightVal('KG', awb?.wgt?.value)
                                                            wgtValue = Math.round(kg)
                                                          }
                                                          else {
                                                            wgtValue = Math.round(awb?.wgt?.value)
                                                          }
                                                        }
                                                        else if (this.state.editWgtUnit === 'LB') {
                                                          if (unit === 'K' || unit === 'KG' || unit === 'KGM' || unit === 'KGS') {
                                                            let lb = this.updateWeightVal('LB', awb?.wgt?.value)
                                                            wgtValue = Math.round(lb)
                                                          }
                                                          else {
                                                            wgtValue = Math.round(awb?.wgt?.value)
                                                          }
                                                        }
                                                      }   
                                                      return <div>
                                                        {(Number(wgtValue) || 0) - (Number(awbLookup[awb.awb_no]?.wgt) || 0)} 
                                                      </div>
                                                    })()}
                                                  </td>

                                                  <td style={{ textAlign: 'center' }}>
                                                    {(() => {
                                                      const awbAssigned = Object.values(awbMap)
                                                      const awbLookup = Object.fromEntries(
                                                        awbAssigned.map(a => [a.awb_no, a])
                                                      )
                                                      let vol = awb?.vol?.value || 0
                                                      if (this.state.editWgtUnit === 'LB' && awb?.vol?.unit === 'CBM') {
                                                        vol = Math.round(this.updateVolumeVal('CBF', vol))
                                                      } else if (this.state.editWgtUnit === 'KG' && (awb?.vol?.unit === 'CBF' || awb?.vol?.unit === 'CFT')) {
                                                        vol = Math.round(this.updateVolumeVal('CBM', vol) * 10) / 10
                                                      } else {
                                                        vol = awb?.vol?.unit === 'CBF' || awb?.vol?.unit === 'CFT' ? Math.round(vol) : (Math.round(vol * 10) / 10)
                                                      }
                                                      
                                                      return <div>
                                                        {vol - (awbLookup[awb.awb_no]?.vol || 0)}
                                                      </div>
                                                    })()}
                                                  </td>

                                                  {i === 0 && (
                                                    <>
                                                      <td rowSpan={unassigned.length + 1} style={{
                                                        color:'#006bbe',
                                                        fontWeight:'bold',
                                                        textAlign: 'center' 
                                                      }}>
                      Not Assigned
                                                      </td>
                                                      <td rowSpan={unassigned.length + 1} style={{ textAlign: 'center' }}>{unassigned.length > 0 ? Math.max(...unassigned.map(u => Number(u.pri) ?? 0)) : ''}</td>
                                                    </>
                                                  )}
                                                  <td style={{ textAlign: 'center' }}>{awb?.on_hand ? 'Y' : 'N'}</td>
                                                </tr>
                                              ))}

                                              {/* TOTAL ROW */}
                                              {unassigned.length > 0 && (
                                                <tr style={{
                                                  fontWeight:'bold',
                                                  color:'#006bbe' 
                                                }}>
                                                  <td colSpan='3'></td>
                                                  <td style={{ textAlign: 'center' }}>{totals.pcs}</td>
                                                  <td style={{ textAlign: 'center' }}>{totals.wgt}</td>
                                                  <td style={{ textAlign: 'center' }}>{totals.vol}</td>
                                                </tr>
                                              )}
                                            </>
                                          )
                                        })()}

                                      </>
                                    )
                                  })()}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
            

                        <tr>
                          <td align='left' style={{
                            fontSize: '0px',
                            padding: '10px 25px',
                            wordBreak: 'break-word'
                          }}>
                            <p style={{
                              fontSize: '16px',
                              textAlign: 'left',
                              display: 'inline-block',
                              width: '50%',
                              marginBottom: 0
                            }}>Load Planning Notes</p>
                            <div style={{
                              display: 'inline-block',
                              textAlign: 'right',
                              width: '50%'
                            }}>
                              <p style={{
                                fontSize: '16px',
                                display: 'inline-block',
                                marginBottom: 0
                              }}>Last Update: </p>
                              <div style={{
                                fontSize: '16px',
                                display: 'inline-block'
                              }}>
                                <b style={{
                                  display: 'inline-block',
                                  paddingRight: '10px'
                                }}>{this.state.lastUpdatedAt ? this.state.lastUpdatedAt + ' ' + this.state.ext : 'N/A'}</b>
                                <b style={{ display: 'inline-block', }}>{this.state.lastUpdatedBy ? this.state.lastUpdatedBy : 'N/A'}</b>
                              </div>
                            </div>
                          </td>
                        </tr>


                        <tr>
                          <td align='left' style={{
                            fontSize: '0px',
                            padding: '10px 25px',
                            wordBreak: 'break-word'
                          }}>

                            <div>
                              <table align='center' border='0' cellPadding='6' cellSpacing='0' role='presentation' width='100%'>
                                <thead>
                                  <tr style={{
                                    backgroundColor: '#dddddd',
                                    textAlign: 'center'
                                  }}>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>DOD Team Comments</th>
                                    <th style={{
                                      border: '1px solid #bfc9d1',
                                      padding: '6px 6px',
                                      fontSize: '12px',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      background: '#eeeeee'
                                    }}>Warehouse Team Comments</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.editAllocArray.map((record, index) => {
                                    return (<tr key={index}>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 6px',
                                        fontSize: '12px',
                                        textAlign: 'center'
                                      }}>{record?.comm1}</td>
                                      <td style={{
                                        border: '1px solid #bfc9d1',
                                        padding: '6px 6px',
                                        fontSize: '12px',
                                        textAlign: 'center'
                                      }}>{record?.comm2}</td>
                                    </tr>
                                    )
                                  })
                                  }
                                </tbody>
                              </table>
                            </div>

                          </td>
                        </tr>


                        <tr>
                          <td align='left' style={{
                            fontSize: '0px',
                            padding: '10px 25px',
                            wordBreak: 'break-word'
                          }}>

                            <div style={{
                              fontSize: '14px',
                              lineHeight: '20px',
                              paddingTop: '30px',
                              textAlign: 'left',
                              color: '#525252'
                            }}>
                              Regards,<br /><br /> Cargo Optimization Team<br />
                            </div>

                          </td>
                        </tr>

                        <tr>
                          <td style={{
                            fontSize: '0px',
                            padding: '20px 0'
                          }}></td>
                        </tr>

                      </tbody>
                    </table>

                  </td>
                </tr>
              </tbody>
            </table>

          </div>


        </div>
      </div>
    )
  }


  //GENERATE SUMMARY URL
  summaryURL = () => {
    let contPresent = this.state.editRecord?.cont_type?.length > 0 ? this.state.editRecord?.cont_type : ''
    let selected = ''
    if (contPresent) {
      if (contPresent?.includes('LD2') && this.state.editBagLD2 > 0) {
        selected = 'LD2'
      } else if (contPresent?.includes('LD3') && this.state.editBagLD3 > 0) {
        selected = 'LD3'
      }
    }

    if (!selected) {
      if (this.state.editBagLD2 > 0) {
        selected = 'LD2'
      } else if (this.state.editBagLD3 > 0) {
        selected = 'LD3'
      }
    }

    let url = `summery?id=${this.state.editRecord?.id}&fleet=${this.state.editRecord?.ac_type}`
    //if(selected === 'LD2') {
    url += `&ld2=${this.state.editBagLD2 || 0}`
    //}
    //else if(selected === 'LD3') {
    url += `&ld3=${this.state.editBagLD3 || 0}`
    //}
    return url
  }
  //FETCH FLIGHT SUMMARY
  fetchFlightSummary = async () => {
    await Http.get(this.summaryURL()).then((resp) => {
      if (resp?.data?.data) {
        this.calcSummary(resp?.data?.data)
      } else {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: resp?.data?.message,
        })
      }
    }).catch(() => {
      this.setState({ servererror: true }, () => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
    })
  }
  //CALULATE SUMMARY DATA
  calcSummary = (data) => {
    let SLU3CharArr = []
    let SLUAll = []
    let PTU3CharArr = []
    let PTUAll = []
    let Built3CharArr = []
    let BuiltAll = []

    let blkObj = {}
    let blk_count_IT = 0
    let blk_count_CI = 0
    let weight_lbs_IT = 0
    let weight_lbs_CI = 0
    let weight_kg_IT = 0
    let weight_kg_CI = 0

    let vol_IT = 0
    let vol_CI = 0

    data?.summery?.map((item) => {
      if (item?.ulds_in?.blk) {
        if (item?.location) {
          blk_count_CI += 1
          // vol_CI += parseFloat(item?.vol?.value || 0) || 0
          if (item?.vol?.unit === 'FTQ') {
            vol_CI += parseFloat(item?.vol?.value || 0)
          } else if (item?.vol?.unit === 'MTQ') {
            vol_CI += parseFloat((item?.vol?.value || 0) * 35.314667)
          } else if (item?.vol?.unit === 'CF') {
            vol_CI += parseFloat(item?.vol?.value || 0)
          }

          if (item.wgt.unit === 'L' || item.wgt.unit === 'LB' || item.wgt.unit === 'LBR' || item.wgt.unit === 'LBS') {
            weight_lbs_CI += item.wgt.value //ROUNDED TO NEAREST INTEGER
            weight_kg_CI += weightCalculator(parseFloat(item.wgt.value), 'LBS')
          } else if (item.wgt.unit === 'K' || item.wgt.unit === 'KG' || item.wgt.unit === 'KGM') {
            weight_kg_CI += item.wgt.value //ROUNDED TO NEAREST INTEGER
            weight_lbs_CI += weightCalculator(parseFloat(item.wgt.value), 'KGM')
          }
        } else {
          blk_count_IT += 1
          // vol_IT += parseFloat(item?.vol?.value || 0) || 0
          if (vol_IT?.vol?.unit === 'FTQ') {
            vol_CI += parseFloat(item?.vol?.value || 0)
          } else if (item?.vol?.unit === 'MTQ') {
            vol_IT += parseFloat((item?.vol?.value || 0) * 35.314667)
          } else if (item?.vol?.unit === 'CF') {
            vol_IT += parseFloat(item?.vol?.value || 0)
          }

          if (item.wgt.unit === 'L' || item.wgt.unit === 'LB' || item.wgt.unit === 'LBR' || item.wgt.unit === 'LBS') {
            weight_lbs_IT += item.wgt.value //ROUNDED TO NEAREST INTEGER
            weight_kg_IT += weightCalculator(item.wgt.value, 'LBS')
          } else if (item.wgt.unit === 'K' || item.wgt.unit === 'KG' || item.wgt.unit === 'KGM') {
            weight_kg_IT += item.wgt.value //ROUNDED TO NEAREST INTEGER
            weight_lbs_IT += weightCalculator(item.wgt.value, 'KGM')
          }
        }
        //ADD CART IN BUILD UP SUMMARY
        if (!item?.ulds_in?.master && this.checkULDType(item?.ulds_in) === 'CART') {
          if (!BuiltAll.includes(item?.ulds_in?.uld_no)) {
            BuiltAll.push(item?.ulds_in?.uld_no)
            Built3CharArr.push({
              uld_no: item?.ulds_in?.uld_no,
              ready: item?.ulds_in?.rdy === true ? true : false,
            })
          }
        }
      } else {
        let uldType = this.checkULDType(item?.ulds_in)
        if (uldType === 'SLU') {
          if (!SLUAll?.includes(item?.ulds_in?.uld_no)) {
            SLUAll.push(item?.ulds_in?.uld_no)
            SLU3CharArr.push({
              uld_no: item?.ulds_in?.uld_no,
              location: item?.ulds_in?.location,
            })
          }
        } else if (item?.ulds_in?.uld_dispo && item?.ulds_in?.master) {
          if (uldType === 'PTU') {
            if (!PTUAll?.includes(item?.ulds_in?.uld_no)) {
              PTUAll.push(item?.ulds_in?.uld_no)
              PTU3CharArr.push({
                uld_no: item?.ulds_in?.uld_no,
                location: item?.ulds_in?.location,
              })
            }
          }
        } else if (item?.ulds_in && !item?.ulds_in?.master) {
          if (!BuiltAll.includes(item?.ulds_in?.uld_no)) {
            BuiltAll.push(item?.ulds_in?.uld_no)
            Built3CharArr.push({
              uld_no: item?.ulds_in?.uld_no,
              ready: item?.ulds_in?.rdy === true ? true : false,
            })
          }
        }
      }
    })

    blkObj.blk_count_CI = blk_count_CI
    blkObj.blk_count_IT = blk_count_IT
    blkObj.weight_lbs_CI = weight_lbs_CI
    blkObj.weight_lbs_IT = weight_lbs_IT
    blkObj.weight_kg_CI = weight_kg_CI
    blkObj.weight_kg_IT = weight_kg_IT
    blkObj.vol_CI = vol_CI?.toFixed(2) || 0
    blkObj.vol_IT = vol_IT?.toFixed(2) || 0
    this.sortSummary(data.bag)

    this.setState({
      SLUSummary: SLU3CharArr || [],
      PTUSummary: PTU3CharArr || [],
      BuiltSummary: Built3CharArr || [],
      BLKSummary: blkObj || null,
      bagSummary: data?.bag?.length > 0 ? data.bag : []
    }, () => this.setState({ optimalBuild: true }))
  }
  //SORT
  sortSummary = (array) => {
    array && array.sort(function (a, b) {
      // Compare the fields
      if (a?.pmc > b?.pmc) return -1
      if (a?.pmc < b?.pmc) return 1
      return 0
    })
  }
  //SEARCH MODAL
  searchModal = () => {
    let SLU = this.state.SLUSummary
    let PTU = this.state.PTUSummary
    let BUILT = this.state.BuiltSummary
    let BLK = this.state.BLKSummary
    let bagSummary = this.state.bagSummary
    const obcolumns = [
      {
        title: 'MD',
        dataIndex: 'md',
        key: 'md',
        className: 'space-nowrap',
        render: (_, record) => <span>{record?.md || 0}</span>
      },
      {
        // title: 'P96',
        title: 'PMC',
        dataIndex: 'pmc',
        key: 'pmc',
        render: (_, record) => <span>{record?.pmc - this.state.editBagP96}</span>
      },
      {
        // title: 'P88',
        title: 'PAG',
        dataIndex: 'pag',
        key: 'pag',
        render: (_, record) => <span>{record?.pag - this.state.editBagP88}</span>
      },
      {
        title: 'LD3',
        dataIndex: 'ld3',
        key: 'ld3',
        render: (_, record) => <span>{record?.ld3 - this.state.editBagLD3}</span>
      },
      {
        title: 'LD2',
        dataIndex: 'ld2',
        key: 'ld2',
        render: (_, record) => <span>{record?.ld2 - this.state.editBagLD2}</span>
      },
    ]
    return (
      <Modal
        title={`Optimal Build - ${this.state.editRecord?.flight_no}/${moment(this.state.editRecord?.flight_date).format(dateOnly)} - ${this.state.editRecord?.ac_type}`}
        open={this.state.optimalBuild}
        onCancel={() => this.setState({ optimalBuild: false })}
        footer={false}
        width={1160}
        centered
        className='curved-modal pb-0'
        destroyOnClose={true}
        closeIcon={<Text type='secondary'><CloseCircleFilled /></Text>}
      >
        <Card size='small' className='custom-card custom-padding mb-4'
          title={
            <Space>
              <span>Cargo Summary</span>
              <Popover content={legendPopover} title='Legend'><InfoCircleFilled /></Popover>
            </Space>}>
          <Row gutter={[{
            xs: 8,
            sm: 16,
            lg: 24
          }, {
            xs: 8,
            sm: 16,
            lg: 24
          }]}>
            <Col xs={24} lg={16}>
              <Card title='On Hand' size='small' bordered={false} className='curved-card custom-padding'>
                <Row gutter={[8, 8]} className='p-2'>
                  <Col xs={24} sm={12} xl={6}>
                    <div className='cargo-summary'>
                      <p>SLU</p>
                      {SLU?.map((key) => (
                        <p key={key}>
                          <span>{`${key?.uld_no}`}</span>
                          <span>
                            {!key?.location ?
                              <img src={planeLightIcon} width='15' height='15' className='float-right' alt='plane' /> :
                              <span className='float-right'>AS</span>
                            }
                          </span>
                        </p>
                      ))}
                    </div>
                  </Col>

                  <Col xs={24} sm={12} xl={6}>
                    <div className='cargo-summary'>
                      <p>Potential TUs</p>
                      {PTU?.map((key) => (
                        <p key={key}>
                          <span>{`${key?.uld_no}`}</span>
                          <span>
                            {!key?.location ?
                              <img src={planeLightIcon} width='15' height='15' className='float-right' alt='plane' /> :
                              <span className='float-right'>AS</span>
                            }
                          </span>
                        </p>
                      ))}
                    </div>
                  </Col>

                  <Col xs={24} sm={12} xl={6}>
                    <div className='cargo-summary'>
                      <p>Built Up</p>
                      {BUILT?.map((key) => (
                        <p key={key}>
                          <span>{`${key?.uld_no}`}</span>
                          <span>
                            {key?.ready === true ?
                              <span style={{ color: '#629d03' }} className='float-right'>C</span> :
                              <span style={{ color: '#D9001B' }} className='float-right'>O</span>
                            }
                          </span>
                        </p>
                      ))}
                    </div>
                  </Col>

                  <Col xs={24} sm={12} xl={6}>
                    <div className='cargo-summary'>
                      <p>Loose</p>
                      {/* IN TRANSIT */}
                      {BLK?.blk_count_IT > 0 && <p>
                        <span className='dib-w90'>
                          {`${BLK?.blk_count_IT} | ${formatWeight(this.state.weight_unit === 'KG' ?
                            BLK?.weight_kg_IT : this.state.weight_unit === 'LB' ? BLK?.weight_lbs_IT : 0) || 0}${this.state.weight_unit} | ${BLK?.vol_IT}CF`}
                        </span>
                        <span>
                          <img src={planeLightIcon} width='15' height='15' className='float-right' alt='plane' />
                        </span>
                      </p>}
                      {/* CHECKED IN */}
                      {BLK?.blk_count_CI > 0 && <p>
                        <span className='dib-w90'>
                          {`${BLK?.blk_count_CI} | ${formatWeight(this.state.weight_unit === 'KG' ?
                            BLK?.weight_kg_CI : this.state.weight_unit === 'LB' ? BLK?.weight_lbs_CI : 0) || 0} | ${BLK?.vol_CI}CF`}
                        </span>
                        <span>
                          <span className='float-right'>AS</span>
                        </span>
                      </p>}
                    </div>
                  </Col>

                </Row>
              </Card>
            </Col>
            <Col xs={24} lg={8}>
              <Card title='Booked, Not Tendered' size='small' bordered={false} className='curved-card custom-padding'>
                <Row gutter={[8, 8]} className='p-2'>
                  <Col xs={24} sm={12} md={12} lg={24} xl={12}>
                    <div className='cargo-summary'>
                      <p>SLU</p>
                      <p><span className='dib-w90'>MD</span><span>0</span></p>
                      <p><span className='dib-w90'>PMC/PAG</span><span>{this.state.editRecord?.not_tendered?.udp || 0}</span></p>
                      <p><span className='dib-w90'>LD3</span><span>{this.state.editRecord?.not_tendered?.ldc || 0}</span></p>
                      <p><span className='dib-w90'>LD2</span><span>{this.state.editRecord?.not_tendered?.ldp || 0}</span></p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={24} xl={12}>
                    <div className='cargo-summary'>
                      <p>Loose</p>
                      <p>
                        <span className='dib-w90'>
                          {`${this.state.editRecord?.not_tendered?.blk_count || 0} | ${formatWeight(this.state.weight_unit === 'KG' ?
                            this.state.editRecord?.not_tendered?.weight_kg || 0 :
                            this.state.weight_unit === 'LB' ? this.state.editRecord?.not_tendered?.weight_lbs || 0 :
                              0) || 0}${this.state.weight_unit} | ${this.state.editRecord?.not_tendered?.pcs || 0}CF`}
                        </span>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Card>
        <Card size='small' className='custom-card custom-padding' title='Available Configurations'>
          <Row gutter={[{
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12
          }, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12
          },]} className='p-12'>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              className='table-overflow'
            >
              <Table
                className='custom-table w-100'
                dataSource={bagSummary}
                columns={obcolumns}
                pagination={false}
                rowKey='id'
                rowSelection={{
                  type: 'checkbox',
                  onChange: (_, rows) => this.handleCheckboxChange(rows),
                  hideSelectAll: true,
                  selectedRowKeys: this.state.selected
                }}
              />
            </Col>
            <Col xs={24}>
              <Form layout='vertical' >
                <Form.Item label='Hints' className='hint-form'>
                  <Input.TextArea placeholder='Enter hints'
                    value={this.state.editHints}
                    onChange={(e) => this.setState({ editHints: e.target.value })}
                    disabled
                  />
                </Form.Item>
                <Form.Item label='Notes'>
                  <Input.TextArea placeholder='Enter notes'
                    value={this.state.editNotes}
                    onChange={(e) => this.setState({ editNotes: e.target.value })}
                    disabled
                  />
                </Form.Item>
              </Form>
            </Col>
            <Col className='ml-auto'>
              <Button
                disabled={!this.state.bagSelected}
                type='primary'
                className='custom-button mr-4'
                onClick={this.updateBaggage}
              >Update
              </Button>
            </Col>
          </Row>
        </Card>
      </Modal>
    )
  }
  //UPDATE BAGGAGE POSITIONS
  updateBaggage = () => {
    this.setState({
      editCargoMD: this.state.bagSelected?.md,
      editCargoP96: this.state.editBagP96 > 0 ? this.state.bagSelected?.pmc - this.state.editBagP96 : this.state.bagSelected?.pmc,
      editCargoP88: this.state.editBagP88 > 0 ? this.state.bagSelected?.pag - this.state.editBagP88 : this.state.bagSelected?.pag,
      editCargoLD3: this.state.editBagLD3 > 0 ? this.state.bagSelected?.ld3 - this.state.editBagLD3 : this.state.bagSelected?.ld3,
      editCargoLD2: this.state.editBagLD2 > 0 ? this.state.bagSelected?.ld2 - this.state.editBagLD2 : this.state.bagSelected?.ld2,
      hints: this.state.editHints,
      notes: this.state.editNotes,
      selectedRow: this.state.bagSelected.id
      // remainingP96: 0,
      // remainingP88: 0,
      // remainingLD3: 0,
      // remainingLD2: 0,
      // remainingMD: 0,
    }, () => this.setState({
      selected: [],
      bagSelected: null,
      optimalBuild: false,
      //showAlloc: true,
    }))
  }
  //HANDLE CHECKBOX CHANGE
  handleCheckboxChange = (selectedRow) => {
    this.setState({
      selected: [selectedRow[selectedRow?.length - 1]?.id] || [],
      bagSelected: selectedRow[selectedRow?.length - 1] || null,
      editHints: selectedRow[selectedRow?.length - 1]?.hint || null,
      editNotes: selectedRow[selectedRow?.length - 1]?.note || null,
    })
  }
  //HANDLE CHECKBOX CHANGE
  handleFilterChange = (e) => {
    let destFilters = this.state.destFilters
    if (e.target.checked) {
      destFilters.push(e.target.value)
    } else {
      destFilters = destFilters.filter((item) => item !== e.target.value)
    }
    this.setState({ destFilters: destFilters })
  }
  //SAVE CHANGES
  submit = async (action) => {
    if (this.state.editRecord?.id) {
      let headers = {
        station: this.state.station,
        user_id: this.state.user_id,
      }
      let formdata = {}
      let url = ''

      if (action == 'add' || action === 'edit') {
        url = `/flight_plan/${action}/${parseInt(this.state.editRecord.id)}`
        if (this.state.editAllocRecord) {
          formdata.id = this.state.editAllocRecord?.id
        }
        formdata.comm1 = this.state.editAllocRecord ? this.state.editTComm1 || '' : this.state.editComm1 || ''
        formdata.comm2 = this.state.editAllocRecord ? this.state.editTComm2 || '' : this.state.editComm2 || ''
      } else if (action == 'delete') {
        url = `/flight_plan/${action}/${parseInt(this.state.editRecord?.id)}/${parseInt(this.state.deleteAllocID)}`
      }

      let awaitMehod = action == 'add' || action === 'edit' ? Http.post(url, formdata, { headers }) : Http.delete(url, { headers })
      await awaitMehod.then((data) => {
        if (data && data?.status === 200) {
          //CLEAR LOAD PLAN FORM
          if (action == 'add') this.clearEditAllocForm()
          //CLEAR LOAD PLAN TABLE FORM
          if (this.state.editAllocRecord) this.clearAllocTableForm()

          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
        this.setState({ loading: false })
      })
    } else {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: 'Invalid Input',
      })
    }
  }
  //SET RECORD EDITABLE
  setEdit = (record, type = '') => {
    let flight_index1 = this.state.flightData.findIndex((item) => item.id === record.id)
    this.setState({
      editRecordId: record?.id,
      flightDataIndex: flight_index1
    })
    let calcRemainingPos = record?.details?.length > 0 ? this.calcPos(record?.details) : ''
    let org_dst = record?.org_stn + record?.dest_stn
    let goal = ch_wt_goals.find((item) => item.lane == org_dst)
    this.setState({ chblWgtGoal: goal })

    if (type) {
      if (type === 'DETAILS') {
        this.setState({
          editRecord: record,
          editFcst: record?.fcst || 0,
          editBagP96: record?.bag?.p96 || 0,
          editBagP88: record?.bag?.p88 || 0,
          editBagLD3: record?.bag?.ld3 || 0,
          editBagLD2: record?.bag?.ld2 || 0,
          editCargoMD: record?.cargo?.md || 0,
          editCargoP96: record?.cargo?.p96 || 0,
          editCargoP88: record?.cargo?.p88 || 0,
          editCargoLD3: record?.cargo?.ld3 || 0,
          editCargoLD2: record?.cargo?.ld2 || 0,
          editWgtValue: this.state.weight_unit === 'KG' ? parseFloat(record?.weight_kg || 0)?.toFixed(2) : parseFloat(record?.weight_lbs || 0)?.toFixed(2),
          editWgtUnit: this.state.weight_unit === 'KG' ? 'KG' : 'LB',
          editBuPrio: record?.bu_prio || false,
          editIsExceeded: record?.load_plan || false,
          previewFwd: record?.fwd_conf?.path,
          previewAft: record?.aft_conf?.path,
          lastUpdatedBy: record?.last_updated_by,
          lastUpdatedAt: record?.last_updated_at,
          lastUpdatedPpr: record?.last_updated_ppr,
          isWideBody: record?.acpt_body,
          remainingP96: calcRemainingPos?.P96 ? (record?.cargo?.p96 || 0) - calcRemainingPos.P96 : (record?.cargo?.p96 || 0),
          remainingP88: calcRemainingPos?.P88 ? (record?.cargo?.p88 || 0) - calcRemainingPos.P88 : (record?.cargo?.p88 || 0),
          remainingLD3: calcRemainingPos?.LD3 ? (record?.cargo?.ld3 || 0) - calcRemainingPos.LD3 : (record?.cargo?.ld3 || 0),
          remainingLD2: calcRemainingPos?.LD2 ? (record?.cargo?.ld2 || 0) - calcRemainingPos.LD2 : (record?.cargo?.ld2 || 0),
          remainingMD: calcRemainingPos?.MD ? (record?.cargo?.md || 0) - calcRemainingPos.MD : (record?.cargo?.md || 0),
          searchFlightNo: record?.flight_no?.toUpperCase() || '',
          searchDate: record?.dept_date ? moment.utc(record.dept_date).tz(this.state.timezone) :
            record?.schdl ? moment.tz(record.schdl, this.state.timezone) :
              record?.flight_date ? moment(record.flight_date) : '',
        }, () => this.bookedULD())
      } else {
        this.setState({
          editRecord: record,
          lastUpdatedBy: record?.last_updated_by,
          lastUpdatedAt: record?.last_updated_at,
          lastUpdatedPpr: record?.last_updated_ppr,
          isWideBody: record?.acpt_body,
          editAllocArray: record?.details || [],
          searchFlightNo: record?.flight_no?.toUpperCase() || '',
          searchDate: record?.dept_date ? moment.utc(record.dept_date).tz(this.state.timezone) :
            record?.schdl ? moment.tz(record.schdl, this.state.timezone) :
              record?.flight_date ? moment(record.flight_date) : '',
        }, () => this.bookedULD())
      }
    } else {
      this.setState({
        editRecord: record,
        editFcst: record?.fcst || 0,
        editBagP96: record?.bag?.p96 || 0,
        editBagP88: record?.bag?.p88 || 0,
        editBagLD3: record?.bag?.ld3 || 0,
        editBagLD2: record?.bag?.ld2 || 0,
        editCargoMD: record?.cargo?.md || 0,
        editCargoP96: record?.cargo?.p96 || 0,
        editCargoP88: record?.cargo?.p88 || 0,
        editCargoLD3: record?.cargo?.ld3 || 0,
        editCargoLD2: record?.cargo?.ld2 || 0,
        notes: record?.cargo?.notes || '',
        hints: record?.cargo?.hints || '',
        editHints: '',
        editNotes: '',
        editWgtValue: this.state.weight_unit === 'KG' ? parseFloat(record?.weight_kg || 0)?.toFixed(2) : parseFloat(record?.weight_lbs || 0)?.toFixed(2),
        editWgtUnit: this.state.weight_unit === 'KG' ? 'KG' : 'LB',
        editBuPrio: record?.bu_prio || false,
        editIsExceeded: record?.load_plan || false,
        previewFwd: record?.fwd_conf?.path,
        previewAft: record?.aft_conf?.path,
        lastUpdatedBy: record?.last_updated_by,
        lastUpdatedAt: record?.last_updated_at,
        lastUpdatedPpr: record?.last_updated_ppr,
        isWideBody: record?.acpt_body,
        editAllocArray: record?.details || [],
        remainingP96: calcRemainingPos?.P96 ? (record?.cargo?.p96 || 0) - calcRemainingPos.P96 : (record?.cargo?.p96 || 0),
        remainingP88: calcRemainingPos?.P88 ? (record?.cargo?.p88 || 0) - calcRemainingPos.P88 : (record?.cargo?.p88 || 0),
        remainingLD3: calcRemainingPos?.LD3 ? (record?.cargo?.ld3 || 0) - calcRemainingPos.LD3 : (record?.cargo?.ld3 || 0),
        remainingLD2: calcRemainingPos?.LD2 ? (record?.cargo?.ld2 || 0) - calcRemainingPos.LD2 : (record?.cargo?.ld2 || 0),
        remainingMD: calcRemainingPos?.MD ? (record?.cargo?.md || 0) - calcRemainingPos.MD : (record?.cargo?.md || 0),
        searchFlightNo: record?.flight_no?.toUpperCase() || '',
        searchDate: record?.dept_date ? moment.utc(record.dept_date).tz(this.state.timezone) :
          record?.schdl ? moment.tz(record.schdl, this.state.timezone) :
            record?.flight_date ? moment(record.flight_date) : '',
      }, () => this.bookedULD())
    }
  }

  bookedULD = () => {
    this.setState({ loadplanvisible: true })
    let data = cloneDeep(this.state.editRecord)
    let awbsIn = []
    data.ulds_out && data.ulds_out.map(uld => {
      let slu = uld?.info?.remark && uld?.info?.remark?.includes('SLU') ? true : false
      uld.awbs_in && uld.awbs_in?.map(awb => {
        if (cookies.get('station') != awb?.dest) {
          const index = awbsIn.findIndex(x => x.awb_no === awb.awb_no)
          if (index == -1) {
            awbsIn.push({
              ...awb,
              id: null,
              is_assigned: true,
              on_hand: true,
              pre_build: false,
              ch_wgt: {
                unit: awb?.awb?.weight_unit,
                value: awb?.awb?.ch_pcs * (awb?.pcs || 0)
              },
              pri: this.state.priorityData?.find(x => x.p_code == awb?.prod_code)?.priority || null,
              sort_priority: this.state.priorityData?.find(x => x.p_code == awb?.prod_code)?.sort_priority || null,
              delay: awb?.awb?.time_of_avl ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment(awb?.awb?.time_of_avl), 'days') * -1 : 0,
              vol: {
                value: parseFloat(awb?.awb?.vol_pcs) * (awb?.pcs || 0),
                unit: awb?.awb?.vol_unit
              },
              at_stn: [
                {
                  blk: uld?.blk || false,
                  uld_no: uld.uld_no,
                  location: uld.location,
                  pcs: awb.pcs,
                  rdy: uld.rdy,
                }
              ],
              slu_uld: slu ? [{
                uld_no: uld.uld_no,
                pcs: awb.pcs,
                wgt: awb.wgt?.value,
                remark: 'SLU',
                id: uld.id,
              }] : [],
            })
          } else {
            awb?.inbound ? awbsIn[index].location = [...new Set(awbsIn[index]?.location?.split(',').concat(awb?.location?.split(',')))].filter(Boolean).join(',') : {}
            awbsIn[index].pcs += awb.pcs
            awbsIn[index].wgt.value += awb?.wgt?.value || 0
            awbsIn[index].vol.value = awb?.awb?.vol_pcs * (awbsIn[index].pcs || 0)
            awbsIn[index].ch_wgt.value = awb?.awb?.ch_pcs * (awbsIn[index].pcs || 0)
            awbsIn[index].at_stn = [...awbsIn[index].at_stn, {
              blk: uld?.blk || false,
              uld_no: uld.uld_no,
              location: uld.location,
              pcs: awb.pcs,
              rdy: uld.rdy,
            }]
            awbsIn[index].vol.value += awb?.vol?.value || 0
            awbsIn[index].spl_code = [...new Set(awbsIn[index]?.spl_code?.split(',').concat(awb.spl_code?.split(',')))].join(','),
            awbsIn[index].slu_uld = slu ? [...awbsIn[index].slu_uld, {
              uld_no: uld.uld_no,
              pcs: awb.pcs,
              wgt: awb.wgt?.value,
              remark: 'SLU',
              id: uld.id,
            }] : awbsIn[index].slu_uld
          }
        }
      })
    })

    data.awb_segments && data.awb_segments.map(segment => {
      const pre_build = segment.space.ldc || segment.space.ldp || segment.space.udp ? true : false
      const index = awbsIn.findIndex(x => x.awb_no === segment.awb_no)
      if (index == -1) {
        awbsIn.push({
          // remove duplicates flights and then join
          location: [
            ...new Set(
              segment?.segs_outs
                ?.filter(seg => seg.flights_in?.flight_no && seg.flights_in?.flight_date)
                ?.map(seg =>
                  seg.location || `${seg.flights_in.flight_no}/${moment(seg.flights_in.flight_date).format(dateOnly)}`
                )
            )
          ].join(', '),
          is_booked: true,
          awb_no: segment.awb_no,
          awb_id: segment.awb_id,
          pcs: segment.space.pcs,
          avl_pcs: segment.space.pcs,
          wgt: {
            unit: segment.awb.weight_unit,
            value: segment.space.wgt
          },
          vol: {
            value: segment.awb?.vol_pcs * segment.space.pcs,
            unit: segment.awb.vol_unit
          },
          dest: segment.awb.dest,
          prod_code: segment.awb.prod_code,
          spl_code: segment.awb.spl_code,
          on_hand: false,
          pre_build: pre_build,
          // ch_vol,
          ch_wgt: {
            unit: segment.awb.weight_unit,
            value: segment.awb.ch_pcs * segment.space.pcs
          },
          showred: segment.showred ? true : false,
          pri: this.state.priorityData?.find(x => x.p_code == segment.awb.prod_code)?.priority || null,
          sort_priority: this.state.priorityData?.find(x => x.p_code == segment.awb.prod_code)?.sort_priority || null,
          delay: segment.awb.time_of_avl ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment(segment.awb.time_of_avl), 'days') * -1 : 0,
          booked: [{
            flight_no: data.flight_no,
            flight_date: data.flight_date,
            pcs: segment.space.pcs,
          }],
        })
      } else {
        awbsIn[index].pre_build = pre_build
        awbsIn[index].is_booked = true
      }
    })
    data.build_plan?.map(awb => {
      const index = awbsIn.findIndex(x => x.awb_no === awb.awb_no)
      if (index == -1 && awb.manual) {
        awbsIn.push({
          ...awb,
          ...awb.data,
          wgt: {
            value: awb?.data?.wgt,
            unit: awb?.data?.wgt_unit
          },
          vol: {
            value: awb?.data?.vol,
            unit: awb?.data?.vol_unit
          },
          ch_wgt: {
            value: awb?.data?.ch_wgt,
            unit: awb?.data?.wgt_unit
          },
          sort_priority: this.state.priorityData?.find(x => x.p_code == awb?.data?.prod_code)?.sort_priority || null
        })
      } else {
        if (index != -1) {
          awbsIn[index].is_deleted = awb.is_deleted
          awbsIn[index] = {
            ...awbsIn[index],
            ...awb?.data,
            location: awb?.data?.location || awbsIn[index].location,
            dest: awb?.data?.dest || awbsIn[index].dest,
            prod_code: awb?.data?.prod_code || awbsIn[index].prod_code,
            spl_code: awb?.data?.spl_code || awbsIn[index].spl_code,
            delay: awb?.data?.delay || awbsIn[index].delay,
            pri: awb?.data?.pri && parseInt(awb.data.pri) == awb.data.pri ? awb?.data?.pri : awbsIn[index].pri,
            pre_build: awb?.data?.pre_build || awbsIn[index].pre_build,
            on_hand: awb?.data?.on_hand || awbsIn[index].on_hand,
            wgt: awbsIn[index].wgt,
            vol: awbsIn[index].vol,
            ch_wgt: awbsIn[index].ch_wgt,
          }
          if (awb?.data?.wgt && awb?.data?.wgt > 0)
            awbsIn[index].wgt = {
              value: awb.data.wgt,
              unit: awb.data.wgt_unit
            }
          if (awb?.data?.vol && awb?.data?.vol > 0)
            awbsIn[index].vol = {
              value: awb.data.vol,
              unit: awb.data.vol_unit
            }
          if (awb?.data?.ch_wgt)
            awbsIn[index].ch_wgt = {
              value: awb.data.ch_wgt,
              unit: awb.data.wgt_unit
            }
        }
      }
    })

    this.setState({ mergeEditRecord: awbsIn }, this.fetchUlds)
  }

  addULD = (record) => {
    let assignUld = {
      type: 'BULK',
      id: 0,
    }
    let bpIndex = this.state.editRecord?.build_plan?.findIndex(item => item.awb_no === record.awb_no)
    if(bpIndex != -1){
      if(this.state.editRecord.build_plan[bpIndex].data?.blk > 0){
        assignUld = {
          type: 'BULK',
          id: 0 
        }
      } else if(this.state.editRecord.build_plan[bpIndex].ulds && this.state.editRecord.build_plan[bpIndex].ulds.length > 0){
        assignUld = { id: this.state.editRecord.build_plan[bpIndex].ulds[0].id }
      }
    }
    this.setState({
      addULD: true,
      flightDetails: {
        ...record,
        editWgtUnit: this.state.editWgtUnit
      },
      assignUld: assignUld
    }
    , () => {
      this.fetchUlds()
    }
    )

  }
  // //OPEN CHECKLIST MODAL 
  // showCheckList(record) {
  //   let title  = record?.flight_no && record?.dept_time ? 'Checklist for  - '+ formatFlightNo(record.flight_no, record.dept_time) : ''
  //   this.setState ({ 
  //     checkListOpen: true,
  //     checkListTitle : title
  //   })
  // }


  //CHECK FOR ULD TYPE
  checkULDType = (uld) => {
    let type = ''
    if (uld?.blk && (!uld?.uld_no?.startsWith('C') && !uld?.uld_no?.endsWith('#'))) {
      type = 'BLK'
    } else {
      if (uld?.info?.remark?.toUpperCase()?.includes('SLU')) {
        type = 'SLU'
      } else if (!uld?.info?.remark?.toUpperCase()?.includes('SLU') && uld?.dest && uld?.dest !== this.state.station && uld?.master) {
        type = 'PTU'
      } else if (uld?.uld_no?.startsWith('C') || uld?.uld_no?.endsWith('#')) {
        type = 'CART'
      }
    }
    return type
  }
  //CALCULATE REMAINING POSITIONS
  calcPos = (details) => {
    let countp96 = 0
    let countp88 = 0
    let countld3 = 0
    let countld2 = 0
    let countmd = 0

    details?.map((item) => {
      switch (item?.type) {
      case 'P96':
        countp96 += parseInt(item?.pos || 0)
        break
      case 'P88':
        countp88 += parseInt(item?.pos || 0)
        break
      case 'LD3':
        countld3 += parseInt(item?.pos || 0)
        break
      case 'LD2':
        countld2 += parseInt(item?.pos || 0)
        break
      case 'MD':
        countmd += parseInt(item?.pos || 0)
        break
      default:
        break
      }
    })

    return {
      P96: countp96,
      P88: countp88,
      LD3: countld3,
      LD2: countld2,
      MD: countmd,
    }
  }
  //SET ALLOCATIONS VALUES
  editAllocTableForm = (record) => {
    this.setState({
      editAllocRecord: record,
      editTPos: record?.pos,
      editTType: record?.type,
      editTWorkArea: record?.work_area,
      editTULDAWB: record?.uld_awb_no,
      editTProd: record?.prod_code,
      editTComm1: record?.comm1,
      editTComm2: record?.comm2,
    })
  }
  //CLEAR FLIGHT FORM
  clearEditFlightForm = () => {
    this.setState({
      editRecord: null,
      editFcst: 0,
      editBagP96: 0,
      editBagP88: 0,
      editBagLD3: 0,
      editBagLD2: 0,
      editCargoMD: 0,
      editCargoP96: 0,
      editCargoP88: 0,
      editCargoLD3: 0,
      editCargoLD2: 0,
      editWgtValue: 0,
      editWgtUnit: this.state.weight_unit === 'KG' ? 'KG' : 'LB',
      editBuPrio: false,
      editIsExceeded: false,
      editAllocArray: [],
      previewFwd: null,
      previewAft: null,
      lastUpdatedAt: '',
      lastUpdatedBy: '',
      lastUpdatedPpr: '',
      isWideBody: false,
      searchDate: '',
      searchFlightNo: '',
    })
  }
  //CLEAR ALLOCATIONS FORM
  clearEditAllocForm = () => {
    this.setState({
      editPos: '',
      editType: '',
      editWorkArea: '',
      editULDAWB: '',
      editProd: '',
      editComm1: '',
      editComm2: '',
    })
  }
  //CLEAR ALLOCATIONS TABLE FORM
  clearAllocTableForm = () => {
    this.setState({
      editAllocRecord: null,
      deleteAllocID: null,
      editTPos: '',
      editTType: '',
      editTWorkArea: '',
      editTULDAWB: '',
      editTProd: '',
      editTComm1: '',
      editTComm2: '',
    })
  }
  //SORT
  sort = (array, on_load) => {
    let sort = this.state.sort
    array && array.sort(function (keyA, keyB) {
      let a = sort === 'ac_type' ? keyA[sort] : keyA[sort] ? moment(keyA[sort]) : null
      let b = sort === 'ac_type' ? keyB[sort] : keyB[sort] ? moment(keyB[sort]) : null

      let va = (a === null) ? '' : '' + a
      let vb = (b === null) ? '' : '' + b

      if (sort === 'notes_date') {
        return va > vb ? -1 : (va === vb ? 0 : 1)
      } else {
        return va > vb ? 1 : (va === vb ? 0 : -1)
      }
    })

    if (!on_load) {
      this.setState({ flightData: [] }, () => this.setState({ flightData: array }, () => {
        if (this.state.departedFlightsCheck) {
          this.departedFlightsFilter()
        }
      }))
    }
  }
  sortDodCC = (flightData) => {
    let sort = this.state.dodsort
    flightData && flightData.sort(function (keyA, keyB) {
      let a = sort === 'dest_stn' || sort === 'flight_no' ? keyA[sort] : keyA[sort] ? moment(keyA[sort]) : null
      let b = sort === 'dest_stn' || sort === 'flight_no' ? keyB[sort] : keyB[sort] ? moment(keyB[sort]) : null
      let va = (a === null) ? '' : '' + a
      let vb = (b === null) ? '' : '' + b
      return va > vb ? 1 : (va === vb ? 0 : -1)
    })
    return flightData
  }
  //FILTER DEPARTED FLIGHTS
  departedFlightsFilter = () => {
    if (this.state.departedFlightsCheck || this.state.amberFlightsCheck || this.state.redFlightsCheck) {
      let filtered_data = cloneDeep(this.state.flightData)
      let filters = {}
      if (this.state.departedFlightsCheck) {
        filtered_data = filtered_data?.filter((flight) => moment(flight?.dept_time).valueOf() > moment().tz(this.state.timezone).valueOf())
      }

      if (this.state.amberFlightsCheck) {
        filters.amberEquals = item => item.cccolour === 'amber'
      }
      if (this.state.redFlightsCheck) {
        filters.redEquals = item => item.cccolour === 'red'
      }
      if (this.state.amberFlightsCheck || this.state.redFlightsCheck) {
        filtered_data = filtered_data?.filter(item => Object.values(filters)?.some(f => f(item)))
      }

      this.setState({ displayData: filtered_data })
    }
    else {
      this.setState({ displayData: [] })
    }
  }
  //SHOW NOTES
  showFlightNotes = (record) => {
    let note = record?.awb_no ? record.awb_no : record?.flight_no ? record.flight_no : null
    if (record.flight_no && record.flight_date) {
      note = note + '/' + moment(record.flight_date).format(dateOnly)
    }
    let title = record?.flight_no && record?.dept_time ? 'Flight Notes - ' + formatFlightNo(record.flight_no, record.dept_time) : record?.awb_no ? 'AWB Notes - ' + formatAWBNo(record.awb_no) :
      record?.flight_no && record?.flight_date ? 'Flight Notes - ' + formatFlightNo(record.flight_no, record.flight_date) : record?.awb_no ? 'AWB Notes - ' + formatAWBNo(record.awb_no) : ''
    this.setState({
      searchString: note,
      flightNotes: true,
      notesTitle: title,
      noteType: this.state.radioValue === 2 ? 'checklist' : null
    })
  }
  //SET FILTERS
  setFilters = (type) => {
    let current_date = moment().tz(this.state.timezone).format(dateFormat)
    let selected_date_time = ''
    if (type === 'start') {
      selected_date_time = moment(this.state.start).format(dateFormat)

      if (selected_date_time < current_date) {
        this.setState({
          flightData: [],
          page: 1,
          end: moment(this.state.start).add(1, 'day'),
          stime: moment().tz(this.state.timezone).set({
            minutes: 0,
            second: 0,
          }),
          etime: moment().tz(this.state.timezone).set({
            minutes: 0,
            second: 0,
          }),
        }, () => this.fetchFlights())
      } else if (selected_date_time === current_date) {
        this.setState({
          flightData: [],
          page: 1,
          end: moment(this.state.start),
          stime: moment().tz(this.state.timezone).set({
            hours: 0,
            minutes: 0,
            second: 0,
          }),
          etime: moment().tz(this.state.timezone).set({
            hours: 23,
            minutes: 59,
            seconds: 59,
          }),
        }, () => this.fetchFlights())
      } else if (selected_date_time > current_date) {
        this.setState({
          flightData: [],
          page: 1,
          end: moment(this.state.start),
          stime: moment().tz(this.state.timezone).set({
            hours: 0,
            minutes: 0,
            second: 0,
          }),
          etime: moment().tz(this.state.timezone).set({
            minutes: 0,
            second: 0,
          }),
        }, () => this.fetchFlights())
      }
    } else if (type === 'end') {
      selected_date_time = moment(this.state.end).format(dateFormat)

      if (selected_date_time < current_date) {
        this.setState({
          flightData: [],
          page: 1,
          start: moment(this.state.end),
          stime: moment().tz(this.state.timezone).set({
            minutes: 0,
            second: 0,
          }),
          etime: moment().tz(this.state.timezone).set({
            hours: 23,
            minutes: 59,
            second: 59,
          }),
        }, () => this.fetchFlights())
      } else if (selected_date_time === current_date) {
        this.setState({
          flightData: [],
          page: 1,
          start: moment(this.state.end),
          stime: moment().tz(this.state.timezone).set({
            hours: 0,
            minutes: 0,
            second: 0,
          }),
          etime: moment().tz(this.state.timezone).set({
            hours: 23,
            minutes: 59,
            seconds: 59,
          }),
        }, () => this.fetchFlights())
      } else if (selected_date_time > current_date) {
        this.setState({
          flightData: [],
          page: 1,
          start: moment(this.state.end).subtract(1, 'day'),
          stime: moment().tz(this.state.timezone).set({
            minutes: 0,
            second: 0,
          }),
          etime: moment().tz(this.state.timezone).set({
            minutes: 0,
            second: 0,
          }),
        }, () => this.fetchFlights())
      }
    } else if (type === 'stime' || type === 'etime') {
      this.setState({
        flightData: [],
        page: 1,
      }, () => this.fetchFlights())
    }
  }
  //SET DATES DISABLED ON CONDITION
  disabledDate = (current) => {
    let prev = moment().tz(this.state.timezone).subtract(1, 'month').format(dateFormat)
    let next = moment().tz(this.state.timezone).add(1, 'week').format(dateFormat)
    return current && (current < moment(prev, dateFormat) || current > moment(next, dateFormat))
  }

  openBP = () => {
    this.setState({ showBP: true })
  }

  submitData = async () => {
    let headers = {
      station: this.state.station,
      user_id: this.state.user_id,
    }
    let formdata = {
      bag: {},
      cargo: {},
      wgt: {},
    }
    formdata.fcst = this.state.editFcst || 0
    formdata.bag.p96 = this.state.editBagP96 || 0
    formdata.bag.p88 = this.state.editBagP88 || 0
    formdata.bag.ld3 = this.state.editBagLD3 || 0
    formdata.bag.ld2 = this.state.editBagLD2 || 0
    formdata.cargo.md = this.state.editCargoMD || 0
    formdata.cargo.p96 = this.state.editCargoP96 || 0
    formdata.cargo.p88 = this.state.editCargoP88 || 0
    formdata.cargo.ld3 = this.state.editCargoLD3 || 0
    formdata.cargo.ld2 = this.state.editCargoLD2 || 0
    formdata.wgt.value = this.state.editWgtValue || 0
    formdata.wgt.unit = this.state.editWgtUnit
    formdata.bu_prio = this.state.editBuPrio
    formdata.load_plan = this.state.editIsExceeded
    formdata.cargo.hint = this.state.hints
    formdata.cargo.note = this.state.notes
    formdata.cargo.id = this.state.selectedRow
    // formdata.details = this.state.editAllocArray

    await Http.put(`/flight_control_update/${parseInt(this.state.editRecord.id)}`, formdata, { headers })
      .then((data) => {
        if (data && data?.status === 200) {
          this.setState({ showSuccess: true })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
        this.setState({ loading: false })
      })
  }
  checkFlightDate = (record) => {
    let hours = moment.utc(record.flight_date).format('HH')
    let mins = moment.utc(record.flight_date).format('mm')
    if (hours === '00' && mins === '00') {
      return moment(record.flight_date).format(dateOnly)
    } else {
      return moment.utc(record.flight_date).tz(this.state.timezone).format(dateOnly)
    }
  }

  emailLoadPlan = async () => {
    const builderCopy = await this.generateLoadPlan('email')
    const lhrCopy = this.state.editRecord?.org_stn === 'LHR' ? await this.generateLoadPlanLHR('email') : null
    const scrubCopy = await this.exportScrub('email')

    const attachments = [
      builderCopy,
      scrubCopy,
      ...(lhrCopy ? [lhrCopy] : [])
    ]

    const divContent = this.modalRef.current.innerHTML
    const formData = new FormData()
    formData.append('emailContent', divContent)
    formData.append('emailSubject', `Build Plan: ${this.state.editRecord?.flight_no || 'N/A'}/${this.state.editRecord?.org && this.state.editRecord?.dest ? (this.state.editRecord.org.origin) + '-' + (this.state.editRecord.dest.arriv) : 'N/A'} ${this.state.editRecord?.flight_date ? moment(this.state.editRecord?.flight_date).format(dateOnly)?.toUpperCase() : 'N/A'}`)

    attachments.forEach((att) => {
      formData.append('attachments', att.fileBlob, att.fileName)
    })
    Http.post('/email_load_plan', formData)
      .then((data) => {
        if (data && data?.status === 200) {
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      }).catch((err) => {
        console.log('err', err)
      })
  }

  handleAnswers = (e, question) => {
    let questionsData = this.state.questionsData
    if (e?.target?.type === 'textarea') {
      questionsData[question].answer = e?.target?.value || null
    } else {
      questionsData[question].answer = e
      questionsData[question].comment = null
      if (questionsData[question].details.nested === 'Yes') {
        let parent_id = questionsData[question].id
        questionsData.map((item, index) => {
          if (item?.parent_id === parent_id) {
            questionsData[index].showchild = e === 'Yes' ? true : false
            questionsData[index].answer = null
          }
        })
      }
    }
    this.setState({ questionsData })
  }

  handleAnswerAttachment = (e, question, action) => {
    let questionsData = this.state.questionsData
    if (action === 'remove') {
      questionsData[question].answer_attach_conf = null,
      questionsData[question].answer_attach_data = [],
      this.setState({ questionsData })
      return
    }
    if (e?.fileList?.[0]) {
      questionsData[question].answer_attach_conf = e?.fileList[0].originFileObj,
      questionsData[question].answer_attach_data = e?.fileList,
      this.setState({ questionsData })
    } else {
      questionsData[question].answer_attach_conf = null,
      questionsData[question].answer_attach_data = [],
      this.setState({ questionsData })
    }
  }

  handleComment = (e, question) => {

    let questionsData = this.state.questionsData
    questionsData[question].comment = e?.target?.value ? e?.target?.value : e || null
    this.setState({ questionsData })
  }

  saveAnswers = async () => {
    let headers = {
      station: this.state.station,
      user_id: this.state.user_id,
    }
    let milestones_id = this.state.quizMilestonid
    let answers = []
    let isAnswered = true
    this.state.questionsData.map((question) => {
      if (!question?.answer || question?.answer === null || question?.answer === '') {
        if (!question.parent_id || question.parent_id && question?.showchild) {
          isAnswered = false
        }
      } if (question?.details?.type === 'yes/no' && question?.answer === question?.details?.comment && (question?.comment === null || question?.comment === '')) {
        if (!question.parent_id || question.parent_id && question?.showchild) {
          isAnswered = false
        }
      } if (question?.details?.type === 'mcq' && question.details.options && question.details.options.length > 0
        && question.details.options.find((option) => option?.name === question.answer)?.commentsReq
        && (question?.comment === null || question?.comment === '')) {
        if (!question.parent_id || question.parent_id && question?.showchild) {
          isAnswered = false
        }
      }
      answers.push({
        question_id: question?.id,
        answer: question?.answer,
        comment: question?.comment,
        answer_attach_conf: question?.answer_attach_conf,
        answer_attach_data: question?.answer_attach_data,
        has_attachment: question?.answer_attach_conf ? true : false, // Flag to indicate file presence
      })
    })
    if (!isAnswered) {
      notification.destroy()
      notification.warning({
        message: 'Warning',
        description: 'Please answer all questions',
      })
    } else {
      let formdata = new FormData()
      formdata.append('answers', JSON.stringify(answers))
      formdata.append('flight_id', this.state.quizModalFlight.id)
      formdata.append('milestones_id', milestones_id)

      // Append files with unique identifiers
      this.state.questionsData.forEach((question) => {
        if (question?.answer_attach_conf && question?.answer_attach_data?.[0]) {
          const file = question.answer_attach_data[0].originFileObj
          if (file) {
            // Append the actual file with question_id in the field name
            formdata.append(`attachment_${question.id}`, file)

            // Optionally append metadata (for filename reference)
            formdata.append(`answer_attach_data_${question.id}`, JSON.stringify({
              name: file.name,
              size: file.size,
              type: file.type
            }))
          }
        }
      })

      if (this.state.quizModalFlight.answers?.id) {
        Http.put(`/answer/${this.state.quizModalFlight.answers?.id}`, formdata, { headers })
          .then((resp) => {
            if (resp?.data?.data) {
              this.setState({ openQuizModal: false })
            } else {
              notification.destroy()
              notification.error({
                message: 'Failed',
                description: resp?.data?.message,
              })
            }
          })
      } else {
        Http.post('/answer', formdata, { headers })
          .then((resp) => {
            if (resp?.data?.data) {
              this.setState({ openQuizModal: false })
            } else {
              notification.destroy()
              notification.error({
                message: 'Failed',
                description: resp?.data?.message,
              })
            }
          })
      }
    }
  }

  getAct = (flight, ms_id, format) => {
    let answers = flight?.answers
    if (answers && answers.length > 0) {
      let answer = answers.find((item) => item?.milestones_id === ms_id || item?.type === ms_id)
      if (answer) {
        if (answer?.updatedAt)
          return moment.utc(answer?.updatedAt).tz(this.state.timezone).format(format)
        else
          return null
      } else {
        return null
      }
    } else {
      return null
    }
  }

  checkStatusColour = (dept, act, amber, flight_leg, milestone, greymilestones, ignoremilestones) => {
    let greyfound = false
    let ignorefound = false
    greymilestones.findIndex((item) => item === milestone.id) > -1 ? greyfound = true : greyfound = false
    ignoremilestones.findIndex((item) => item === milestone.id) > -1 ? ignorefound = true : ignorefound = false
    // if (flight_leg?.cancel) {
    // }
    if (flight_leg && flight_leg?.cancel || greyfound) {
      return 'bg-grey'
    } else if (!act || ignorefound) {
      if ((moment().tz(this.state.timezone)).diff(dept, 'minutes') > 0) {
        return 'bg-red'
      } else {
        if (amber && amber !== undefined && dept.diff(moment().tz(this.state.timezone), 'minutes') > 0 && dept.diff(moment().tz(this.state.timezone), 'minutes') < parseInt(amber)) {
          return 'bg-amber'
        } else {
          return 'bg-white'
        }
      }
    } else {
      // if (moment(act).diff(dept, 'minutes') > 0) {
      //   return 'bg-red'
      // } else {
      //   return 'bg-green'
      // }
      return 'bg-green'
    }
  }

  getCountdown = (dept, act, cutoff, amber) => {
    let flightData = this.state.flightData
    let date = moment.utc(dept).tz(this.state.timezone).subtract(cutoff, 'minutes')
    let curr_diff = date.diff(moment().tz(this.state.timezone), 'minutes')
    if (!act) {
      if (curr_diff > 0) {
        //return curr_diff
        if (amber) {
          let amber_date = date.subtract(amber, 'minutes')
          let amber_curr_diff = amber_date.diff(moment().tz(this.state.timezone), 'minutes')
          if (amber_curr_diff > 0) {
            return <Countdown className='hidden-countdown' onFinish={() => {
              this.setState({ flightData: flightData })
            }} value={moment(amber_date)} format='HH:mm' />
          } else {
            return <Countdown className='hidden-countdown' onFinish={() => {
              this.setState({ flightData: flightData })
            }} value={moment(date)} format='HH:mm' />
          }
        } else {
          return <Countdown className='hidden-countdown' onFinish={() => {
            this.setState({ flightData: flightData })
          }} value={moment(date)} format='HH:mm' />
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }

  handleNoRideEvent = (action, details) => {
    let flightData = this.state.flightData
    let index = flightData.findIndex((item) => item.id == details.flight_id)
    let norideData = []
    if (index > -1) {
      if (action === 'INSERT') {
        if (!Array.isArray(flightData[index].norides)) {
          flightData[index].norides = []
        }
        flightData[index].norides.push(details.data)
        norideData = flightData[index].norides
      } else if (action === 'UPDATE') {
        let norideIndex = flightData[index].norides.findIndex((item) => item.id === details.data.id)
        if (norideIndex > -1) {
          flightData[index].norides[norideIndex] = details.data
          norideData = flightData[index].norides
        }
      } else if (action === 'DELETE') {
        let norideIndex = flightData[index].norides.findIndex((item) => parseInt(item.id) === parseInt(details.noride_id))
        if (norideIndex > -1) {
          flightData[index].norides.splice(norideIndex, 1)
          norideData = flightData[index].norides
        }
      }
      this.setState({ flightData: flightData }, () => {
        if (parseInt(details?.flight_id) === parseInt(this.state.noride_flight)) {
          this.setState({ norideData: [] }, () => this.setState({ norideData: norideData }))
        }
      })
    }
  }

  fetchNoride = async () => {
    if (this.state.noride_flight) {
      await Http.get(`/norides/${this.state.noride_flight}`)
        .then((resp) => {
          if (resp?.data?.data) {
            this.setState({
              norideData: resp?.data?.data,
              openNoRideModal: true,
              noride_ldd: this.state.quizModalFlight?.noride?.ldd_name || null,
              noride_ala: this.state.quizModalFlight?.noride?.ala_name || null,
              questionsData: [],
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: resp?.data?.message,
            })
          }
        })
    }
  }
  addNoRide = async () => {
    if (this.state.noride_container_id && this.state.noride_type && this.state.noride_rmvbfpe && this.state.noride_cutcode && this.state.noride_cutreason && this.state.noride_cutby /*&& this.state.noride_comment*/) {
      let headers = {
        station: this.state.station,
        user_id: this.state.user_id,
      }
      let formdata = new FormData()
      formdata.append('container_id', this.state.noride_container_id || '')
      formdata.append('type', this.state.noride_type || '')
      formdata.append('rmvbfpe', this.state.noride_rmvbfpe || '')
      formdata.append('cut_code', this.state.noride_cutcode || '')
      formdata.append('cut_reason', this.state.noride_cutreason || '')
      formdata.append('cut_by', this.state.noride_cutby || '')
      formdata.append('comments', this.state.noride_comment || '')
      formdata.append('attach_conf', this.state.noride_attach_conf || '')
      formdata.append('flight_id', this.state.noride_flight || '')
      formdata.append('trigger', 'user')
      await Http.post('/noride', formdata, { headers })
        .then((resp) => {
          if (resp?.data?.data) {
            this.setState({
              // openNoRideModal: false,
              // quizModalFlight: null,
              // noride_flight: null,
              noride_container_id: null,
              noride_type: null,
              noride_rmvbfpe: null,
              noride_cutcode: null,
              noride_cutreason: null,
              cut_reasons: [],
              noride_cutby: null,
              noride_comment: null,
              noride_attach_conf: false,
              noride_fileList: [],
            })
            notification.destroy()
            notification.success({
              message: 'Success',
              description: resp?.data?.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: resp?.data?.message,
            })
          }
        })
    } else {
      notification.destroy()
      notification.error({
        message: 'Warning',
        description: 'Please fill all the fields!',
      })
    }
  }
  editNoRide = async (record) => {
    let norideData = this.state.norideData
    let index = norideData.findIndex((item) => item.id === record.id)
    if (index > -1) {
      // norideData[index].edit = true
      this.setState({
        // norideData: norideData,
        edit_noride_id: norideData[index].id,
        edit_noride_container_id: record.container_id,
        edit_noride_type: record.type,
        edit_noride_rmvbfpe: record.noride_rmvbfpe,
        edit_noride_cutcode: record.cut_code,
        edit_noride_cutreason: record.cut_reason,
        edit_cut_reasons: cut_codes.find((item) => item?.code === record.cut_code)?.reasons,
        edit_noride_cutby: record.cut_by,
        edit_noride_comment: record.comments,
        edit_noride_flight: record.flight_id,
        edit_noride_attach_conf: record.attach_conf ? JSON.stringify(record?.attach_conf) : [],
        edit_noride_fileList: record.attach_conf?.name ? [{ name: record.attach_conf?.name }] : []
      })
    }
  }
  clearNoRide = () => {
    this.setState({ edit_noride_id: null, })
  }

  saveNoRide = async (record) => {
    let headers = {
      station: this.state.station,
      user_id: this.state.user_id,
    }

    let formdata = new FormData()
    formdata.append('container_id', this.state.edit_noride_container_id || '')
    formdata.append('type', this.state.edit_noride_type || '')
    formdata.append('rmvbfpe', this.state.edit_noride_rmvbfpe || '')
    formdata.append('cut_code', this.state.edit_noride_cutcode || '')
    formdata.append('cut_reason', this.state.edit_noride_cutreason || '')
    formdata.append('cut_by', this.state.edit_noride_cutby || '')
    formdata.append('comments', this.state.edit_noride_comment || '')
    formdata.append('attach_conf', this.state.edit_noride_attach_conf || '')
    formdata.append('flight_id', this.state.edit_noride_flight || '')
    formdata.append('trigger', 'user')
    await Http.put(`/noride/${record.id}`, formdata, { headers })
      .then((resp) => {
        if (resp?.data?.data) {
          this.setState({
            edit_noride_id: null,
            edit_noride_container_id: null,
            edit_noride_type: null,
            edit_noride_rmvbfpe: null,
            edit_noride_cutcode: null,
            edit_noride_cutreason: null,
            edit_cut_reasons: [],
            edit_noride_cutby: null,
            edit_noride_comment: null,
            edit_noride_flight: null,
          })
          notification.destroy()
          notification.success({
            message: 'Success',
            description: resp?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: resp?.data?.message,
          })
        }
      })

  }
  deleteNoRide = async (record) => {
    let headers = {
      station: this.state.station,
      user_id: this.state.user_id,
    }
    await Http.delete(`/noride/${record.id}`, { headers })
      .then((resp) => {
        if (resp?.data?.data) {
          notification.destroy()
          notification.success({
            message: 'Success',
            description: resp.data?.message,
          })
        }
        else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: resp?.data?.message,
          })
        }
      })

  }
  setNoRide = async () => {
    let headers = {
      station: this.state.station,
      user_id: this.state.user_id,
    }
    let formdata = {
      ldd_name: this.state.noride_ldd,
      ala_name: this.state.noride_ala,
      noRideQts: this.state.noRideQts,
      completedBy: this.state.completedBy || '',
      completedById: this.state.completedById || '',
    }
    await Http.put(`/flight_noride_update/${parseInt(this.state.quizModalFlight.id)}`, formdata, { headers })
      .then((data) => {
        if (data?.data?.data) {
          this.setState({
            openNoRideModal: false,
            quizModalFlight: null,
            noride_flight: null,
            noride_ldd: null,
            noride_ala: null,
            norideData: [],
            noRideQts: [],
            completedBy: null,
            completedById: null,
          }, () => this.closeNoride())
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      })
  }
  saveAudit = async () => {
    // set spinner to true
    this.setState({ loading: true })
    let { bin_config, audit_built_right, audit_reason, audit_explain, audit_was_optimal, audit_was_optimal_explain, audit_meet_wgt_goal, audit_meet_wgt_goal_explain } = this.state
    if ((bin_config && audit_built_right === 'Yes' && audit_was_optimal && audit_meet_wgt_goal) || (bin_config && audit_built_right === 'No' && audit_reason && audit_was_optimal && audit_meet_wgt_goal)) {
      let headers = {
        station: this.state.station,
        user_id: this.state.user_id,
      }
      let formdata = new FormData()
      formdata.append('bin_config', bin_config || '')
      formdata.append('audit_built_right', audit_built_right || '')
      formdata.append('audit_reason', audit_reason || '')
      formdata.append('audit_explain', audit_explain || '')
      formdata.append('audit_was_optimal', audit_was_optimal || '')
      formdata.append('audit_was_optimal_explain', audit_was_optimal === 'No' ? audit_was_optimal_explain || '' : '')
      formdata.append('audit_meet_wgt_goal', audit_meet_wgt_goal || '')
      formdata.append('audit_meet_wgt_goal_explain', audit_meet_wgt_goal === 'No' ? audit_meet_wgt_goal_explain || '' : '')
      if (Array.isArray(this.state.audit_meet_wgt_goal_conf_fileList) && this.state.audit_meet_wgt_goal_conf_fileList.length > 0) {
        const existingFiles = []
        this.state.audit_meet_wgt_goal_conf_fileList.forEach(file => {
          if (file.originFileObj) {
            formdata.append('audit_meet_wgt_goal_conf', file.originFileObj)
          } else if (file.name && (file.url || file.path || file.key)) {
            existingFiles.push({
              name: file.name,
              key: file.key,
              path: file.url || file.path,
            })
          }
        })
        // Always send metadata for existing files, even if new files are added
        if (existingFiles.length > 0) {
          formdata.append('audit_meet_wgt_goal_conf_metadata', JSON.stringify(existingFiles))
        }
      } else if (this.state.audit_meet_wgt_goal_conf) {
        // fallback for single file
        formdata.append('audit_meet_wgt_goal_conf', this.state.audit_meet_wgt_goal_conf)
      }
      formdata.append('load_trac_conf', this.state.load_trac_conf || '')
      formdata.append('build_plan_conf', this.state.build_plan_conf || '')
      formdata.append('wandb_conf', this.state.wandb_conf || '')
      formdata.append('wandb_conf2', this.state.wandb_conf2 || '')
      formdata.append('onesource_conf', this.state.onesource_conf || '')
      formdata.append('flight_id', this.state.noride_flight || '')
      formdata.append('trigger', 'user')
      formdata.append('completedBy', this.state.completedBy || '')
      formdata.append('completedById', this.state.completedById || '')
      await Http.put(`/flight_audit_update/${this.state.noride_flight}`, formdata, { headers })
        .then((resp) => {
          this.setState({ loading: false })
          if (resp?.data?.data) {
            this.setState({
              // openNoRideModal: false,
              // quizModalFlight: null,
              // noride_flight: null,
              bin_config: null,
              audit_built_right: null,
              audit_reason: null,
              audit_explain: null,
              attach_conf: false,
              fileList: [],
              openNoRideModal: false,
            }, () => this.closeNoride())
            notification.destroy()
            notification.success({
              message: 'Success',
              description: resp?.data?.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: resp?.data?.message,
            })
          }
        })
    } else {
      this.setState({ loading: false })
      notification.destroy()
      notification.error({
        message: 'Warning',
        description: 'Please fill all the fields!',
      })
    }
  }

  attachAudit = async (file, filename, fieldName) => {
    if (!file) return
    const headers = {
      station: this.state.station,
      user_id: this.state.user_id,
    }
    const formdata = new FormData()
    if (fieldName === 'wandb_conf') {
      formdata.append('wandb_conf', file, filename) //Weight & Balance Initial
    } else if (fieldName === 'load_trac_conf') {
      formdata.append('load_trac_conf', file, filename) //Proposed Build Plan
    } else if (fieldName === 'build_plan_conf') {
      formdata.append('build_plan_conf', file, filename) //Final Build Plan
    } else if (fieldName === 'wandb_conf2') {
      formdata.append('wandb_conf2', file, filename) //Weight & Balance Final
    }
    await Http.put(`/attach_audit_file/${this.state.editRecordId}`, formdata, { headers })
      .then((resp) => {
        if (resp?.data?.data) {
          notification.success({
            message: 'Success',
            description: 'Audit files uploaded successfully!',
          })
        } else {
          notification.error({
            message: 'Failed',
            description: resp?.data?.message || 'Upload failed',
          })
        }
      })
      .catch(() => {
        notification.error({
          message: 'Failed',
          description: 'Upload failed',
        })
      })
  }

  handleAuditScreenshotUpload = (blob, filename, fieldName) => {
    if (!blob) return
    const file = new File([blob], filename, { type: 'image/png' })
    this.attachAudit(file, filename, fieldName)
  }

  saveLDD = async () => {
    let { pallets_paired, pallets_paired_contact, pallets_paired_explain, conveyances_staged, conveyances_staged_contact, conveyances_staged_explain } = this.state
    if (pallets_paired === null || conveyances_staged === null) {
      // do nothing
    }
    else if (pallets_paired === 'No' && (pallets_paired_contact === null || (pallets_paired_contact === 'No' && (!pallets_paired_explain || pallets_paired_explain.trim() === '')))) {
      // do nothing
    } else if (conveyances_staged === 'Yes' && (conveyances_staged_contact === null || (conveyances_staged_contact === 'No' && (!conveyances_staged_explain || conveyances_staged_explain.trim() === '')))) {
      // do nothing
    } else {
      let headers = {
        station: this.state.station,
        user_id: this.state.user_id,
      }
      let formdata = {
        pallets_paired: pallets_paired,
        pallets_paired_contact: pallets_paired_contact,
        pallets_paired_explain: pallets_paired_explain,
        conveyances_staged: conveyances_staged,
        conveyances_staged_contact: conveyances_staged_contact,
        conveyances_staged_explain: conveyances_staged_explain,
      }
      await Http.put(`/flight_ldd_update/${parseInt(this.state.quizModalFlight.id)}`, formdata, { headers })
        .then((data) => {
          if (data?.data?.data) {
            this.setState({
              openLDDModal: false,
              pallets_paired: null,
              pallets_paired_contact: null,
              pallets_paired_explain: null,
              conveyances_staged: null,
              conveyances_staged_contact: null,
              conveyances_staged_explain: null,
            })
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data?.data?.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data?.data?.message,
            })
          }
        })
    }
  }

  closeNoride = () => {
    this.setState({
      openNoRideModal: false,
      noRideModalType: null,
      noRideTitle: null,
      norideData: [],
      noride_container_id: null,
      noride_type: null,
      noride_rmvbfpe: null,
      noride_cutcode: null,
      noride_cutreason: null,
      noride_cutby: null,
      cut_reasons: [],
      noride_comment: null,
      noride_flight: null,
      noride_ldd: null,
      noride_ala: null,

      edit_noride_id: null,
      edit_noride_container_id: null,
      edit_noride_type: null,
      edit_noride_rmvbfpe: null,
      edit_noride_cutcode: null,
      edit_noride_cutreason: null,
      edit_cut_reasons: [],
      edit_noride_cutby: null,
      edit_noride_comment: null,
      edit_noride_flight: null,
    })
  }

  onChangeFileHandler = (e, t) => {
    if (e?.fileList[0]) {
      if (t == 'noride') {
        this.setState({
          noride_attach_conf: e?.fileList[0].originFileObj,
          noride_fileList: e?.fileList,
        })
      } else {
        if (e?.fileList[0].lastModifiedDate) {
          this.setState({ [t + '_previewImg']: false, })
        }
        this.setState({
          [t]: e?.fileList[0].originFileObj,
          [t + '_fileList']: e?.fileList,
        })
      }
    } else {
      if (t == 'noride') {
        this.setState({
          noride_attach_conf: false,
          noride_fileList: [],
        })
      } else {
        this.setState({
          attach_conf: null,
          fileList: []
        })
      }
    }
  }

  onRemoveFileHandler = (t) => {
    if (t == 'noride') {
      this.setState({
        noride_attach_conf: false,
        noride_fileList: [],
      })
    } else {
      this.setState({
        attach_conf: false,
        fileList: [],
        previewImg: false,
      })
    }
  }
  onRemoveEditFileHandler = (t) => {
    if (t == 'noride') {
      this.setState({
        edit_noride_attach_conf: false,
        edit_noride_fileList: [],
      })
    }
  }

  onChangeEditFileHandler = (e) => {
    if (e?.fileList[0]) {
      this.setState({
        edit_noride_attach_conf: e?.fileList[0].originFileObj,
        edit_noride_fileList: e?.fileList
      })
    } else {
      this.setState({
        edit_noride_attach_conf: false,
        edit_noride_fileList: [],
      })
    }
  }

  handleAssignUldChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    let other_data = {}
    let flightDetails = this.state.flightDetails
    // if (name == 'id') {
    //   const findData = this.state.assignedUldsData.find((item) => item.id == value)
    //   if (findData) {
    //     other_data = {
    //       ...findData,
    //       pcs: findData.pcs,
    //       wgt: findData.wgt,
    //       vol: findData.vol,
    //       ch_wgt: findData.ch_wgt,
    //     }
    //   } else {
    //     other_data = {
    //       pcs: '',
    //       wgt: '',
    //       vol: '',
    //       ch_wgt: '',
    //     }
    //   }
    // } else {
    other_data = { ...this.state.assignUld }
    // }
    if (name == 'pcs') {
      let actual_wgt = this.state.editWgtUnit === 'LB' ? ['K', 'KG', 'KGM', 'KGS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('LB', flightDetails?.wgt?.value) : flightDetails?.wgt?.value : ['L', 'LB', 'LBR', 'LBS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('KG', flightDetails?.wgt?.value) : flightDetails?.wgt?.value
      actual_wgt = (actual_wgt / flightDetails?.pcs) * value
      other_data.wgt = actual_wgt
      let actual_vol = (this.state.editWgtUnit === 'KG' ? (['CBF', 'CFT'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBM', flightDetails?.vol?.value) : flightDetails?.vol?.value) : (['CBM'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBF', flightDetails?.vol?.value) : flightDetails?.vol?.value))
      actual_vol = (actual_vol / flightDetails?.pcs) * value
      other_data.vol = actual_vol
      let actual_ch_wgt = this.state.editWgtUnit === 'LB' ? ['K', 'KG', 'KGM', 'KGS'].includes(flightDetails?.ch_wgt?.unit) ? this.updateWeightVal('LB', flightDetails?.ch_wgt?.value) : flightDetails?.ch_wgt?.value : ['L', 'LB', 'LBR', 'LBS'].includes(flightDetails?.ch_wgt?.unit) ? this.updateWeightVal('KG', flightDetails?.ch_wgt?.value) : flightDetails?.ch_wgt?.value
      actual_ch_wgt = (actual_ch_wgt / flightDetails?.pcs) * value
      other_data.ch_wgt = actual_ch_wgt
    }
    this.setState(() => ({
      assignUld: {
        ...other_data,
        [name]: value
      }
    }))
  }


  submitAssignUld = () => {
    let error = {}
    if (!this.state.assignUld?.pcs) {
      error.e_pcs = 'Please enter pcs'
    }
    if (!this.state.assignUld?.wgt) {
      error.e_wgt = 'Please enter wgt'
    }
    if (!this.state.assignUld?.vol) {
      error.e_vol = 'Please enter vol'
    }
    if (Object.keys(error).length > 0) {
      this.setState({
        assignUld: {
          ...this.state.assignUld,
          ...error
        },
      })
      return
    }
    let awb = this.state.mergeEditRecord?.find((item) => item?.awb_no === this.state.flightDetails?.awb_no)
    let uld = this.state.editRecord?.build_uld?.find((item) => item?.id === this.state.assignUld?.id)
    if (uld && awb) {
      let formData = {
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        pcs: this.state.assignUld?.pcs,
        remark: awb?.priority,
        uld_no: uld?.uld_no,
        uld_type: uld?.type,
        wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(this.state.assignUld?.wgt || 0, 'KGM') : this.state.assignUld?.wgt,
        vol: this.state?.editWgtUnit === 'KG' ? this.state.assignUld?.vol : volumnCalculator(this.state.assignUld?.vol || 0, 'CBF'),
        id: uld?.id,
        ch_wgt: this.state.editWgtUnit === 'KG' ? weightCalculator(this.state.assignUld?.ch_wgt || 0, 'KGM') : this.state.assignUld?.ch_wgt,
      }
      Http.post(`/build_plan_uld/${this.state.editRecordId}`, formData)
        .then((data) => {
          if (data && data?.status === 200) {
            this.setState({
              assignUld: {
                ...this.state.assignUld,
                pcs: '',
                wgt: '',
                vol: '',
                e_pcs: '',
                e_wgt: '',
                e_vol: '',
              }
            })
            // Reset form fields
            this.assignUldFormRef.current?.resetFields(['pcs', 'wgt', 'vol'])
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data?.data?.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data?.data?.message,
            })
          }
        }).catch(() => {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: constants.SERVER_CONNECTION_ERROR,
          })
        })
    } else if (this.state.assignUld?.id == 0 && awb) {
      // let ch_wgt_lb = weightCalculator(awb?.ch_wgt || 0, 'KGM')
      let formData = {
        add: true,
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        blk: this.state.assignUld?.pcs,
        blk_wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(this.state.assignUld?.wgt || 0, 'KGM') : this.state.assignUld?.wgt,
        blk_vol: this.state?.editWgtUnit === 'KG' ? this.state.assignUld?.vol : volumnCalculator(this.state.assignUld?.vol || 0, 'CBF'),
        // ch_wgt: awb?.ch_wgt ? ch_wgt_lb * this.state.assignUld.pcs : 0,
        only_blk: true,
      }
      Http.put(`/build_plan_awb/${this.state.editRecordId}`, formData).then((data) => {
        if (data && data?.status === 200) {
          this.setState({
            assignUld: {
              ...this.state.assignUld,
              pcs: '',
              wgt: '',
              vol: '',
              e_pcs: '',
              e_wgt: '',
              e_vol: '',
            }
          })
          // Reset form fields
          this.assignUldFormRef.current?.resetFields(['pcs', 'wgt', 'vol'])
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
    }
    else {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: 'Please select correct ULD',
      })
    }
  }

  updateUlds = async () => {
    let awb = this.state.mergeEditRecord?.find((item) => item?.awb_no === this.state.flightDetails?.awb_no)
    let uld = this.state.editRecord?.build_uld?.find((item) => item?.id === this.state.assignUld?.id)
    if (uld && awb) {
      let formData = {
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        pcs: this.state.editUlds?.pcs,
        remark: awb?.priority,
        uld_no: uld?.uld_no,
        uld_type: uld?.type,
        wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(this.state.editUlds?.wgt || 0, 'KGM') : this.state.editUlds?.wgt,
        vol: this.state?.editWgtUnit === 'KG' ? this.state.editUlds?.vol : volumnCalculator(this.state.editUlds?.vol || 0, 'CBF'),
        id: uld?.id,
        ch_wgt: this.state.editWgtUnit === 'KG' ? weightCalculator(this.state.editUlds?.ch_wgt || 0, 'KGM') : this.state.editUlds?.ch_wgt,
        uld_id: this.state.editUlds?.uld_id,
      }
      await Http.put(`/build_plan_uld/${this.state.editRecordId}`, formData)
        .then(async (data) => {
          if (data && data?.status === 200) {
            this.setState({ editUlds: {}, })
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data?.data?.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data?.data?.message,
            })
          }
          this.setState({ loading: false })
        }).catch(() => {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: constants.SERVER_CONNECTION_ERROR,
          })
          this.setState({ servererror: true })
        })
    } else if (this.state.assignUld?.id == 0 && awb) {
      // let ch_wgt_lb = weightCalculator(awb?.ch_wgt || 0, 'KGM')
      let formData = {
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        blk: this.state.editUlds?.pcs,
        blk_wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(this.state.editUlds?.wgt || 0, 'KGM') : this.state.editUlds?.wgt,
        blk_vol: this.state?.editWgtUnit === 'KG' ? this.state.editUlds?.vol : volumnCalculator(this.state.editUlds?.vol || 0, 'CBF'),
        // ch_wgt: awb?.ch_wgt ? ch_wgt_lb * this.state.editUlds.pcs : 0,
        only_blk: true,
      }
      Http.put(`/build_plan_awb/${this.state.editRecordId}`, formData).then((data) => {
        if (data && data?.status === 200) {
          this.setState({ editUlds: {} })
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
    } else {
      notification.destroy()
      notification.error({
        message: 'Failed',
        description: 'Please select correct ULD',
      })
    }
  }

  fetchUlds = () => {
    let awbs = this.state.editRecord?.build_plan?.filter((item) => item?.awb_no === this.state.flightDetails?.awb_no)
    if (awbs?.length > 0) {
      this.setState({ assignedUldsData: awbs[0]?.ulds || [] })
    }
    else {
      this.setState({ assignedUldsData: [] })
    }
  }

  handleEditUldChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    let other_data = {}
    let flightDetails = this.state.flightDetails
    if (name == 'pcs') {
      let actual_wgt = this.state.editWgtUnit === 'LB' ? ['K', 'KG', 'KGM', 'KGS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('LB', flightDetails?.wgt?.value) : flightDetails?.wgt?.value : ['L', 'LB', 'LBR', 'LBS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('KG', flightDetails?.wgt?.value) : flightDetails?.wgt?.value
      actual_wgt = (actual_wgt / flightDetails?.pcs) * value
      other_data.wgt = actual_wgt
      let actual_vol = (this.state.editWgtUnit === 'KG' ? (['CBF', 'CFT'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBM', flightDetails?.vol?.value) : flightDetails?.vol?.value) : (['CBM'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBF', flightDetails?.vol?.value) : flightDetails?.vol?.value))
      actual_vol = (actual_vol / flightDetails?.pcs) * value
      other_data.vol = actual_vol
      let actual_ch_wgt = this.state.editWgtUnit === 'LB' ? ['K', 'KG', 'KGM', 'KGS'].includes(flightDetails?.ch_wgt?.unit) ? this.updateWeightVal('LB', flightDetails?.ch_wgt?.value) : flightDetails?.ch_wgt?.value : ['L', 'LB', 'LBR', 'LBS'].includes(flightDetails?.ch_wgt?.unit) ? this.updateWeightVal('KG', flightDetails?.ch_wgt?.value) : flightDetails?.ch_wgt?.value
      actual_ch_wgt = (actual_ch_wgt / flightDetails?.pcs) * value
      other_data.ch_wgt = actual_ch_wgt

    }
    this.setState(prevState => ({
      editUlds: {
        ...prevState.editUlds,
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        [name]: value,
        ...other_data
      }
    }))
  }


  editUlds = (record) => {
    this.setState({
      editUlds: {
        ...record,
        wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(record?.wgt || 0, 'LBS') : record?.wgt,
        vol: this.state?.editWgtUnit === 'KG' ? record?.vol : volumnCalculator(record?.vol || 0, 'CBM'),
        ch_wgt: this.state?.editWgtUnit === 'KG' ? weightCalculator(record?.ch_wgt || 0, 'LBS') : record?.ch_wgt,
      }
    })
  }

  deleteUlds = (record) => {
    let formdata = {
      awb_no: this.state.flightDetails?.awb_no,
      uld_id: record.uld_id,
      stn: cookies.get('station'),
    }
    if (record.id == 0) {
      let formData = {
        stn: cookies.get('station'),
        awb_no: this.state.flightDetails.awb_no,
        blk: 0,
        blk_wgt: 0,
        blk_vol: 0,
        only_blk: true,
      }
      Http.put(`/build_plan_awb/${this.state.editRecordId}`, formData).then((data) => {
        if (data && data?.status === 200) {
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
      })
    } else {
      Http.put(`/build_plan_uld_remove/${this.state.editRecordId}`, formdata)
        .then((data) => {
          if (data && data.status === 200) {
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data.data.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data.data.message,
            })
          }
        })
    }
  }


  editAwbs = (record) => {
    let bpIndex = this.state.editRecord.build_plan.findIndex((item) => item.awb_no === record.awb_no)
    let editAwbs = {
      pcs: record.pcs,
      location: record.location,
      dest: record.dest,
      prod_code: record.prod_code,
      spl_code: record.spl_code,
      delay: record.delay,
      pre_build: record.pre_build,
      on_hand: record.on_hand,
      pri: record.pri,
    }

    let wgt = this.state.editWgtUnit === 'LB' ?
      (['L', 'LB', 'LBR', 'LBS'].includes(record?.wgt?.unit) ?
        (record?.wgt?.value || 0)
        :
        this.updateWeightVal('LB', record?.wgt?.value || 0)
      ) :
      (['K', 'KG', 'KGM', 'KGS'].includes(record?.wgt?.unit) ?
        (record?.wgt?.value || 0)
        :
        this.updateWeightVal('KG', record?.wgt?.value || 0)
      )
    let vol = this.state.editWgtUnit === 'LB' ?
      (['CBF', 'CFT'].includes(record?.vol?.unit) ?
        (record?.vol?.value || 0)
        :
        this.updateVolumeVal('CBF', record?.vol?.value || 0)
      ) :
      (['CBM'].includes(record?.vol?.unit) ?
        (record?.vol?.value || 0)
        :
        this.updateVolumeVal('CBM', record?.vol?.value || 0)
      )
    let ch_wgt = this.state.editWgtUnit === 'LB' ?
      (['L', 'LB', 'LBR', 'LBS'].includes(record?.ch_wgt?.unit) ?
        (record?.ch_wgt?.value || 0)
        :
        this.updateWeightVal('LB', record?.ch_wgt?.value || 0)
      ) :
      (['K', 'KG', 'KGM', 'KGS'].includes(record?.ch_wgt?.unit) ?
        (record?.ch_wgt?.value || 0)
        :
        this.updateWeightVal('KG', record?.ch_wgt?.value || 0)
      )
    editAwbs.wgt = wgt
    editAwbs.vol = vol
    editAwbs.ch_wgt = ch_wgt

    if (bpIndex !== -1) {

      if (this.state.editRecord?.build_plan[bpIndex]?.data) {
        if (record.manual) {
          editAwbs = {
            ...editAwbs,
            ...this.state.editRecord?.build_plan[bpIndex]?.data
          }
        }
        editAwbs = {
          ...editAwbs,
          blk: this.state.editRecord?.build_plan[bpIndex]?.data?.blk || record?.blk || 0,
          blk_wgt: this.state.editRecord?.build_plan[bpIndex]?.data?.blk_wgt || record?.blk_wgt || 0,
          blk_vol: this.state.editRecord?.build_plan[bpIndex]?.data?.blk_vol || record?.blk_vol || 0,
        }
      }
      if (record?.manual) {
        // 'L' || item.wgt.unit === 'LB' || item.wgt.unit === 'LBR' || item.wgt.unit === 'LBS'
        editAwbs = {
          ...this.state.editRecord?.build_plan[bpIndex]?.data,
          ...editAwbs,
          awb_no: record.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2'),
          manual: record.manual,
          id: this.state.editRecord?.build_plan[bpIndex]?.id,
        }
      }
    }
    this.setState({
      editAwbs,
      editAwbsRecord: record,
      bpIndex: bpIndex,
    })
  }

  handleEditAwb = (e, nameOverride) => {
    let name, value
    if (e && e.target) {
      name = e.target.name
      value = e.target.value
    } else if (typeof nameOverride === 'string') {
      name = nameOverride
      value = e
    } else {
      // fallback: do nothing or handle error
      return
    }
    let other_data = {}
    if (name == 'blk') {
      let actual_wgt = ['K', 'KG', 'KGM', 'KGS'].includes(this.state.editAwbsRecord?.wgt.unit) ? this.updateWeightVal('LB', this.state.editAwbsRecord?.wgt.value || 0) : this.state.editAwbsRecord?.wgt.value || 0
      actual_wgt = (actual_wgt / this.state.editAwbsRecord?.pcs) * value
      other_data.blk_wgt = actual_wgt
      let actual_vol = (['CBF', 'CFT'].includes(this.state.editAwbsRecord?.vol.unit) ? this.updateVolumeVal('CBM', this.state.editAwbsRecord?.vol.value || 0) : this.state.editAwbsRecord?.vol.value || 0)
      actual_vol = (actual_vol / this.state.editAwbsRecord?.pcs) * value
      other_data.blk_vol = actual_vol
    }
    if (this.state.editAwbsRecord?.manual) {
      const calculateChargeableWeight = ({ grossWeight, volume, volumeUnit }) => {
        let dimensionalWeight = 0

        if (volumeUnit === 'CFT') {
          dimensionalWeight = volume * 10.4048682
        } else if (volumeUnit === 'CBM') {
          dimensionalWeight = volume * 166.67
        }

        return Math.max(grossWeight, dimensionalWeight)?.toFixed(2)
      }
      if (name == 'wgt' && value > 0 && this.state.editAwbs.vol && this.state.editAwbs.vol > 0) {
        other_data.ch_wgt = calculateChargeableWeight({
          grossWeight: value,
          volume: this.state.editAwbs.vol,
          volumeUnit: this.state.editWgtUnit === 'KG' ? 'CBM' : 'CFT'
        })
      }
      if (name == 'vol' && value > 0 && this.state.editAwbs.wgt && this.state.editAwbs.wgt > 0) {
        other_data.ch_wgt = calculateChargeableWeight({
          grossWeight: this.state.editAwbs.wgt,
          volume: value,
          volumeUnit: this.state.editWgtUnit === 'KG' ? 'CBM' : 'CFT'
        })
      }
    }
    this.setState(prevState => ({
      editAwbs: {
        ...prevState.editAwbs,
        stn: cookies.get('station'),
        ...other_data,
        [name]: value
      }
    }), async () => {
      if (name === 'awb_no' && this.state.editAwbsRecord?.manual && RegExp(/(\d{3})-?(\d{8})/).test(value)) {
        await Http.get(`/awb_info/${value.replace(/(\d{3})-?(\d{8})/, '$1$2')}`).then((data) => {
          if (data && data?.status === 200) {
            let awbData = data?.data?.data
            let pcs = awbData?.pcs?.total?.value || 0
            let wgt_unit = awbData?.weight_unit
            let wgt = 0
            if (this.state.editWgtUnit === 'KG') {
              wgt = ['K', 'KG', 'KGM', 'KGS'].includes(wgt_unit) ? awbData?.wgt?.total?.value || 0 : this.updateWeightVal('KG', awbData?.wgt?.total?.value || 0)
            } else {
              wgt = ['L', 'LB', 'LBR', 'LBS'].includes(wgt_unit) ? awbData?.wgt?.total?.value || 0 : this.updateWeightVal('LB', awbData?.wgt?.total?.value || 0)
            }
            let vol = 0
            if (this.state.editWgtUnit === 'KG') {
              vol = ['CBF', 'CFT'].includes(awbData?.vol_unit) ? this.updateVolumeVal('CBM', awbData?.vol?.total?.value || 0) : awbData?.vol?.total?.value || 0
            } else {
              vol = ['CBM'].includes(awbData?.vol_unit) ? this.updateVolumeVal('CBF', awbData?.vol?.total?.value || 0) : awbData?.vol?.total?.value || 0
            }
            let ch_wgt = 0
            if (this.state.editWgtUnit === 'KG') {
              ch_wgt = ['K', 'KG', 'KGM', 'KGS'].includes(wgt_unit) ? awbData?.ch_pcs || 0 : this.updateWeightVal('KG', awbData?.ch_pcs || 0)
            } else {
              ch_wgt = ['L', 'LB', 'LBR', 'LBS'].includes(wgt_unit) ? awbData?.ch_pcs || 0 : this.updateWeightVal('LB', awbData?.ch_pcs || 0)
            }

            ch_wgt = ch_wgt * pcs

            this.setState(prevState => ({
              editAwbs: {
                ...prevState.editAwbs,
                pcs: pcs,
                wgt: wgt,
                vol: vol,
                pri: awbData?.prod_code ? this.state.priorityData?.find((item) => item.p_code === awbData?.prod_code)?.priority || null : null,
                sort_priority: awbData?.prod_code ? this.state.priorityData?.find((item) => item.p_code === awbData?.prod_code)?.sort_priority || null : null,
                ch_wgt: ch_wgt,
                dest: awbData?.dest,
                prod_code: awbData?.prod_code,
                spl_code: awbData?.spl_code,
                delay: awbData?.time_of_avl ? moment(moment().tz(new Cookies().get('timezone')).format('YYYY-MM-DD')).diff(moment(awbData?.time_of_avl), 'days') * -1 : 0,
              }
            }))
          }
        })
      }
    })
  }

  mismatchPcs = (pcs, row) => {
    let bpIndex = this.state.editRecord.build_plan.findIndex((item) => item.awb_no === row.awb_no)
    this.state.editRecord.build_plan && this.state.editRecord.build_plan.length > 0 && this.state.editRecord.build_plan[bpIndex] && this.state.editRecord.build_plan[bpIndex]?.ulds?.length > 0 ?
      this.state.editRecord.build_plan[bpIndex]?.ulds?.map((uld) => {
        return pcs - uld.pcs !== 0 ? 'bg-red' : null
      }) : (row.slu_uld && row.slu_uld.length > 0 ? row.slu_uld.map((uld) => {
        return pcs - uld.pcs !== 0 ? 'bg-red' : null
      }) : null)
  }

  updateAwbRecord = async () => {
    let formdata = {
      stn: cookies.get('station'),
      awb_no: this.state.editAwbsRecord?.manual ? this.state.editAwbs.awb_no : this.state.editAwbsRecord?.awb_no,
      ch_wgt: this.state.editAwbs?.ch_wgt,
      blk: this.state.editAwbs?.blk,
      blk_wgt: this.state.editAwbs?.blk_wgt,
      blk_vol: this.state.editAwbs?.blk_vol,
      pri: this.state.editAwbs?.pri,
    }
    formdata.manual = this.state.editAwbsRecord?.manual
    formdata.location = this.state.editAwbs?.location
    formdata.pcs = this.state.editAwbs?.pcs
    formdata.wgt = this.state.editAwbs?.wgt
    formdata.wgt_unit = this.state.editWgtUnit === 'LB' ? 'LB' : 'KG'
    formdata.vol = this.state.editAwbs?.vol
    formdata.vol_unit = this.state.editWgtUnit === 'LB' ? 'CBF' : 'CBM'
    formdata.dest = this.state.editAwbs.dest
    formdata.prod_code = this.state.editAwbs.prod_code
    formdata.delay = this.state.editAwbs.delay
    formdata.spl_code = this.state.editAwbs.spl_code
    formdata.pre_build = this.state.editAwbs.pre_build
    formdata.on_hand = this.state.editAwbs.on_hand
    formdata.id = this.state.editAwbs?.id
    formdata.stn = cookies.get('station')
    await Http.put(`/build_plan_awb/${this.state.editRecordId}`, formdata)
      .then(async (data) => {
        if (data && data?.status === 200) {
          this.setState({
            editAwbs: {},
            editAwbsRecord: {},
          })
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
        this.setState({ loading: false })
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
        this.setState({ servererror: true })
      })
  }

  blkAwbRecord = async (blk, record) => {
    let formdata = {
      stn: cookies.get('station'),
      awb_no: record?.awb_no,
      blk
    }
    await Http.put(`/build_plan_awb/${this.state.editRecordId}`, formdata)
      .then(async (data) => {
        if (data && data?.status != 200) {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
        this.setState({ loading: false })
      }).catch(() => {
        notification.destroy()
        notification.error({
          message: 'Failed',
          description: constants.SERVER_CONNECTION_ERROR,
        })
        this.setState({ servererror: true })
      })
  }

  deleteAwbRecord = (record) => {
    let formdata = {
      awb_no: record?.awb_no,
      stn: cookies.get('station'),
    }
    Http.put(`/build_plan_awb_remove/${this.state.editRecordId}`, formdata)
      .then((data) => {
        if (data && data.status === 200) {
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data.data.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data.data.message,
          })
        }
      })
  }

  sendFeedback = async () => {
    if (!this.state.fb_req_name?.trim() || !this.state.fb_req_email?.trim() || !this.state.fb_type || !this.state.fb_urgency || !this.state.fb_description?.trim() || !this.state.fb_rec_solution?.trim() || (this.state.fb_milestones && this.state.fb_milestones.length === 0) || (this.state.fb_tools_impacted && this.state.fb_tools_impacted.length === 0)) {
      notification.destroy()
      notification.error({
        message: 'Warning',
        description: 'Please fill all the fields!',
      })
    } else {
      let headers = {
        station: this.state.station,
        user_id: this.state.user_id,
      }

      const formData = new FormData()
      formData.append('fb_req_name', this.state.fb_req_name)
      formData.append('fb_req_email', this.state.fb_req_email)
      formData.append('fb_type', this.state.fb_type)
      formData.append('fb_urgency', this.state.fb_urgency)
      formData.append('fb_milestones', JSON.stringify(this.state.fb_milestones))
      formData.append('fb_tools_impacted', JSON.stringify(this.state.fb_tools_impacted))
      formData.append('fb_description', this.state.fb_description)
      formData.append('fb_rec_solution', this.state.fb_rec_solution)

      // Append file attachments
      if (this.state.fb_fileList && this.state.fb_fileList.length > 0) {
        this.state.fb_fileList.forEach((file) => {
          formData.append('attachments', file.originFileObj || file)
        })
      }

      Http.post('/send_feedback', formData, { headers })
        .then((data) => {
          if (data && data?.status === 200) {
            this.clearFeedbackForm()
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data?.data?.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data?.data?.message,
            })
          }
        }).catch((err) => {
          console.log('err', err)
        })
    }
  }

  clearFeedbackForm = () => {
    this.setState({
      fb_req_name: cookies.get('name'),
      fb_req_email: cookies.get('username').match(emailregex) ? cookies.get('username') : null,
      fb_type: null,
      fb_urgency: null,
      fb_milestones: [],
      fb_tools_impacted: [],
      fb_description: null,
      fb_rec_solution: null,
      fb_fileList: [],
      feedback: false,
    })
  }
  clearTableForm = (record) => {
    this.setState({
      editAwbs: {},
      editAwbsRecord: {},
      editUlds: {}
    })
    if (record.init && record.id == 0) {
      let mergeEditRecord = this.state.mergeEditRecord.filter(item => item.awb_no !== record.awb_no)
      this.setState({ mergeEditRecord })
    }
  }

  addFlight = async () => {
    let flight_no = this.state.flight_no
    if (!this.state.flight_no || !this.state.flight_date || !this.state.dept_time || !this.state.arr_time || !this.state.org_stn || !this.state.dest_stn || !this.state.aircrafttype) {
      notification.destroy()
      notification.warning({
        message: 'Warning',
        description: 'Please fill all the fields!',
      })
    } else if (flight_no.length <= 4 || flight_no.length >= 8 || !flightno_pattern.test(flight_no)) {
      notification.destroy()
      notification.warning({
        message: 'Warning',
        description: 'Please enter valid flight number!',
      })
    } else {
      let headers = {
        station: this.state.station,
        user_id: this.state.user_id,
      }
      let formdata = {
        flight_no: this.state.flight_no,
        flight_date: this.state.flight_date.format('YYYY-MM-DD'),
        dept_time: this.state.dept_time.format('YYYY-MM-DD HH:mm'),
        arr_time: this.state.arr_time.format('YYYY-MM-DD HH:mm'),
        org_stn: this.state.org_stn,
        dest_stn: this.state.dest_stn,
        aircrafttype: this.state.aircrafttype,
      }
      await Http.post('/create_flight', formdata, { headers })
        .then((data) => {
          if (data && data?.status === 200) {
            this.setState({
              flightModalType: 'ADD',
              showFlightModal: false,
              flight_no: null,
              flight_date: null,
              dept_time: moment().startOf('day'),
              arr_time: moment().startOf('day'),
              org_stn: cookies.get('station'),
              dest_stn: null,
              aircrafttype: null,
              ack1: false,
              ack2: false,
            })
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data?.data?.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data?.data?.message,
            })
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    }
  }

  putFlight = async () => {
    let flight_no = this.state.flight_no
    if (!this.state.flight_no || !this.state.flight_date || !this.state.dept_time || !this.state.arr_time || !this.state.org_stn || !this.state.dest_stn || !this.state.aircrafttype) {
      notification.destroy()
      notification.warning({
        message: 'Warning',
        description: 'Please fill all the fields!',
      })
    } else if (flight_no.length <= 4 || flight_no.length >= 8 || !flightno_pattern.test(flight_no)) {
      notification.destroy()
      notification.warning({
        message: 'Warning',
        description: 'Please enter valid flight number!',
      })
    } else {
      let headers = {
        station: this.state.station,
        user_id: this.state.user_id,
      }
      let formdata = {
        flight_no: this.state.flight_no,
        flight_date: this.state.flight_date.format('YYYY-MM-DD'),
        dept_time: this.state.dept_time.format('YYYY-MM-DD HH:mm'),
        arr_time: this.state.arr_time.format('YYYY-MM-DD HH:mm'),
        org_stn: this.state.org_stn,
        dest_stn: this.state.dest_stn,
        aircrafttype: this.state.aircrafttype,
      }
      await Http.put(`/update_flight/${this.state.edit_flight_id}`, formdata, { headers })
        .then((data) => {
          if (data && data?.status === 200) {
            this.setState({
              flightModalType: 'ADD',
              showFlightModal: false,
              flight_no: null,
              flight_date: null,
              dept_time: moment().startOf('day'),
              arr_time: moment().startOf('day'),
              org_stn: cookies.get('station'),
              dest_stn: null,
              aircrafttype: null,
              ack1: false,
              ack2: false,
            })
            notification.destroy()
            notification.success({
              message: 'Success',
              description: data?.data?.message,
            })
          } else {
            notification.destroy()
            notification.error({
              message: 'Failed',
              description: data?.data?.message,
            })
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    }
  }

  getFilteredFlights = () => {
    let milestoneData = this.state.milestoneData.filter((item) => item?.type !== 'No Rides')
    let flights = this.state.flightData
    if (this.state.hideCompleted) {
      flights = this.state.flightData.filter((item) =>
        !item.audit || !item.noride || milestoneData.filter(milestone => {
          return !item.answers.some(answer => answer.milestones_id === milestone.id)
        }).length > 0
      )
      flights = flights.filter((item) => item?.awb_segments?.length > 0 || item?.ulds_out?.length > 0)
    }
    // else {
    //   flights = this.state.flightData.filter((item) => item?.awb_segments?.length > 0 || item?.ulds_out?.length > 0)
    // }
    const country = ['USA', 'U.S. VIRGIN ISLANDS', 'PUERTO RICO']
    //if both filters are off Or if both filter are on, show all flights
    if ((!this.state.showInternational && !this.state.showDomestic) || (this.state.showInternational && this.state.showDomestic)) {
      // No filtering
    } else {
      // Filter International flights
      if (this.state.showInternational) {
        flights = flights.filter(flight => {
          let details = this.state.stationsData?.find(stn => stn?.code === flight?.dest?.arriv) || ''
          return details && !country.includes(details?.country?.toUpperCase())
        })
      }
      // Filter Domestic flights
      if (this.state.showDomestic) {
        flights = flights.filter(flight => {
          let details = this.state.stationsData?.find(stn => stn?.code === flight?.dest?.arriv) || ''
          return details && country.includes(details?.country?.toUpperCase())
        })
      }
    }
    if (this.state.showMyFlights) {
      flights = flights.filter(flight => parseInt(flight?.dod_agent_id) === parseInt(new Cookies().get('id')))
    }
    return flights
  }

  handleUploadOk = () => {
    this.setState({ isUploadModalOpen: true, })
  }

  handleUploadClose = () => {
    this.setState({
      isUploadModalOpen: false,
      previewImage: '',
      previewFileName: '',

    })
  }

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    } else {
      file.preview = file.url || file.thumbUrl
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewFileName: file.name,
      previewOpen: true,
    })
  }

  handleChange = (info) => {

    this.setState({
      audit_meet_wgt_goal_conf_fileList: info.fileList,
      audit_meet_wgt_goal_conf: info.fileList.map(file => {
        if (file.response) {
          return {
            name: file.name,
            key: file.response.key,
            path: file.response.path
          }
        }
        // For already uploaded files
        return {
          name: file.name,
          key: file.key || '',
          path: file.url || file.path || ''
        }
      })
    })
  }

  showPreview = (record) => {
    this.setState({
      isModalVisible: true,
      previewImgNoRide: record.attach_conf
    })
  }

  openPreview = (type) => {
    this.setState({
      flightAuditImg: true,
      previewType: type
    })
  }

  handleNoRideQtsChange = (e, type) => {
    let value = e
    this.setState(prevState => ({
      noRideQts: {
        ...prevState.noRideQts,
        [type]: value
      }
    }))
  }

  //dod_agents_list
  fetchDodAgents = async () => {
    let headers = {}
    await Http.get(`/dod_agents_list?station=${this.state.assessment_station}`, { headers })
      .then((data) => {
        if (data && data?.status === 200) {
          this.setState({ dodAgents: data?.data?.data || [], })

        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      })
  }

  fetchAssessmentFlights = async () => {
    //fetch flights by assessment date
    let headers = {
      station: this.state.station,
      user_id: this.state.user_id,
    }
    await Http.get(`/dod_assessment_flight_list?flight_dept_dt=${this.state.assessment_date.format('YYYY-MM-DD')}&station=${this.state.assessment_station}`, { headers })
      .then((data) => {
        if (data && data?.status === 200) {
          let dodAssignmentFlights = data?.data?.data || []
          //sort by dept_date
          dodAssignmentFlights.sort((a, b) => {
            return new Date(a.dept_date) - new Date(b.dept_date)
          })
          this.setState({ dodAssignmentFlights: dodAssignmentFlights, })

        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      })
  }

  assigndodAgents = async () => {
    //call POST method assign_multiple_dod_agents
    let headers = {
      station: this.state.station,
      user_id: this.state.user_id,
    }
    let formdata = {
      flights: this.state.dodAssignmentFlights.filter(flight => flight.dod_agent_changed).map(flight => ({
        flight_id: flight.id,
        dod_agent_id: flight.dod_agent_id,
      })),
    }
    await Http.post('/assign_multiple_dod_agents', formdata, { headers })
      .then((data) => {
        if (data && data?.status === 200) {
          this.setState({
            dodAssignmentFlights: this.state.dodAssignmentFlights.map(flight => ({
              ...flight,
              dod_agent_changed: false,
            })),
          })
          notification.destroy()
          notification.success({
            message: 'Success',
            description: data?.data?.message,
          })
        } else {
          notification.destroy()
          notification.error({
            message: 'Failed',
            description: data?.data?.message,
          })
        }
      })
  }

  render() {
    const dodAssessmentColumns = [
      {
        title: 'Flight #',
        dataIndex: 'flight_no',
        key: 'flight_no',
        render: (_, record) => (
          <span>{record?.flight_no}</span>
        )
      },
      {
        title: (<span className='test'>  Flight Date  </span>),
        dataIndex: 'date',
        key: 'date',
        className: '',
        render: (_, record) => (
          <span>{record?.flight_date && `${moment(record?.flight_date).format('DDMMMYY')?.toUpperCase()}`}</span>
        )
      },
      {
        title: 'Dept Time EST',
        dataIndex: 'dept_date',
        key: 'dept_date',
        align: 'center',
        render: (_, record) => (
          <span>{moment.utc(record.dept_date, 'YYYY-MM-DD HH:mm:ss').tz(this.state.timezone).format(dateTimeFormat)?.toUpperCase()}</span>
        )
      },
      {
        title: 'ORG-DST',
        dataIndex: 'org_dest',
        key: 'org_dest',
        render: (_, record) => (
          <span>{record?.org_stn}-{record?.dest_stn}</span>
        )
      },
      {
        title: 'AC Type',
        dataIndex: 'ac_type',
        key: 'ac_type',
        render: (_, record) => (
          <span>{record?.ac_type}</span>
        )
      },
      {
        title: 'Assigned DOD Agent',
        dataIndex: 'dod_agent_id',
        key: 'dod_agent_id',
        render: (_, record, index) => (
          <Select
            size='small'
            className='w-100'
            value={record?.dod_agent_id || ''}
            placeholder='Select DOD Agent'
            onChange={value => {
              const dodAssignmentFlights = [...this.state.dodAssignmentFlights]
              dodAssignmentFlights[index] = {
                ...dodAssignmentFlights[index],
                dod_agent_id: value,
                dod_agent_changed: true,
              }
              this.setState({ dodAssignmentFlights })
            }}
          >
            {this.state.dodAgents?.map((agent) => (
              <Select.Option key={agent.id} value={agent.id}>{agent.name.first_name} {agent.name.last_name}</Select.Option>
            ))}
          </Select>
        )
      }
    ]
    const noridecols = [
      {
        title: 'Container ID',
        dataIndex: 'container_id',
        key: 'container_id',
        render: (_, record) => (
          record?.id === this.state.edit_noride_id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.edit_noride_container_id || ''}
              onChange={(e) => this.setState({
                edit_noride_container_id: e.target.value,
                edit_noride_type: e.target.value.substring(0, 3)
              })}
            />
            : <span>{record?.container_id}</span>
        )
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        render: (_, record) => (
          record?.id === this.state.edit_noride_id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.edit_noride_type || ''}
              onChange={(e) => this.setState({ edit_noride_type: e.target.value })}
            />
            : <span>{record?.type}</span>
        )
      },
      {
        title: 'Removed before FPE?',
        dataIndex: 'rmvbfpe',
        key: 'rmvbfpe',
        render: (_, record) => (
          record?.id === this.state.edit_noride_id ?
            <Select
              size='small'
              className='w-100'
              dropdownClassName='dropdown-options'
              placeholder={'Select Option'}
              value={this.state.edit_noride_rmvbfpe}
              onChange={(e) => this.setState({ edit_noride_rmvbfpe: e })}
            >
              <Option value='Yes'>Yes</Option>
              <Option value='No'>No</Option>
            </Select>
            : <span>{record?.rmvbfpe}</span>
        )
      },
      {
        title: 'Cut Code',
        dataIndex: 'cut_code',
        key: 'cut_code',
        render: (_, record) => (
          record?.id === this.state.edit_noride_id ?
            <Select
              size='small'
              className='w-100'
              dropdownClassName='dropdown-options'
              placeholder={'Select Cut Code'}
              value={this.state.edit_noride_cutcode}
              onChange={(e) => this.setState({
                edit_noride_cutcode: e,
                edit_cut_reasons: cut_codes.find((item) => item?.code === e)?.reasons,
                edit_noride_cutreason: cut_codes.find((item) => item?.code === e)?.reasons.length === 1 ?
                  cut_codes.find((item) => item?.code === e)?.reasons[0] : null,
                edit_noride_cutby: cut_codes.find((item) => item?.code === e)?.cutby,
              })}
            >
              {
                cut_codes?.map((item, index) => (
                  <Option key={index} value={item?.code}>{item?.code}</Option>
                ))
              }
            </Select>
            : <span>{record?.cut_code}</span>
        )
      },
      {
        title: 'Reason',
        dataIndex: 'cut_reason',
        key: 'cut_reason',
        render: (_, record) => (
          record?.id === this.state.edit_noride_id ?
            <Select
              size='small'
              className='w-100'
              dropdownClassName='dropdown-options'
              placeholder={'Select Reason'}
              value={this.state.edit_noride_cutreason}
              onChange={(e) => this.setState({ edit_noride_cutreason: e })}
            >
              {
                this.state.edit_cut_reasons?.map((item, index) => (
                  <Option key={index} value={item}>{item}</Option>
                ))
              }
            </Select>
            : <span>{record?.cut_reason}</span>
        )
      },
      {
        title: 'Cut By',
        dataIndex: 'cut_by',
        key: 'cut_by',
        render: (_, record) => (
          record?.id == this.state.edit_noride_id ?
            <Input
              size='small'
              className='w-100'
              value={this.state.edit_noride_cutby}
              onChange={(e) => this.setState({ edit_noride_cutby: e.target.value })}
            />
            // <Select
            //   size='small'
            //   className='w-100'
            //   placeholder={'Select Cut By'}
            //   value={this.state.edit_noride_cutby}
            //   onChange={(e) => this.setState({ edit_noride_cutby: e })}
            // >
            //   <Option value='ALA'>ALA</Option>
            //   <Option value='LCC'>LCC</Option>
            //   <Option value='LDD'>LDD</Option>
            // </Select>
            : <span>{record?.cut_by}</span>
        )
      },
      {
        title: 'Comments',
        dataIndex: 'comments',
        key: 'comments',
        render: (_, record) => (
          parseInt(record?.id) === parseInt(this.state.edit_noride_id) ?
            <Input
              size='small'
              placeholder=''
              value={this.state.edit_noride_comment || ''}
              onChange={(e) => this.setState({ edit_noride_comment: e.target.value })}
            />
            : <span>{record?.comments}</span>
        )
      },
      {
        title: 'Attachment',
        dataIndex: 'attachment',
        key: 'attachment',
        align: 'center',
        render: (_, record) => {
          return (
            parseInt(record?.id) === parseInt(this.state.edit_noride_id) ?
              <div className='scaletbl-img'>
                <Upload
                  accept='image/jpg,image/jpeg,image/png'
                  fileList={this.state.edit_noride_fileList}
                  maxCount={1}
                  beforeUpload={() => false}
                  onChange={(e) => this.onChangeEditFileHandler(e)}
                  onRemove={() => this.onRemoveEditFileHandler('noride')}
                  className='upload-name'>
                  <Button type='ghost' className={`image-btn ${this.state.edit_noride_attach_conf ? 'green-fliter' : ''}`} >
                    <img src={download} alt='download' />
                  </Button>
                </Upload>
              </div>
              :
              <span className={record.id === this.state.duplicate?.id ? 'red-border' : ''}>
                <Tooltip title='Preview' onClick={() => this.showPreview(record)}>{record?.attach_conf && (<CheckOutlined />)}</Tooltip>
                {!record?.attach_conf && (<CloseOutlined />)}
              </span>
          )
        }
      },
      {
        title: 'Action',
        key: 'action',
        align: 'center',
        render: (record) =>
          <div>
            <div className='action-column'>
              {
                parseInt(record?.id) === parseInt(this.state.edit_noride_id) ?
                  <>
                    <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.saveNoRide(record)} ><img src={Update} alt='Save' /></Tooltip>
                    <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.clearNoRide()} ><span className='form-clear'>x</span></Tooltip>
                  </>
                  :
                  <>
                    <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.editNoRide(record)} ><img src={editIcon} alt='edit' /></Tooltip>
                    <Popconfirm placement='top' title={constants.DeleteText} okText='Yes' cancelText='No' onConfirm={() => this.deleteNoRide(record)} >
                      <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
                    </Popconfirm>
                  </>
              }
            </div>
          </div>
      },
    ]
    const tools_impacted_options = [
      {
        label: 'Build Plan',
        value: 'Build Plan',
      },
      {
        label: 'Weight & Balance',
        value: 'Weight & Balance',
      },
      {
        label: 'Milestone',
        value: 'Milestone',
      }
    ]

    const milestones = [
      {
        label: 'Build Plan Submitted to Warehouse',
        value: 'Apple',
      },
      {
        label: 'Cutoff Review',
        value: 'cutoff',
      },
      {
        label: 'FPE Review',
        value: 'fpe',
      },
      {
        label: 'No Ride Alert',
        value: 'no_ride',
      },
      {
        label: 'Flight Audit',
        value: 'flight_audit  ',
      },
    ]
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      // slidesToShow: 7,
      slidesToShow: this.state.editRecord?.build_uld.length > 5 ? 5 : this.state.editRecord?.build_uld.length + 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
      ]
    }

    const uploadButton = (
      <button style={{
        border: 0,
        background: 'none'
      }} type='button'>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </button>
    )

    const getRemaingWgt = (flightDetails) => {
      // {Math.round(['K', 'KGM', 'KG', 'KGS'].includes(this.state.flightDetails?.wgt?.unit) ? this.updateWeightVal('LB', this.state.flightDetails?.wgt?.value) : this.state.flightDetails?.wgt?.value - (this.state?.editRecord?.build_plan.find((item) => item.awb_no === this.state.flightDetails?.awb_no)?.data?.wgt || 0) - this.state.assignedUldsData?.map(item => item.wgt).reduce((prev, curr) => Number(prev) + Number(curr), 0))}
      let actual_wgt = this.state.editWgtUnit === 'LB' ? ['K', 'KG', 'KGM', 'KGS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('LB', flightDetails?.wgt?.value) : flightDetails?.wgt?.value : ['L', 'LB', 'LBR', 'LBS'].includes(flightDetails?.wgt?.unit) ? this.updateWeightVal('KG', flightDetails?.wgt?.value) : flightDetails?.wgt?.value
      let build_wgt = this.state.editWgtUnit === 'LB' ? (this.state?.editRecord?.build_plan.find((item) => item.awb_no === flightDetails?.awb_no)?.data?.blk_wgt || 0) : this.updateWeightVal('KG', this.state?.editRecord?.build_plan.find((item) => item.awb_no === flightDetails?.awb_no)?.data?.blk_wgt || 0)
      let assigned_wgt = this.state.editWgtUnit === 'LB' ? this.state.assignedUldsData?.map(item => item.wgt).reduce((prev, curr) => Number(prev) + Number(curr), 0) : this.updateWeightVal('KG', this.state.assignedUldsData?.map(item => item.wgt).reduce((prev, curr) => Number(prev) + Number(curr), 0))
      return Math.round(actual_wgt - (build_wgt || 0) - (assigned_wgt || 0))
    }

    const getRemaingVol = (flightDetails) => {
      // Math.round((((this.state.flightDetails?.vol?.unit === 'CBF' || this.state.flightDetails?.vol?.unit === 'CFT') ? this.updateVolumeVal('CBM', this.state.flightDetails?.vol?.value) : this.state.flightDetails?.vol?.value) - (this.state?.editRecord?.build_plan.find((item) => item.awb_no === this.state.flightDetails?.awb_no)?.data?.vol || 0) - this.state.assignedUldsData?.map(item => item.vol).reduce((prev, curr) => Number(prev) + Number(curr), 0)) * 10) / 10
      let actual_vol = (this.state.editWgtUnit === 'KG' ? (['CBF', 'CFT'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBM', flightDetails?.vol?.value) : flightDetails?.vol?.value) : (['CBM'].includes(flightDetails?.vol?.unit) ? this.updateVolumeVal('CBF', flightDetails?.vol?.value) : flightDetails?.vol?.value))
      let build_vol = this.state.editWgtUnit === 'KG' ? (this.state?.editRecord?.build_plan.find((item) => item.awb_no === flightDetails?.awb_no)?.data?.blk_vol || 0) : volumnCalculator(this.state?.editRecord?.build_plan.find((item) => item.awb_no === flightDetails?.awb_no)?.data?.blk_vol || 0, 'CBM')
      let assigned_vol = this.state.editWgtUnit === 'KG' ? this.state.assignedUldsData?.map(item => item.vol).reduce((prev, curr) => Number(prev) + Number(curr), 0) : this.state.assignedUldsData?.map(item => volumnCalculator(item.vol, 'CBM')).reduce((prev, curr) => Number(prev) + Number(curr), 0)
      actual_vol = actual_vol - build_vol - assigned_vol
      return this.state.editWgtUnit === 'KG' ? Math.round(actual_vol * 10) / 10 : Math.round(actual_vol)
    }
    const CardAwbColumns = [
      {
        title: (<span className='test'>  AWB </span>),
        dataIndex: 'awb',
        key: 'awb',
        className: 'space-nowrap',
        render: (_, record) => (
          // <span className={record?.showred ? 'bg-red' : null}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</span>
          <span className={this.mismatchPcs(record?.pcs, record)}>{record?.awb_no?.replace(/(\d{3})(\d{8})/, '$1-$2')}</span>
        )
      },
      {
        title: (<span className='test'>  Pcs </span>),
        dataIndex: 'pcs',
        key: 'pcs',
        render: (_, record) => (
          record?.uld_id === this.state.editUlds.uld_id ?
            <Input
              size='small'
              placeholder=''
              value={this.state.editUlds.pcs || ''}
              name='pcs'
              onChange={(e) => this.handleEditUldChange(e)}
            />
            : <span>{record?.pcs}</span>
        )
      },
      {
        title: (<span className='test'>GrWt.({this.state?.flightDetails?.editWgtUnit === 'KG' ? 'kgs' : 'lbs'}) </span>),
        // title: (<span className='test'>  GrWt.(lbs) </span>),
        dataIndex: 'wgt',
        key: 'wgt',
        className: 'min-width-100',
        render: (_, record) => {
          if (record?.uld_id === this.state.editUlds.uld_id) {
            return <Input
              size='small'
              placeholder=''
              value={this.state.editUlds.wgt || ''}
              name='wgt'
              onChange={(e) => this.handleEditUldChange(e)}
            />
          } else {
            let weight = this.state.editWgtUnit === 'KG' ? this.updateWeightVal('KG', record?.wgt) : record?.wgt
            return <span>{Math.round(weight)}</span>
          }
        }
      },
      {
        title: (<span className='test'>  Vol.({this.state?.flightDetails?.editWgtUnit === 'KG' ? 'cbm' : 'cbf'}) </span>),
        // title: (<span className='test'>  Vol.(cbm) </span>),
        dataIndex: 'vol',
        key: 'vol',
        render: (_, record) => {
          if (record?.uld_id === this.state.editUlds.uld_id)
            return <Input
              size='small'
              placeholder=''
              value={this.state.editUlds.vol || ''}
              name='vol'
              onChange={(e) => this.handleEditUldChange(e)}
            />
          else {
            let vol = this.state.editWgtUnit === 'KG' ? (Math.round(record?.vol * 10) / 10) : Math.round(volumnCalculator(record?.vol, 'CBM'))
            return <span>{vol}</span>
          }
        }
      },
      {
        title: 'Action',
        key: 'action',
        align: 'center',
        render: (record) =>
          this.state.flightDetails.awb_no == record?.awb_no && <div>
            {record?.uld_id === this.state.editUlds?.uld_id ?
              <div className='action-column'>
                <Tooltip title='Save' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.updateUlds()} ><img src={Update} alt='Save' /></Tooltip>
                <Tooltip title='Clear' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.clearTableForm()} ><span className='form-clear'>x</span></Tooltip>
              </div>
              :
              <div className='action-column'>
                <Tooltip title='Edit' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }} onClick={() => this.editUlds(record)} ><img src={editIcon} alt='edit' /></Tooltip>
                <Popconfirm placement='top' title={constants.DeleteText} onConfirm={() => this.deleteUlds(record)} okText='Yes' cancelText='No'>
                  <Tooltip title='Delete' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={deleteIcon} alt='delete' /></Tooltip>
                </Popconfirm>
              </div>
            }
          </div>
      }
    ]

    return (
      <div className='print-uld'>
        {
          this.state.servererror ?
            <p className='dis-server'>Disconnected from the server, Please refresh the page.</p> : null
        }
        <Spin spinning={this.state.loading}>
          {this.state.loadplanvisible && this.loadPlanModal()}
          {this.state.optimalBuild && this.searchModal()}
          <HeaderSearch searchResults={this.state.radioValue === 2 ? this.fetchFlightsChecklist : this.fetchFlights} page='FCP' />
          <Row gutter={[{
            xs: 0,
            sm: 0,
            md: 24,
            lg: 24
          }, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24
          },]} >
            {!this.state.showBP}
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className=''>
              {this.state.showBP ?
                <Button
                  className='custom-button close'
                  onClick={() => {
                    this.setState({ showBP: false })
                  }}>
                  Back
                </Button> : ''}
              {!this.state.showBP ?
                <Card className='custom-card h-100 dod-card'>
                  <Row gutter={[{
                    xs: 0,
                    sm: 0,
                    md: 12,
                    lg: 12
                  }, {
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12
                  },]} className='with-table'>
                    <Col xs={24} flex={'auto'} className='fv-middle'>
                      <Title level={5} className='mb-0 title-divider' xs={12}>
                        Flights
                      </Title>
                      <Space>
                        <Popover
                          overlayClassName='history-popover'
                          content={this.state.paxLogs.length > 0 ?
                            <List
                              className='history-popover'
                              itemLayout='horizontal'
                              dataSource={this.state.paxLogs}
                              renderItem={(item) => (
                                <List.Item>
                                  <List.Item.Meta
                                    title={moment.utc(item?.createdAt).tz(this.state.timezone).format('YYYY-MM-DD HH:mm')}
                                    description={item?.name}
                                    onClick={() => window.open(`${item?.src}`, '_blank')}
                                    className='history-link-item'
                                  />
                                </List.Item>
                              )}
                            />
                            : <div className='p-2'>No History Found</div>
                          }
                          title={'Pax File History'}
                          trigger='click'
                        >
                          <span className='history-icon'> H </span>
                        </Popover>
                        <ReloadOutlined
                          style={{
                            fontSize: 16,
                            cursor: 'pointer',
                            marginTop: 4
                          }}
                          onClick={() => {
                            this.setState({
                              flightData: [],
                              page: 1,
                            }, () => this.fetchData())
                          }}
                          title='Refresh'
                        />
                      </Space>
                    </Col>
                    <Col flex={'auto'}>
                      <div className='toggle-view'>
                        <Radio.Group
                          onChange={(e) => this.setState({
                            radioValue: e.target.value,
                            flightData: [],
                            page: 1,
                          }, () => this.handleToggle())}
                          className='custom-radio-group'
                          value={this.state.radioValue}
                          style={ENV === 'stage' && users.includes(cookies.get('username')) ? { display: 'block' } : ENV === 'development' || ENV === 'local' ? { display: 'block' } : { display: 'none' }}
                        >
                          <Space size={0}>
                            <Radio.Button value={1} className='radio-change' size='small'>Ops info </Radio.Button>
                            <Radio.Button value={2} className='radio-change' size='small'>Checklist</Radio.Button>
                          </Space>
                        </Radio.Group>
                      </div>
                    </Col>
                    <Col flex={'none'}>
                      <Space direction='horizontal' size={0} className='ml-auto d-flex'>
                        <Upload
                          accept='.xlsx,.xls'
                          showUploadList={false}
                          beforeUpload={(file) => {
                            const formData = new FormData()
                            formData.append('file', file)

                            Http.post(
                              '/upload_directives',
                              formData,
                              {
                                headers: {
                                  'Content-Type': 'multipart/form-data',
                                  'station': this.state.station
                                }
                              }
                            )

                            return false // prevent default upload
                          }}
                        >
                          <Button type='link' className='link-btn-dod uld-upload' icon={<UploadOutlined style={{ fontSize: 16 }} />}>ULD Directive Upload</Button>
                        </Upload>
                        <Button
                          type='link'
                          className='link-btn-dod wb-btn ml-auto d-flex'
                          icon={<img src={RedirectIcon} alt='redirect' width={14} />}
                          onClick={() => window.open('https://apps.powerapps.com/play/e/f7a9917a-c0f8-e704-b911-cd160be3bc02/a/faa9ead5-f82c-4d61-af1d-b855629dab74?tenantId=45e6435d-dc1c-42e3-89be-e72e6c8f072d&hint=24b3d692-f70a-40ef-ad30-4e63c2841a23&sourcetime=1706817146356&source=portal&hidenavbar=true', '_blank')}
                        >
                          Widebody Bin Tool
                        </Button>
                      </Space>
                    </Col>
                    {this.state.radioValue === 1 && !this.state.showBP ?
                      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className=' mb-4'>
                        <Row gutter={[{
                          xs: 24,
                          sm: 24,
                          md: 24,
                          lg: 24
                        }, {
                          xs: 12,
                          sm: 12,
                          md: 12,
                          lg: 12
                        },]} className=''>
                          <Col xs={24} sm={12} md={6} lg={6} xl={3} xxl={3} className='xl-auto'>
                            <div>
                              <label className='custom-label'>Fromds {moment(this.state.stime).format('YYYY-MM-DD HH:mm:ss')}</label>
                              <DatePicker
                                allowClear={false}
                                className=''
                                onChange={(moment) => this.setState({
                                  start: moment,
                                  flightData: [],
                                  page: 1,
                                }, () => this.fetchFlights())}
                                // onChange={(moment) => this.setState({ start: moment }, () => this.setFilters('start'))}
                                value={moment(this.state.start, dateFormat)}
                                disabledDate={(current) => this.disabledDate(current)}
                              />
                            </div>
                          </Col>
                          {/* <Col xs={24} sm={12} md={6} lg={6} xl={3} xxl={3} className='xl-auto'>
                            <div>
                              <label className='custom-label transparent'>-</label>
                              <TimePicker
                                allowClear={false}
                                onChange={(moment) => this.setState({
                                  stime: moment,
                                  flightData: [],
                                  page: 1,
                                }, () => this.fetchFlights())}
                                // onChange={(moment) => this.setState({ stime: moment }, () => this.setFilters('stime'))}
                                value={moment(this.state.stime, timeFormat)}
                                disabledHours={() => {
                                  var hours = []
                                  let start = this.state.start ? moment(this.state.start, dateFormat).format(dateFormat) : null
                                  let atlstart = moment().tz(this.state.timezone).subtract(1, 'day').format(dateFormat)
                                  if (start && atlstart && start === atlstart) {
                                    for (var i = 0; i < moment().tz(this.state.timezone).hour(); i++) {
                                      hours.push(i)
                                    }
                                  }
                                  return hours
                                }}
                              />
                            </div>
                          </Col> */}
                          <Col xs={24} sm={12} md={6} lg={6} xl={3} xxl={3} className='xl-auto'>
                            <div>
                              <label className='custom-label'>To</label>
                              <DatePicker
                                allowClear={false}
                                className=''
                                onChange={(moment) => this.setState({
                                  end: moment,
                                  flightData: [],
                                  page: 1,
                                }, () => this.fetchFlights())}
                                // onChange={(moment) => this.setState({ end: moment }, () => this.setFilters('end'))}
                                value={moment(this.state.end, dateFormat)}
                                disabledDate={(current) => this.disabledDate(current)}
                              />
                            </div>
                          </Col>
                          {/* <Col xs={24} sm={12} md={6} lg={6} xl={3} xxl={3} className='xl-auto'>
                            <div>
                              <label className='custom-label transparent'>-</label>
                              <TimePicker
                                allowClear={false}
                                onChange={(moment) => this.setState({
                                  etime: moment,
                                  flightData: [],
                                  page: 1,
                                }, () => this.fetchFlights())}
                                // onChange={(moment) => this.setState({ etime: moment }, () => this.setFilters('etime'))}
                                value={moment(this.state.etime, timeFormat)}
                                disabledHours={() => {
                                  var hours = []
                                  let end = this.state.end ? moment(this.state.end, dateFormat).format(dateFormat) : null
                                  let atlend = moment().tz(this.state.timezone).add(1, 'day').format(dateFormat)
                                  if (end && atlend && end === atlend) {
                                    for (var i = 23; i > moment().tz(this.state.timezone).hour(); i--) {
                                      hours.push(i)
                                    }
                                  }
                                  return hours
                                }}
                              />
                            </div>
                          </Col> */}
                          <Col xs={24} sm={12} md={6} lg={6} xl={3} xxl={3} className='xl-auto'>
                            <div>
                              <Form.Item className='mb-0'>
                                <label className='custom-label'>Sort By</label>
                                <Select
                                  value={this.state.sort}
                                  size='small'
                                  placeholder='Sort By'
                                  className='text-center'
                                  onChange={(e) => this.setState({ sort: e }, () => this.sort(this.state.flightData, false))}
                                >
                                  <Option value='dept_time'>Dept Time</Option>
                                  <Option value='ac_type'>AC Type</Option>
                                  <Option value='notes_date'>New Notes</Option>
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={17} lg={17} flex={'480px'} className='pr-0'>
                            <div className='mt-1'>
                              <label className='custom-label transparent'>-</label>
                              <Checkbox
                                checked={this.state.amberFlightsCheck}
                                onChange={(e) => this.setState({ amberFlightsCheck: e.target.checked }, () => this.departedFlightsFilter())}
                              >
                                Show Payload Critical Flights
                              </Checkbox>
                              <Checkbox
                                checked={this.state.redFlightsCheck}
                                onChange={(e) => this.setState({ redFlightsCheck: e.target.checked }, () => this.departedFlightsFilter())}
                              >
                                Show Build Conflicts
                              </Checkbox>
                              <Checkbox
                                checked={this.state.departedFlightsCheck}
                                onChange={(e) => this.setState({ departedFlightsCheck: e.target.checked }, () => this.departedFlightsFilter())}
                              >
                                Hide Departed Flights
                              </Checkbox>
                            </div>
                          </Col>
                          {/* <Col flex={'30px'} className='text-center ml-auto'>
                          <label className='custom-label transparent'>-</label>
                          <Button
                            type='ghost'
                            className='image-btn'
                            onClick={() => {
                              this.clearEditFlightForm()
                              this.clearEditAllocForm()
                              this.clearAllocTableForm()
                              this.setState({ loadplanvisible: true })
                            }}
                          >
                            <Tooltip title={'Add'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                          </Button>
                          // <Switch
                          // checked={this.state.hideMD}
                          // checkedChildren='Hide MD'
                          // unCheckedChildren='Show MD'
                          // onChange={(e) => this.setState({ hideMD: e }) }
                          // /> 
                        </Col> */}
                        </Row>
                      </Col> : ''}
                    {this.state.radioValue === 1 ?
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        className='table-overflow'
                      >
                        <div className='table-outer'>
                          <Table
                            className='custom-table w-100 multi-head fc-table'
                            dataSource={this.state.departedFlightsCheck || this.state.amberFlightsCheck || this.state.redFlightsCheck ? this.state.displayData : this.state.flightData}
                            pagination={false}
                          >
                            <Column
                              title='Flight #'
                              dataIndex=''
                              key='flight_no'
                              className='space-nowrap'
                              render={(_, record) => (
                                <span>{record?.flight_no ? record.flight_no : 'N/A'}</span>
                              )}
                            />
                            <Column
                              title='Flight Date'
                              dataIndex=''
                              key='flight_date'
                              className='space-nowrap'
                              render={(_, record) => (
                                <span>{record?.flight_date ? this.checkFlightDate(record) :
                                  record?.dept_date ? moment.utc(record.dept_date).tz(this.state.timezone).format(dateOnly)?.toUpperCase() :
                                    record?.schdl ? moment.tz(record.schdl, this.state.timezone).format(dateOnly)?.toUpperCase() :
                                      'N/A'}</span>
                              )}

                            />
                            <Column
                              title='AC'
                              dataIndex=''
                              key='ac_type'
                              render={(_, record) => (
                                <span>{record?.ac_type ? record.ac_type : 'N/A'}</span>
                              )}
                            />
                            <Column
                              title='Routing'
                              dataIndex=''
                              key='routing'
                              render={(_, record) => (
                                <span>{record?.org && record?.dest ? `${record.org.origin}-${record.dest.arriv}` : 'N/A'}</span>
                              )}
                            />
                            <Column
                              title={`Dept Time (in ${this.state.ext})`}
                              dataIndex=''
                              key='dept_time'
                              render={(_, record) => (
                                <Space className=''>
                                  <span className='px-1 fs-10 pa-badge'>{record?.dept_prefix ? record?.dept_prefix : ''}</span>
                                  <span>{record?.dept_time ? `${moment.tz(record.dept_time, this.state.timezone).format(dateTimeFormat)?.toUpperCase()}` : 'N/A'}</span>
                                </Space>
                              )}
                            />
                            <Column
                              title='P CAP/FCST'
                              dataIndex='cap_fcst'
                              key='cap_fcst'
                              render={(_, record) => (
                                <span>{`${record?.pax_cap}/${record?.fcst || 0}`}</span>
                              )}
                            />
                            <ColumnGroup title='Bag Posns' align='center'>
                              {/* <Column
                     title= 'PMC'
                     dataIndex= 'bag_posns'
                     key= 'bag_posns'
                     className='psn'
                     render= {(_, record) => (
                       <span>{record?.bag?.p96 || 0}</span>
                     )}
                   />
                   <Column
                     title= 'PAG'
                     dataIndex= 'bag_posns'
                     key= 'bag_posns'
                     className='psn'
                     render= {(_, record) => (
                       <span>{record?.bag?.p88 || 0}</span>
                     )}
                   /> */}
                              <Column
                                title='LD3'
                                dataIndex='bag_posns'
                                key='bag_posns'
                                className='psn'
                                render={(_, record) => (
                                  <span>{record?.bag?.ld3 || 0}</span>
                                )}
                              />
                              <Column
                                title='LD2'
                                dataIndex='bag_posns'
                                key='bag_posns'
                                // width='70px'
                                align='left'
                                className='psn'
                                render={(_, record) => (
                                  <span>{record?.bag?.ld2 || 0}</span>
                                )}
                              />
                            </ColumnGroup>
                            <ColumnGroup title='Optimal Cargo Build' align='center' className=''>
                              <Column width={20}></Column>
                              {this.state.hideMD ? null : <Column
                                title='MD'
                                dataIndex=''
                                key=''
                                className='psn op-build'
                                render={(_, record) => (
                                  <span>{record?.cargo?.md || 0}</span>
                                )}
                              />}
                              <Column
                                title='PMC'
                                dataIndex=''
                                key=''
                                className='psn op-build'
                                render={(_, record) => (
                                  <span>{record?.cargo?.p96 || 0}</span>
                                )}
                              />
                              <Column
                                title='PAG'
                                dataIndex=''
                                key=''
                                className='psn op-build'
                                render={(_, record) => (
                                  <span>{record?.cargo?.p88 || 0}</span>
                                )}
                              />
                              <Column
                                title='LD3'
                                dataIndex=''
                                key=''
                                className='psn op-build'
                                render={(_, record) => (
                                  <span>{record?.cargo?.ld3 || 0}</span>
                                )}
                              />
                              <Column
                                title='LD2'
                                dataIndex=''
                                key=''
                                className='psn op-build'
                                render={(_, record) => (
                                  <span>{record?.cargo?.ld2 || 0}</span>
                                )}
                              />
                            </ColumnGroup>
                            <Column
                              title='Bkd + Asd'
                              dataIndex='booked'
                              key='booked'
                              render={(_, record) => (
                                <span>{this.state.weight_unit === 'KG' && record?.booked_kg ? `${formatWeight(record?.booked_kg)}KG` :
                                  this.state.weight_unit === 'LB' && record?.booked_lbs ? `${formatWeight(record?.booked_lbs)}LB` :
                                    'N/A'}</span>
                              )}
                            />
                            <Column
                              title='Ready'
                              dataIndex='built_up'
                              key='built_up'
                              align='center'
                              render={(_, record) => (
                                <span>{this.state.weight_unit === 'KG' && record?.ready_kg ? `${formatWeight(record?.ready_kg)}KG` :
                                  this.state.weight_unit === 'LB' && record?.ready_lbs ? `${formatWeight(record?.ready_lbs)}LB` :
                                    '-'}</span>
                              )}
                            />
                            <Column
                              title='At Gate'
                              dataIndex='at_gate'
                              key='at_gate'
                              render={(_, record) => (
                                <span>{this.state.weight_unit === 'KG' && record?.gate_kg ? `${formatWeight(record?.gate_kg)}KG` :
                                  this.state.weight_unit === 'LB' && record?.gate_lbs ? `${formatWeight(record?.gate_lbs)}LB` :
                                    '-'}</span>
                              )}
                            />
                            <Column
                              title='FPE'
                              dataIndex='dept_time'
                              key='dept_time'
                              render={(_, record) => (
                                <span className='countdown'>{record?.time_to_dept ? <Countdown value={moment(record.time_to_dept)} format='HH:mm' /> : 'N/A'}</span>
                              )}
                            />
                            <Column
                              title='BU PRIO'
                              dataIndex=''
                              key='priority'
                              align='center'
                              render={(_, record) => (
                                record?.bu_prio ? <CheckOutlined /> : <CloseOutlined />
                              )}
                            />
                            <Column
                              title='Actions'
                              dataIndex='action'
                              key='action'
                              render={(_, record) =>
                                <div className='action-column'>
                                  {/* <Tooltip title='DoD Checklist' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                                  <Button
                                    className='modal-btn'
                                    icon={<CheckSquareOutlined 
                                      className='modal-icon'
                                      onClick={() => this.showCheckList(record)}
                                    />}
                                  >
                                  </Button>
                                </Tooltip>  */}
                                  <Tooltip title='Cargo Capacity' overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                                    <Button
                                      className={record.cccolour_css}
                                      onClick={() => this.setEdit(record)}
                                    >
                                      BP
                                    </Button>
                                  </Tooltip>
                                  <Badge size='small' count={record?.notes || 0} color={'#0a1227'}>
                                    <Tooltip
                                      title='Notes'
                                      overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}
                                      onClick={() => this.showFlightNotes(record)}
                                    >
                                      <img src={documentIcon} alt='document' />
                                    </Tooltip>
                                  </Badge>
                                </div>
                              }
                            />
                          </Table>
                        </div>
                      </Col> : ''}
                    {this.state.radioValue === 2 && !this.state.showBP ?
                      <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className=' mb-4'>
                        <Row gutter={[{
                          xs: 24,
                          sm: 24,
                          md: 24,
                          lg: 24
                        }, {
                          xs: 12,
                          sm: 12,
                          md: 12,
                          lg: 12
                        },]} className=''>
                          <Col xs={24} sm={12} md={6} lg={6} xl={3} xxl={3} className='xl-auto'>
                            <div>
                              <label className='custom-label'>From</label>
                              <DatePicker
                                allowClear={false}
                                className=''
                                onChange={(moment) => this.setState({
                                  start_checklist: moment,
                                  flightData: [],
                                  page: 1,
                                }, () => this.fetchFlightsChecklist())}
                                // onChange={(moment) => this.setState({ fetchFlightsChecklist: moment }, () => this.setFilters('fetchFlightsChecklist'))}
                                value={moment(this.state.start_checklist, dateFormat)}
                                disabledDate={(current) => this.disabledDate(current)}
                              />
                            </div>
                          </Col>
                          {/* <Col xs={24} sm={12} md={6} lg={6} xl={3} xxl={3} className='xl-auto'>
                            <div>
                              <label className='custom-label transparent'>-</label>
                              <TimePicker
                                allowClear={false}
                                onChange={(moment) => this.setState({
                                  stime_checklist: moment,
                                  flightData: [],
                                  page: 1,
                                }, () => this.fetchFlightsChecklist())}
                                // onChange={(moment) => this.setState({ stime_checklist: moment }, () => this.setFilters('stime_checklist'))}
                                value={moment(this.state.stime_checklist, timeFormat)}
                                disabledHours={() => {
                                  var hours = []
                                  let start = this.state.start_checklist ? moment(this.state.start_checklist, dateFormat).format(dateFormat) : null
                                  let atlstart = moment().tz(this.state.timezone).subtract(1, 'day').format(dateFormat)
                                  if (start && atlstart && start === atlstart) {
                                    for (var i = 0; i < moment().tz(this.state.timezone).hour(); i++) {
                                      hours.push(i)
                                    }
                                  }
                                  return hours
                                }}
                              />
                            </div>
                          </Col> */}
                          <Col xs={24} sm={12} md={6} lg={6} xl={3} xxl={3} className='xl-auto'>
                            <div>
                              <label className='custom-label'>To</label>
                              <DatePicker
                                allowClear={false}
                                className=''
                                onChange={(moment) => this.setState({
                                  end_checklist: moment,
                                  flightData: [],
                                  page: 1,
                                }, () => this.fetchFlightsChecklist())}
                                // onChange={(moment) => this.setState({ end_checklist: moment }, () => this.setFilters('end_checklist'))}
                                value={moment(this.state.end_checklist, dateFormat)}
                                disabledDate={(current) => this.disabledDate(current)}
                              />
                            </div>
                          </Col>
                          {/* <Col xs={24} sm={12} md={6} lg={6} xl={3} xxl={3} className='xl-auto'>
                            <div>
                              <label className='custom-label transparent'>-</label>
                              <TimePicker
                                allowClear={false}
                                onChange={(moment) => this.setState({
                                  etime_checklist: moment,
                                  flightData: [],
                                  page: 1,
                                }, () => this.fetchFlightsChecklist())}
                                // onChange={(moment) => this.setState({ end_checklist: moment }, () => this.setFilters('end_checklist'))}
                                value={moment(this.state.etime_checklist, timeFormat)}
                              />
                            </div>
                          </Col> */}
                          <Col xs={24} sm={12} md={6} lg={6} xl={5} xxl={3} className='xl-auto'>
                            <div>
                              <Form.Item className='mb-0'>
                                <label className='custom-label'>Sort By</label>
                                <Select
                                  value={this.state.dodsort}
                                  size='small'
                                  placeholder='Sort By'
                                  className='text-center'
                                  onChange={(e) => {
                                    let flightData = this.state.flightData
                                    this.setState({
                                      dodsort: e,
                                      flightData: []
                                    }, () => this.setState({ flightData: this.sortDodCC(flightData) })
                                    )
                                  }}
                                >
                                  <Option value='dept_time'>Dept Time</Option>
                                  <Option value='flight_no'>Flight#</Option>
                                  <Option value='dest_stn'>Org-Dest</Option>
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={17} lg={17} flex={'0 0 180px'} className='pr-0'>
                            <div className='mt-1'>
                              <label className='custom-label transparent'>-</label>

                              <Checkbox
                                checked={this.state.hideCompleted}
                                onChange={
                                  (e) => {
                                    let flights = this.state.flightData
                                    this.setState({
                                      hideCompleted: e.target.checked,
                                      flightData: []
                                    }, () => this.setState({ flightData: flights }))
                                  }
                                }
                              >
                                Hide Completed Flights
                              </Checkbox>
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={17} lg={17} flex={'0 0 auto'} className='pr-0'>
                            <div className='mt-1'>
                              <label className='custom-label transparent'>-</label>
                              <Checkbox
                                checked={this.state.showInternational}
                                onChange={
                                  (e) => {
                                    let flights = this.state.flightData
                                    this.setState({
                                      showInternational: e.target.checked,
                                      flightData: []
                                    }, () => this.setState({ flightData: flights }))
                                  }
                                }
                              >
                                INT
                              </Checkbox>
                            </div>
                          </Col>
                          <Col xs={24} sm={24} md={17} lg={17} flex={'0 0 auto'} className='pr-0'>
                            <div className='mt-1'>
                              <label className='custom-label transparent'>-</label>
                              <Checkbox
                                checked={this.state.showDomestic}
                                onChange={
                                  (e) => {
                                    let flights = this.state.flightData
                                    this.setState({
                                      showDomestic: e.target.checked,
                                      flightData: []
                                    }, () => this.setState({ flightData: flights }))
                                  }
                                }
                              >
                                DOM
                              </Checkbox>
                            </div>
                          </Col>
                          {(cookies.get('role') === 'DOD Agent' || cookies.get('role') === 'Centralized DoD') &&
                            <Col xs={24} sm={24} md={17} lg={17} flex={'0 0 auto'} className='pr-0'>
                              <div className='mt-1'>
                                <label className='custom-label transparent'>-</label>
                                <Checkbox
                                  checked={this.state.showMyFlights}
                                  onChange={
                                    (e) => {
                                      let flights = this.state.flightData
                                      this.setState({
                                        showMyFlights: e.target.checked,
                                        flightData: []
                                      }, () => this.setState({ flightData: flights }))
                                    }
                                  }
                                >
                                  My Flights
                                </Checkbox>
                              </div>
                            </Col>
                          }
                          <Col flex='none' className=''>
                            <div className=''>
                              <label className='custom-label transparent'>-</label>
                              <Button type='text' icon={<UserOutlined />} onClick={() => this.setState({ flightAssessment: true })} className='feedback-btn'>
                                Flight Assignment
                              </Button>
                            </div>
                          </Col>
                          <Col flex='none' className='pr-0'>
                            <div className=''>
                              <label className='custom-label transparent'>-</label>
                              <Button type='text' icon={<CustomerServiceOutlined />} onClick={() => this.setState({ feedback: true })} className='feedback-btn'>
                                Feedback Form
                              </Button>
                            </div>
                          </Col>
                          <Col flex={'30px'} className='text-center ml-auto'>
                            <label className='custom-label transparent'>-</label>
                            <Button
                              type='ghost'
                              className='image-btn'
                              onClick={() => this.setState({
                                flightModalType: 'ADD',
                                showFlightModal: true
                              })}
                            >
                              <Tooltip title={'Add Flight'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                            </Button>
                          </Col>
                        </Row>
                      </Col> : ''}

                    {this.state.radioValue === 2 && !this.state.showBP ?
                      <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
                        <div className='table-outer'>
                          <Table
                            className='custom-table w-100 multi-head dod-multihead'
                            // dataSource={this.state.departedFlightsCheck ||this.state.amberFlightsCheck ||this.state.redFlightsCheck? this.state.displayData : this.state.flightData}
                            dataSource={this.getFilteredFlights()}
                            columns={this.generateMilestonesColumns()}
                            pagination={false}
                          />
                        </div>
                      </Col> : ''
                    }
                  </Row>
                </Card> : ''}
            </Col>
          </Row>
        </Spin>
        {this.state.showBP === true ?
          <BuildPlan /> : ''}
        <Modal
          title={this.state.notesTitle}
          open={this.state.flightNotes}
          onCancel={() => this.setState({
            flightNotes: false,
            notesTitle: ''
          })}
          footer={false}
          width={'80%'}
          centered
          className='custom-modal pb-0'
          destroyOnClose={true}
        >
          <Notes search={this.state.searchString} type={this.state.noteType} />
        </Modal>
        <Modal
          title={this.state.checkListTitle}
          open={this.state.checkListOpen}
          closable={true}
          onCancel={() => this.setState({ checkListOpen: false })}
          footer={false}
          width={'90%'}
          centered
          className='custom-modal pb-0'
        >
          {/* <Spin spinning={this.state.skeletonLoad}> */}
          <Row
            gutter={[
              {
                xs: 0,
                sm: 0,
                md: 24,
                lg: 24,
              },
              {
                xs: 24,
                sm: 24,
                md: 12,
                lg: 12,
              },
            ]}
            className='with-table'
          >
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='space-nowrap'>
              <div className='div-icons' style={{ FontSize: '150%' }}>
                <span>Feedback Form Link</span>
                <CustomerServiceOutlined
                  className='CsIcon'
                />
              </div>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
              <div className='table-outer'>
                <Table
                  className='custom-table w-100 multi-head checklist-table'
                  dataSource={this.getFilteredFlights()}
                  columns={this.generateMilestonesColumns()}
                  pagination={false}
                />
              </div>
            </Col>
          </Row>
        </Modal>
        <Modal
          title={'Feedback Form'}
          open={this.state.feedback}
          closable={true}
          onCancel={() => this.clearFeedbackForm()}
          footer={false}
          width={'60%'}
          centered
          className='custom-modal pb-0'
        >
          <Row
            gutter={[
              {
                xs: 24,
                sm: 24,
                md: 24,
                lg: 24
              }, {
                xs: 24,
                sm: 24,
                md: 24,
                lg: 24
              },
            ]}
            className='with-table'
          >
            <Col xs={6} className='fields'>
              <label  >Requestor Name</label>
              <Input
                value={this.state.fb_req_name}
                size='small'
                placeholder=''
                onChange={(e) => this.setState({ fb_req_name: e.target.value })}

              />
            </Col>
            <Col xs={6} className='fields'>
              <label className>Requestor Email</label>
              <Input
                placeholder=''
                value={this.state.fb_req_email}
                onChange={(e) => this.setState({ fb_req_email: e.target.value })}
              />
            </Col>
            <Col xs={6} className='fields'>
              <label >Type of Feedback</label>
              <Select
                size='small'
                placeholder=''
                className='w-100'
                value={this.state.fb_type}
                onChange={(e) => this.setState({ fb_type: e })}
              >
                <Option value={'Report Issue'}>Report Issue</Option>
                <Option value={'Provide Feedback/Recommendations'}>Provide Feedback/Recommendations</Option>
              </Select>
            </Col>
            <Col xs={6} className='fields'>
              <label >Level of Urgency</label>
              <Select
                size='small'
                placeholder=''
                className='w-100'
                value={this.state.fb_urgency}
                onChange={(e) => this.setState({ fb_urgency: e })}
              >
                <Option value={'High'} >High - Impacts operations, no workaround available</Option>
                <Option value={'Medium'} >Medium - Impacts operations, but workaround avaiable</Option>
                <Option value={'Low'} >Low - minimal impact to operations</Option>
              </Select>
            </Col>
            <Col sm={24} lg={'auto'}>
              <label className='custom-label label-border'>Tools Impacted</label>
              <Checkbox.Group
                options={tools_impacted_options}
                defaultValue={['']}
                value={this.state.fb_tools_impacted}
                onChange={(e) => this.setState({ fb_tools_impacted: e })}
              />
            </Col>
            <Col sm={24} lg={'auto'}>
              <label className='custom-label label-border'>Please select the impacted milestone(s)</label>
              <Checkbox.Group
                options={milestones}
                defaultValue={['']}
                value={this.state.fb_milestones}
                onChange={(e) => this.setState({ fb_milestones: e })}
              />
            </Col>

            <Col xs={12} className='fields'>
              <label>Description of Issue/Feedback</label>
              <Input.TextArea
                value={this.state.fb_description}
                placeholder=''
                onChange={(e) => this.setState({ fb_description: e.target.value })}
                className='custom-textarea'
              />
            </Col>
            <Col xs={12} className='fields'>
              <label>Recommended Solution</label>
              <Input.TextArea
                value={this.state.fb_rec_solution}
                placeholder=''
                onChange={(e) => this.setState({ fb_rec_solution: e.target.value })}
                className='custom-textarea'
              />
            </Col>
            <Col xs={24} className='fields'>
              <Dragger
                multiple={true}
                fileList={this.state.fb_fileList}
                beforeUpload={(file) => {
                  this.setState((prevState) => ({ fb_fileList: [...prevState.fb_fileList, file] }))
                  return false
                }}
                onRemove={(file) => {
                  this.setState((prevState) => ({ fb_fileList: prevState.fb_fileList.filter(f => f.uid !== file.uid) }))
                }}
                className='dragger-upload'
              >
                <p className='ant-upload-drag-icon'>
                  <InboxOutlined className='dragger-upload-icon' />
                </p>
                <p className='ant-upload-text'>Click or drag file to this area to upload</p>
              </Dragger>
            </Col>

            <Col className='noride-submit'>
              <button className='modal-submit1 submit' onClick={() => this.sendFeedback()}>Submit </button>
              <button className='modal-submit1' onClick={() => this.clearFeedbackForm()}> Close </button>
            </Col>
            {/* <Form.Item xs={6} >
              <label className='card-text'>Ac Type</label>
              <Input
                // value={this.state.sort}
                value='339'
                disabled={true}
                size='small'
                // placeholder='Sort By'
                className='text-center'
                // onChange={(e) => this.setState({ sort: e }, () => this.sort(this.state.flightData, false))}
              />
                  
            </Form.Item> */}
          </Row>
        </Modal>
        <Modal
          title={`${this.state.checklistTitle}`}
          open={this.state.openQuizModal}
          closable={true}
          onCancel={() => this.setState({
            openQuizModal: false,
            quizMilestonid: null,
            quizModalFlight: null,
            questionsData: this.state.tempquestionsData,
          })}
          footer={<div className='noride-submit'>
            <button className='modal-submit1 submit' onClick={() => this.saveAnswers()}>{this.state.milestonButton}</button>
            <button className='modal-submit1' onClick={() =>
              this.setState({
                openQuizModal: false,
                quizMilestonid: null,
                quizModalFlight: null,
                questionsData: this.state.tempquestionsData,
              })}>
              Close
            </button>
          </div>}
          width={'60%'}
          centered
          className='custom-modal pb-0 quiz-modal'
        >
          <Row gutter={[24, 24]}>
            <Col xs={24}>
              <div className='cargo-cap-card quiz-cargo-cap-card'>
                <Row gutter={[{
                  xs: 12,
                  sm: 12,
                  md: 24,
                  lg: 24
                }, {
                  xs: 12,
                  sm: 12,
                  md: 24,
                  lg: 24
                },]} className='flight-ctrl'
                >
                  {/* <Col xs={24} xl={8} xxl={8}>
                    <Row> */}
                  <Col xs={24} sm={12} md={6} lg={5} xl={5} >
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Flight Number</small>
                      {/* <p className='info-data mb-2'>{this.state.editRecord?.ac_type || 'N/A'}</p> */}
                      <p className={this.state.editRecord?.ac_type === '75D' ? 'new-ac' : 'info-data mb-2'}>{this.state.quizModalFlight?.flight_no}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Flight Date</small>
                      <p className='info-data mb-2'>{
                        this.state.quizModalFlight?.flight_date ? moment(this.checkFlightDate(this.state.quizModalFlight)).format(dateOnly)?.toUpperCase() :
                          this.state.quizModalFlight?.dept_date ? moment.utc(this.state.quizModalFlight?.dept_date).tz(this.state.timezone).format(dateOnly)?.toUpperCase() :
                            this.state.quizModalFlight?.schdl ? moment.tz(this.state.quizModalFlight?.schdl, this.state.timezone).format(dateOnly)?.toUpperCase() :
                              'N/A'
                      }</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={4} xl={4}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Origin</small>
                      <p className='info-data mb-2 space-nowrap'>{this.state.quizModalFlight?.org_stn}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht min-width-80'>
                      <small className='info-title mb-1'>Dest</small>
                      <p className='info-data mb-2'>{this.state.quizModalFlight?.dest_stn}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht min-width-80'>
                      <small className='info-title mb-1'>Aircraft</small>
                      <p className='info-data mb-2'>{this.state.quizModalFlight?.ac_type}</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            {/* <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
              <div style={{ 
                display:'flex',
                justifyContent: 'flex-end'
              }}>
                <button className='modal-submit'> Add Rows </button>
                <button className='modal-submit'> Clear Table </button>
              </div>   
              <div className='table-outer'>
                <Table
                  className='custom-table w-100 multi-head  checklist-table'
                  dataSource={noRideData}
                  columns={noRideCols}
                  pagination={false}
                />
              </div>
            </Col> */}
            <Col xs={22} offset={1}>
              <Row gutter={[{
                xs: 12,
                sm: 24,
              }, {
                xs: 12,
                sm: 12,
                md: 24,
                xl: 24
              },]}>
                {
                  this.state.questionsData?.map((item, index) => (
                    (item.parent_id && item.showchild === false) ? (
                      null
                    ) : (
                      <Col xs={24} key={index}>
                        <Row gutter={[24, 24]}>
                          <Col xs={24} xl={10} className='d-flex'>
                            <p className='d-flex gap-10'>
                              <span>{`${index + 1}.`}</span>
                              <span>{`${item.details.question}`}</span>
                            </p>
                            {
                              item.details.attachment === 'Yes' &&
                              <Button type='link' className='redirect-icon' icon={<img src={RedirectIcon} alt='redirect' width={14} />}
                                onClick={() => window.open('https://linewb-web.tech-ace-maint-prd.aws.delta.com/LMA/ams/#/aircraftSummary', '_blank')}
                              />
                              // <div className='scaletbl-img d-flex'>
                              //   <Upload
                              //     accept='image/jpg,image/jpeg,image/png'
                              //     fileList={item.answer_attach_data}
                              //     maxCount={1} beforeUpload={() => false}
                              //     onChange={(e) => this.handleAnswerAttachment(e, index, 'add')}
                              //     onRemove={(e) => this.handleAnswerAttachment(e, index, 'remove')}
                              //     className='upload-name'>
                              //     <Button type='ghost' className={`image-btn ${item.answer_attach_conf ? 'green-fliter' : ''}`}>
                              //       <img src={download} alt='download' />
                              //     </Button>
                              //   </Upload>
                              // </div>
                            }
                          </Col>
                          <Col xs={24} xl={5}>
                            {
                              item.details.type === 'yes/no' ?
                                <Select
                                  size='small'
                                  className='w-100'
                                  value={item?.answer}
                                  onChange={(e) => this.handleAnswers(e, index)}
                                  popupClassName='mcq-popup'
                                >
                                  <Option value='Yes'>Yes</Option>
                                  <Option value='No'>No</Option>
                                  <Option value='N/A'>N/A</Option>
                                </Select> :
                                item.details.type === 'other' ?
                                  <Input.TextArea placeholder='Provide details' value={item?.answer} onChange={(e) => this.handleAnswers(e, index)} /> :
                                  item.details.type === 'mcq' ?
                                    <Select
                                      size='small'
                                      className='w-100'
                                      value={item?.answer}
                                      onChange={(e) => this.handleAnswers(e, index)}
                                      popupClassName='mcq-popup other-popup'
                                    >
                                      {item.details.options?.map((option, index) => <Option key={index} value={option.name}>{option.name}</Option>)}
                                    </Select>
                                    : null
                            }
                          </Col>
                          <>
                            {
                              item.details.info ?
                                <Col flex={'auto'}>
                                  <ExclamationCircleOutlined style={{ color: '#eaaa00' }} />
                                  <span className='info-text'>{item.details.info}</span>
                                </Col>
                                : null
                            }
                            {
                              (item.details.type === 'yes/no' && item.details.comment && item.details.comment === item.answer && !item.details.is_fup_quiz)
                                || (item.details.type === 'mcq' && item.details.options && item.details.options.length > 0 && item.details.options.find((option) => option?.name === item.answer)?.commentsReq && !(item.details.options.find((option) => option?.name === item.answer)?.is_fup_quiz))
                                ?
                                <Col flex={'auto'}>
                                  <Input.TextArea rows={1} placeholder={'If ' + (item.answer ? `${item.answer.toLowerCase()}` : '') + ', provide details'} value={item?.comment} onChange={(e) => this.handleComment(e, index)} />
                                </Col>
                                : null
                            }
                            {
                              (item.details.type === 'mcq' && item.details.options && item.details.options.length > 0 && item.details.options.find((option) => option?.name === item.answer)?.is_fup_quiz) &&
                              <Col xs={24}>
                                <Row gutter={[24, 24]}>
                                  <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                                    <p className='d-flex gap-10'>
                                      <span className='space-nowrap'>{`${index + 1}. a`}</span>
                                      <span>{getFollowupQuestion(item.details.options, item.answer) || item.details.followup_question}</span>
                                    </p>
                                  </Col>
                                  <Col flex={'auto'}>
                                    {
                                      item.details.options.find((option) => option?.name === item.answer)?.fupType === 'text' ?
                                        <Input.TextArea rows={1} placeholder={'If ' + (item.answer ? `${item.answer.toLowerCase()}` : '') + ', provide details'} value={item?.comment} onChange={(e) => this.handleComment(e, index)} />
                                        : item.details.options.find((option) => option?.name === item.answer)?.fupType === 'yes/no' ?
                                          <Select
                                            size='small'
                                            className='w-80'
                                            value={item?.comment}
                                            onChange={(e) => this.handleComment(e, index)}
                                            popupClassName='mcq-popup other-popup'
                                          >
                                            <Option value='Yes'>Yes</Option>
                                            <Option value='No'>No</Option>
                                            <Option value='N/A'>N/A</Option>
                                          </Select>
                                          : null
                                    }
                                  </Col>
                                </Row>
                              </Col>
                            }
                            {
                              item.details.type === 'yes/no' && item.details.comment && item.details.comment === item.answer && item.details.is_fup_quiz && item.details.followup_question ?
                                <Col xs={24}>
                                  <Row gutter={[24, 24]}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                                      <p className='d-flex gap-10'>
                                        <span className='space-nowrap'>{`${index + 1}. a`}</span>
                                        <span>{`${item.details.followup_question}`}</span>
                                      </p>
                                    </Col>
                                    {/* <Col flex={'70px'}></Col> */}
                                    <Col flex={'auto'}>
                                      {
                                        item?.details.fupType === 'text' ?
                                          <Input.TextArea rows={1} placeholder={'If ' + (item.answer ? `${item.answer.toLowerCase()}` : '') + ', provide details'} value={item?.comment} onChange={(e) => this.handleComment(e, index)} />
                                          : item?.details.fupType === 'yes/no' ?
                                            <Select
                                              size='small'
                                              className='w-80'
                                              value={item?.comment}
                                              onChange={(e) => this.handleComment(e, index)}
                                              popupClassName='mcq-popup other-popup'
                                            >
                                              <Option value='Yes'>Yes</Option>
                                              <Option value='No'>No</Option>
                                              <Option value='N/A'>N/A</Option>
                                            </Select>
                                            : null
                                      }
                                    </Col>
                                  </Row>
                                </Col>
                                : null
                            }

                          </>
                        </Row>
                      </Col>
                    )
                  ))
                }
              </Row>
            </Col>
            <Col xs={22} offset={1}>
              <Row gutter={[{
                xs: 12,
                sm: 24,
              }, {
                xs: 12,
                sm: 12,
                md: 24,
                xl: 24
              },]}
              className=''>
                <Col xs={24} xl={10}>
                  <span className='ml-4'>Completed By:</span>
                </Col>
                <Col xs={24} xl={5}>
                  <Input
                    size='small'
                    value={this.state.completedBy}
                    className='completed-by-input'
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal>
        <Modal
          title={this.state.noRideTitle}
          open={this.state.openNoRideModal}
          closable={true}
          onCancel={() => this.closeNoride()}
          footer={<>
            {this.state.noRideModalType === 'AUDIT' ?
              <div className='noride-submit'>
                <button className='modal-submit1 submit' onClick={() => this.saveAudit()}>{this.state.quizModalFlight?.audit ? 'Resubmit' : 'Submit'}</button>
                <button className='modal-submit1' onClick={() => this.closeNoride()}> Close  </button>
              </div> : null}
            {
              this.state.noRideModalType === 'NORIDE' ?
                <>
                  <div className='noride-submit'>
                    <button className='modal-submit1 submit' onClick={() => this.setNoRide()}>{this.state.quizModalFlight?.noride ? 'Resubmit' : 'Submit'}</button>
                    <button className='modal-submit1' onClick={() => this.closeNoride()}> Close  </button>
                  </div>
                </ > : null
            }
          </>
          }
          width={'70%'}
          centered
          className='custom-modal pb-0 audit-modal'
        >
          <Row gutter={[24, 24]}>
            <Col xs={24}>
              <div className='cargo-cap-card cargo-cap-card-dod'>
                <Row gutter={[{
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: 24
                }, {
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: 24
                },]} className='flight-ctrl'
                >
                  {/* <Col xs={24} xl={8} xxl={8}>
                    <Row> */}
                  <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Flight Number</small>
                      {/* <p className='info-data mb-2'>{this.state.editRecord?.ac_type || 'N/A'}</p> */}
                      <p className={this.state.editRecord?.ac_type === '75D' ? 'new-ac' : 'info-data mb-2'}>{this.state.quizModalFlight?.flight_no}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Flight Date</small>
                      <p className='info-data mb-2'>{
                        this.state.quizModalFlight?.flight_date ? moment(this.checkFlightDate(this.state.quizModalFlight)).format(dateOnly)?.toUpperCase() :
                          this.state.quizModalFlight?.dept_date ? moment.utc(this.state.quizModalFlight?.dept_date).tz(this.state.timezone).format(dateOnly)?.toUpperCase() :
                            this.state.quizModalFlight?.schdl ? moment.tz(this.state.quizModalFlight?.schdl, this.state.timezone).format(dateOnly)?.toUpperCase() :
                              'N/A'
                      }</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={4} xl={4}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Origin</small>
                      <p className='info-data mb-2 space-nowrap'>{this.state.quizModalFlight?.org_stn}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht min-width-80'>
                      <small className='info-title mb-1'>Dest</small>
                      <p className='info-data mb-2'>{this.state.quizModalFlight?.dest_stn}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht min-width-80'>
                      <small className='info-title mb-1'>Aircraft</small>
                      <p className='info-data mb-2'>{this.state.quizModalFlight?.ac_type}</p>
                    </div>
                  </Col>
                  {/* <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht min-width-80'>
                      <small className='info-title mb-1'>Gate</small>
                      <p className='info-data mb-2'>{this.state.quizModalFlight?.dept?.gate || 'N/A'}</p>
                    </div>
                  </Col> */}
                </Row>
              </div>
            </Col>
            {/* send no-ride alert */}
            {this.state.noRideModalType === 'NORIDE' &&
              <Col xs={24} sm={22} offset={1} >
                <Row
                  gutter={[{
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12
                  }, {
                    xs: 24,
                    sm: 24,
                    md: 24,
                    lg: 24
                  },]} className='flight-ctrl'
                >
                  <Col xs={24}>
                    <Row gutter={[12, 12]}>
                      <Col xs={24}>
                        <Row
                          gutter={[{
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12
                          }, {
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12
                          },]} className='flight-ctrl'
                        >
                          <Col xs={24} lg={10} className='d-flex gap-10'>
                            <p>1.</p>
                            <p>In OneSource, were any conveyances staged to No Ride? </p>
                          </Col>
                          <Col flex='120px'>
                            <Select
                              size='small'
                              className='w-100'
                              value={this.state.noRideQts?.onesource}
                              onChange={(e) => this.handleNoRideQtsChange(e, 'onesource')}
                            >
                              <Option value='yes'>Yes</Option>
                              <Option value='no'>No</Option>
                            </Select>
                          </Col>
                        </Row>
                      </Col>
                      {this.state.noRideQts?.onesource === 'yes' &&
                        <Col xs={24}>
                          <Row gutter={[12, 12]}>
                            <Col xs={24} lg={10}>
                              <p>1a. If yes, did you contact the LDD to troubleshoot?</p>
                            </Col>
                            <Col flex='120px'>
                              <Select
                                size='small'
                                className='w-100'
                                value={this.state.noRideQts?.onesource_ldd}
                                onChange={(e) => this.handleNoRideQtsChange(e, 'onesource_ldd')}
                              >
                                <Option value='yes'>Yes</Option>
                                <Option value='no'>No</Option>
                              </Select>
                            </Col>
                            {this.state.noRideQts?.onesource_ldd === 'no' &&
                              <Col flex='auto'>
                                <Input
                                  disabled={this.state.noRideQts?.onesource_ldd !== 'no'}
                                  placeholder='If no, explain why not.'
                                  value={this.state.noRideQts?.onesource_ldd_explain}
                                  onChange={(e) => this.handleNoRideQtsChange(e.target.value, 'onesource_ldd_explain')}
                                />
                              </Col>
                            }
                          </Row>
                        </Col>
                      }
                    </Row>
                  </Col>
                </Row>
              </Col>
            }
            {/* XXX send no-ride alert */}

            {
              this.state.noRideModalType === 'AUDIT' ?
                <Col xs={{
                  span: 24,
                  offset: 0
                }}
                md={{
                  span: 24,
                  offset: 0
                }}
                lg={{
                  span: 22,
                  offset: 1
                }}>
                  <Row
                    gutter={[{
                      xs: 12,
                      sm: 12,
                      md: 12,
                      lg: 12
                    }, {
                      xs: 24,
                      sm: 24,
                      md: 24,
                      lg: 24
                    },]} className='flight-ctrl'
                  >
                    {/* <Col xs={16}>
                    <Form.Item label='1. Optimal Bin Configuration chosen'>
                      <Input placeholder='Enter Configuration' value={this.state.bin_config} onChange={(e) => this.setState({ bin_config: e.target.value })} />
                    </Form.Item>
                  </Col> */}
                    <Col xs={24}>
                      <Row gutter={[12, 12]} className=''>
                        <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                          <p className='d-flex gap-10'>
                            <span>1.</span>
                            <span>Planned Bin Configuration</span>
                          </p>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={10}>
                          <Input placeholder='Ex: 1 PMC, 1 PAG, 1LD3' value={this.state.bin_config} onChange={(e) => this.setState({ bin_config: e.target.value })} />
                        </Col>
                      </Row>
                    </Col>
                    {/* </Row>
                <Row
                  gutter={[{
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12
                  }, {
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 24
                  },]} className='flight-ctrl'
                > */}
                    {/* <Col xs={24}>
                    <Form.Item label='2. Was everything built according to the flight plan ?'> 
                      <Row gutter={16}>
                        <Col xs='4'>
                          <Select
                            size='small'
                            className='w-60'
                            value={this.state.audit_built_right}
                            placeholder={'Select Yes/No'}
                            onChange={(e) => this.setState({
                              audit_built_right: e,
                              audit_reason: null,
                              audit_explain: null
                            })}
                          >
                            <Option value='Yes'>Yes</Option>
                            <Option value='No'>No</Option>
                          </Select>
                        </Col>
                        <Col xs='6'>
                          <Select
                            size='small'
                            className='w-60'
                            value={this.state.audit_reason}
                            placeholder={'Select Reason'}
                            onChange={(e) => this.setState({
                              audit_reason: e,
                              audit_explain: null
                            })}
                            disabled={this.state.audit_built_right !== 'No'}
                          >
                            <Option value='Not tendered'>Not tendered</Option>
                            <Option value='Did not make the cut off time'>Did not make the cut off time</Option>
                            <Option value='Not built by Warehouse'>Not built by Warehouse</Option>
                            <Option value='Damaged'>Damaged</Option>
                            <Option value='On hold'>On hold</Option>
                            <Option value='Other'>Other</Option>
                          </Select>
                        </Col>
                        <Col xs='10'>
                          <Input placeholder='If other, explain' value={this.state.audit_explain} onChange={(e) => this.setState({ audit_explain: e.target.value })}
                            disabled={this.state.audit_built_right === 'Yes' || this.state.audit_reason !== 'Other'}
                          />
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col> */}
                    <Col xs={24}>
                      <Row gutter={[12, 12]} className=''>
                        <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                          <p className='d-flex gap-10'>
                            <span>2.</span>
                            <span> Was everything built according to the flight plan ?</span>
                          </p>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={6} xl={4}>
                          <Select
                            size='small'
                            className='w-100'
                            value={this.state.audit_built_right}
                            placeholder={'Select Yes/No'}
                            onChange={(e) => this.setState({
                              audit_built_right: e,
                              audit_reason: null,
                              audit_explain: null
                            })}
                          >
                            <Option value='Yes'>Yes</Option>
                            <Option value='No'>No</Option>
                          </Select>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                          <Select
                            size='small'
                            className='w-100'
                            value={this.state.audit_reason}
                            placeholder={'Select Reason'}
                            onChange={(e) => this.setState({
                              audit_reason: e,
                              audit_explain: null
                            })}
                            disabled={this.state.audit_built_right !== 'No'}
                          >
                            <Option value='Not tendered'>Not tendered</Option>
                            <Option value='Did not make the cut off time'>Did not make the cut off time</Option>
                            <Option value='Not built by Warehouse'>Not built by Warehouse</Option>
                            <Option value='Damaged'>Damaged</Option>
                            <Option value='On hold'>On hold</Option>
                            <Option value='ULDs not available'>ULDs not available</Option>
                            <Option value='Other'>Other</Option>
                          </Select>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={10} xl={4}>
                          <Input placeholder='If other, explain' value={this.state.audit_explain} onChange={(e) => this.setState({ audit_explain: e.target.value })}
                            disabled={this.state.audit_built_right === 'Yes' || this.state.audit_reason !== 'Other'}
                          />
                        </Col>
                      </Row>
                    </Col>
                    {/* </Row>
                <Row
                  gutter={[{
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12
                  }, {
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 24
                  },]} className='flight-ctrl'
                > */}
                    {/* <Col xs={24}>
                    <Form.Item label='3 Was the Planned Bin Configuration shown as Optimal on the Build Plan ?'>
                      <Row gutter={16}>
                        <Col xs='4'>
                          <Select
                            size='small'
                            className='w-60'
                            value={this.state.audit_was_optimal}
                            placeholder={'Select Yes/No'}
                            onChange={(e) => this.setState({ audit_was_optimal: e })}
                          >
                            <Option value='Yes'>Yes</Option>
                            <Option value='No'>No</Option>
                          </Select>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col> */}
                    <Col xs={24}>
                      <Row gutter={[12, 12]} className=''>
                        <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                          <p className='d-flex gap-10'>
                            <span>3.</span>
                            <span> Was the Planned Bin Configuration shown as Optimal on the Build Plan ?</span>
                          </p>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={4}>
                          <Select
                            size='small'
                            className='w-100'
                            value={this.state.audit_was_optimal}
                            placeholder={'Select Yes/No'}
                            onChange={(e) => this.setState({
                              audit_was_optimal: e,
                              audit_was_optimal_explain: null
                            })}
                          >
                            <Option value='Yes'>Yes</Option>
                            <Option value='No'>No</Option>
                          </Select>
                        </Col>
                        <Col xs={10}>
                          <Input.TextArea
                            disabled={this.state.audit_was_optimal !== 'No'}
                            placeholder='Please explain why Planned Bin Configuration was suboptimal.'
                            value={this.state.audit_was_optimal_explain}
                            onChange={(e) => this.setState({ audit_was_optimal_explain: e.target.value })}
                          />
                        </Col>
                      </Row>
                    </Col>
                    {/* </Row>
                  {/* </Row>
                <Row
                  gutter={[{
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12
                  }, {
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 24
                  },]} className='flight-ctrl'
                > */}
                    {/* <Col xs={24}>
                    <Form.Item label='4 Did all containers meet/exceed chargeable weight goal ?'>
                      <Row gutter={16}>
                        <Col xs='4'>
                          <Select
                            size='small'
                            className='w-60'
                            value={this.state.audit_meet_wgt_goal}
                            placeholder={'Select Yes/No'}
                            onChange={(e) => this.setState({ audit_meet_wgt_goal: e })}
                          >
                            <Option value='Yes'>Yes</Option>
                            <Option value='No'>No</Option>
                          </Select>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col> */}
                    <Col xs={24}>
                      <Row gutter={[12, 12]} className=''>
                        <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                          <p className='d-flex gap-10'>
                            <span>4.</span>
                            <span>Did all containers meet/exceed chargeable weight goal ?</span>
                          </p>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={4}>
                          <Select
                            size='small'
                            className='w-100'
                            value={this.state.audit_meet_wgt_goal}
                            placeholder={'Select Yes/No'}
                            onChange={(e) => this.setState({
                              audit_meet_wgt_goal: e,
                              audit_meet_wgt_goal_explain: null
                            })}
                          >
                            <Option value='Yes'>Yes</Option>
                            <Option value='No'>No</Option>
                          </Select>
                        </Col>
                        <Col flex={'auto'}>
                          <Input.TextArea
                            disabled={this.state.audit_meet_wgt_goal !== 'No'}
                            placeholder='For each suboptimal container, please explain why chargeable weight goal was not met.'
                            value={this.state.audit_meet_wgt_goal_explain}
                            onChange={(e) => this.setState({ audit_meet_wgt_goal_explain: e.target.value })}
                          />
                        </Col>
                        <Col flex='none'>
                          <Tooltip title={'Please click the icon to upload images of all suboptimal containers.'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                            <Button type='ghost'
                              className={`image-btn ${this.state.audit_meet_wgt_goal_conf_fileList && this.state.audit_meet_wgt_goal_conf_fileList.length > 0 ? 'green-fliter' : 'image-btn'}`}
                              icon={<PaperClipOutlined className='paperclip-icon' />}
                              onClick={this.handleUploadOk}
                            >
                            </Button>
                          </Tooltip>
                        </Col>
                      </Row>
                    </Col>
                    {/* </Row>
                <Row
                  gutter={[{
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12
                  }, {
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 24
                  },]} className='flight-ctrl'
                > */}
                    {/* <Col xs={24}>
                    <Form.Item label='5. Upload LoadTrac image(.jpg, .jpeg or .png)'>
                      <div className='scaletbl-img'>
                        <Upload
                          accept='image/jpg,image/jpeg,image/png'
                          fileList={this.state.fileList}
                          maxCount={1} beforeUpload={() => false}
                          onChange={(e) => this.onChangeFileHandler(e)}
                          onRemove={() => this.onRemoveFileHandler()}>
                          <Button type='ghost' className={`image-btn ${this.state.attach_conf ? 'green-fliter' : ''}`} >
                            <img src={download} alt='download' />
                          </Button>
                        </Upload> */}
                    {/* {this.checkType(record)} */}
                    {/* {this.state.previewImg && (<img className='prev-img' src={this.state.previewImg} alt={this.state.previewImg} />)}
                      </div> */}

                    {/* <Input placeholder='Enter Configuration' value={this.state.bin_config} onChange={(e) => this.setState({ bin_config: e.target.value })} /> */}
                    {/* </Form.Item>
                  </Col> */}
                    <Col xs={24}>
                      <Row gutter={[12, 12]} className=''>
                        <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                          <p className='d-flex gap-10'>
                            <span>5.</span>
                            <span>Upload Proposed Build Plan image (.jpg, .jpeg or .png)</span>
                          </p>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={14}>
                          <div className='d-flex'>
                            <Upload
                              accept='image/jpg,image/jpeg,image/png'
                              fileList={this.state.load_trac_conf_fileList}
                              maxCount={1} beforeUpload={() => false}
                              onChange={(e) => this.onChangeFileHandler(e, 'load_trac_conf')}
                              onRemove={() => this.onRemoveFileHandler()}
                              className='upload-name upload-doc-text'>
                              <Button type='ghost' className={`upload-block ${this.state.load_trac_conf_fileList[0]?.lastModifiedDate ? 'green-fliter' : ''}`}
                                icon={<CloudUploadOutlined />}
                              >
                                Upload Document
                              </Button>
                            </Upload>
                            {this.state.load_trac_conf_previewImg && (
                              <>
                                <Tooltip title={'View Attachment'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                                  <Button type='link' className='uploaded-img-btn' onClick={() => this.openPreview('load_trac_conf_previewImg')}>
                                    <InfoCircleOutlined style={{
                                      fontSize: '18px',
                                      color: 'grey'
                                    }} />
                                  </Button>
                                </Tooltip>
                              </>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>

                    <Col xs={24}>
                      <Row gutter={[12, 12]} className=''>
                        <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                          <p className='d-flex gap-10'>
                            <span>6.</span>
                            <span>Upload Build Plan image (.jpg, .jpeg or .png)</span>
                          </p>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={14}>
                          <div className='d-flex'>
                            <Upload
                              accept='image/jpg,image/jpeg,image/png'
                              fileList={this.state.build_plan_conf_fileList}
                              maxCount={1} beforeUpload={() => false}
                              onChange={(e) => this.onChangeFileHandler(e, 'build_plan_conf')}
                              onRemove={() => this.onRemoveFileHandler()}
                              className='upload-name upload-doc-text'>
                              <Button type='ghost' className={`upload-block ${this.state.build_plan_conf_fileList[0]?.lastModifiedDate ? 'green-fliter' : ''}`}
                                icon={<CloudUploadOutlined />}
                              >
                                Upload Document
                              </Button>
                            </Upload>
                            {this.state.build_plan_conf_previewImg && (
                              <>
                                <Tooltip title={'View Attachment'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                                  <Button type='link' className='uploaded-img-btn' onClick={() => this.openPreview('build_plan_conf_previewImg')}>
                                    <InfoCircleOutlined style={{
                                      fontSize: '18px',
                                      color: 'grey'
                                    }} />
                                  </Button>
                                </Tooltip>
                              </>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>

                    <Col xs={24}>
                      <Row gutter={[12, 12]} className=''>
                        <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                          <p className='d-flex gap-10'>
                            <span>7.</span>
                            <span>Upload Weight & Balance Tool image (.jpg, .jpeg or .png)</span>
                          </p>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={14}>
                          <div className='d-flex'>
                            <Upload
                              accept='image/jpg,image/jpeg,image/png'
                              fileList={this.state.wandb_conf_fileList}
                              maxCount={1} beforeUpload={() => false}
                              onChange={(e) => this.onChangeFileHandler(e, 'wandb_conf')}
                              onRemove={() => this.onRemoveFileHandler()}
                              className='upload-name upload-doc-text'>
                              <Button type='ghost' className={`upload-block ${this.state.wandb_conf_fileList[0]?.lastModifiedDate ? 'green-fliter' : ''}`}
                                icon={<CloudUploadOutlined />}
                              >
                                Upload Document
                              </Button>
                            </Upload>
                            {this.state.wandb_conf_previewImg && (
                              <>
                                <Tooltip title={'View Attachment'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                                  <Button type='link' className='uploaded-img-btn' onClick={() => this.openPreview('wandb_conf_previewImg')}>
                                    <InfoCircleOutlined style={{
                                      fontSize: '18px',
                                      color: 'grey'
                                    }} />
                                  </Button>
                                </Tooltip>
                              </>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={24}>
                      <Row gutter={[12, 12]} className=''>
                        <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                          <p className='d-flex gap-10'>
                          </p>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={14}>
                          <div className='d-flex'>
                            <Upload
                              accept='image/jpg,image/jpeg,image/png'
                              fileList={this.state.wandb_conf2_fileList}
                              maxCount={1} beforeUpload={() => false}
                              onChange={(e) => this.onChangeFileHandler(e, 'wandb_conf2')}
                              onRemove={() => this.onRemoveFileHandler()}
                              className='upload-name upload-doc-text'>
                              <Button type='ghost' className={`upload-block ${this.state.wandb_conf2_fileList[0]?.lastModifiedDate ? 'green-fliter' : ''}`}
                                icon={<CloudUploadOutlined />}
                              >
                                Upload Document
                              </Button>
                            </Upload>
                            {this.state.wandb_conf2_previewImg && (
                              <>
                                <Tooltip title={'View Attachment'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                                  <Button type='link' className='uploaded-img-btn' onClick={() => this.openPreview('wandb_conf2_previewImg')}>
                                    <InfoCircleOutlined style={{
                                      fontSize: '18px',
                                      color: 'grey'
                                    }} />
                                  </Button>
                                </Tooltip>
                              </>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={24}>
                      <Row gutter={[12, 12]} className=''>
                        <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                          <p className='d-flex gap-10'>
                            <span>8.</span>
                            <span>Upload OneSource image (.jpg, .jpeg or .png)</span>
                          </p>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={14}>
                          <div className='d-flex'>
                            <Upload
                              accept='image/jpg,image/jpeg,image/png'
                              fileList={this.state.onesource_conf_fileList}
                              maxCount={1} beforeUpload={() => false}
                              onChange={(e) => this.onChangeFileHandler(e, 'onesource_conf')}
                              onRemove={() => this.onRemoveFileHandler()}
                              className='upload-name upload-doc-text'>
                              <Button type='ghost' className={`upload-block ${this.state.onesource_conf_fileList[0]?.lastModifiedDate ? 'green-fliter' : ''}`}
                                icon={<CloudUploadOutlined />}
                              >
                                Upload Document
                              </Button>
                            </Upload>
                            {this.state.onesource_conf_previewImg && (
                              <>
                                <Tooltip title={'View Attachment'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}>
                                  <Button type='link' className='uploaded-img-btn' onClick={() => this.openPreview('onesource_conf_previewImg')} >
                                    <InfoCircleOutlined style={{
                                      fontSize: '18px',
                                      color: 'grey'
                                    }} />
                                  </Button>
                                </Tooltip>
                              </>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    {/* <Col xs={24}>
                    <button className='modal-submit1' onClick={() => this.saveAudit()}>Save Audit</button>
                  </Col> */}
                  </Row>
                </Col>
                : null
            }
            {this.state.noRideModalType === 'AUDIT' ? <Col xs={{
              span: 24,
              offset: 0
            }}
            md={{
              span: 24,
              offset: 0
            }}
            lg={{
              span: 22,
              offset: 1
            }} className='no-ride title-text'>No Ride Alerts Submitted</Col> : ''}
            <Col xs={{
              span: 24,
              offset: 0
            }}
            md={{
              span: 24,
              offset: 0
            }}
            lg={{
              span: 22,
              offset: 1
            }}>
              <div className='d-flex gap-10'>
                <p>{this.state.noRideModalType === 'AUDIT' ? '8.' : '2.'}</p>
                <p>If there were any offloads, please enter them below. </p>
              </div>
              <Row
                gutter={[{
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: 12
                }, {
                  xs: 0,
                  sm: 0,
                  md: 0,
                  xxl: 0
                },]} wrap={true} className={`flight-ctrl noride-cols mb-0 p-0 ${this.state.noRideModalType === 'AUDIT' ? 'mt-0' : ''}`}
              >
                <Col flex={'1 1 150px'} className=''>
                  <Form.Item required label='Container ID/AWB ID' labelCol={{ span: 24 }} colon={false} className='custom-formitem'>
                    <Input placeholder='Container ID' value={this.state.noride_container_id} onChange={(e) => this.setState({
                      noride_container_id: e.target.value,
                      noride_type: e.target.value.substring(0, 3)
                    })} />
                  </Form.Item>
                </Col>
                <Col flex={'1 1 80px'} className=''>
                  <Form.Item required label='Type' labelCol={{ span: 24 }} colon={false} className='custom-formitem'>
                    <Input placeholder='Type' value={this.state.noride_type} onChange={(e) => this.setState({ noride_type: e.target.value })} />
                  </Form.Item>
                </Col>
                <Col flex={'1 1 140px'} className=''>
                  <Form.Item required label='Removed before FPE?' labelCol={{ span: 24 }} colon={false} className='custom-formitem'>
                    <Select
                      size='small'
                      className='w-60'
                      placeholder={'Select Reason'}
                      value={this.state.noride_rmvbfpe}
                      onChange={(e) => this.setState({ noride_rmvbfpe: e })}
                    >
                      <Option value='yes'>Yes</Option>
                      <Option value='no'>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col flex={'1 1 150px'} className=''>
                  <Form.Item required label='Cut Code' labelCol={{ span: 24 }} colon={false} className='custom-formitem'>
                    <Select
                      size='small'
                      className='w-60'
                      value={this.state.noride_cutcode}
                      placeholder={'Select Cut Code'}
                      dropdownClassName='dropdown-options'
                      onChange={(e) => this.setState({
                        noride_cutcode: e,
                        cut_reasons: cut_codes?.find((item) => item?.code === e)?.reasons,
                        noride_cutreason: cut_codes?.find((item) => item?.code === e)?.reasons.length == 1 ?
                          cut_codes?.find((item) => item?.code === e)?.reasons[0] : null,
                        noride_cutby: cut_codes?.find((item) => item?.code === e)?.cutby,
                      })}
                    >
                      {
                        cut_codes?.map((item, index) => (
                          <Option key={index} value={item?.code}>{item?.code}</Option>
                        ))
                      }
                    </Select>
                  </Form.Item>
                </Col>
                <Col flex={'1 1 150px'} className=''>
                  <Form.Item required label='Cut Reason' labelCol={{ span: 24 }} colon={false} className='custom-formitem'>
                    <Select
                      size='small'
                      className='w-60'
                      dropdownClassName='dropdown-options'
                      placeholder={'Select Reason'}
                      value={this.state.noride_cutreason}
                      onChange={(e) => this.setState({ noride_cutreason: e })}
                    >
                      {
                        this.state.cut_reasons?.map((item, index) => (
                          <Option key={index} value={item}>{item}</Option>
                        ))
                      }
                    </Select>
                  </Form.Item>
                </Col>
                <Col flex={'1 1 80px'} className=''>
                  <Form.Item required label='Cut By' labelCol={{ span: 24 }} colon={false} className='custom-formitem'>
                    <Input
                      size='small'
                      className='w-60'
                      value={this.state.noride_cutby}
                      placeholder='Cut By'
                      onChange={(e) => this.setState({ noride_cutby: e.target.value })}
                    />
                    {/* <Select
                    size='small'
                    className='w-60'
                    value={this.state.noride_cutby}
                    placeholder={'Select Cut By'}
                    onChange={(e) => this.setState({ noride_cutby: e })}
                  >
                    <Option value='ALA'>ALA</Option>
                    <Option value='LCC'>LCC</Option>
                    <Option value='LDD'>LDD</Option>
                  </Select> */}
                  </Form.Item>
                </Col>
                <Col flex={'1 1 150px'} className=''>
                  <Form.Item label='Comments' labelCol={{ span: 24 }} colon={false} className='custom-formitem'>
                    <Input placeholder='Comments' value={this.state.noride_comment} onChange={(e) => this.setState({ noride_comment: e.target.value })} />
                  </Form.Item>
                </Col>
                <Col flex={'104px'} className='text-center p-0'>
                  <label className='custom-label'>Attachment</label>
                  <div className='scaletbl-img'>
                    <Upload
                      accept='image/jpg,image/jpeg,image/png'
                      fileList={this.state.noride_fileList}
                      maxCount={1} beforeUpload={() => false}
                      onChange={(e) => this.onChangeFileHandler(e, 'noride')}
                      onRemove={() => this.onRemoveFileHandler()}
                      className='upload-name'
                    >
                      <Button type='ghost' className={`image-btn ${this.state.noride_attach_conf ? 'green-fliter' : ''}`} >
                        <img src={download} alt='download' />
                      </Button>
                    </Upload>
                  </div>
                </Col>
                <Col flex={'30px'} className='plus-btn pl-0'>
                  {/* <button className='modal-submit1 noride-btn' onClick={() => this.addNoRide()}>Add </button> */}
                  <label className='custom-label transparent'>-</label>
                  <Button type='ghost' className='ml-auto image-btn' onClick={() => this.addNoRide()}>
                    <Tooltip title={'Add'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                  </Button>
                </Col>
                {/* <Col flex='44px' className='text-center ml-auto p-0'>
                    <label className='custom-label transparent'>-</label>
                    <Button type='ghost' className='ml-auto image-btn' onClick={() => this.submit('add')}>
                      <Tooltip title={this.state.isEdit ? 'Update' : 'Add'} overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}><img src={addIcon} alt='add' /></Tooltip>
                    </Button>
                  </Col> */}
              </Row>
            </Col>

            <Col xs={24}>
              <Row gutter={[{
                xs: 12,
                sm: 12,
              }, {
                xs: 12,
                sm: 12,
                md: 24,
                lg: 24
              },]}
              >
                {/* <Col xs={24} sm={24} md={24} lg={24} xl={24} className='table-overflow'>
              <div style={{ 
                display:'flex',
                justifyContent: 'flex-end'
              }}>
                <button className='modal-submit'> Add Rows </button>
                <button className='modal-submit'> Clear Table </button>
              </div>   
              <div className='table-outer'>
                <Table
                  className='custom-table w-100 multi-head  checklist-table'
                  dataSource={noRideData}
                  columns={noRideCols}
                  pagination={false}
                />
              </div>
            </Col> */}
                {
                  this.state.questionsData?.map((item, index) => (
                    (item.parent_id && item.showchild === false) ? (
                      null
                    ) : (
                      <>
                        <Col xs={7}>
                          <p className='questions d-flex gap-10'>
                            <span>{`${index + 1}.`}</span>
                            <span>{`${item.details.question}`}</span></p>
                        </Col>
                        {
                          item.details.attachment === 'Yes' &&
                          <Col xs={2}>
                            <div className='scaletbl-img d-flex'>
                              <Upload
                                accept='image/jpg,image/jpeg,image/png'
                                fileList={item.answer_attach_data}
                                maxCount={1} beforeUpload={() => false}
                                onChange={(e) => this.handleAnswerAttachment(e, index, 'add')}
                                onRemove={(e) => this.handleAnswerAttachment(e, index, 'remove')}
                                className='upload-name'>
                                <Button type='ghost' className={`image-btn ${item.answer_attach_conf ? 'green-fliter' : ''}`}>
                                  <img src={download} alt='download' />
                                </Button>
                              </Upload>
                            </div>
                          </Col>
                        }
                        <Col xs={6}>
                          {
                            item.details.type === 'yes/no' ?
                              <Select
                                size='small'
                                className='w-60'
                                value={item?.answer}
                                onChange={(e) => this.handleAnswers(e, index)}
                              >
                                <Option value='Yes'>Yes</Option>
                                <Option value='No'>No</Option>
                                <Option value='N/A'>N/A</Option>
                              </Select> :
                              item.details.type === 'other' ?
                                <Input.TextArea placeholder='Provide details' value={item?.answer} onChange={(e) => this.handleAnswers(e, index)} /> :
                                item.details.type === 'mcq' ?
                                  <Select
                                    size='small'
                                    className='w-60'
                                    value={item?.answer}
                                    onChange={(e) => this.handleAnswers(e, index)}
                                  >
                                    {item.details.options?.map((option, index) => <Option key={index} value={option.name}>{option.name}</Option>)}
                                  </Select>
                                  : null
                          }
                        </Col>
                        <Col xs={8}>
                          {
                            item.details.info ?
                              <>
                                <ExclamationCircleOutlined style={{ color: '#eaaa00' }} />
                                <span className='info-text'>{item.details.info}</span>
                              </>
                              : null
                          }
                          {
                            item.details.type === 'yes/no' && item.details.comment && item.details.comment === item.answer ?
                              <>
                                <Input.TextArea placeholder='If no, provide details' value={item?.comment} onChange={(e) => this.handleComment(e, index)} />
                              </>
                              : null
                          }
                        </Col>
                      </>
                    )
                  ))
                }
              </Row>
            </Col>
            <Col xs={{
              span: 24,
              offset: 0
            }}
            md={{
              span: 24,
              offset: 0
            }}
            lg={{
              span: 22,
              offset: 1
            }} className='table-overflow'>
              <div className='table-outer'>
                <Table
                  className='custom-table w-100 checklist-table'
                  dataSource={this.state.norideData}
                  columns={noridecols}
                  pagination={false}
                />
              </div>
            </Col>

            {
              this.state.noRideModalType === 'NORIDE' ?
                <>
                  <Col xs={{
                    span: 24,
                    offset: 0
                  }}
                  md={{
                    span: 24,
                    offset: 0
                  }}
                  lg={{
                    span: 22,
                    offset: 1
                  }}>
                    <Row gutter={[12, 12]} className='flight-ctrl'>
                      <Col xs={24} lg={8} className='d-flex gap-10'>
                        <p>3.</p>
                        <p>For each offloaded shipment, was it rebooked and reassigned according to Reprioritization Matrix? </p>
                      </Col>
                      <Col flex='50px'>
                        <Button type='link' className='redirect-icon' icon={<img src={RedirectIcon} alt='redirect' width={14} />}
                          onClick={() => window.open('https://deltaairlines.sharepoint.com/:b:/r/sites/DL003345/Shared%20Documents/Rebook%20and%20Reassign%20Policy%20and%20Procedure%2020241113.pdf?csf=1&web=1&e=9N38fV', '_blank')}
                        />
                      </Col>
                      <Col flex='120px'>
                        <Select
                          size='small'
                          className='w-100'
                          value={this.state.noRideQts?.offloaded_shipment}
                          onChange={(e) => this.handleNoRideQtsChange(e, 'offloaded_shipment')}
                        >
                          <Option value='yes'>Yes</Option>
                          <Option value='no'>No</Option>
                        </Select>
                      </Col>
                      {this.state.noRideQts?.offloaded_shipment === 'no' &&
                        <Col flex='auto'>
                          <Input
                            placeholder='If no, explain why not.'
                            value={this.state.noRideQts?.offloaded_shipment_explain}
                            onChange={(e) => this.handleNoRideQtsChange(e.target.value, 'offloaded_shipment_explain')}
                          />
                        </Col>
                      }
                    </Row>
                  </Col>
                  {this.state.norideData &&
                    this.state.norideData.filter((item) => (
                      item.cut_code?.includes('36U Aircraft Mechanical')
                    )).length >= 3 ?
                    <Col xs={{
                      span: 24,
                      offset: 0
                    }}
                    md={{
                      span: 24,
                      offset: 0
                    }}
                    lg={{
                      span: 22,
                      offset: 1
                    }}>
                      <Row
                        gutter={[12, 12]} className='flight-ctrl'
                      >
                        <Col xs={24} lg={10} className='d-flex gap-10'>
                          <p>4.</p>
                          <p>Please confirm ship number. </p>
                        </Col>
                        <Col flex='120px'>
                          <Input
                            placeholder='Enter ship number'
                            value={this.state.noRideQts?.ship_number}
                            onChange={(e) => this.handleNoRideQtsChange(e.target.value, 'ship_number')}
                          />
                        </Col>
                      </Row>
                    </Col>
                    : null
                  }</> : null
            }
            <Col xs={{
              span: 24,
              offset: 0
            }}
            md={{
              span: 24,
              offset: 0
            }}
            lg={{
              span: 22,
              offset: 1
            }}>
              <Row gutter={[12, 12]}>
                <Col xs={9}>
                  <p>Completed By: </p>
                </Col>
                <Col xs={6}>
                  <Input
                    size='small'
                    value={this.state.completedBy}
                    className='completed-by-input'
                    placeholder='Name'
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal>
        <Modal
          title='LDD Communication'
          open={this.state.openLDDModal}
          closable={true}
          onCancel={() => this.setState({
            openLDDModal: false,
            // quizMilestonid: null,
            // quizModalFlight: null,
            // questionsData: this.state.tempquestionsData,
          })}
          footer={<>
            <div className='noride-submit'>
              <button className='modal-submit1 submit' onClick={() => this.saveLDD()}>{this.state.quizModalFlight?.ldd ? 'Resubmit' : 'Submit'}</button>
              <button className='modal-submit1' onClick={() => this.setState({ openLDDModal: false })}> Close  </button>
            </div>
          </>
          }
          width={'60%'}
          centered
          className='custom-modal pb-0 audit-modal'
        >
          <Col xs={24} sm={24} md={24} lg={24} xl={24} >
            <Col className='cargo-cap-card'>
              <div>
                <Row gutter={[{
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: 24
                }, {
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: 24
                },]} className='flight-ctrl'
                >
                  <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Flight Number</small>
                      <p className={this.state.editRecord?.ac_type === '75D' ? 'new-ac' : 'info-data mb-2'}>{this.state.quizModalFlight?.flight_no}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Flight Date</small>
                      <p className='info-data mb-2'>{
                        this.state.quizModalFlight?.flight_date ? moment(this.checkFlightDate(this.state.quizModalFlight)).format('DD/MM/YYYY') :
                          this.state.quizModalFlight?.dept_date ? moment.utc(this.state.quizModalFlight?.dept_date).tz(this.state.timezone).format('DD/MM/YYYY')?.toUpperCase() :
                            this.state.quizModalFlight?.schdl ? moment.tz(this.state.quizModalFlight?.schdl, this.state.timezone).format('DD/MM/YYYY')?.toUpperCase() :
                              'N/A'
                      }</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={4} xl={4}>
                    <div className='recd-ht'>
                      <small className='info-title mb-1'>Origin</small>
                      <p className='info-data mb-2 space-nowrap'>{this.state.quizModalFlight?.org_stn}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht min-width-80'>
                      <small className='info-title mb-1'>Dest</small>
                      <p className='info-data mb-2'>{this.state.quizModalFlight?.dest_stn}</p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={5} xl={5}>
                    <div className='recd-ht min-width-80'>
                      <small className='info-title mb-1'>Gate</small>
                      <p className='info-data mb-2'>{this.state.quizModalFlight?.dept?.gate || 'N/A'}</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Col>

          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='audit-quiz' >
            <Row
              gutter={[{
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12
              }, {
                xs: 24,
                sm: 24,
                md: 36,
                lg: 42
              },]} className='flight-ctrl'
            >
              <Col xs={24}>
                <Row gutter={[12, 12]} className=''>
                  <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                    <p className='d-flex gap-10'>
                      <span>1.</span>
                      <span>In LoadTrac, were the Cargo pallets (PMC,PAG) paired?</span>
                    </p>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={10}>
                    <Select
                      size='small'
                      className='w-100'
                      value={this.state.pallets_paired}
                      placeholder={'Select Yes/No'}
                      onChange={(e) => this.setState({
                        pallets_paired: e,
                        pallets_paired_contact: null,
                        pallets_paired_explain: null
                      })}
                    >
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Col>
                </Row>
              </Col>
              <Col xs={24}>
                <Row gutter={[12, 12]} className=''>
                  <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                    <p className='d-flex gap-10'>
                      <span>1a.</span>
                      <span> If no, did you contact the LDD to recommend pairing the pallets ?</span>
                    </p>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={6} xl={4}>
                    <Select
                      size='small'
                      className='w-100'
                      value={this.state.pallets_paired_contact}
                      placeholder={'Select Yes/No'}
                      disabled={this.state.pallets_paired !== 'No'}
                      onChange={(e) => this.setState({
                        pallets_paired_contact: e,
                        pallets_paired_explain: null
                      })}
                    >
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                    <Input placeholder='If no, explain why not'
                      disabled={this.state.pallets_paired_contact !== 'No'}
                      value={this.state.pallets_paired_explain}
                      onChange={(e) => this.setState({ pallets_paired_explain: e.target.value })}
                    />
                  </Col>
                </Row>
              </Col>


              <Col xs={24}>
                <Row gutter={[12, 12]} className=''>
                  <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                    <p className='d-flex gap-10'>
                      <span>2.</span>
                      <span>In LoadTrac, were and conyeyances staged to No Ride?</span>
                    </p>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={10}>
                    <Select
                      size='small'
                      className='w-100'
                      value={this.state.conveyances_staged}
                      placeholder={'Select Yes/No'}
                      onChange={(e) => this.setState({
                        conveyances_staged: e,
                        conveyances_staged_contact: null,
                        conveyances_staged_explain: null,
                      })}
                    >
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Col>
                </Row>
              </Col>
              <Col xs={24}>
                <Row gutter={[12, 12]} className=''>
                  <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                    <p className='d-flex gap-10'>
                      <span>2a.</span>
                      <span> If yes, did you contact the LDD to troubleshoot?</span>
                    </p>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={6} xl={4}>
                    <Select
                      size='small'
                      className='w-100'
                      value={this.state.conveyances_staged_contact}
                      placeholder={'Select Yes/No'}
                      disabled={this.state.conveyances_staged !== 'Yes'}
                      onChange={(e) => this.setState({
                        conveyances_staged_contact: e,
                        conveyances_staged_explain: null,
                      })}
                    >
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                    <Input placeholder='If no, explain why not'
                      disabled={this.state.conveyances_staged_contact !== 'No'}
                      value={this.state.conveyances_staged_explain}
                      onChange={(e) => this.setState({ conveyances_staged_explain: e.target.value })}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>

          <Row gutter={[{
            xs: 12,
            sm: 12,
            md: -140,
            lg: -140
          }, {
            xs: 12,
            sm: 12,
            md: 25,
            lg: 50
          },]}
          className='modal-row1'>
            {
              this.state.questionsData?.map((item, index) => (
                (item.parent_id && item.showchild === false) ? (
                  null
                ) : (
                  <>
                    <Col xs={7}>
                      <p className='questions d-flex gap-10'>
                        <span>{`${index + 1}.`}</span>
                        <span>{`${item.details.question}`}</span></p>
                    </Col>
                    {
                      item.details.attachment === 'Yes' &&
                      <Col xs={2}>
                        <div className='scaletbl-img d-flex'>
                          <Upload
                            accept='image/jpg,image/jpeg,image/png'
                            fileList={item.answer_attach_data}
                            maxCount={1} beforeUpload={() => false}
                            onChange={(e) => this.handleAnswerAttachment(e, index, 'add')}
                            onRemove={(e) => this.handleAnswerAttachment(e, index, 'remove')}
                            className='upload-name'>
                            <Button type='ghost' className={`image-btn ${item.answer_attach_conf ? 'green-fliter' : ''}`}>
                              <img src={download} alt='download' />
                            </Button>
                          </Upload>
                        </div>
                      </Col>
                    }
                    <Col xs={6}>
                      {
                        item.details.type === 'yes/no' ?
                          <Select
                            size='small'
                            className='w-60'
                            value={item?.answer}
                            onChange={(e) => this.handleAnswers(e, index)}
                          >
                            <Option value='Yes'>Yes</Option>
                            <Option value='No'>No</Option>
                            <Option value='N/A'>N/A</Option>
                          </Select> :
                          item.details.type === 'other' ?
                            <Input.TextArea placeholder='Provide details' value={item?.answer} onChange={(e) => this.handleAnswers(e, index)} /> :
                            item.details.type === 'mcq' ?
                              <Select
                                size='small'
                                className='w-60'
                                value={item?.answer}
                                onChange={(e) => this.handleAnswers(e, index)}
                              >
                                {item.details.options?.map((option, index) => <Option key={index} value={option.name}>{option.name}</Option>)}
                              </Select>
                              : null
                      }
                    </Col>
                    <Col xs={8}>
                      {
                        item.details.info ?
                          <>
                            <ExclamationCircleOutlined style={{ color: '#eaaa00' }} />
                            <span className='info-text'>{item.details.info}</span>
                          </>
                          : null
                      }
                      {
                        item.details.type === 'yes/no' && item.details.comment && item.details.comment === item.answer ?
                          <>
                            <Input.TextArea placeholder='If no, provide details' value={item?.comment} onChange={(e) => this.handleComment(e, index)} />
                          </>
                          : null
                      }
                    </Col>
                  </>
                )
              ))
            }
            <Row gutter={[{
              xs: 12,
              sm: 12,
              md: -140,
              lg: -140
            }, {
              xs: 12,
              sm: 12,
              md: 25,
              xl: 50
            },]}
            className='modal-row1'>
              <Col xs={12} className='mt-3'>
                <label className='custom-label'>Completed By:</label>
                <Input
                  size='small'
                  value={this.state.completedBy}
                  className='completed-by-input'
                  disabled
                />
              </Col>
            </Row>
          </Row>
        </Modal>
        <Modal
          title={
            <>
              <div className='mb-2'>Assign to ULD</div>
              <Row gitter={[12, 12]}>
                <Col xs={6} className='awb-block'>
                  <span className='awb-block-label mr-2'>AWB:</span>
                  <span className='awb-block-data'>{this.state.flightDetails?.awb_no}</span>
                </Col>

                <Col xs={4} className='awb-block'>
                  <span className='awb-block-label mr-2'>Org:</span>
                  <span className='awb-block-data'>{this.state.flightDetails?.org}</span>
                </Col>
                <Col xs={4} className='awb-block'>
                  <span className='awb-block-label mr-2'>Dest:</span>
                  <span className='awb-block-data'>{this.state.flightDetails?.dest}</span>
                </Col>
              </Row>
            </>
          }
          open={this.state.addULD}
          closable={true}
          onCancel={() => this.setState({
            addULD: false,
            assignUld: {}
          })}
          footer={false}
          width={'50%'}
          centered
          className='custom-modal pb-0'
          zIndex={1001}
        >
          {/* // assignuld */}
          <div className='awb-section'>
            <p className='remaining-awb-title'>Remaining AWB</p>
            <Row gutter={[{
              xs: 12,
              sm: 12,
              md: 24,
              lg: 24
            }, {
              xs: 12,
              sm: 12,
              md: 24,
              lg: 24
            },]} >
              <Col xs={8} className=''>
                <div className='awb-card'>
                  <p className='awb-card-title mb-0'> Pieces </p>
                  <p className='awb-card-data mb-0'>{this.state.flightDetails?.pcs - (this.state?.editRecord?.build_plan.find((item) => item.awb_no === this.state.flightDetails?.awb_no)?.data?.blk || 0) - this.state.assignedUldsData?.map(item => item.pcs).reduce((prev, curr) => Number(prev) + Number(curr), 0)}</p>
                </div>
              </Col>
              <Col xs={8} className=''>
                <div className='awb-card'>
                  <p className='awb-card-title mb-0'> Weight {this.state?.editWgtUnit === 'KG' ? '(KG)' : '(LB)'} </p>
                  <p className='awb-card-data mb-0'>{getRemaingWgt(this.state.flightDetails)}</p>
                </div>
              </Col>
              <Col xs={8} className=''>
                <div className='awb-card'>
                  <p className='awb-card-title mb-0'> Volume {this.state?.editWgtUnit === 'KG' ? '(CBM)' : '(CBF)'} </p>
                  <p className='awb-card-data mb-0'>{getRemaingVol(this.state.flightDetails)}</p>
                </div>
              </Col>
            </Row>
          </div>
          <Row className='select-uld-wrapper'>
            <Col xs={24} className='mb-2'>
              <p className='remaining-awb-title'>Select ULD to assign AWB</p>
            </Col>
            <Col xs={24} className=''>
              <Slider {...settings} className='custom-slider mb-24px'>
                {(() => 
                {
                  let yellow_flag = false
                  let bpIndex = this.state.editRecord?.build_plan?.findIndex(item => item.awb_no === this.state.flightDetails?.awb_no)
                  if(bpIndex > -1){
                    if(this.state.editRecord?.build_plan[bpIndex]?.data.blk > 0){
                      yellow_flag = true
                    }
                  }

                  return <div key={99} className={`tabs tab-indicator ${this.state.assignUld.id == 0 ? 'active-tab' : ''} ${yellow_flag ? 'yellow-star' : ''}`} onClick={() => this.handleAssignUldChange({
                    target: {
                      name: 'id',
                      value: 0,
                    }
                  })}>
                    <span>BULK</span>
                  </div>
                })()}
                {this.state.editRecord?.build_uld?.map((option, i) => {
                  let yellow_flag = false
                  let wgt = 0
                  let org_dest = this.state.editRecord?.org_stn + this.state.editRecord?.dest_stn
                  let goal = ch_wt_goals.find((item) => item.lane == org_dest)
                  if (this.state.editRecord && this.state.editRecord?.build_plan && this.state.editRecord?.build_plan?.length > 0) {
                    this.state.editRecord?.build_plan?.map((item) => {
                      if (item?.ulds && item?.ulds?.length > 0) {
                        item?.ulds?.map((uld) => {
                          if (uld.id && uld.id == option.id) {
                            wgt = wgt + (uld?.ch_wgt || 0)
                            if(item.awb_no == this.state.flightDetails?.awb_no){
                              if(uld.id == option.id){
                                yellow_flag = true
                              }
                            }
                          }
                        })
                      }
                    })
                  }
                  let classname = ''
                  if (wgt) {
                    if (goal) {
                      if (parseFloat(goal?.lbs) <= (wgt / option?.data?.ld3)) {
                        classname = 'green-tab'
                      } else {
                        classname = 'red-tab'
                      }
                    }
                  }

                  return <div key={i} className={`tabs uld-tabs tab-indicator ${this.state.assignUld.id == option.id ? 'active-tab' : ''} ${classname} ${yellow_flag ? 'yellow-star' : ''}`} onClick={() => this.handleAssignUldChange({
                    target: {
                      name: 'id',
                      value: option.id
                    }
                  })}>
                    <span>{option.type + ' ' + (option.uld_no || '')}</span>
                  </div>
                })}
              </Slider>
            </Col>
            {this.state.assignUld?.id > -1 && this.state.editWgtUnit &&
              <Col xs={24} className=''>
                <Table
                  className='custom-table w-100 ex-tabl buildup-table nested'
                  dataSource={this.showAwbs(this.state.assignUld?.id == 0 ? {
                    id: 0,
                    type: 'BULK'
                  } : this.state.editRecord?.build_uld?.find(uld => uld.id === this.state.assignUld.id), this.state.editRecord?.build_plan || [])}
                  columns={CardAwbColumns}
                  summary={(record) => {
                    let data = this.showAwbs(this.state.assignUld?.id == 0 ? {
                      id: 0,
                      type: 'BULK'
                    } : this.state.editRecord?.build_uld?.find(uld => uld.id === this.state.assignUld.id), this.state.editRecord?.build_plan || [])

                    let wgt = 0
                    let vol = 0
                    data.map(item => {
                      wgt += Number(this.state.editWgtUnit === 'KG' ? this.updateWeightVal('KG', item?.wgt) : item?.wgt)
                      vol += Number(this.state.editWgtUnit === 'KG' ? item?.vol : volumnCalculator(item?.vol, 'CBM'))
                    })

                    return record.length > 0 && <Table.Summary fixed>
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                        <Table.Summary.Cell index={1}>{data.map(item => item.pcs).reduce((prev, curr) => Number(prev) + Number(curr), 0)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>{Math.round(wgt)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>{this.state.editWgtUnit === 'KG' ? (Math.round(vol * 10) / 10) : Math.round(vol)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={4}></Table.Summary.Cell>
                      </Table.Summary.Row>
                    </Table.Summary>
                  }}
                  pagination={false}
                // rowKey={this.state.editRecord.id}
                />
              </Col>
            }
          </Row>
          <Row gutter={[{
            xs: 0,
            sm: 0,
            md: 8,
            lg: 8
          }, {
            xs: 8,
            sm: 8,
            md: 8,
            lg: 8
          },]} className='with-table'>
            <Col xs={24} className='mt-4'>
              <p className='remaining-awb-title'>Assign AWB Details</p>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className=''>
              <Form
                ref={this.assignUldFormRef}
                layout='vertical'
                className='position-relative'
                onFinish={() => this.submitAssignUld()}
              >
                <Row
                  gutter={[{
                    xs: 24,
                    sm: 24,
                    md: 24,
                    lg: 24
                  }, {
                    xs: 0,
                    sm: 0,
                    md: 0,
                    lg: 0
                  },]} >
                  {/* <Col xs={24} sm={24} md={24} lg={6} xl={4} xxl={4} className=''>
                    <Form.Item label='Uld No.'>
                      <Select
                        size='small'
                        className='w-60'
                        value={this.state.assignUld.uld_no}
                        onChange={(e) => this.handleAssignUldChange({
                          target:{
                            name: 'uld_no',
                            value: e
                          } 
                        })}
                        // popupClassName='mcq-popup other-popup'
                      >
                        {this.state.editRecord?.build_uld?.map((option, index) => <Option key={index} value={option.uld_no}>{option.uld_no}</Option>)}
                      </Select>
                    </Form.Item>
                  </Col> */}
                  <Col xs={24} sm={24} md={12} lg={7} xl={7} className=''>
                    <Form.Item
                      label='Awb Pcs'
                      name='pcs'
                      rules={[{
                        required: true,
                        message: 'Please enter pieces'
                      }]}
                    >
                      <Input
                        size='small'
                        placeholder=''
                        name='pcs'
                        value={this.state.assignUld?.pcs}
                        onChange={(e) => this.handleAssignUldChange(e)}
                      />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} sm={24} md={24} lg={6} xl={4} xxl={4} className=''>
                    <Form.Item label='Remarks/Pri#'>
                      <Input
                        size='small'
                        placeholder=''
                        name='remark'
                        value={this.state.assignUld.remark}
                        onChange={(e) => this.handleAssignUldChange(e)}

                      />
                    </Form.Item>
                  </Col> */}
                  <Col xs={24} sm={24} md={12} lg={6} xl={6} className=''>
                    <Form.Item
                      label={`Est. GrWt(${this.state?.editWgtUnit === 'KG' ? 'kg' : 'lbs'})`}
                      // name='wgt'
                      rules={[{
                        required: true,
                        message: 'Please enter weight'
                      }]}
                    >
                      <Input
                        size='small'
                        placeholder=''
                        name='wgt'
                        value={this.state.assignUld?.wgt}
                        onChange={(e) => this.handleAssignUldChange(e)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={6} xl={6} className=''>
                    <Form.Item
                      label={`Est. GrVol(${this.state?.editWgtUnit === 'KG' ? 'cbm' : 'cbf'})`}
                      // name='vol'
                      rules={[{
                        required: true,
                        message: 'Please enter volume'
                      }]}
                    >
                      <Input
                        size='small'
                        placeholder=''
                        name='vol'
                        value={this.state.assignUld?.vol}
                        onChange={(e) => this.handleAssignUldChange(e)}
                      />
                    </Form.Item>
                  </Col>
                  <Col flex='none' className='text-center ml-auto pl-0 assign-uld-btn-col'>
                    <Space size='middle'>
                      <Button type='primary' htmlType='submit' className='ml-auto custom-button'>
                        Add
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Modal>
        <Modal
          title={this.state.flightModalType === 'ADD' ? 'Add New Flight' : 'Edit Flight'}
          open={this.state.showFlightModal}
          closable={true}
          onCancel={() => this.setState({
            flightModalType: 'ADD',
            showFlightModal: false,
            flight_no: null,
            flight_date: null,
            dept_time: moment().startOf('day'),
            arr_time: moment().startOf('day'),
            org_stn: cookies.get('station'),
            dest_stn: null,
            aircrafttype: null,
            ack1: false,
            ack2: false,
          })}
          footer={[
            <>
              <Space size={[24, 0]} >
                {/* <div>
                  <Checkbox className='modal-checkbox' />
                  <label> I acknowledge that the above information is correct</label>
                </div>
                <div>
                  <Checkbox className='modal-checkbox' />
                  <label>I acknowledge that the flight does not already appear in command</label>
                </div> */}

                <button className='modal-submit' onClick={
                  this.state.flightModalType === 'EDIT' ? this.putFlight : this.addFlight
                } disabled={!this.state.ack1 || !this.state.ack2 ? true : false}>Submit </button>
              </Space>
            </>
          ]}
          width={'850px'}
          centered
          className='custom-modal pb-0'
        >
          {/* <Spin spinning={this.state.skeletonLoad}> */}
          <Card className='modal-card'>
            <Row
              gutter={[24, 12]}
              className='with-table add-flight-details'
            >
              <Col xs={6} className='fields'>
                <label className='card-text' >Flight Number</label>
                <Input
                  size='small'
                  placeholder=''
                  onChange={(e) => this.setState({ flight_no: e.target.value })}
                  value={this.state.flight_no}
                />
              </Col>
              <Col xs={6} className='fields'>
                <label className='card-text'>Flight Date</label>
                <DatePicker
                  min={0}
                  precision={0}
                  controls={false}
                  size='small'
                  placeholder=''
                  value={this.state.flight_date || ''}
                  onChange={(e) => this.setState({ flight_date: e })}
                />
              </Col>

              <Col xs={6} className='fields'>
                <label className='card-text'>Origin</label>
                {/* <Select
                  onChange={(e) => this.setState({ org_stn: e })}
                  value={this.state.org_stn}
                >
                  {
                    org_stations?.map((item, index) => ( <Option key={index} value={item.value}>{item.label}</Option>))
                  }
                </Select> */}
                <Input className='card-text' value={this.state.org_stn} disabled />
              </Col>
              <Col xs={6} className='fields'>
                <label className='card-text'>Dest</label>
                <Input
                  size='small'
                  placeholder=''
                  onChange={(e) => this.setState({ dest_stn: e.target.value })}
                  value={this.state.dest_stn}
                />
              </Col>
              <Col xs={6} className='fields'>
                <label className='card-text'>Ac Type</label>
                <Select
                  value={this.state.aircrafttype}
                  size='small'
                  // placeholder='Sort By'
                  className='text-center w-100'
                  onChange={(e) => this.setState({ aircrafttype: e })}
                >
                  {this.state.fleetData?.map((option, index) => <Option key={index} value={option.details?.ac_code}>{option.details?.ac_code}</Option>)}
                </Select>
                {/* <Input
                  size='small'
                  placeholder=''
                  onChange={(e) => this.setState({ aircrafttype: e.target.value })}
                  value={this.state.aircrafttype}
                /> */}
              </Col>
              <Col xs={6} className='fields'>
                <label className='card-text'>Schd dept time(Local)</label>
                <TimePicker
                  format='HH:mm'
                  allowClear={false}
                  onChange={(moment) => this.setState({ dept_time: moment })}
                  value={moment(this.state.dept_time, timeFormat)}
                />
              </Col>
              <Col xs={6} className='fields'>
                <label className='card-text'>Schd arriv time(Local)</label>
                <TimePicker
                  format='HH:mm'
                  allowClear={false}
                  onChange={(moment) => this.setState({ arr_time: moment })}
                  value={moment(this.state.arr_time, timeFormat)}
                />
              </Col>
              <Col xs={6} className='add-flight-info'>
                <Tooltip
                  title='Note: FPE does not change for delayed flights. FPE is always based on original scheduled departure time'
                  overlayInnerStyle={{ fontSize: cssconstants.Tooltipfs }}
                  placement='right'
                >
                  <ExclamationCircleOutlined style={{ color: '#eaaa00' }} />
                </Tooltip>
              </Col>
            </Row>
          </Card>
          <div className='info-section'>
            <Row gutter={[12]} justify={'space-between'}>
              <Col flex='none'>
                <Checkbox className='ack-checkbox' checked={this.state.ack1} onChange={(e) => this.setState({ ack1: e.target.checked })}>
                  I acknowledge that the above information is correct</Checkbox>
              </Col>
              <Col flex='none'>
                <Checkbox className='ack-checkbox' checked={this.state.ack2} onChange={(e) => this.setState({ ack2: e.target.checked })}>
                  I acknowledge that the flight does not already appear in command center</Checkbox>
              </Col>
            </Row>
          </div>

          {/* <Row className='modal-row' xs={24}>
            <Form layout='inline' > */}
          {/*               
                <div className='info-item'>
                  <ExclamationCircleOutlined style={{ color: '#eaaa00' }} />
                  <p className='info-text'>Text</p>
                </div>
         */}
          {/* <Form.Item label='I acknowledge that the above information is correct'>
                <Checkbox className='modal-checkbox' />
              </Form.Item>
              <Form.Item label='I acknowledge that the flight does not already appear in command'>
                <Checkbox className='modal-checkbox' />
              </Form.Item>
              <Form.Item> 
                <button className='modal-submit'>Submit </button>
              </Form.Item>
            </Form>
          </Row> */}
          {/* <Space className='info-section'>
            <ExclamationCircleOutlined style={{ color: '#eaaa00' }} />
            <p className='info-text'>Note: FPE does not change for delayed flights. FPE is always based on original scheduled departure time</p>
          </Space> */}
        </Modal>
        <Modal
          width={'60%'}
          closable
          //maskClosable= {false}
          destroyOnClose
          footer={null}
          centered
          open={this.state.flightAuditImg}
          onCancel={() => this.setState({ flightAuditImg: false })}
          className='preview-modal'
        >
          {this.state.previewType ? this.state[this.state.previewType] && (<img className='prev-img' src={this.state[this.state.previewType]} alt={this.state.previewType} />) : null}
        </Modal>
        <Modal
          width={400}
          closable
          //maskClosable= {false}
          destroyOnClose
          footer={null}
          centered
          open={this.state.isModalVisible}
          onCancel={() => { this.setState({ previewImgNoRide: false }, () => this.setState({ isModalVisible: false })) }}
          className='preview-modal'
        >
          {this.state.previewImgNoRide && (<img className='prev-img' src={this.state.previewImgNoRide.path} alt={this.state.previewImgNoRide.name} />)}
        </Modal>
        {this.state.isUploadModalOpen &&
          <Modal
            title='Attachment'
            closable={{ 'aria-label': 'Custom Close Button' }}
            open={this.state.isUploadModalOpen}
            width={'40%'}
            //  onOk={this.handleUploadOk}
            onCancel={this.handleUploadClose}
            footer={<>
              <Space size='middle' align='end' className=''>
                {/* <Button className='wnb-footer-button mr-2' > Save Changes  </Button>
                <Button className='wnb-footer-button mr-2' > Save and Exit  </Button> */}
                <Button className='wnb-footer-button mr-2' onClick={this.handleUploadClose} > Close  </Button>
              </Space>
            </>
            }
          >
            <p>Please name all files with the ULD ID (e.g., PMC12345DL.png).</p>
            <Upload
              accept='image/jpg,image/jpeg,image/png'
              //  action='https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload'
              action=''
              listType='picture-card'
              fileList={this.state.audit_meet_wgt_goal_conf_fileList}
              onPreview={this.handlePreview}
              onChange={this.handleChange}
              multiple={true}
            >
              {this.state.audit_meet_wgt_goal_conf_fileList.length >= 8 ? null : uploadButton}
            </Upload>
            {this.state.previewImage && (
              <>
                <Image
                  styles={{ display: 'none' }}
                  preview={{
                    open: this.state.previewOpen,
                    onVisibleChange: visible => this.setState({ previewOpen: visible }),
                    afterOpenChange: visible => !visible && this.setState({ previewImage: '' }),
                  }}
                  src={this.state.previewImage}
                />
                {this.state.previewFileName && <p className='mt-2'>File Name: {this.state.previewFileName}</p>}
              </>
            )}
          </Modal>
        }
        <Modal
          width={'80%'}
          title={'DOD Flight Assignments'}
          closable
          //maskClosable= {false}
          destroyOnClose
          centered
          open={this.state.flightAssessment}
          onCancel={() => this.setState({ flightAssessment: false })}
          className=''
          footer={[
            <>
              <Button
                onClick={this.assigndodAgents}
                type='primary'
                className='custom-button mr-4'
              >Assign Agents
              </Button>
            </>
          ]}
        >
          <Card className='custom-card h-100'>
            <Form
              name='filter-form'
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              initialValues={{ remember: true }}
              autoComplete='off'
            >
              <Row gutter={[24, 24]}>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item
                    label='Station'
                    name='station'
                  >
                    <Select
                      value={this.state.assessment_station}
                      onChange={e => this.setState({ assessment_station: e })}
                      placeholder='Select Station'
                      className='w-100'
                    >
                      {this.state.searchStations.map(stn => (
                        <Option key={stn} value={stn}>{stn}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item
                    label='Departure Date'
                    name='to_date'
                  >
                    <DatePicker
                      allowClear={false}
                      className='w-100'
                      onChange={(moment) => this.setState({ assessment_date: moment })}
                      value={moment(this.state.assessment_date, dateFormat)}
                      disabledDate={(current) => this.disabledDate(current)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={2} lg={2}>
                  <Form.Item label={null}>
                    <Button type='primary' htmlType='submit' className='custom-button w-100 assign-agent-submit' onClick={() => {
                      this.fetchAssessmentFlights()
                      this.fetchDodAgents()
                    }}>
                      Submit
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <div className='table-outer'>
              <Table dataSource={this.state.dodAssignmentFlights} columns={dodAssessmentColumns} pagination={false} className='custom-table assign-agent-table' />
            </div>
          </Card>
        </Modal>

        {(this.state.openPlanner || this.state.openInitPlanner || this.state.openFinalPlanner) &&
          <WeightAndBalance
            onWandbImageReady={this.handleAuditScreenshotUpload}
            wgt_unit={this.state.editWgtUnit}
            copy={this.state.openInitPlanner ? true
              : this.state.openFinalPlanner ? true : false}
            openWB={this.openWB}
            openInitWB={this.openInitWB}
            openFinalWB={this.openFinalWB}
            openWnb={this.openWnb}
            lockWB={this.lockWB}
            trimPlan={this.trimPlan}
            unlockWB={this.unlockWB}
            openTruckPlanner={this.openTruckPlanner}
            openPlanner={this.state.openPlanner}
            openInitPlanner={this.state.openInitPlanner}
            openFinalPlanner={this.state.openFinalPlanner}
            // openWnbPlanner={this.state.openWnbPlanner}
            editRecordId={this.state.editRecordId}
            editRecord={
              this.state.openInitPlanner
                ? {
                  ...this.state.editRecord,
                  ...this.state.editRecord?.init_wgt_bal_plan,
                  build_uld: this.state.editRecord?.build_uld.map((item) => {
                    let awbs = this.showAwbs(item, this.state.editRecord?.init_build_plan?.data?.build_plan || [])
                    return {
                      ...item,
                      awbs 
                    }
                  })
                }
                : this.state.openFinalPlanner
                  ? {
                    ...this.state.editRecord,
                    ...this.state.editRecord?.final_wgt_bal_plan,
                    build_uld: this.state.editRecord?.build_uld.map((item) => {
                      let awbs = this.showAwbs(item, this.state.editRecord?.final_build_plan?.data?.build_plan || [])
                      return {
                        ...item,
                        awbs 
                      }
                    })
                  }
                  : {
                    ...this.state.editRecord,
                    build_uld: this.state.editRecord?.build_uld.map((item) => {
                      let awbs = this.showAwbs(item, this.state.editRecord?.build_plan || [])
                      return {
                        ...item,
                        awbs 
                      }
                    })
                  }
            }
            ccPlanModalVisible={this.state.openInitPlanner || this.state.openFinalPlanner}
          />
        }
        {
          this.state.truckplanner &&
          <TruckLoading
            openTruckPlanner={this.openTruckPlanner}
            truckplanner={this.state.truckplanner}
            editRecordId={this.state.editRecordId}
            editRecord={this.state.editRecord}
          />
        }
      </div>
    )
  }
}

export default FlightControl